import React, { forwardRef, useState, useEffect, useRef, cloneElement, Children, useImperativeHandle, useContext, useMemo, Component, createContext } from 'react';
import PropTypes, { bool, number, oneOf, string, node, func, oneOfType, object as object$1, arrayOf, boolean } from 'prop-types';
import { joinClassNames, safeRest, getBreakpoints, warn, deprecate, useWindowDimensions, usePreviousState, capitalize, generateId, isClient, LANGUAGE } from '@telus/koodo-shared-utils';
import ReactDOM, { createPortal } from 'react-dom';

function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function () {
    return !!t;
  })();
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty$1(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _defineProperty$1(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _extends$1() {
  _extends$1 = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$1.apply(this, arguments);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf$1(subClass, superClass);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _setPrototypeOf$1(o, p) {
  _setPrototypeOf$1 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf$1(o, p);
}
function _objectWithoutPropertiesLoose$1(source, excluded) {
  if (source == null) return {};
  var target = {};
  for (var key in source) {
    if (Object.prototype.hasOwnProperty.call(source, key)) {
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutProperties$1(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose$1(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _assertThisInitialized$1(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$1(self);
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var getThemeColors = function getThemeColors(theme, defaultBorderColor) {
  // These filters assume that the original color of the svg is "black"
  var svgFilterMosque = 'invert(22%) sepia(80%) saturate(2221%) hue-rotate(161deg) brightness(90%) contrast(104%)';
  var svgFilterWhite = 'invert(100%) sepia(1%) saturate(7497%) hue-rotate(200deg) brightness(101%) contrast(101%)';
  var colors = {
    yellow: {
      bgInactive: 'beeswax',
      bgActive: 'flirt',
      textInactive: 'flirt',
      textActive: 'white'
    },
    green: {
      bgInactive: 'mint-tulip',
      bgActive: 'mosque',
      textInactive: 'mosque',
      textActive: 'white',
      svgBonusInactive: svgFilterMosque
    },
    yellowGreen: {
      bgInactive: 'beeswax',
      bgActive: 'mosque',
      textInactive: 'mosque',
      textActive: 'white',
      svgBonusInactive: svgFilterMosque
    },
    blue: {
      bgInactive: 'onahau',
      bgActive: 'chathams-blue',
      textInactive: 'chathams-blue',
      textActive: 'white'
    },
    purple: {
      bgInactive: 'hero-pink',
      textInactive: 'white',
      bgActive: 'flirt',
      textActive: 'white'
    },
    pink: {
      bgInactive: 'hibiscus',
      textInactive: 'white',
      bgActive: 'cardinal-pink',
      textActive: 'white',
      svgBonusInactive: svgFilterWhite
    },
    "default": {
      bgActive: defaultBorderColor
    }
  };
  return colors[theme];
};

var styles$$ = {"flirt":"#7c1366","mosque":"#016b6a","texas":"#f9f6a5","amaranth":"#ee2c74","cardinal-pink":"#8c0448","trinidad":"#df3d0c","chestnut":"#bc4850","onahau":"#c3efff","burnt-sienna":"#ed6358","chathams-blue":"#17367d","mid-blue":"#1a347d","well-read":"#b8373e","wattle":"#d5e04d","beeswax":"#feeec7","bilbao":"#258b0b","sea-buckthorn":"#fbaf34","mint-tulip":"#c1f2e8","turquoise":"#39cdc9","hibiscus":"#c53a70","carousel-pink":"#fae6f4","white":"#fff","black":"#000","mortar":"#595959","gallery":"#efefef","silver":"#c9c8c8","dove":"#666666","iceberg":"#cbf0e8","icicle":"#e5f7fb","light-gray":"#fafafa","super-nova":"#fbaf33","expand-yellow":"#fee8b8","expand-yellow-light":"rgba(254, 232, 184, 0.5)","hero-pink":"#a6298c","clickable":"KDS_Clickable-modules__clickable___3EJQT KDS_Spacing-modules__nospacing___11hAP KDS_Borders-modules__none___uTgzs KDS_Forms-modules__font___sDGt2"};

var _excluded$17 = ["dangerouslyAddClassName", "dangerouslyAddStyle", "children", "type"];

/**
 * An invisible button.
 */
var Clickable = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var dangerouslyAddClassName = _ref.dangerouslyAddClassName,
    dangerouslyAddStyle = _ref.dangerouslyAddStyle,
    children = _ref.children,
    type = _ref.type,
    rest = _objectWithoutProperties$1(_ref, _excluded$17);
  return (
    /*#__PURE__*/
    // eslint-disable-next-line react/button-has-type
    React.createElement("button", _extends$1({}, safeRest(rest), {
      className: joinClassNames(styles$$.clickable, dangerouslyAddClassName),
      style: dangerouslyAddStyle,
      type: type // eslint-disable-line
      ,
      ref: ref
    }), children)
  );
});
Clickable.propTypes = {
  dangerouslyAddClassName: PropTypes.string,
  dangerouslyAddStyle: PropTypes.object,
  children: PropTypes.node.isRequired,
  type: PropTypes.oneOf(['submit', 'reset', 'button'])
};
Clickable.defaultProps = {
  dangerouslyAddClassName: undefined,
  dangerouslyAddStyle: undefined,
  type: 'button'
};
Clickable.displayName = 'Clickable';

var getColorStyle = function getColorStyle(color) {
  var property = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'fill';
  return color ? _defineProperty$1({}, property, "var(--color-".concat(color, ")")) : {};
};
var icons = {
  chevronUp: /*#__PURE__*/React.createElement("path", {
    d: "M23.0948 18.5165C23.3602 18.2517 23.5707 17.9373 23.7143 17.5911C23.8579 17.2449 23.9318 16.8738 23.9318 16.499C23.9318 16.1242 23.8579 15.753 23.7143 15.4068C23.5707 15.0606 23.3602 14.7462 23.0948 14.4815L13.9523 5.33145C13.4145 4.79879 12.6881 4.49998 11.9311 4.49998C11.1741 4.49998 10.4477 4.79879 9.90984 5.33145L0.767341 14.4815C0.262146 15.0235 -0.0127713 15.7405 0.000587052 16.4813C0.0139454 17.2221 0.314534 17.9288 0.838941 18.4522C1.36335 18.9757 2.07057 19.2749 2.81141 19.2869C3.55225 19.2989 4.26878 19.0227 4.80984 18.5165L11.5598 11.7665C11.6128 11.7129 11.6759 11.6705 11.7454 11.6415C11.815 11.6125 11.8895 11.5975 11.9648 11.5975C12.0402 11.5975 12.1147 11.6125 12.1842 11.6415C12.2538 11.6705 12.3168 11.7129 12.3698 11.7665L19.1198 18.479C19.647 19.0017 20.3573 19.2981 21.0997 19.3051C21.8421 19.3121 22.5579 19.0292 23.0948 18.5165Z"
  }),
  chevronRight: /*#__PURE__*/React.createElement("path", {
    d: "M5.28855 23.0947C5.55328 23.3601 5.86774 23.5706 6.21394 23.7142C6.56013 23.8578 6.93125 23.9317 7.30605 23.9317C7.68085 23.9317 8.05197 23.8578 8.39817 23.7142C8.74436 23.5706 9.05882 23.3601 9.32355 23.0947L18.4736 13.9522C19.0062 13.4144 19.305 12.688 19.305 11.931C19.305 11.174 19.0062 10.4476 18.4736 9.90973L9.32355 0.767235C8.78155 0.262039 8.06451 -0.0128781 7.32369 0.000480239C6.58288 0.0138386 5.87621 0.314427 5.35278 0.838834C4.82935 1.36324 4.53007 2.07046 4.51809 2.8113C4.5061 3.55214 4.78235 4.26867 5.28855 4.80973L12.0386 11.5597C12.0921 11.6127 12.1345 11.6758 12.1635 11.7453C12.1925 11.8148 12.2075 11.8894 12.2075 11.9647C12.2075 12.0401 12.1925 12.1146 12.1635 12.1841C12.1345 12.2537 12.0921 12.3167 12.0386 12.3697L5.32605 19.1197C4.8033 19.6469 4.50689 20.3572 4.49988 21.0996C4.49288 21.842 4.77584 22.5578 5.28855 23.0947Z"
  }),
  chevronDown: /*#__PURE__*/React.createElement("path", {
    d: "M0.836872 5.28879C0.571551 5.55352 0.361054 5.86799 0.21743 6.21418C0.0738066 6.56037 -0.000122021 6.93149 -0.00012207 7.30629C-0.000122119 7.6811 0.0738065 8.05222 0.21743 8.39841C0.361054 8.7446 0.571551 9.05906 0.836871 9.32379L9.97937 18.4738C10.5172 19.0065 11.2436 19.3053 12.0006 19.3053C12.7576 19.3053 13.484 19.0065 14.0219 18.4738L23.1644 9.3238C23.6696 8.7818 23.9445 8.06476 23.9311 7.32394C23.9178 6.58312 23.6172 5.87646 23.0928 5.35302C22.5684 4.82959 21.8611 4.53031 21.1203 4.51833C20.3795 4.50635 19.6629 4.7826 19.1219 5.2888L12.3719 12.0388C12.3189 12.0923 12.2558 12.1348 12.1863 12.1638C12.1168 12.1928 12.0422 12.2077 11.9669 12.2077C11.8916 12.2077 11.817 12.1928 11.7475 12.1638C11.6779 12.1348 11.6149 12.0923 11.5619 12.0388L4.81187 5.32629C4.28471 4.80354 3.57437 4.50713 2.83199 4.50013C2.08961 4.49312 1.3738 4.77608 0.836872 5.28879Z"
  }),
  chevronLeft: /*#__PURE__*/React.createElement("path", {
    d: "M18.5162 0.837009C18.2515 0.571689 17.937 0.361191 17.5908 0.217567C17.2446 0.0739435 16.8735 1.52588e-05 16.4987 1.52588e-05C16.1239 1.52588e-05 15.7528 0.0739435 15.4066 0.217567C15.0604 0.361191 14.746 0.571689 14.4812 0.837009L5.33122 9.97951C4.79857 10.5174 4.49976 11.2438 4.49976 12.0008C4.49976 12.7577 4.79857 13.4841 5.33122 14.022L14.4812 23.1645C15.0232 23.6697 15.7403 23.9446 16.4811 23.9313C17.2219 23.9179 17.9286 23.6173 18.452 23.0929C18.9754 22.5685 19.2747 21.8613 19.2867 21.1204C19.2987 20.3796 19.0224 19.6631 18.5162 19.122L11.7662 12.372C11.7127 12.319 11.6702 12.2559 11.6412 12.1864C11.6122 12.1169 11.5973 12.0423 11.5973 11.967C11.5973 11.8917 11.6122 11.8171 11.6412 11.7476C11.6702 11.6781 11.7127 11.615 11.7662 11.562L18.4787 4.81201C19.0015 4.28484 19.2979 3.5745 19.3049 2.83213C19.3119 2.08975 19.0289 1.37394 18.5162 0.837009Z"
  }),
  chevronRightFilled: {
    viewBox: '0 0 28 28',
    elements: function elements(_ref2) {
      var color = _ref2.color;
      return /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
        fill: "#1A347D",
        style: getColorStyle(color),
        d: "M14 0C6.26762 0 0 6.26762 0 14C0 21.7324 6.26762 28 14 28C21.7324 28 28 21.7324 28 14C28 6.26762 21.7324 0 14 0Z"
      }), /*#__PURE__*/React.createElement("path", {
        fill: "white",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.3396 19.6622C10.8818 19.2158 10.8877 18.498 11.3522 18.0581L15.6372 14.0002L11.3522 9.94231C10.8877 9.50322 10.8818 8.78545 11.3396 8.33907C11.7965 7.89188 12.5442 7.88621 13.0079 8.32692L18.233 13.2741C18.6497 13.6685 18.6497 14.3319 18.233 14.7264L13.0079 19.6735C12.7786 19.8914 12.4793 20 12.18 20C11.8749 20 11.5705 19.8874 11.3396 19.6622Z"
      }));
    }
  },
  cart: {
    elements: function elements(_ref3) {
      var color = _ref3.color;
      return /*#__PURE__*/React.createElement("path", {
        d: "M23.8061 5.82374C23.7163 5.70862 23.6006 5.61441 23.4677 5.54811C23.3348 5.4818 23.1881 5.4451 23.0384 5.44074H6.25932L5.51159 3.38212C5.43882 3.21168 5.3164 3.06502 5.15902 2.95973C5.00164 2.85443 4.81597 2.79497 4.62428 2.78848H1.04515C0.913281 2.77543 0.780032 2.78912 0.654021 2.82865C0.52801 2.86818 0.412042 2.93268 0.313621 3.01796C0.215199 3.10325 0.136515 3.20743 0.0826599 3.32377C0.0288044 3.4401 0.000976562 3.566 0.000976563 3.69331C0.000976562 3.82062 0.0288044 3.94652 0.0826599 4.06286C0.136515 4.17919 0.215199 4.28337 0.313621 4.36866C0.412042 4.45395 0.52801 4.51844 0.654021 4.55797C0.780032 4.5975 0.913281 4.61119 1.04515 4.59814H4.03607L8.93121 18.0031C8.70831 18.3178 8.58062 18.6857 8.56233 19.0659C8.56274 19.5623 8.74165 20.0434 9.06881 20.4277C9.39596 20.812 9.85128 21.0761 10.3578 21.1752C10.8643 21.2743 11.3908 21.2023 11.8485 20.9715C12.3061 20.7407 12.6667 20.3652 12.8693 19.9085H15.9997C16.1583 20.2668 16.415 20.5772 16.7425 20.8066C17.07 21.036 17.4562 21.1758 17.8599 21.2113C18.2636 21.2468 18.6697 21.1765 19.0352 21.008C19.4006 20.8395 19.7117 20.579 19.9353 20.2543C20.1589 19.9296 20.2867 19.5527 20.3051 19.1638C20.3235 18.7748 20.2319 18.3884 20.0399 18.0455C19.8479 17.7026 19.5627 17.4161 19.2147 17.2164C18.8667 17.0168 18.4689 16.9114 18.0635 16.9115C17.6489 16.9112 17.2425 17.0222 16.8902 17.232C16.5378 17.4418 16.2536 17.7421 16.0695 18.0988H12.8094C12.6227 17.7441 12.3378 17.4457 11.9861 17.2363C11.6343 17.0268 11.2293 16.9145 10.8155 16.9115C10.6994 16.9017 10.5826 16.9017 10.4665 16.9115L10.1774 16.1072H19.7783C19.9739 16.1119 20.1661 16.057 20.3273 15.9504C20.4885 15.8437 20.6104 15.6908 20.6756 15.5136L23.9755 6.61846C24.0096 6.48215 24.012 6.34033 23.9828 6.20301C23.9535 6.06569 23.8931 5.93622 23.8061 5.82374V5.82374ZM18.0435 19.8319C17.8803 19.83 17.7213 19.7818 17.5866 19.6933C17.4518 19.6049 17.3473 19.4801 17.2862 19.3347C17.2251 19.1894 17.2101 19.0299 17.2432 18.8763C17.2762 18.7228 17.3558 18.5821 17.4719 18.4719C17.588 18.3617 17.7355 18.287 17.8957 18.2571C18.056 18.2272 18.2218 18.2435 18.3724 18.3039C18.5231 18.3643 18.6517 18.4662 18.7422 18.5967C18.8327 18.7271 18.881 18.8804 18.881 19.0372C18.881 19.1423 18.8593 19.2465 18.8171 19.3435C18.7749 19.4406 18.713 19.5286 18.6351 19.6025C18.5572 19.6765 18.4648 19.7348 18.3633 19.7742C18.2617 19.8135 18.153 19.8332 18.0435 19.8319ZM10.8055 18.2425C11.025 18.2425 11.2355 18.3262 11.3906 18.4752C11.5458 18.6243 11.633 18.8264 11.633 19.0372C11.633 19.2479 11.5458 19.4501 11.3906 19.5991C11.2355 19.7482 11.025 19.8319 10.8055 19.8319C10.6968 19.8319 10.5892 19.8113 10.4889 19.7714C10.3885 19.7315 10.2972 19.6729 10.2204 19.5991C10.1436 19.5253 10.0826 19.4377 10.041 19.3413C9.99943 19.2449 9.97803 19.1415 9.97803 19.0372C9.97803 18.9328 9.99943 18.8295 10.041 18.733C10.0826 18.6366 10.1436 18.549 10.2204 18.4752C10.2972 18.4014 10.3885 18.3429 10.4889 18.3029C10.5892 18.263 10.6968 18.2425 10.8055 18.2425V18.2425ZM19.1103 14.2784H9.56927L6.93726 7.25041H21.7024L19.1103 14.2784Z",
        fill: "black",
        style: getColorStyle(color)
      });
    }
  },
  filledCart: {
    elements: function elements(_ref4) {
      var color = _ref4.color;
      return /*#__PURE__*/React.createElement("g", {
        clipPath: "url(#clip0_1537_49380)"
      }, /*#__PURE__*/React.createElement("path", {
        d: "M20.7918 10.3033C20.4559 10.299 20.1217 10.2555 19.7958 10.1738C19.088 9.99721 18.4392 9.63728 17.9147 9.13024C17.3901 8.62321 17.0084 7.98695 16.8079 7.28552C16.6994 6.91352 16.6457 6.52767 16.6486 6.14017C16.633 5.92133 16.633 5.70167 16.6486 5.48283H6.07149L5.31456 3.43115C5.24865 3.25961 5.13268 3.11184 4.98172 3.00706C4.83075 2.90227 4.65176 2.84529 4.468 2.84354H1.00206C0.875731 2.83024 0.748021 2.84364 0.62721 2.88288C0.506399 2.92212 0.395185 2.98632 0.300782 3.0713C0.206379 3.15629 0.130894 3.26017 0.0792248 3.37621C0.0275552 3.49225 0.000854492 3.61786 0.000854492 3.74488C0.000854492 3.8719 0.0275552 3.99751 0.0792248 4.11355C0.130894 4.22959 0.206379 4.33347 0.300782 4.41846C0.395185 4.50345 0.506399 4.56764 0.62721 4.60688C0.748021 4.64612 0.875731 4.65952 1.00206 4.64622H3.83058L8.5116 17.9622C8.3239 18.2784 8.22739 18.6403 8.23273 19.008C8.22993 19.503 8.39874 19.9837 8.71043 20.3683C9.02213 20.7529 9.45746 21.0176 9.94235 21.1174C10.4272 21.2172 10.9317 21.1459 11.37 20.9157C11.8082 20.6854 12.1531 20.3104 12.346 19.8545H15.3339C15.4863 20.2086 15.7315 20.5149 16.0435 20.7412C16.3555 20.9675 16.7228 21.1054 17.1067 21.1403C17.4905 21.1753 17.8767 21.1059 18.2245 20.9396C18.5722 20.7734 18.8686 20.5163 19.0824 20.1956C19.2962 19.8749 19.4195 19.5024 19.4392 19.1175C19.459 18.7325 19.3744 18.3494 19.1946 18.0085C19.0147 17.6676 18.7461 17.3816 18.4172 17.1806C18.0883 16.9796 17.7113 16.8712 17.3258 16.8667C16.9291 16.8641 16.5396 16.9729 16.2016 17.1807C15.8635 17.3884 15.5905 17.6868 15.4136 18.0419H12.2863C12.1084 17.6875 11.8352 17.3898 11.4974 17.1822C11.1596 16.9745 10.7706 16.8653 10.374 16.8667C10.2647 16.8564 10.1547 16.8564 10.0454 16.8667L9.76651 16.0699H18.9393C19.1269 16.0738 19.311 16.018 19.4649 15.9106C19.6188 15.8032 19.7347 15.6498 19.7958 15.4723L21.6682 10.1738C21.3825 10.2525 21.0881 10.296 20.7918 10.3033ZM17.296 18.271C17.4001 18.2696 17.5035 18.289 17.6001 18.328C17.6967 18.3669 17.7847 18.4247 17.8588 18.4979C17.9329 18.5711 17.9917 18.6582 18.0319 18.7544C18.0721 18.8505 18.0927 18.9536 18.0927 19.0578C18.0947 19.2158 18.0497 19.3708 17.9633 19.5031C17.877 19.6354 17.7532 19.7391 17.6078 19.8009C17.4624 19.8628 17.3019 19.88 17.1467 19.8504C16.9915 19.8208 16.8486 19.7457 16.7362 19.6347C16.6238 19.5236 16.5469 19.3817 16.5153 19.2269C16.4838 19.072 16.4989 18.9113 16.5589 18.7652C16.6189 18.619 16.7211 18.494 16.8523 18.406C16.9835 18.318 17.138 18.271 17.296 18.271V18.271ZM10.374 18.271C10.5827 18.271 10.7828 18.3539 10.9304 18.5014C11.078 18.649 11.1608 18.8491 11.1608 19.0578C11.1608 19.2664 11.078 19.4666 10.9304 19.6141C10.7828 19.7617 10.5827 19.8446 10.374 19.8446C10.1654 19.8446 9.96524 19.7617 9.81768 19.6141C9.67013 19.4666 9.58723 19.2664 9.58723 19.0578C9.58042 18.9503 9.59573 18.8426 9.6322 18.7414C9.66868 18.6401 9.72556 18.5474 9.79931 18.4689C9.87306 18.3905 9.96212 18.3281 10.061 18.2854C10.1598 18.2428 10.2664 18.2209 10.374 18.2212V18.271Z",
        fill: "#010101",
        style: getColorStyle(color)
      }), /*#__PURE__*/React.createElement("path", {
        d: "M23.9987 6.14016C24.0004 6.76543 23.8181 7.37737 23.4745 7.8998C23.131 8.42222 22.6413 8.83205 22.0666 9.07824C21.6666 9.26057 21.2313 9.35239 20.7917 9.34715C20.5545 9.34416 20.3179 9.32083 20.0846 9.27744C19.5683 9.1596 19.0891 8.91614 18.6895 8.56866C18.2899 8.22118 17.9823 7.78043 17.7939 7.28552C17.6506 6.92058 17.5763 6.53222 17.5748 6.14016C17.5722 5.91908 17.5956 5.69846 17.6445 5.48283C17.798 4.69692 18.2399 3.99687 18.8835 3.52033C19.527 3.04379 20.3255 2.82523 21.122 2.90762C21.9185 2.99002 22.6554 3.36741 23.1877 3.9656C23.72 4.56378 24.0093 5.33948 23.9987 6.14016V6.14016Z",
        fill: "#DD4026"
      }));
    }
  },
  circledLine: {
    viewBox: '0 0 14 14',
    elements: function elements(_ref5) {
      var color = _ref5.color;
      return /*#__PURE__*/React.createElement("g", {
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
      }, /*#__PURE__*/React.createElement("g", {
        transform: "translate(-179.000000, -707.000000)"
      }, /*#__PURE__*/React.createElement("g", {
        transform: "translate(0.000000, 571.000000)"
      }, /*#__PURE__*/React.createElement("g", {
        transform: "translate(179.000000, 136.000000)"
      }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
        fill: "#fff"
      }), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("path", {
        d: "M7,0 C3.1335,0 0,3.1335 0,7 C0,10.866 3.1335,14 7,14 C10.866,14 14,10.866 14,7 C14,3.1335 10.866,0 7,0",
        fill: "#000",
        mask: "url(#mask-2)",
        style: getColorStyle(color)
      })), /*#__PURE__*/React.createElement("rect", {
        fill: "#fff",
        x: "3",
        y: "6",
        width: "8",
        height: "2",
        rx: "1"
      }))))));
    }
  },
  tag: {
    viewBox: '0 0 25 25',
    elements: function elements(_ref6) {
      var color = _ref6.color;
      return /*#__PURE__*/React.createElement("g", {
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
      }, /*#__PURE__*/React.createElement("g", {
        transform: "translate(-143.000000, -290.000000)",
        fill: "#8C0448",
        fillRule: "nonzero",
        style: getColorStyle(color)
      }, /*#__PURE__*/React.createElement("path", {
        d: "M167.107152,290 L157.285824,290 C157.049045,290.000051 156.821983,290.09415 156.65458,290.2616 L143.26186,303.654081 C143.094204,303.821548 143,304.048794 143,304.285759 C143,304.522725 143.094204,304.749971 143.26186,304.917438 L153.083188,314.738591 C153.431845,315.087136 153.997018,315.087136 154.345675,314.738591 L167.738395,301.34611 C167.906067,301.178492 168.000186,300.951069 168,300.713985 L168,290.892832 C168,290.399735 167.600258,290 167.107152,290 Z M161.750064,298.035489 C160.763851,298.035489 159.964368,297.23602 159.964368,296.249824 C159.964368,295.263629 160.763851,294.46416 161.750064,294.46416 C162.736276,294.46416 163.53576,295.263629 163.53576,296.249824 C163.53576,296.723412 163.347624,297.177603 163.012742,297.51248 C162.677859,297.847357 162.22366,298.035489 161.750064,298.035489 Z"
      })));
    }
  },
  tagOutline: {
    viewBox: '0 0 33 32',
    elements: function elements(_ref7) {
      var color = _ref7.color;
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
        style: getColorStyle(color),
        d: "M32.3728 13.7763L32.4795 1.36334C32.4805 1.18787 32.4469 1.01393 32.3805 0.851482C32.3142 0.689037 32.2164 0.541288 32.0928 0.416705C31.9682 0.293134 31.8205 0.195371 31.658 0.12902C31.4956 0.0626694 31.3217 0.0290371 31.1462 0.0300516H18.7466C18.5702 0.0307839 18.3957 0.0665151 18.2332 0.135175C18.0707 0.203835 17.9234 0.304058 17.8 0.430038L0.867203 17.3628C0.618876 17.6126 0.479492 17.9505 0.479492 18.3028C0.479492 18.655 0.618876 18.9929 0.867203 19.2427L13.2268 31.6023C13.3507 31.7273 13.4982 31.8265 13.6607 31.8942C13.8231 31.9619 13.9974 31.9967 14.1734 31.9967C14.3494 31.9967 14.5237 31.9619 14.6862 31.8942C14.8486 31.8265 14.9961 31.7273 15.1201 31.6023L31.9862 14.6962C32.2293 14.4512 32.3679 14.1214 32.3728 13.7763V13.7763ZM14.1734 28.7491L3.69377 18.2694L19.2266 2.69663H29.8129V13.2163L14.1734 28.7491Z",
        fill: "#7C1066"
      }), /*#__PURE__*/React.createElement("path", {
        style: getColorStyle(color),
        d: "M24.4797 10.2964C25.7684 10.2964 26.813 9.25176 26.813 7.96314C26.813 6.67452 25.7684 5.62988 24.4797 5.62988C23.1911 5.62988 22.1465 6.67452 22.1465 7.96314C22.1465 9.25176 23.1911 10.2964 24.4797 10.2964Z",
        fill: "#7C1066"
      }));
    }
  },
  shipping: {
    viewBox: '0 0 36 24',
    elements: function elements(_ref8) {
      var color = _ref8.color;
      return /*#__PURE__*/React.createElement("path", {
        style: getColorStyle(color),
        fill: "#7C1366",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M 28.8442 22.7705 C 27.512 22.7705 26.4305 21.662 26.4305 20.2949 C 26.4305 18.9265 27.512 17.818 28.8442 17.818 C 30.1764 17.818 31.2566 18.9265 31.2566 20.2949 C 31.2566 21.662 30.1764 22.7705 28.8442 22.7705 Z M 25.1151 16.0571 C 24.8179 16.0571 24.575 15.7601 24.575 15.3941 C 24.575 15.0268 24.8179 14.7311 25.1151 14.7311 H 26.5972 C 26.8944 14.7311 27.1373 15.0268 27.1373 15.3941 C 27.1373 15.7601 26.8944 16.0571 26.5972 16.0571 H 25.1151 Z M 21.6535 6.8456 C 21.5488 6.91322 21.4338 6.94372 21.3188 6.94372 C 21.1095 6.94372 20.9028 6.83764 20.7839 6.64273 C 20.7774 6.63477 20.749 6.59101 20.7025 6.53002 C 19.6507 9.06527 17.0432 11.3884 13.119 11.3884 C 9.11855 11.3884 6.34435 8.95389 5.45149 6.4014 C 5.42436 6.44781 5.39851 6.49952 5.37913 6.55389 C 5.28481 6.81245 5.04447 6.97289 4.78863 6.97289 C 4.71369 6.97289 4.64003 6.95831 4.56638 6.93179 C 4.23818 6.80449 4.07279 6.42925 4.19683 6.09378 C 4.46947 5.35389 5.04447 4.854 5.86239 4.64317 C 6.418 4.50262 6.89738 4.5477 6.95036 4.553 C 7.29665 4.5888 7.54991 4.90836 7.51114 5.26637 C 7.47626 5.62041 7.16744 5.8803 6.81986 5.84449 C 6.80564 5.84317 6.71649 5.83654 6.58856 5.84052 C 7.39873 8.51101 10.443 10.0889 13.119 10.0889 C 16.5354 10.0889 18.7643 8.0509 19.6003 5.87367 C 19.5202 5.87632 19.4375 5.88825 19.3522 5.91477 C 19.0175 6.02085 18.6635 5.83124 18.5601 5.48781 C 18.4555 5.14571 18.6415 4.78107 18.9749 4.67499 C 19.7114 4.43897 20.4505 4.59676 21.1147 5.12715 C 21.5656 5.49046 21.8253 5.90549 21.8538 5.95057 C 22.0385 6.25422 21.9507 6.65599 21.6535 6.8456 Z M 7.16873 22.7705 C 5.83396 22.7705 4.75374 21.662 4.75374 20.2949 C 4.75374 18.9265 5.83396 17.818 7.16873 17.818 C 8.50091 17.818 9.58113 18.9265 9.58113 20.2949 C 9.58113 21.662 8.50091 22.7705 7.16873 22.7705 Z M 35.0283 13.7234 H 28.9243 C 27.8699 13.7234 27.012 12.8429 27.012 11.761 V 8.81996 C 27.012 8.454 27.3014 8.15698 27.658 8.15698 C 28.0146 8.15698 28.3041 8.454 28.3041 8.81996 V 11.761 C 28.3041 12.1123 28.5819 12.3974 28.9243 12.3974 H 32.8433 L 31.5538 6.84427 C 31.2411 5.49974 30.0691 4.54903 28.7214 4.54903 H 25.6436 V 1.39985 C 25.6436 0.626816 25.0324 -0.000366211 24.2791 -0.000366211 H 1.3632 C 0.609885 -0.000366211 0 0.626816 0 1.39985 V 19.3654 C 0 20.1384 0.609885 20.7643 1.3632 20.7643 H 3.60375 C 3.83116 22.5862 5.33132 23.9996 7.16873 23.9996 C 9.00484 23.9996 10.505 22.5862 10.7324 20.7643 H 25.2792 C 25.5066 22.5862 27.0068 23.9996 28.8442 23.9996 C 30.6816 23.9996 32.1818 22.5862 32.4092 20.7643 H 35.0244 C 35.5633 20.7643 36 20.3161 36 19.7632 V 14.7245 C 36 14.1729 35.5658 13.726 35.0283 13.7234 Z"
      });
    }
  },
  times: /*#__PURE__*/React.createElement("path", {
    d: "M14.943 12l7.44-7.42a2.107 2.107 0 0 0 .023-2.956 2.05 2.05 0 0 0-2.92-.023L12 9.066 4.515 1.601a2.047 2.047 0 0 0-2.92.023 2.109 2.109 0 0 0 .021 2.957L9.057 12l-7.44 7.418a2.108 2.108 0 0 0-.023 2.957 2.046 2.046 0 0 0 2.92.022L12 14.935l7.485 7.463a2.045 2.045 0 0 0 2.92-.022 2.109 2.109 0 0 0-.021-2.957l-7.441-7.418z",
    fillRule: "evenodd"
  }),
  timesCircled: {
    viewBox: '0 0 14 14',
    elements: function elements(_ref9) {
      var color = _ref9.color;
      return /*#__PURE__*/React.createElement("g", {
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
      }, /*#__PURE__*/React.createElement("g", {
        transform: "translate(-179.000000, -650.000000)"
      }, /*#__PURE__*/React.createElement("g", {
        transform: "translate(0.000000, 571.000000)"
      }, /*#__PURE__*/React.createElement("g", {
        transform: "translate(179.000000, 79.000000)"
      }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
        fill: "#fff"
      })), /*#__PURE__*/React.createElement("path", {
        d: "M7,0 C3.1335,0 0,3.1335 0,7 C0,10.866 3.1335,14 7,14 C10.866,14 14,10.866 14,7 C14,3.1335 10.866,0 7,0",
        fill: "#df3d0c",
        mask: "url(#mask-2)",
        style: getColorStyle(color)
      })), /*#__PURE__*/React.createElement("rect", {
        fill: "#fff",
        transform: "translate(7.000000, 7.000000) rotate(-315.000000) translate(-7.000000, -7.000000)",
        x: "3",
        y: "6",
        width: "8",
        height: "2",
        rx: "1"
      }), /*#__PURE__*/React.createElement("rect", {
        fill: "#fff",
        transform: "translate(7.000000, 7.000000) rotate(-225.000000) translate(-7.000000, -7.000000)",
        x: "3",
        y: "6",
        width: "8",
        height: "2",
        rx: "1"
      })))));
    }
  },
  check: /*#__PURE__*/React.createElement("path", {
    d: "M23.1378 3.70937C22.898 3.47836 22.615 3.29685 22.3051 3.17521C21.9951 3.05358 21.6642 2.9942 21.3313 3.00046C20.9984 3.00673 20.67 3.07853 20.3648 3.21174C20.0597 3.34496 19.7837 3.53699 19.5528 3.77687L8.0478 16.2569L4.2453 12.4469C3.76392 12.0069 3.13147 11.7693 2.47945 11.7836C1.82743 11.7979 1.206 12.0629 0.744363 12.5236C0.282722 12.9843 0.0163873 13.6051 0.000731313 14.2571C-0.0149247 14.9091 0.221302 15.5421 0.6603 16.0244L6.2928 21.6569C6.53133 21.8955 6.8151 22.0841 7.12748 22.2117C7.43985 22.3392 7.77454 22.4031 8.11193 22.3996C8.44932 22.3961 8.78262 22.3253 9.09229 22.1913C9.40195 22.0573 9.68176 21.8629 9.9153 21.6194L23.2128 7.29437C23.4433 7.05408 23.6243 6.77073 23.7453 6.46051C23.8663 6.15028 23.925 5.81925 23.918 5.48633C23.911 5.15341 23.8385 4.82513 23.7047 4.52023C23.5708 4.21534 23.3782 3.9398 23.1378 3.70937V3.70937Z"
  }),
  checkCircledFilled: /*#__PURE__*/React.createElement("path", {
    d: "M9.573 17.613l-.01.014-4.433-4.433 1.946-1.945 2.486 2.478 7.356-7.355 1.951 1.953-9.296 9.288zM12 1C6.17 1 1.414 5.536 1.037 11.271 1.02 11.513 1 11.752 1 12a11.002 11.002 0 0 0 10.999 11C18.072 23 23 18.07 23 11.999 23 5.924 18.072 1 11.999 1z",
    fillRule: "evenodd"
  }),
  checkCircledNotFilled: {
    viewBox: '0 0 40 40',
    elements: function elements(_ref10) {
      var color = _ref10.color;
      return /*#__PURE__*/React.createElement("g", {
        fill: "none",
        fillRule: "evenodd",
        stroke: "none",
        strokeWidth: "1"
      }, /*#__PURE__*/React.createElement("g", {
        transform: "translate(-141.000000, -16.000000)"
      }, /*#__PURE__*/React.createElement("g", {
        transform: "translate(20.000000, 16.000000)"
      }, /*#__PURE__*/React.createElement("g", {
        transform: "translate(121.000000, 0.000000)"
      }, /*#__PURE__*/React.createElement("path", {
        d: "M20,40 C31.045695,40 40,31.045695 40,20 C40,8.954305 31.045695,1.0658141e-14 20,1.0658141e-14 C8.954305,1.0658141e-14 0,8.954305 0,20 C0,31.045695 8.954305,40 20,40 Z",
        fill: "#016b6a",
        style: getColorStyle(color)
      }), /*#__PURE__*/React.createElement("g", {
        fill: "#fff",
        transform: "translate(3.000000, 3.000000)"
      }, /*#__PURE__*/React.createElement("path", {
        d: "M13.5619271,24.9513958 L13.5463438,24.970875 L7.26820833,18.6907917 L10.0245104,15.9364375 L13.5463438,19.4465833 L23.9676979,9.02717708 L26.7317917,11.7932187 L13.5619271,24.9513958 Z M16.9980521,1.41666667 C8.74278125,1.41666667 2.00298958,7.84284375 1.46926042,15.9676042 C1.4439375,16.3104375 1.41666667,16.649375 1.41666667,16.9980521 C1.41666667,22.9002396 4.70085417,28.033 9.53753125,30.6802188 C11.7542604,31.8879271 14.2962917,32.5833333 16.9980521,32.5833333 C25.602,32.5833333 32.5833333,25.6000521 32.5833333,16.9980521 C32.5833333,8.39215625 25.602,1.41666667 16.9980521,1.41666667 L16.9980521,1.41666667 Z"
      }))))));
    }
  },
  arrowDownCircled: /*#__PURE__*/React.createElement("path", {
    d: "M12 1c6.077 0 11 4.925 11 11s-4.924 11-11 11C5.925 23 1 18.075 1 12S5.925 1 12 1zm2.391 4.132l-4.69.018v8.238l-2.88.027 5.225 5.454 5.134-5.554-2.789.028V5.132z",
    fillRule: "evenodd"
  }),
  exclamationTriangle: {
    viewBox: '0 0 28 25',
    elements: function elements(_ref11) {
      var color = _ref11.color;
      return /*#__PURE__*/React.createElement("g", {
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
      }, /*#__PURE__*/React.createElement("g", {
        transform: "translate(-81.000000, -46.000000)"
      }, /*#__PURE__*/React.createElement("g", {
        transform: "translate(81.000000, 46.000000)"
      }, /*#__PURE__*/React.createElement("path", {
        d: "M1.00362145,24 L26.9965429,24 C27.5488276,24 27.9965429,23.5522847 27.9965429,23 C27.9965429,22.8211759 27.9485908,22.6456233 27.8576821,22.4916308 L14.8612214,0.476601297 C14.5804569,0.00100722868 13.9673071,-0.156933311 13.491713,0.123831229 C13.346208,0.20972938 13.2248411,0.331096274 13.1389429,0.476601297 L0.142482211,22.4916308 C-0.138282329,22.9672249 0.0196582105,23.5803747 0.495252279,23.8611392 C0.649244721,23.9520479 0.824797357,24 1.00362145,24 Z",
        fill: "#E61360",
        style: getColorStyle(color)
      }), /*#__PURE__*/React.createElement("rect", {
        fill: "#EE2C74",
        style: getColorStyle(color),
        x: "12",
        y: "7",
        width: "5",
        height: "16"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M8.5,15.5 L19.5,15.5",
        stroke: "#FFFFFF",
        strokeWidth: "2",
        strokeLinecap: "square"
      }))));
    }
  },
  caution: {
    viewBox: '0 0 30 25',
    elements: function elements(_ref12) {
      var color = _ref12.color;
      return /*#__PURE__*/React.createElement("g", {
        width: "30",
        height: "25",
        fill: "none"
      }, /*#__PURE__*/React.createElement("path", {
        style: getColorStyle(color),
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M1.14247 23.4916C0.748938 24.1582 1.2295 25 2.00361 25H27.9965C28.7706 25 29.2512 24.1582 28.8577 23.4916L15.8612 1.47659C15.4742 0.821081 14.5259 0.821081 14.1389 1.47659L1.14247 23.4916Z",
        fill: "#DF3D0C"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M14 18H16V10H14V18Z",
        fill: "white"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M14 22H16V20H14V22Z",
        fill: "white"
      }));
    }
  },
  exclamationOctagon: {
    elements: function elements(_ref13) {
      var color = _ref13.color;
      return /*#__PURE__*/React.createElement("g", {
        fillRule: "evenodd"
      }, /*#__PURE__*/React.createElement("g", {
        transform: "translate(-1.000000, -1.000000)"
      }, /*#__PURE__*/React.createElement("rect", {
        fill: "#FFFFFF",
        x: "10",
        y: "4",
        width: "3.4000001",
        height: "17"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M10.618125,14.072625 L13.3805,14.072625 L13.3805,4.403625 L10.618125,4.403625 L10.618125,14.072625 Z M10.618125,19.597375 L13.3805,19.597375 L13.3805,16.835 L10.618125,16.835 L10.618125,19.597375 Z M7.44325,1.0005 L1,7.442375 L1,16.55725 L7.44325,23.0005 L16.55675,23.0005 L23,16.55725 L23,7.442375 L16.55675,1.0005 L7.44325,1.0005 Z",
        fill: "#E61360",
        style: getColorStyle(color)
      })));
    }
  },
  informationCircled: /*#__PURE__*/React.createElement("path", {
    d: "M10.724 8.897h2.596V6.532h-2.596v2.365zm-.027 8.625h2.596v-6.341h-2.596v6.341zM12 1C5.924 1 1 5.927 1 12c0 6.076 4.924 11 11 11 6.073 0 11-4.924 11-11 0-6.073-4.927-11-11-11z",
    fillRule: "evenodd"
  }),
  boxOutline: /*#__PURE__*/React.createElement("path", {
    d: "M1 23h22V1H1v22zm2.64-2.64h16.721V3.639H3.64V20.36z",
    fillRule: "evenodd"
  }),
  boxOutlineChecked: /*#__PURE__*/React.createElement("path", {
    d: "M1 23h22V1H1v22zm2.64-2.64h16.72V3.64H3.64v16.72zm3.435-9.111l2.487 2.479 7.356-7.355 1.951 1.951-9.296 9.289-.01.014-4.433-4.433 1.945-1.945z",
    fillRule: "evenodd"
  }),
  radialOutline: /*#__PURE__*/React.createElement("path", {
    d: "M12 3.64c-4.61 0-8.361 3.751-8.361 8.36s3.75 8.36 8.361 8.36c4.61 0 8.36-3.751 8.36-8.36S16.61 3.64 12 3.64M12 23C5.935 23 1 18.065 1 12 1 5.934 5.935 1 12 1s11 4.934 11 11c0 6.065-4.935 11-11 11",
    fillRule: "evenodd"
  }),
  radialOutlineChecked: /*#__PURE__*/React.createElement("path", {
    d: "M12 20.36c-4.609 0-8.36-3.75-8.36-8.36 0-4.61 3.751-8.36 8.36-8.36 4.61 0 8.36 3.75 8.36 8.36 0 4.61-3.75 8.36-8.36 8.36M12 1C5.935 1 1 5.935 1 12c0 6.066 4.934 11 11 11s11-4.934 11-11c0-6.065-4.934-11-11-11m0 17.6a6.6 6.6 0 1 1 0-13.2 6.6 6.6 0 0 1 0 13.2",
    fillRule: "evenodd"
  }),
  hamburger: {
    elements: function elements(_ref14) {
      var color = _ref14.color;
      return /*#__PURE__*/React.createElement("g", {
        transform: "translate(-276.000000, -46.000000)",
        fill: "#000000",
        style: getColorStyle(color)
      }, /*#__PURE__*/React.createElement("path", {
        d: "M277,60 C276.447715,60 276,59.5522847 276,59 L276,58 C276,57.4477153 276.447715,57 277,57 L298,57 C298.552285,57 299,57.4477153 299,58 L299,59 C299,59.5522847 298.552285,60 298,60 L277,60 Z M277,68 C276.447715,68 276,67.5522847 276,67 L276,66 C276,65.4477153 276.447715,65 277,65 L298,65 C298.552285,65 299,65.4477153 299,66 L299,67 C299,67.5522847 298.552285,68 298,68 L277,68 Z M277,52 C276.447715,52 276,51.5522847 276,51 L276,50 C276,49.4477153 276.447715,49 277,49 L298,49 C298.552285,49 299,49.4477153 299,50 L299,51 C299,51.5522847 298.552285,52 298,52 L277,52 Z"
      }));
    }
  },
  spyglass: /*#__PURE__*/React.createElement("path", {
    d: "M3.838,9.8165 C3.838,6.509625 6.528875,3.828375 9.84675,3.828375 C13.166,3.828375 15.8555,6.509625 15.8555,9.8165 C15.8555,13.123375 13.166,15.804625 9.84675,15.804625 C6.528875,15.804625 3.838,13.123375 3.838,9.8165 M22.269875,18.75675 L17.58525,14.08725 C18.28925,12.82225 18.6935,11.3675 18.6935,9.8165 C18.6935,4.947625 14.732125,1 9.84675,1 C4.96,1 1,4.947625 1,9.8165 C1,14.68675 4.96,18.633 9.84675,18.633 C11.374375,18.633 12.809875,18.248 14.063875,17.56875 L14.041875,17.589375 L18.741625,22.272625 C19.227,22.758 19.865,23 20.50575,23 C21.14375,23 21.78175,22.758 22.269875,22.272625 C23.243375,21.301875 23.243375,19.7275 22.269875,18.75675",
    fillRule: "evenodd"
  }),
  offerStar: {
    viewBox: '0 0 28 28',
    elements: function elements(_ref15) {
      var color = _ref15.color;
      return /*#__PURE__*/React.createElement("path", {
        style: getColorStyle(color),
        d: "M9.371,9.519 L0,12.936 L8.46,18.172 L8.859,28 L16.549,21.728 L26.178,24.388 L22.474,15.259 L28,7.084 L18.031,7.727 L11.85,0 L9.371,9.519 Z M19.056,12.124 C18.914,11.901 18.999,11.592 19.227,11.452 C19.796,11.144 20.394,11.144 21.021,11.424 C21.42,11.649 21.705,11.901 21.733,11.928 C21.932,12.153 21.932,12.46 21.733,12.657 C21.648,12.712 21.562,12.767 21.477,12.796 C21.306,12.824 21.136,12.767 20.993,12.657 C20.993,12.628 20.965,12.6 20.907,12.572 C20.508,14.672 18.8,16.884 15.695,17.528 C12.505,18.201 9.913,16.8 8.773,15.007 C8.773,15.036 8.745,15.092 8.745,15.12 C8.717,15.344 8.546,15.511 8.346,15.54 C8.289,15.568 8.232,15.568 8.147,15.568 C7.862,15.511 7.691,15.259 7.719,14.98 C7.833,14.364 8.204,13.888 8.802,13.609 C9.229,13.412 9.627,13.357 9.656,13.357 C9.941,13.328 10.197,13.524 10.226,13.804 C10.255,14.084 10.055,14.336 9.77,14.364 C9.77,14.364 9.685,14.364 9.6,14.392 C10.681,16.296 13.359,16.996 15.467,16.548 C18.202,15.96 19.626,14.056 19.939,12.263 C19.882,12.263 19.796,12.292 19.74,12.32 C19.656,12.366 19.567,12.387 19.48,12.387 C19.301,12.387 19.133,12.294 19.056,12.124 L19.056,12.124 Z",
        fillRule: "evenodd"
      });
    }
  },
  bullet: /*#__PURE__*/React.createElement("path", {
    d: "M1.399 14.925A10.926 10.926 0 0 1 1 12.003c0-1.99.557-3.95 1.503-5.558a11.294 11.294 0 0 1 3.943-3.952A11.058 11.058 0 0 1 11.997 1c1.99 0 3.952.547 5.558 1.493a11.329 11.329 0 0 1 3.952 3.952C22.453 8.052 23 10.013 23 12.003c0 1.99-.547 3.943-1.493 5.55a11.294 11.294 0 0 1-3.952 3.944A11.09 11.09 0 0 1 11.997 23c-1.99 0-3.943-.557-5.55-1.503a11.26 11.26 0 0 1-3.944-3.943 10.724 10.724 0 0 1-1.104-2.63m8.254-5.272a3.203 3.203 0 0 0-.976 2.35 3.322 3.322 0 0 0 3.32 3.321 3.327 3.327 0 0 0 3.326-3.32 3.331 3.331 0 0 0-3.326-3.326c-.917 0-1.698.321-2.344.975"
  }),
  info: {
    elements: function elements(_ref16) {
      var color = _ref16.color;
      return /*#__PURE__*/React.createElement("g", {
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
      }, /*#__PURE__*/React.createElement("circle", {
        stroke: "#016b6a",
        style: getColorStyle(color, 'stroke'),
        fillRule: "nonzero",
        cx: "12",
        cy: "12",
        r: "11"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M12.8333333,18 L11.1333333,18 L11.1333333,8.2732475 L12.0833333,8.2732475 C12.75,8.2732475 12.8333333,8.49642346 12.8333333,9.72389127 L12.8333333,18 Z M12,7.19456366 C11.4666667,7.19456366 11,6.71101574 11,6.11587983 C11,5.50214592 11.4666667,5 12,5 C12.5333333,5 13,5.50214592 13,6.11587983 C13,6.71101574 12.5333333,7.19456366 12,7.19456366 Z",
        fill: "#016b6a",
        style: getColorStyle(color)
      }));
    }
  },
  infoHovered: {
    elements: function elements(_ref17) {
      var color = _ref17.color;
      return /*#__PURE__*/React.createElement("g", {
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
      }, /*#__PURE__*/React.createElement("circle", {
        style: _objectSpread2(_objectSpread2({}, getColorStyle(color, 'stroke')), getColorStyle(color)),
        fillOpacity: color ? 0.25 : 1,
        stroke: "#016b6a",
        fill: "#c3efff",
        fillRule: "nonzero",
        cx: "12",
        cy: "12",
        r: "11"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M12.8333333,18 L11.1333333,18 L11.1333333,8.2732475 L12.0833333,8.2732475 C12.75,8.2732475 12.8333333,8.49642346 12.8333333,9.72389127 L12.8333333,18 Z M12,7.19456366 C11.4666667,7.19456366 11,6.71101574 11,6.11587983 C11,5.50214592 11.4666667,5 12,5 C12.5333333,5 13,5.50214592 13,6.11587983 C13,6.71101574 12.5333333,7.19456366 12,7.19456366 Z",
        fill: "#016b6a",
        style: getColorStyle(color)
      }));
    }
  },
  infoSelected: {
    elements: function elements(_ref18) {
      var color = _ref18.color;
      return /*#__PURE__*/React.createElement("g", {
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
      }, /*#__PURE__*/React.createElement("circle", {
        style: _objectSpread2(_objectSpread2({}, getColorStyle(color, 'stroke')), getColorStyle(color)),
        fillOpacity: color ? 0.25 : 1,
        stroke: "#016b6a",
        fill: "#016b6a",
        fillRule: "nonzero",
        cx: "12",
        cy: "12",
        r: "11"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M12.8333333,18 L11.1333333,18 L11.1333333,8.2732475 L12.0833333,8.2732475 C12.75,8.2732475 12.8333333,8.49642346 12.8333333,9.72389127 L12.8333333,18 Z M12,7.19456366 C11.4666667,7.19456366 11,6.71101574 11,6.11587983 C11,5.50214592 11.4666667,5 12,5 C12.5333333,5 13,5.50214592 13,6.11587983 C13,6.71101574 12.5333333,7.19456366 12,7.19456366 Z",
        fill: "#ffff",
        style: getColorStyle(color)
      }));
    }
  },
  refresh: {
    elements: function elements(_ref19) {
      var color = _ref19.color;
      return /*#__PURE__*/React.createElement("g", {
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
      }, /*#__PURE__*/React.createElement("g", {
        fill: "#666666",
        fillRule: "nonzero",
        style: getColorStyle(color)
      }, /*#__PURE__*/React.createElement("path", {
        d: "M9.815,-1.82076576e-13 C9.57935,-1.82076576e-13 9.388325,0.191025 9.388325,0.426675 L9.388325,1.985275 C7.191675,-0.1414 3.68695,-0.08465 1.560275,2.111975 C0.558025,3.1472 -0.0011,4.532425 0.00166471975,5.973325 C0.00166471975,6.208975 0.1927,6.4 0.42835,6.4 C0.664,6.4 0.855,6.208975 0.855,5.973325 C0.855525,3.381275 2.9572,1.2804 5.549275,1.280925 C6.8657,1.281175 8.121475,1.8343 9.010325,2.805325 L7.1202,3.4355 C6.89635,3.509975 6.775225,3.7518 6.8497,3.97565 C6.924175,4.1995 7.166,4.320625 7.38985,4.24615 L9.94985,3.392825 C10.1246,3.334625 10.242275,3.170825 10.2417021,2.98665 L10.2417021,0.42665 C10.2417021,0.191025 10.05065,-1.82076576e-13 9.815,-1.82076576e-13 Z"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M10.668325,5.546675 C10.432675,5.546675 10.24165,5.7377 10.24165,5.97335 C10.241125,8.5654 8.13945,10.666275 5.547375,10.66575 C4.23095,10.6655 2.975175,10.112375 2.086325,9.14135 L3.97645,8.511175 C4.2003,8.4367 4.321425,8.194875 4.24695,7.971025 C4.172475,7.747175 3.93065,7.62605 3.7068,7.700525 L1.1468,8.55385 C0.97205,8.61205 0.854375,8.77585 0.854947902,8.960025 L0.854947902,11.520025 C0.854947902,11.755675 1.045975,11.9467 1.281625,11.9467 C1.517275,11.9467 1.7083,11.755675 1.7083,11.520025 L1.7083,9.9614 C3.90495,12.088075 7.4097,12.03135 9.53635,9.8347 C10.5386,8.799475 11.097725,7.41425 11.0949603,5.97335 C11.0949603,5.7377 10.903975,5.546675 10.668325,5.546675 Z"
      })));
    }
  },
  kebab: {
    viewBox: '0 0 4 16',
    elements: function elements(_ref20) {
      var color = _ref20.color;
      return /*#__PURE__*/React.createElement("g", {
        fill: "none",
        fillRule: "evenodd",
        stroke: "none",
        strokeWidth: "1"
      }, /*#__PURE__*/React.createElement("g", {
        fill: "#000",
        style: getColorStyle(color),
        transform: "translate(-293.000000, -502.000000)"
      }, /*#__PURE__*/React.createElement("g", {
        transform: "translate(0.000000, 424.000000)"
      }, /*#__PURE__*/React.createElement("g", {
        transform: "translate(0.000000, 57.000000)"
      }, /*#__PURE__*/React.createElement("g", {
        transform: "translate(293.000000, 21.000000)"
      }, /*#__PURE__*/React.createElement("circle", {
        cx: "2",
        cy: "2",
        r: "2"
      }), /*#__PURE__*/React.createElement("circle", {
        cx: "2",
        cy: "8",
        r: "2"
      }), /*#__PURE__*/React.createElement("circle", {
        cx: "2",
        cy: "14",
        r: "2"
      }))))));
    }
  },
  eyeOpened: {
    viewBox: '0 0 29 18',
    elements: function elements(_ref21) {
      var color = _ref21.color;
      return /*#__PURE__*/React.createElement("g", {
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
      }, /*#__PURE__*/React.createElement("g", {
        transform: "translate(-842.000000, -448.000000)",
        fillRule: "nonzero",
        stroke: "#016b6a",
        strokeWidth: "2",
        style: getColorStyle(color, 'stroke')
      }, /*#__PURE__*/React.createElement("g", {
        transform: "translate(844.000000, 449.000000)"
      }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
        d: "M12.5,16 C17.1023729,16 21.2690396,13.3333333 25,8 C21.2690396,2.66666667 17.1023729,0 12.5,0 C7.89762709,0 3.73096042,2.66666667 0,8 C3.73096042,13.3333333 7.89762709,16 12.5,16 Z"
      }), /*#__PURE__*/React.createElement("circle", {
        cx: "12",
        cy: "8",
        r: "4"
      })))));
    }
  },
  eyeClosed: {
    viewBox: '0 0 29 24',
    elements: function elements(_ref22) {
      var color = _ref22.color;
      return /*#__PURE__*/React.createElement("g", {
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
      }, /*#__PURE__*/React.createElement("g", {
        transform: "translate(-824.000000, -438.000000)",
        fillRule: "nonzero",
        stroke: "#016b6a",
        strokeWidth: "2",
        style: getColorStyle(color, 'stroke')
      }, /*#__PURE__*/React.createElement("g", {
        transform: "translate(826.000000, 438.000000)"
      }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
        d: "M12.5,20 C17.1023729,20 21.2690396,17.3333333 25,12 C21.2690396,6.66666667 17.1023729,4 12.5,4 C7.89762709,4 3.73096042,6.66666667 0,12 C3.73096042,17.3333333 7.89762709,20 12.5,20 Z"
      }), /*#__PURE__*/React.createElement("circle", {
        cx: "12",
        cy: "12",
        r: "4"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M1,23 C16.6110454,7.66666667 23.9443787,0.333333333 23,1",
        strokeLinecap: "round"
      })))));
    }
  },
  profile: /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 5C13.66 5 15 6.34 15 8C15 9.66 13.66 11 12 11C10.34 11 9 9.66 9 8C9 6.34 10.34 5 12 5ZM6 15.98C7.29 17.92 9.5 19.2 12 19.2C14.5 19.2 16.71 17.92 18 15.98C17.97 13.99 13.99 12.9 12 12.9C10 12.9 6.03 13.99 6 15.98Z"
  }),
  lock: {
    viewBox: '0 0 23 28',
    elements: function elements(_ref23) {
      var color = _ref23.color;
      return /*#__PURE__*/React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: "black",
        d: "M9.20039 18.083C9.20039 16.794 10.2295 15.75 11.5 15.75C12.7705 15.75 13.7996 16.794 13.7996 18.083C13.7996 18.906 13.3797 19.629 12.7479 20.044C12.7479 20.044 12.9726 21.421 13.225 23.042C13.225 23.525 12.8395 23.917 12.3625 23.917H10.6375C10.1605 23.917 9.77505 23.525 9.77505 23.042L10.2521 20.044C9.6203 19.629 9.20039 18.906 9.20039 18.083ZM6.8998 11.667V7.583C6.8998 5.005 8.9589 2.917 11.5 2.917C14.0411 2.917 16.1002 5.005 16.1002 7.583V11.667H6.8998ZM4.02554 7.583V11.667H2.30059C1.02906 11.667 0 12.711 0 14V25.667C0 26.956 1.02906 28 2.30059 28H20.6994C21.97 28 23 26.956 23 25.667V14C23 12.711 21.97 11.667 20.6994 11.667H18.9745V7.583C18.9745 3.395 15.6281 0 11.5 0C7.37195 0 4.02554 3.395 4.02554 7.583Z",
        style: getColorStyle(color)
      });
    }
  },
  gift: {
    viewBox: '0 0 32 32',
    elements: function elements(_ref24) {
      var color = _ref24.color;
      return /*#__PURE__*/React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M30.5679 6.46736H23.408C23.8303 5.93124 24.1265 5.30692 24.2746 4.6407C24.4405 4.10302 24.4771 3.53376 24.3814 2.97926C24.2857 2.42477 24.0603 1.90072 23.7237 1.44979C23.3872 0.998851 22.9489 0.633777 22.4445 0.384289C21.9401 0.1348 21.384 0.00794973 20.8213 0.0140661C19.8911 0.0723011 18.9935 0.378845 18.222 0.901777C17.4505 1.42471 16.8333 2.14491 16.4347 2.98738C16.035 2.14301 15.4157 1.42157 14.6416 0.898502C13.8676 0.375439 12.9672 0.0699764 12.0347 0.0140661C11.472 0.00794973 10.9159 0.1348 10.4115 0.384289C9.90716 0.633777 9.46885 0.998851 9.13227 1.44979C8.7957 1.90072 8.57037 2.42477 8.47464 2.97926C8.37892 3.53376 8.41549 4.10302 8.5814 4.6407C8.7469 5.30838 9.05634 5.93181 9.48806 6.46736H1.48811C1.13449 6.46736 0.795354 6.60783 0.545307 6.85788C0.29526 7.10793 0.154785 7.44706 0.154785 7.80068L0.154785 15.8673C0.154785 16.2209 0.29526 16.5601 0.545307 16.8101C0.795354 17.0601 1.13449 17.2006 1.48811 17.2006H2.82143V30.6805C2.82143 31.0342 2.96191 31.3733 3.21196 31.6233C3.462 31.8734 3.80114 32.0139 4.15476 32.0139H27.8479C28.2016 32.0139 28.5407 31.8734 28.7907 31.6233C29.0408 31.3733 29.1813 31.0342 29.1813 30.6805V17.174H30.5146C30.8682 17.174 31.2073 17.0335 31.4574 16.7834C31.7074 16.5334 31.8479 16.1942 31.8479 15.8406V7.78735C31.8448 7.44509 31.7101 7.11715 31.4718 6.87143C31.2336 6.62571 30.9099 6.48103 30.5679 6.46736V6.46736ZM20.8213 2.68072C20.9566 2.67481 21.0915 2.6993 21.2161 2.75237C21.3407 2.80543 21.4518 2.88574 21.5413 2.98738C21.6382 3.1479 21.7002 3.32706 21.7232 3.51315C21.7461 3.69925 21.7296 3.8881 21.6746 4.06737C21.5701 4.44509 21.378 4.79284 21.1139 5.08242C20.8498 5.37199 20.5212 5.59523 20.1547 5.73403C19.4552 5.97346 18.743 6.17377 18.0213 6.33402C18.6213 3.69404 19.9013 2.68072 20.8213 2.68072ZM11.3147 2.98738C11.4036 2.88497 11.5146 2.80414 11.6393 2.75101C11.7641 2.69788 11.8993 2.67384 12.0347 2.68072C12.9547 2.68072 14.248 3.70738 14.9014 6.34736C14.184 6.18713 13.4763 5.98682 12.7814 5.74736C12.3918 5.61646 12.0418 5.38874 11.7642 5.08556C11.4867 4.78239 11.2907 4.41368 11.1947 4.01404C11.1435 3.84156 11.1277 3.6605 11.1484 3.48177C11.169 3.30304 11.2256 3.13033 11.3147 2.97405V2.98738ZM26.5146 29.3472H5.48808V17.174H26.5146V29.3472ZM29.2479 14.5073H2.82143V9.12067H11.9547L10.9814 9.74734C10.7466 9.90487 10.568 10.1329 10.4713 10.3986C10.3747 10.6643 10.365 10.9538 10.4436 11.2254C10.5223 11.497 10.6852 11.7365 10.9089 11.9094C11.1326 12.0823 11.4054 12.1796 11.688 12.1873C11.9351 12.1962 12.1798 12.1362 12.3947 12.014L16.3947 9.454L20.3947 12.014C20.5435 12.1138 20.7105 12.1833 20.8862 12.2186C21.0619 12.2538 21.2428 12.2541 21.4186 12.2194C21.5944 12.1848 21.7617 12.1158 21.9109 12.0165C22.06 11.9172 22.1882 11.7895 22.288 11.6407C22.3878 11.4918 22.4573 11.3248 22.4925 11.1491C22.5278 10.9734 22.5281 10.7925 22.4934 10.6167C22.4588 10.4409 22.3898 10.2736 22.2905 10.1244C22.1912 9.97528 22.0635 9.84714 21.9146 9.74734L20.928 9.12067H29.2479V14.5073Z",
        fill: "#7C1066",
        style: getColorStyle(color)
      });
    }
  },
  perks: {
    viewBox: '0 0 24 24',
    elements: function elements(_ref25) {
      var color = _ref25.color;
      return /*#__PURE__*/React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M23.383 0.436729C22.7516 -0.162802 21.7484 -0.142552 21.1422 0.48196L13.9538 8.19285L11.5757 5.84076C10.9568 5.22861 9.95339 5.22861 9.33449 5.84076C8.71558 6.4529 8.71558 7.44539 9.33449 8.05754L12.8563 11.5409C13.1575 11.8388 13.5672 12.0042 13.9931 11.9999C14.419 11.9956 14.8252 11.8219 15.1202 11.518L23.4288 2.65305C24.0349 2.02854 24.0144 1.03626 23.383 0.436729ZM18.9678 1.04769C18.5859 0.923539 18.1784 0.856433 17.7551 0.856433H9.91837C7.75431 0.856433 6 2.61075 6 4.7748V12.6115C6 14.7756 7.75431 16.5299 9.91837 16.5299H17.7551C19.9192 16.5299 21.6735 14.7756 21.6735 12.6115V5.99999L19.7143 8.09037V12.6115C19.7143 13.6936 18.8371 14.5707 17.7551 14.5707H9.91837C8.83634 14.5707 7.95918 13.6936 7.95918 12.6115V6.77598C7.95694 6.71467 7.95694 6.65329 7.95918 6.59198V4.7748C7.95918 3.69277 8.83634 2.81562 9.91837 2.81562H17.3196L18.9678 1.04769ZM4 7.99999H5V9.99999H4C2.89543 9.99999 2 10.8954 2 12V20C2 21.1046 2.89543 22 4 22H12C13.1046 22 14 21.1046 14 20V17.5315H16V20C16 22.2091 14.2091 24 12 24H4C1.79086 24 0 22.2091 0 20V12C0 9.79085 1.79086 7.99999 4 7.99999Z",
        fill: "black",
        style: getColorStyle(color)
      });
    }
  },
  phone: {
    viewBox: '0 0 24 25',
    elements: function elements(_ref26) {
      var color = _ref26.color;
      return /*#__PURE__*/React.createElement("g", {
        clipPath: "url(#clip0_6897_96799)"
      }, /*#__PURE__*/React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4.54492 4.24057C4.54492 2.59951 5.87527 1.26917 7.51633 1.26917H16.4836C18.1247 1.26917 19.4551 2.59951 19.4551 4.24057V21.5478C19.4551 23.1888 18.1247 24.5192 16.4836 24.5192H7.51633C5.87527 24.5192 4.54492 23.1888 4.54492 21.5478V4.24057ZM7.51633 2.7501C6.69316 2.7501 6.02586 3.41741 6.02586 4.24057V21.5478C6.02586 22.3709 6.69316 23.0382 7.51633 23.0382H16.4836C17.3068 23.0382 17.9741 22.3709 17.9741 21.5478V4.24057C17.9741 3.41741 17.3068 2.7501 16.4836 2.7501H7.51633ZM11.992 19.2297C11.3759 19.2297 10.8765 19.7291 10.8765 20.3451C10.8765 20.9612 11.3759 21.4606 11.992 21.4606H12.0072C12.6233 21.4606 13.1227 20.9612 13.1227 20.3451C13.1227 19.7291 12.6233 19.2297 12.0072 19.2297H11.992Z",
        fill: "black",
        style: getColorStyle(color)
      }));
    }
  },
  plan: {
    viewBox: '0 0 24 25',
    elements: function elements(_ref27) {
      var color = _ref27.color;
      return /*#__PURE__*/React.createElement("g", {
        clipPath: "url(#clip0_6897_96786)"
      }, /*#__PURE__*/React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.8669 3.29422C16.6362 4.20085 17.4272 5.08898 18.1961 5.95249C18.2319 5.99272 18.2677 6.0329 18.3034 6.07302C18.2989 10.4546 18.299 14.8365 18.2991 19.2169C18.2991 20.3088 18.2991 21.4007 18.2991 22.4924C14.1155 22.4938 8.12162 22.495 5.6969 22.4935C5.69635 20.2286 5.69647 17.9637 5.69658 15.6985C5.69663 14.759 5.69668 13.8196 5.69668 12.8799C5.69585 10.7809 5.69656 8.68283 5.69728 6.58465C5.69765 5.49102 5.69802 4.39709 5.69818 3.30246C5.88152 3.30254 6.07641 3.30263 6.28112 3.30272C9.08243 3.304 13.7255 3.3061 15.8669 3.29422ZM4.67833 24.8922C3.84801 24.8888 3.40524 24.4678 3.40501 23.6808C3.40406 21.0197 3.4042 18.3587 3.40433 15.6976C3.40438 14.7583 3.40443 13.8191 3.40443 12.8799C3.4036 10.7806 3.40431 8.68133 3.40503 6.58202C3.40551 5.1545 3.406 3.72697 3.406 2.29945C3.406 1.38939 3.8852 0.902151 4.63242 0.902151C5.03546 0.902151 5.60797 0.902411 6.28812 0.902721C9.09373 0.903996 13.731 0.906103 15.8616 0.894215C16.557 0.890302 17.0848 1.1151 17.5223 1.63155C18.2902 2.53866 19.082 3.42785 19.8737 4.31693C19.9633 4.41765 20.053 4.51836 20.1426 4.6191C20.451 4.96559 20.5959 5.34768 20.5959 5.80362C20.5911 10.2744 20.5913 14.7453 20.5914 19.2161C20.5914 20.7059 20.5914 22.1958 20.5913 23.6857C20.5913 24.4647 20.1415 24.8918 19.3117 24.8921C14.337 24.894 5.55107 24.8956 4.67833 24.8922Z",
        fill: "black",
        style: getColorStyle(color)
      }), /*#__PURE__*/React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.0973 2.79293L16.2481 2.97071C17.0123 3.87121 17.7985 4.7541 18.5673 5.61756L18.5695 5.61998L18.8036 5.88283L18.8034 6.07354C18.7989 10.4548 18.799 14.8364 18.7991 19.2169V22.9922L18.2993 22.9924C14.1157 22.9938 8.12159 22.995 5.69659 22.9935L5.19703 22.9932L5.1969 22.4936C5.19635 20.2287 5.19647 17.9638 5.19658 15.6986L5.19668 12.8801C5.19668 12.88 5.19668 12.8801 5.19668 12.8801C5.19585 10.781 5.19656 8.68256 5.19728 6.58448C5.19765 5.49104 5.19802 4.39676 5.19818 3.30239L5.19825 2.80226L6.28135 2.80272C6.28136 2.80272 6.28135 2.80272 6.28135 2.80272C9.08354 2.804 13.7247 2.8061 15.8641 2.79423L16.0973 2.79293ZM5.69668 12.8799L5.69658 15.6985C5.69647 17.9637 5.69635 20.2286 5.6969 22.4935C5.69727 22.4935 5.69764 22.4935 5.69801 22.4935C8.12344 22.495 14.1161 22.4938 18.2991 22.4924V19.2169C18.299 14.8365 18.2989 10.4546 18.3034 6.07302L18.192 5.94796C17.4244 5.08588 16.6349 4.19927 15.8669 3.29422C13.7255 3.3061 9.08243 3.304 6.28112 3.30272L5.69818 3.30246C5.69815 3.46914 5.69813 3.63581 5.69809 3.80246C5.69791 4.72953 5.69759 5.65614 5.69728 6.58254L5.69728 6.58465C5.69656 8.68283 5.69585 10.7809 5.69668 12.8799ZM3.40443 12.8799L3.40433 15.6976C3.4042 18.3586 3.40406 21.0197 3.40501 23.6808C3.40524 24.4678 3.84801 24.8888 4.67833 24.8922C5.55107 24.8956 14.337 24.894 19.3117 24.8921C20.1415 24.8918 20.5913 24.4647 20.5913 23.6857C20.5914 22.1958 20.5914 20.7059 20.5914 19.2161L20.5914 19.0272C20.5913 14.6194 20.5912 10.2115 20.5959 5.80362C20.5959 5.34768 20.451 4.96559 20.1426 4.6191L19.8737 4.31693C19.082 3.42785 18.2902 2.53866 17.5223 1.63155C17.0848 1.1151 16.557 0.890302 15.8616 0.894215C13.731 0.906103 9.09373 0.903996 6.28812 0.902721C5.60797 0.902411 5.03546 0.902151 4.63242 0.902151C3.8852 0.902151 3.406 1.38939 3.406 2.29945C3.406 3.72697 3.40551 5.15449 3.40503 6.58202C3.40431 8.68133 3.4036 10.7806 3.40443 12.8799ZM17.1409 1.95477C16.8068 1.56054 16.4245 1.39106 15.8644 1.39421C13.7323 1.4061 9.09437 1.404 6.28949 1.40272L6.2879 1.40272C5.60769 1.40241 5.03532 1.40215 4.63242 1.40215C4.37142 1.40215 4.21047 1.48372 4.10971 1.59505C4.00326 1.71267 3.906 1.92819 3.906 2.29945C3.906 3.72707 3.90551 5.15468 3.90503 6.58219C3.90431 8.68151 3.9036 10.7807 3.90443 12.8797L3.90433 15.6976C3.9042 18.3587 3.90406 21.0196 3.90501 23.6806C3.9051 23.9814 3.9877 24.135 4.07499 24.2181C4.16673 24.3053 4.34366 24.3908 4.68036 24.3922C5.55199 24.3956 14.3359 24.394 19.3115 24.3921C19.6457 24.392 19.8252 24.3063 19.9193 24.2174C20.0089 24.1328 20.0913 23.9791 20.0913 23.6857C20.0914 22.1958 20.0914 20.7059 20.0914 19.2161L20.0914 19.0273C20.0913 14.6195 20.0912 10.2113 20.0959 5.80309C20.0958 5.47076 19.9965 5.20693 19.7691 4.95155L19.5002 4.64944C18.7094 3.76131 17.9133 2.86729 17.1409 1.95477Z",
        fill: "white",
        style: getColorStyle(color)
      }), /*#__PURE__*/React.createElement("path", {
        d: "M14.8655 10.1942C14.8655 10.1942 14.8655 12.6004 14.8655 13.7941C15.4328 13.7941 15.9957 13.7941 16.5728 13.7941C16.5728 13.7026 16.5728 11.1023 16.5728 11.1023C16.5728 11.1023 16.6156 10.2018 15.7203 10.2018C15.3725 10.2018 14.8655 10.1942 14.8655 10.1942Z",
        fill: "black",
        style: getColorStyle(color)
      }), /*#__PURE__*/React.createElement("path", {
        d: "M7.12891 11.2363L7.13522 13.7941H8.81816V10.1988C8.81816 10.1988 9.07301 10.1942 8.09547 10.1942C7.11795 10.1942 7.12891 11.2363 7.12891 11.2363Z",
        fill: "black",
        style: getColorStyle(color)
      }), /*#__PURE__*/React.createElement("path", {
        d: "M8.8481 18.2942H7.13737C7.13737 18.2942 7.12891 20.5909 7.12891 21.0038C7.12891 21.4167 7.42646 21.8942 7.98851 21.8942H8.8481V18.2942Z",
        fill: "black",
        style: getColorStyle(color)
      }), /*#__PURE__*/React.createElement("path", {
        d: "M14.0058 21.8942C14.0058 20.6762 14.0058 19.4852 14.0058 18.2942C13.4188 18.2942 12.8507 18.2942 12.2866 18.2942C12.2866 19.5059 12.2866 20.6977 12.2866 21.8942C12.8681 21.8942 13.4317 21.8942 14.0058 21.8942Z",
        fill: "black",
        style: getColorStyle(color)
      }), /*#__PURE__*/React.createElement("path", {
        d: "M11.4272 18.2942C10.8436 18.2942 10.2783 18.2942 9.70801 18.2942C9.70801 19.5033 9.70801 20.6962 9.70801 21.8942C10.2888 21.8942 10.8532 21.8942 11.4272 21.8942C11.4272 20.6916 11.4272 19.504 11.4272 18.2942Z",
        fill: "black",
        style: getColorStyle(color)
      }), /*#__PURE__*/React.createElement("path", {
        d: "M14.0058 10.1942C13.4396 10.1942 12.8692 10.1942 12.2866 10.1942C12.2866 11.3927 12.2866 12.5866 12.2866 13.7941C12.8634 13.7941 13.4286 13.7941 14.0058 13.7941C14.0058 12.5911 14.0058 11.4029 14.0058 10.1942Z",
        fill: "black",
        style: getColorStyle(color)
      }), /*#__PURE__*/React.createElement("path", {
        d: "M9.70801 10.1942C9.70801 11.4086 9.70801 12.599 9.70801 13.7941C10.2933 13.7941 10.8605 13.7941 11.4272 13.7941C11.4272 12.5854 11.4272 11.3936 11.4272 10.1942C10.8504 10.1942 10.289 10.1942 9.70801 10.1942Z",
        fill: "black",
        style: getColorStyle(color)
      }), /*#__PURE__*/React.createElement("path", {
        d: "M14.8375 17.3925C14.8375 18.7491 14.8375 21.8897 14.8375 21.8897C14.8375 21.8897 15.0418 21.8942 15.7185 21.8942C16.3951 21.8942 16.5844 21.2388 16.5844 20.9988C16.5844 20.7588 16.5795 14.7886 16.5795 14.6932C13.4108 14.6932 10.275 14.6932 7.12891 14.6932C7.12891 15.4585 7.12891 16.6227 7.12891 17.3925C9.65138 17.3925 12.2959 17.3925 14.8375 17.3925Z",
        fill: "black",
        style: getColorStyle(color)
      }));
    }
  }
};

var styles$_ = {"flirt":"KDS_Icon-modules__flirt___dxG0P","mosque":"#016b6a","texas":"#f9f6a5","amaranth":"#ee2c74","cardinal-pink":"#8c0448","trinidad":"#df3d0c","chestnut":"#bc4850","onahau":"#c3efff","burnt-sienna":"#ed6358","chathams-blue":"#17367d","mid-blue":"#1a347d","well-read":"#b8373e","wattle":"#d5e04d","beeswax":"#feeec7","bilbao":"#258b0b","sea-buckthorn":"#fbaf34","mint-tulip":"#c1f2e8","turquoise":"#39cdc9","hibiscus":"#c53a70","carousel-pink":"#fae6f4","white":"KDS_Icon-modules__white___2P9Sn","black":"#000","mortar":"#595959","gallery":"#efefef","silver":"KDS_Icon-modules__silver___3n6Iw","dove":"#666666","iceberg":"#cbf0e8","icicle":"#e5f7fb","light-gray":"#fafafa","super-nova":"#fbaf33","expand-yellow":"#fee8b8","expand-yellow-light":"rgba(254, 232, 184, 0.5)","hero-pink":"#a6298c","icon":"KDS_Icon-modules__icon___3V2Eq","darkenOnHover":"KDS_Icon-modules__darkenOnHover___2yH5_","primary":"KDS_Icon-modules__primary___1EG3h","secondary":"KDS_Icon-modules__secondary___36BGC","error":"KDS_Icon-modules__error___30hih","success":"KDS_Icon-modules__success___1qFL5","info":"KDS_Icon-modules__info___8-leU"};

var _excluded$16 = ["symbol", "variant", "size", "darkenOnHover", "color"];
var Icon = function Icon(_ref) {
  var symbol = _ref.symbol,
    variant = _ref.variant,
    size = _ref.size,
    darkenOnHover = _ref.darkenOnHover,
    color = _ref.color,
    rest = _objectWithoutProperties$1(_ref, _excluded$16);
  if (!icons[symbol]) return null;
  var classes = joinClassNames(styles$_.icon, variant && styles$_[variant], darkenOnHover && styles$_.darkenOnHover);
  var style = color ? {
    fill: "var(--color-".concat(color, ")")
  } : {};
  var viewBox = icons[symbol].viewBox ? icons[symbol].viewBox : '0 0 24 24';

  // check the symbol for the `elements` key (i.e. SVG elements)
  var elements = icons[symbol].elements ? icons[symbol].elements({
    color: color
  }) : icons[symbol];
  return /*#__PURE__*/React.createElement("svg", _extends$1({
    className: classes
  }, safeRest(rest), {
    height: size,
    width: size,
    viewBox: viewBox,
    xmlns: "https://www.w3.org/2000/svg",
    style: style
  }), elements);
};
Icon.propTypes = {
  color: PropTypes.string,
  symbol: PropTypes.oneOf(['chevronUp', 'chevronRight', 'chevronDown', 'chevronLeft', 'chevronRightFilled', 'cart', 'circledLine', 'times', 'shipping', 'timesCircled', 'check', 'checkCircledFilled', 'checkCircledNotFilled', 'arrowDownCircled', 'exclamationTriangle', 'exclamationOctagon', 'informationCircled', 'boxOutline', 'boxOutlineChecked', 'radialOutline', 'radialOutlineChecked', 'hamburger', 'spyglass', 'refresh', 'bullet', 'kebab', 'eyeOpened', 'eyeClosed', 'tag', 'tagOutline', 'offerStar', 'info', 'infoSelected', 'infoHovered', 'profile', 'lock', 'gift', 'caution', 'perks', 'filledCart', 'phone', 'plan']).isRequired,
  variant: PropTypes.oneOf(['primary', 'secondary', 'success', 'error', 'info', 'black', 'white', 'silver', 'tag', 'flirt', 'cart', 'warning']),
  size: PropTypes.oneOf([12, 14, 16, 18, 24, 30, 40]),
  darkenOnHover: PropTypes.bool
};
Icon.defaultProps = {
  color: undefined,
  variant: undefined,
  size: 16,
  darkenOnHover: false
};

var _excluded$15 = ["symbol", "variant", "size", "color"];

/**
 * An icon used for visual aesthetics only.
 */
var DecorativeIcon = function DecorativeIcon(_ref) {
  var symbol = _ref.symbol,
    variant = _ref.variant,
    size = _ref.size,
    color = _ref.color,
    rest = _objectWithoutProperties$1(_ref, _excluded$15);
  return /*#__PURE__*/React.createElement(Icon, _extends$1({}, rest, {
    symbol: symbol,
    variant: variant,
    size: size,
    "aria-hidden": "true",
    color: color
  }));
};
DecorativeIcon.propTypes = {
  /**
   * Color string. Explicitly set the color.
   */
  color: PropTypes.string,
  /**
   * Name of the icon symbol.
   */
  symbol: PropTypes.oneOf(['chevronUp', 'chevronRight', 'chevronDown', 'chevronLeft', 'chevronRightFilled', 'cart', 'circledLine', 'times', 'shipping', 'timesCircled', 'check', 'checkCircledFilled', 'checkCircledNotFilled', 'arrowDownCircled', 'exclamationTriangle', 'exclamationOctagon', 'informationCircled', 'boxOutline', 'boxOutlineChecked', 'radialOutline', 'radialOutlineChecked', 'hamburger', 'spyglass', 'refresh', 'bullet', 'kebab', 'eyeOpened', 'eyeClosed', 'tag', 'tagOutline', 'offerStar', 'info', 'infoSelected', 'infoHovered', 'profile', 'lock', 'gift', 'caution', 'perks', 'filledCart', 'phone', 'plan']).isRequired,
  /**
   * The appearance of the Icon.
   */
  variant: PropTypes.oneOf(['primary', 'secondary', 'success', 'error', 'info', 'black', 'white', 'silver', 'tag', 'flirt', 'cart', 'warning']),
  /**
   * The icon size in pixels.
   */
  size: PropTypes.oneOf([12, 14, 16, 18, 24, 30, 40])
};
DecorativeIcon.defaultProps = {
  color: undefined,
  variant: undefined,
  size: 16
};

var styles$Z = {"item__icon":"KDS_SelectionIcon-modules__item__icon___3RMYH","item__icon--selected":"KDS_SelectionIcon-modules__item__icon--selected___1DRgK"};

var SelectionIcon = function SelectionIcon(_ref) {
  var desktop = _ref.desktop,
    hideCheckOnSelect = _ref.hideCheckOnSelect,
    open = _ref.open;
  var hideIcon = open && hideCheckOnSelect;
  return /*#__PURE__*/React.createElement("div", {
    className: joinClassNames(styles$Z.item__icon, styles$Z["item__icon".concat(open && desktop ? '--selected' : '')])
  }, desktop ? !hideIcon && /*#__PURE__*/React.createElement(DecorativeIcon, {
    symbol: open ? 'check' : 'chevronRight',
    size: 24
  }) : /*#__PURE__*/React.createElement(DecorativeIcon, {
    symbol: open ? 'chevronUp' : 'chevronDown',
    size: 24
  }));
};
SelectionIcon.propTypes = {
  desktop: PropTypes.bool.isRequired,
  hideCheckOnSelect: PropTypes.bool.isRequired,
  open: PropTypes.bool.isRequired
};

var typographyStyles = {"wordbreak":"KDS_Typography-modules__wordbreak___2hwoO"};

var spacingStyles = {"nospacing":"KDS_Spacing-modules__nospacing___11hAP"};

var styles$Y = {"leftAlign":"KDS_Paragraph-modules__leftAlign___2-gGS","centerAlign":"KDS_Paragraph-modules__centerAlign___l1hkp","rightAlign":"KDS_Paragraph-modules__rightAlign___3sjNQ"};

var styles$X = {"flirt":"#7c1366","mosque":"#016b6a","texas":"#f9f6a5","amaranth":"#ee2c74","cardinal-pink":"#8c0448","trinidad":"#df3d0c","chestnut":"#bc4850","onahau":"#c3efff","burnt-sienna":"#ed6358","chathams-blue":"#17367d","mid-blue":"#1a347d","well-read":"#b8373e","wattle":"#d5e04d","beeswax":"#feeec7","bilbao":"#258b0b","sea-buckthorn":"#fbaf34","mint-tulip":"#c1f2e8","turquoise":"#39cdc9","hibiscus":"#c53a70","carousel-pink":"#fae6f4","white":"#fff","black":"#000","mortar":"#595959","gallery":"#efefef","silver":"#c9c8c8","dove":"#666666","iceberg":"#cbf0e8","icicle":"#e5f7fb","light-gray":"#fafafa","super-nova":"#fbaf33","expand-yellow":"#fee8b8","expand-yellow-light":"rgba(254, 232, 184, 0.5)","hero-pink":"#a6298c","basesupsubscripts":"KDS_Text-modules__basesupsubscripts___3YKPl","sup":"KDS_Text-modules__sup___219VQ KDS_Text-modules__basesupsubscripts___3YKPl","base":"KDS_Text-modules__base___33Ovn KDS_Typography-modules__wordbreak___2hwoO","small":"KDS_Text-modules__small___1dBv2 KDS_Typography-modules__wordbreak___2hwoO","medium":"KDS_Text-modules__medium___1SwM7 KDS_Typography-modules__wordbreak___2hwoO","large":"KDS_Text-modules__large___2SjSx KDS_Typography-modules__wordbreak___2hwoO","boldFont":"KDS_Text-modules__boldFont___1MJn-","semiBoldFont":"KDS_Text-modules__semiBoldFont___t1fkw","mediumBoldFont":"KDS_Text-modules__mediumBoldFont___3SBrP","color":"KDS_Text-modules__color___Qi2FL","invertedColor":"KDS_Text-modules__invertedColor___2byCp","inheritColor":"KDS_Text-modules__inheritColor___2sk6H"};

var _excluded$14 = ["bold", "semiBold", "lightBold", "size", "align", "invert", "children", "color"];

/**
 * Block text as an HTML `<p>` element.
 */
var Paragraph$1 = function Paragraph(_ref) {
  var bold = _ref.bold,
    semiBold = _ref.semiBold,
    lightBold = _ref.lightBold,
    size = _ref.size,
    align = _ref.align,
    invert = _ref.invert,
    children = _ref.children,
    color = _ref.color,
    rest = _objectWithoutProperties$1(_ref, _excluded$14);
  var classes = joinClassNames(typographyStyles.wordBreak, spacingStyles.noSpacing, styles$X[size], invert ? styles$X.invertedColor : styles$X.color, semiBold ? styles$X.semiBoldFont : '', lightBold ? styles$X.mediumBoldFont : '', bold ? styles$X.boldFont : styles$X["".concat(size, "Font")], styles$Y["".concat(align, "Align")]);
  return /*#__PURE__*/React.createElement("p", _extends$1({}, safeRest(rest), {
    className: classes,
    style: {
      '--font-color': "var(--color-".concat(color, ")")
    }
  }), children);
};
Paragraph$1.propTypes = {
  /**
   * Embolden paragraph text without conveying any special importance or relevance.
   */
  bold: PropTypes.bool,
  /**
   * Lightly embolden text without conveying any special importance or relevance.
   */
  semiBold: PropTypes.bool,
  /**
   * Slightly embolden text without conveying any special importance or relevance.
   */
  lightBold: PropTypes.bool,
  /**
   * The font size.
   */
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  /**
   * Font color. Must be from the list of available [`Colours`](#section-colours).
   */
  color: PropTypes.string,
  /**
   * Content alignment.
   */
  align: PropTypes.oneOf(['left', 'center', 'right']),
  /**
   * Invert the text color to appear white on dark backgrounds.
   */
  invert: PropTypes.bool,
  /**
   * The content. Can be text, other components, or HTML elements.
   */
  children: PropTypes.node.isRequired
};
Paragraph$1.defaultProps = {
  color: 'font',
  bold: false,
  semiBold: false,
  lightBold: false,
  size: 'medium',
  align: 'left',
  invert: false
};

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf(subClass, superClass);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

function toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}

function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}

function _defineProperty(obj, key, value) {
  key = toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function getAugmentedNamespace(n) {
  if (n.__esModule) return n;
  var f = n.default;
	if (typeof f == "function") {
		var a = function a () {
			if (this instanceof a) {
        return Reflect.construct(f, arguments, this.constructor);
			}
			return f.apply(this, arguments);
		};
		a.prototype = f.prototype;
  } else a = {};
  Object.defineProperty(a, '__esModule', {value: true});
	Object.keys(n).forEach(function (k) {
		var d = Object.getOwnPropertyDescriptor(n, k);
		Object.defineProperty(a, k, d.get ? d : {
			enumerable: true,
			get: function () {
				return n[k];
			}
		});
	});
	return a;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var NODE_ENV = process.env.NODE_ENV;

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (NODE_ENV !== 'production') {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

var invariant_1 = invariant;

var invariant$1 = /*@__PURE__*/getDefaultExportFromCjs(invariant_1);

var camel2hyphen$1 = function (str) {
  return str
          .replace(/[A-Z]/g, function (match) {
            return '-' + match.toLowerCase();
          })
          .toLowerCase();
};

var camel2hyphen_1 = camel2hyphen$1;

var camel2hyphen = camel2hyphen_1;

var isDimension = function (feature) {
  var re = /[height|width]$/;
  return re.test(feature);
};

var obj2mq = function (obj) {
  var mq = '';
  var features = Object.keys(obj);
  features.forEach(function (feature, index) {
    var value = obj[feature];
    feature = camel2hyphen(feature);
    // Add px to dimension features
    if (isDimension(feature) && typeof value === 'number') {
      value = value + 'px';
    }
    if (value === true) {
      mq += feature;
    } else if (value === false) {
      mq += 'not ' + feature;
    } else {
      mq += '(' + feature + ': ' + value + ')';
    }
    if (index < features.length-1) {
      mq += ' and ';
    }
  });
  return mq;
};

var json2mq = function (query) {
  var mq = '';
  if (typeof query === 'string') {
    return query;
  }
  // Handling array of media queries
  if (query instanceof Array) {
    query.forEach(function (q, index) {
      mq += obj2mq(q);
      if (index < query.length-1) {
        mq += ', ';
      }
    });
    return mq;
  }
  // Handling single media query
  return obj2mq(query);
};

var json2mq_1 = json2mq;

var json2mq$1 = /*@__PURE__*/getDefaultExportFromCjs(json2mq_1);

var MediaQueryListener =
/*#__PURE__*/
function () {
  function MediaQueryListener(targetWindow, query, listener) {
    var _this = this;

    this.nativeMediaQueryList = targetWindow.matchMedia(query);
    this.active = true; // Safari doesn't clear up listener with removeListener
    // when the listener is already waiting in the event queue.
    // Having an active flag to make sure the listener is not called
    // after we removeListener.

    this.cancellableListener = function () {
      _this.matches = _this.nativeMediaQueryList.matches;

      if (_this.active) {
        listener.apply(void 0, arguments);
      }
    };

    this.nativeMediaQueryList.addListener(this.cancellableListener);
    this.matches = this.nativeMediaQueryList.matches;
  }

  var _proto = MediaQueryListener.prototype;

  _proto.cancel = function cancel() {
    this.active = false;
    this.nativeMediaQueryList.removeListener(this.cancellableListener);
  };

  return MediaQueryListener;
}();

var queryType = PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.arrayOf(PropTypes.object.isRequired)]);
/**
 * Conditionally renders based on whether or not a media query matches.
 */

var Media =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Media, _React$Component);

  function Media(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "queries", []);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getMatches", function () {
      var result = _this.queries.reduce(function (acc, _ref) {
        var _extends2;

        var name = _ref.name,
            mqListener = _ref.mqListener;
        return _extends({}, acc, (_extends2 = {}, _extends2[name] = mqListener.matches, _extends2));
      }, {}); // return result;


      return unwrapSingleQuery(result);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "updateMatches", function () {
      var newMatches = _this.getMatches();

      _this.setState(function () {
        return {
          matches: newMatches
        };
      }, _this.onChange);
    });

    !(!(!props.query && !props.queries) || props.query && props.queries) ? process.env.NODE_ENV !== "production" ? invariant$1(false, '<Media> must be supplied with either "query" or "queries"') : invariant$1(false) : void 0;
    !(props.defaultMatches === undefined || !props.query || typeof props.defaultMatches === "boolean") ? process.env.NODE_ENV !== "production" ? invariant$1(false, "<Media> when query is set, defaultMatches must be a boolean, received " + typeof props.defaultMatches) : invariant$1(false) : void 0;
    !(props.defaultMatches === undefined || !props.queries || typeof props.defaultMatches === "object") ? process.env.NODE_ENV !== "production" ? invariant$1(false, "<Media> when queries is set, defaultMatches must be a object of booleans, received " + typeof props.defaultMatches) : invariant$1(false) : void 0;

    if (typeof window !== "object") {
      // In case we're rendering on the server, apply the default matches
      var matches;

      if (props.defaultMatches !== undefined) {
        matches = props.defaultMatches;
      } else if (props.query) {
        matches = true;
      }
      /* if (props.queries) */
      else {
          matches = Object.keys(_this.props.queries).reduce(function (acc, key) {
            var _extends3;

            return _extends({}, acc, (_extends3 = {}, _extends3[key] = true, _extends3));
          }, {});
        }

      _this.state = {
        matches: matches
      };
      return _assertThisInitialized(_this);
    }

    _this.initialize(); // Instead of calling this.updateMatches, we manually set the initial state to prevent
    // calling setState, which could trigger an unnecessary second render


    _this.state = {
      matches: _this.props.defaultMatches !== undefined ? _this.props.defaultMatches : _this.getMatches()
    };

    _this.onChange();

    return _this;
  }

  var _proto = Media.prototype;

  _proto.initialize = function initialize() {
    var _this2 = this;

    var targetWindow = this.props.targetWindow || window;
    !(typeof targetWindow.matchMedia === "function") ? process.env.NODE_ENV !== "production" ? invariant$1(false, "<Media targetWindow> does not support `matchMedia`.") : invariant$1(false) : void 0;
    var queries = this.props.queries || wrapInQueryObject(this.props.query);
    this.queries = Object.keys(queries).map(function (name) {
      var query = queries[name];
      var qs = typeof query !== "string" ? json2mq$1(query) : query;
      var mqListener = new MediaQueryListener(targetWindow, qs, _this2.updateMatches);
      return {
        name: name,
        mqListener: mqListener
      };
    });
  };

  _proto.componentDidMount = function componentDidMount() {
    this.initialize(); // If props.defaultMatches has been set, ensure we trigger a two-pass render.
    // This is useful for SSR with mismatching defaultMatches vs actual matches from window.matchMedia
    // Details: https://github.com/ReactTraining/react-media/issues/81

    if (this.props.defaultMatches !== undefined) {
      this.updateMatches();
    }
  };

  _proto.onChange = function onChange() {
    var onChange = this.props.onChange;

    if (onChange) {
      onChange(this.state.matches);
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.queries.forEach(function (_ref2) {
      var mqListener = _ref2.mqListener;
      return mqListener.cancel();
    });
  };

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        render = _this$props.render;
    var matches = this.state.matches;
    var isAnyMatches = typeof matches === "object" ? Object.keys(matches).some(function (key) {
      return matches[key];
    }) : matches;
    return render ? isAnyMatches ? render(matches) : null : children ? typeof children === "function" ? children(matches) : !Array.isArray(children) || children.length // Preact defaults to empty children array
    ? isAnyMatches ? // We have to check whether child is a composite component or not to decide should we
    // provide `matches` as a prop or not
    React.Children.only(children) && typeof React.Children.only(children).type === "string" ? React.Children.only(children) : React.cloneElement(React.Children.only(children), {
      matches: matches
    }) : null : null : null;
  };

  return Media;
}(React.Component);
/**
 * Wraps a single query in an object. This is used to provide backward compatibility with
 * the old `query` prop (as opposed to `queries`). If only a single query is passed, the object
 * will be unpacked down the line, but this allows our internals to assume an object of queries
 * at all times.
 */


_defineProperty(Media, "propTypes", {
  defaultMatches: PropTypes.oneOfType([PropTypes.bool, PropTypes.objectOf(PropTypes.bool)]),
  query: queryType,
  queries: PropTypes.objectOf(queryType),
  render: PropTypes.func,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  targetWindow: PropTypes.object,
  onChange: PropTypes.func
});

function wrapInQueryObject(query) {
  return {
    __DEFAULT__: query
  };
}
/**
 * Unwraps an object of queries, if it was originally passed as a single query.
 */


function unwrapSingleQuery(queryObject) {
  var queryNames = Object.keys(queryObject);

  if (queryNames.length === 1 && queryNames[0] === "__DEFAULT__") {
    return queryObject.__DEFAULT__;
  }

  return queryObject;
}

var breakpoints$1 = {"xsUpper":"576px","smUpper":"768px","mdUpper":"992px","lgUpper":"1200px","smLower":"576px","mdLower":"768px","lgLower":"992px","xlLower":"1200px"};

var styles$W = {"min-sm":"KDS_Responsive-modules__min-sm___of2jz","max-sm":"KDS_Responsive-modules__max-sm___17U4k","min-md":"KDS_Responsive-modules__min-md___2PsfH","max-md":"KDS_Responsive-modules__max-md___3SUsN","min-lg":"KDS_Responsive-modules__min-lg___3aKSi","max-lg":"KDS_Responsive-modules__max-lg___1PpK1","min-xl":"KDS_Responsive-modules__min-xl___30ofe","max-xl":"KDS_Responsive-modules__max-xl___ywEq8"};

var _excluded$13 = ["minWidth", "maxWidth", "query", "children", "useCssMediaQueries"];
var _getBreakpoints$1 = getBreakpoints(breakpoints$1),
  sm = _getBreakpoints$1.sm.lower,
  md = _getBreakpoints$1.md.lower,
  lg = _getBreakpoints$1.lg.lower,
  xl = _getBreakpoints$1.xl.lower;
var breakpoints = {
  sm: sm,
  md: md,
  lg: lg,
  xl: xl
};

/**
 * Respond to device features, most commonly the browser viewport size.
 */
var Responsive = function Responsive(_ref) {
  var minWidth = _ref.minWidth,
    maxWidth = _ref.maxWidth,
    query = _ref.query,
    children = _ref.children,
    useCssMediaQueries = _ref.useCssMediaQueries,
    rest = _objectWithoutProperties$1(_ref, _excluded$13);
  if (!minWidth && !maxWidth) {
    warn('Responsive', 'Responsive needs a minWidth or maxWith prop');
  }

  /* This option uses the browser's built-in CSS media queries instead of JavaScript.
   */

  if (useCssMediaQueries) {
    var minSelector = styles$W["min-".concat(minWidth)] || '';
    var maxSelector = styles$W["max-".concat(maxWidth)] || '';
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "".concat(minSelector, " ").concat(maxSelector)
    }, children(true)), /*#__PURE__*/React.createElement("div", null, children(false)));
  }

  /** Do it this way to not create an object where some keys have the value "undefined",
   * which causes the generated media-query to be invalid.
   * (min-width: 300px) and (max-width: undefined) is bad :(
   * (min-width: 300px) is good :)
   */

  var mediaQuery = {};
  if (minWidth) {
    mediaQuery.minWidth = breakpoints[minWidth];
  }
  if (maxWidth) {
    mediaQuery.maxWidth = breakpoints[maxWidth] - 1;
  }
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isMobile = _useState2[0],
    setIsMobile = _useState2[1];
  useEffect(function () {
    if (window.innerWidth < mediaQuery.minWidth) {
      setIsMobile(true);
    }
  }, [mediaQuery.minWidth]);
  return /*#__PURE__*/React.createElement(Media, _extends$1({}, rest, {
    query: _objectSpread2(_objectSpread2({}, mediaQuery), query),
    key: isMobile
  }), children);
};
Responsive.propTypes = {
  /**
   * Set a min-width media query.
   */
  minWidth: PropTypes.oneOf(['sm', 'md', 'lg', 'xl']),
  /**
   * Set a max-width media query.
   */
  maxWidth: PropTypes.oneOf(['sm', 'md', 'lg', 'xl']),
  /**
   * An object containing any valid CSS media query characteristics. It will be
   * converted to a CSS media query.
   * Use `query` if you need characteristics other than `minWidth` and `maxWidth`.
   *
   * Any `minWidth` or `maxWidth` values here will override the props by the same name.
   */
  query: PropTypes.object,
  /**
   * The content. Can be text, any HTML element, a function, or any component.
   */
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  /**
   * Use the browser's built-in CSS media queries instead of JavaScript.
   */
  useCssMediaQueries: PropTypes.bool
};
Responsive.defaultProps = {
  minWidth: undefined,
  maxWidth: undefined,
  query: {},
  children: undefined,
  useCssMediaQueries: false
};

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  for (var key in source) {
    if (Object.prototype.hasOwnProperty.call(source, key)) {
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }
  }
  return target;
}

var config = {
  disabled: false
};

var timeoutsShape = process.env.NODE_ENV !== 'production' ? PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
  enter: PropTypes.number,
  exit: PropTypes.number,
  appear: PropTypes.number
}).isRequired]) : null;
process.env.NODE_ENV !== 'production' ? PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
  enter: PropTypes.string,
  exit: PropTypes.string,
  active: PropTypes.string
}), PropTypes.shape({
  enter: PropTypes.string,
  enterDone: PropTypes.string,
  enterActive: PropTypes.string,
  exit: PropTypes.string,
  exitDone: PropTypes.string,
  exitActive: PropTypes.string
})]) : null;

var TransitionGroupContext = React.createContext(null);

var forceReflow = function forceReflow(node) {
  return node.scrollTop;
};

var UNMOUNTED = 'unmounted';
var EXITED = 'exited';
var ENTERING = 'entering';
var ENTERED = 'entered';
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

var Transition = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  } // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }
  ;

  var _proto = Transition.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      if (nextStatus === ENTERING) {
        if (this.props.unmountOnExit || this.props.mountOnEnter) {
          var node = this.props.nodeRef ? this.props.nodeRef.current : ReactDOM.findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
          // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
          // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.

          if (node) forceReflow(node);
        }

        this.performEnter(mounting);
      } else {
        this.performExit();
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context ? this.context.isMounting : mounting;

    var _ref2 = this.props.nodeRef ? [appearing] : [ReactDOM.findDOMNode(this), appearing],
        maybeNode = _ref2[0],
        maybeAppearing = _ref2[1];

    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter || config.disabled) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(maybeNode);
      });
      return;
    }

    this.props.onEnter(maybeNode, maybeAppearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(maybeNode, maybeAppearing);

      _this2.onTransitionEnd(enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(maybeNode, maybeAppearing);
        });
      });
    });
  };

  _proto.performExit = function performExit() {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts();
    var maybeNode = this.props.nodeRef ? undefined : ReactDOM.findDOMNode(this); // no exit animation skip right to EXITED

    if (!exit || config.disabled) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(maybeNode);
      });
      return;
    }

    this.props.onExit(maybeNode);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(maybeNode);

      _this3.onTransitionEnd(timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(maybeNode);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
    this.setNextCallback(handler);
    var node = this.props.nodeRef ? this.props.nodeRef.current : ReactDOM.findDOMNode(this);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }

    if (this.props.addEndListener) {
      var _ref3 = this.props.nodeRef ? [this.nextCallback] : [node, this.nextCallback],
          maybeNode = _ref3[0],
          maybeNextCallback = _ref3[1];

      this.props.addEndListener(maybeNode, maybeNextCallback);
    }

    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children;
        _this$props.in;
        _this$props.mountOnEnter;
        _this$props.unmountOnExit;
        _this$props.appear;
        _this$props.enter;
        _this$props.exit;
        _this$props.timeout;
        _this$props.addEndListener;
        _this$props.onEnter;
        _this$props.onEntering;
        _this$props.onEntered;
        _this$props.onExit;
        _this$props.onExiting;
        _this$props.onExited;
        _this$props.nodeRef;
        var childProps = _objectWithoutPropertiesLoose(_this$props, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);

    return (
      /*#__PURE__*/
      // allows for nested Transitions
      React.createElement(TransitionGroupContext.Provider, {
        value: null
      }, typeof children === 'function' ? children(status, childProps) : React.cloneElement(React.Children.only(children), childProps))
    );
  };

  return Transition;
}(React.Component);

Transition.contextType = TransitionGroupContext;
Transition.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A React reference to DOM element that need to transition:
   * https://stackoverflow.com/a/51127130/4671932
   *
   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
   *      (e.g. `onEnter`) because user already has direct access to the node.
   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
   *     (see
   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
   */
  nodeRef: PropTypes.shape({
    current: typeof Element === 'undefined' ? PropTypes.any : function (propValue, key, componentName, location, propFullName, secret) {
      var value = propValue[key];
      return PropTypes.instanceOf(value && 'ownerDocument' in value ? value.ownerDocument.defaultView.Element : Element)(propValue, key, componentName, location, propFullName, secret);
    }
  }),

  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,

  /**
   * By default the child component does not perform the enter transition when
   * it first mounts, regardless of the value of `in`. If you want this
   * behavior, set both `appear` and `in` to `true`.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */
  appear: PropTypes.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function timeout(props) {
    var pt = timeoutsShape;
    if (!props.addEndListener) pt = pt.isRequired;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return pt.apply(void 0, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. Timeouts are still used as a fallback if provided.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func
} : {}; // Name the function so it is clearer in the documentation

function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = UNMOUNTED;
Transition.EXITED = EXITED;
Transition.ENTERING = ENTERING;
Transition.ENTERED = ENTERED;
Transition.EXITING = EXITING;
var Transition$1 = Transition;

var _excluded$12 = ["height", "width", "children"];
var defaultStyle$2 = function defaultStyle(duration, timeout, width) {
  return {
    transition: "height ".concat(duration || timeout, "ms"),
    height: 0,
    width: width !== null && width !== void 0 ? width : 'auto'
  };
};
var hiddenContent = {
  visibility: 'hidden',
  overflow: 'hidden'
};
var transitionStyles$2 = function transitionStyles(height) {
  var styles = {
    height: "".concat(height, "px"),
    overflow: 'hidden'
  };
  return {
    entering: styles,
    entered: {
      height: 'auto'
    },
    exiting: styles,
    exited: hiddenContent
  };
};
var Reveal = function Reveal(_ref) {
  var height = _ref.height,
    width = _ref.width,
    children = _ref.children,
    rest = _objectWithoutProperties$1(_ref, _excluded$12);
  return /*#__PURE__*/React.createElement(Transition$1, rest, function (status) {
    return /*#__PURE__*/React.createElement("div", {
      style: _objectSpread2(_objectSpread2({}, defaultStyle$2(rest.duration, rest.timeout, width)), transitionStyles$2(height)[status]),
      "aria-hidden": status === 'exited',
      "data-testid": "childrenContainer"
    }, children());
  });
};
Reveal.propTypes = {
  timeout: PropTypes.number.isRequired,
  duration: PropTypes.number,
  width: PropTypes.string,
  height: PropTypes.number.isRequired,
  children: PropTypes.func.isRequired
};
Reveal.defaultProps = {
  duration: undefined,
  width: undefined
};

var styles$V = {"flirt":"#7c1366","mosque":"#016b6a","texas":"#f9f6a5","amaranth":"#ee2c74","cardinal-pink":"#8c0448","trinidad":"#df3d0c","chestnut":"#bc4850","onahau":"#c3efff","burnt-sienna":"#ed6358","chathams-blue":"#17367d","mid-blue":"#1a347d","well-read":"#b8373e","wattle":"#d5e04d","beeswax":"#feeec7","bilbao":"#258b0b","sea-buckthorn":"#fbaf34","mint-tulip":"#c1f2e8","turquoise":"#39cdc9","hibiscus":"#c53a70","carousel-pink":"#fae6f4","white":"#fff","black":"#000","mortar":"#595959","gallery":"#efefef","silver":"#c9c8c8","dove":"#666666","iceberg":"#cbf0e8","icicle":"#e5f7fb","light-gray":"#fafafa","super-nova":"#fbaf33","expand-yellow":"#fee8b8","expand-yellow-light":"rgba(254, 232, 184, 0.5)","hero-pink":"#a6298c","feature":"KDS_Feature-modules__feature___1Hu3m","fade":"KDS_Feature-modules__fade___3_zgh","fadein":"KDS_Feature-modules__fadein___bYUqD","default":"KDS_Feature-modules__default___3tfe5"};

var Feature = function Feature(_ref) {
  var children = _ref.children,
    featureRef = _ref.featureRef,
    fade = _ref.fade,
    isDefault = _ref.isDefault;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(styles$V.feature, "  ").concat(isDefault ? styles$V["default"] : '', " ").concat(fade ? styles$V.fade : ''),
    ref: featureRef
  }, children);
};
Feature.propTypes = {
  children: PropTypes.node,
  featureRef: PropTypes.object,
  isDefault: PropTypes.bool,
  fade: PropTypes.bool
};
Feature.defaultProps = {
  children: undefined,
  featureRef: undefined,
  isDefault: false,
  fade: false
};

var styles$U = {"flirt":"#7c1366","mosque":"#016b6a","texas":"#f9f6a5","amaranth":"#ee2c74","cardinal-pink":"#8c0448","trinidad":"#df3d0c","chestnut":"#bc4850","onahau":"#c3efff","burnt-sienna":"#ed6358","chathams-blue":"#17367d","mid-blue":"#1a347d","well-read":"#b8373e","wattle":"#d5e04d","beeswax":"#feeec7","bilbao":"#258b0b","sea-buckthorn":"#fbaf34","mint-tulip":"#c1f2e8","turquoise":"#39cdc9","hibiscus":"#c53a70","carousel-pink":"#fae6f4","white":"#fff","black":"#000","mortar":"#595959","gallery":"#efefef","silver":"#c9c8c8","dove":"#666666","iceberg":"#cbf0e8","icicle":"#e5f7fb","light-gray":"#fafafa","super-nova":"#fbaf33","expand-yellow":"#fee8b8","expand-yellow-light":"rgba(254, 232, 184, 0.5)","hero-pink":"#a6298c","featuresPanel__wrapper":"KDS_FeaturesPanel-modules__featuresPanel__wrapper___1MWZ-","featuresPanel__wrapper--open":"KDS_FeaturesPanel-modules__featuresPanel__wrapper--open___101zp"};

var FeaturesPanel = function FeaturesPanel(_ref) {
  var isDefault = _ref.isDefault,
    selectedFeature = _ref.selectedFeature,
    open = _ref.open,
    fade = _ref.fade,
    theme = _ref.theme,
    desktop = _ref.desktop,
    defaultBorderColor = _ref.defaultBorderColor;
  var featureRef = useRef();
  return /*#__PURE__*/React.createElement("div", {
    className: joinClassNames(styles$U.featuresPanel__wrapper, !desktop ? styles$U["featuresPanel__wrapper".concat(open ? '--open' : '')] : ''),
    style: desktop ? {
      '--featurePanel-border': "var(--color-".concat(getThemeColors(theme, defaultBorderColor).bgActive, ")")
    } : {}
  }, desktop ? /*#__PURE__*/React.createElement(Feature, {
    fade: fade,
    featureRef: featureRef,
    isDefault: isDefault
  }, selectedFeature && /*#__PURE__*/cloneElement(selectedFeature, {
    open: open
  })) : /*#__PURE__*/React.createElement(Reveal, {
    timeout: open ? 500 : 0,
    duration: 700,
    "in": open,
    height: featureRef.current ? featureRef.current.offsetHeight : 0,
    width: "100%"
  }, function () {
    return /*#__PURE__*/React.createElement(Feature, {
      fade: fade,
      featureRef: featureRef
    }, selectedFeature && /*#__PURE__*/cloneElement(selectedFeature, {
      open: open
    }));
  }));
};
FeaturesPanel.propTypes = {
  /** Used to determine if this is the default feature */
  isDefault: PropTypes.bool,
  /** The node containing the features to be displayed in the right panel */
  selectedFeature: PropTypes.node,
  /** Used to determine open panels for mobile accordions */
  open: PropTypes.bool,
  /** Used to activate fading effect on desktop panel feature */
  fade: PropTypes.bool,
  /** Color options for the panels. */
  theme: PropTypes.oneOf(['yellow', 'blue', 'green', 'yellowGreen', 'purple', 'pink', 'default']),
  /** Determines if mobile or desktop version being rendered. */
  desktop: PropTypes.bool.isRequired,
  /** Sets the border color for the default feature. */
  defaultBorderColor: PropTypes.string
};
FeaturesPanel.defaultProps = {
  isDefault: false,
  open: false,
  fade: false,
  selectedFeature: undefined,
  theme: 'yellow',
  defaultBorderColor: undefined
};

var styles$T = {"flirt":"#7c1366","mosque":"#016b6a","texas":"#f9f6a5","amaranth":"#ee2c74","cardinal-pink":"#8c0448","trinidad":"#df3d0c","chestnut":"#bc4850","onahau":"#c3efff","burnt-sienna":"#ed6358","chathams-blue":"#17367d","mid-blue":"#1a347d","well-read":"#b8373e","wattle":"#d5e04d","beeswax":"#feeec7","bilbao":"#258b0b","sea-buckthorn":"#fbaf34","mint-tulip":"#c1f2e8","turquoise":"#39cdc9","hibiscus":"#c53a70","carousel-pink":"#fae6f4","white":"#fff","black":"#000","mortar":"#595959","gallery":"#efefef","silver":"#c9c8c8","dove":"#666666","iceberg":"#cbf0e8","icicle":"#e5f7fb","light-gray":"#fafafa","super-nova":"#fbaf33","expand-yellow":"#fee8b8","expand-yellow-light":"rgba(254, 232, 184, 0.5)","hero-pink":"#a6298c","promoTag":"KDS_PromotionTag-modules__promoTag___193ZE","greenPromo":"KDS_PromotionTag-modules__greenPromo___288Ql"};

var PromotionTag = function PromotionTag(_ref) {
  var children = _ref.children,
    theme = _ref.theme;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(styles$T.promoTag, " ").concat(theme === 'yellow' || theme === 'purple' ? styles$T.greenPromo : '')
  }, children);
};
PromotionTag.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.string]).isRequired,
  theme: PropTypes.string
};
PromotionTag.defaultProps = {
  theme: undefined
};

var styles$S = {"flirt":"#7c1366","mosque":"#016b6a","texas":"#f9f6a5","amaranth":"#ee2c74","cardinal-pink":"#8c0448","trinidad":"#df3d0c","chestnut":"#bc4850","onahau":"#c3efff","burnt-sienna":"#ed6358","chathams-blue":"#17367d","mid-blue":"#1a347d","well-read":"#b8373e","wattle":"#d5e04d","beeswax":"#feeec7","bilbao":"#258b0b","sea-buckthorn":"#fbaf34","mint-tulip":"#c1f2e8","turquoise":"#39cdc9","hibiscus":"#c53a70","carousel-pink":"#fae6f4","white":"#fff","black":"#000","mortar":"#595959","gallery":"#efefef","silver":"#c9c8c8","dove":"#666666","iceberg":"#cbf0e8","icicle":"#e5f7fb","light-gray":"#fafafa","super-nova":"#fbaf33","expand-yellow":"#fee8b8","expand-yellow-light":"rgba(254, 232, 184, 0.5)","hero-pink":"#a6298c","buttonFocus":"KDS_Item-modules__buttonFocus___13sXG","item__button":"KDS_Item-modules__item__button___In_p4","item__button--open":"KDS_Item-modules__item__button--open___zXNUA","selectedTriangle":"KDS_Item-modules__selectedTriangle___3mO83","item__bonus--selected-withIcon":"KDS_Item-modules__item__bonus--selected-withIcon___2Qp8B","item__wrapper--showTriangle":"KDS_Item-modules__item__wrapper--showTriangle___1-Scs","item":"KDS_Item-modules__item___1fILq","item__wrapper":"KDS_Item-modules__item__wrapper___1OssS","item__wrapper--hover":"KDS_Item-modules__item__wrapper--hover___10TpD","item__highlights":"KDS_Item-modules__item__highlights___3blvQ","item__highlights--bonus":"KDS_Item-modules__item__highlights--bonus___2ji-B","item__content":"KDS_Item-modules__item__content___1WgQW","item__bonus":"KDS_Item-modules__item__bonus___Dv3tg","item__bonus--icon-spacer":"KDS_Item-modules__item__bonus--icon-spacer___2C41A","item__bonus--selected":"KDS_Item-modules__item__bonus--selected___3Sv0J","item__promoText":"KDS_Item-modules__item__promoText___NRZZ1","item__promoText--selected":"KDS_Item-modules__item__promoText--selected___3xm9O","selected":"KDS_Item-modules__selected___1pLYN","children__wrapper":"KDS_Item-modules__children__wrapper___3a1Xn","itemPanelWrapper":"KDS_Item-modules__itemPanelWrapper___2YwnL"};

var _excluded$11 = ["children", "bonusText", "theme", "features", "id", "promoTag", "ariaLabelledBy", "hideCheckOnSelect", "iconAtBottom", "promoText", "nestedButton"];

/**
 * This is a single Item to be displayed in the AccordionList.
 *
 * _This component can only be accessed as a name-spaced component: `AccordionList.Item` and must be a child of `AccordionList`._
 */

var Item = function Item(_ref) {
  var children = _ref.children,
    bonusText = _ref.bonusText,
    theme = _ref.theme,
    features = _ref.features,
    id = _ref.id,
    promoTag = _ref.promoTag,
    ariaLabelledBy = _ref.ariaLabelledBy,
    hideCheckOnSelect = _ref.hideCheckOnSelect,
    iconAtBottom = _ref.iconAtBottom,
    promoText = _ref.promoText,
    nestedButton = _ref.nestedButton,
    rest = _objectWithoutProperties$1(_ref, _excluded$11);
  var handleOnClickItem = rest.handleOnClickItem,
    openPanels = rest.openPanels,
    fade = rest.fade,
    _onClick = rest.onClick;
  var open = openPanels.includes(id);
  return /*#__PURE__*/React.createElement(Responsive, {
    minWidth: "md"
  }, function (desktop) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: styles$S.item,
      id: id
    }, /*#__PURE__*/React.createElement(Clickable, {
      onClick: function onClick(e) {
        handleOnClickItem(id, desktop);
        _onClick(e);
      },
      "aria-labelledby": ariaLabelledBy,
      "aria-label": open ? 'Open' : 'Closed',
      dangerouslyAddClassName: open ? styles$S['item__button--open'] : styles$S.item__button,
      "aria-expanded": open
    }, /*#__PURE__*/React.createElement("div", {
      className: joinClassNames(styles$S.item__wrapper, styles$S["item__wrapper".concat(open && !iconAtBottom ? '--showTriangle' : '')], open ? "".concat(styles$S.selected) : "".concat(styles$S['item__wrapper--hover'])),
      style: {
        '--inactive-background': "var(--color-".concat(getThemeColors(theme).bgInactive, ")"),
        '--active-background': "var(--color-".concat(getThemeColors(theme).bgActive, ")"),
        '--active-text': "var(--color-".concat(getThemeColors(theme).textActive, ")"),
        '--inactive-text': "var(--color-".concat(getThemeColors(theme).textInactive, ")"),
        '--border-radius': promoText ? '8px 8px 0 0' : '8px',
        '--border-radius-selected': promoText ? '8px 0 0 0' : '8px 0 0 8px',
        '--bonus-inactive': getThemeColors(theme).svgBonusInactive
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: joinClassNames(styles$S.item__highlights, styles$S["item__highlights".concat(bonusText ? '--bonus' : '')], styles$S["item__highlights".concat(open ? '--selected' : '')]),
      style: {
        '--button-text': "var(--color-".concat(getThemeColors(theme).bgActive, ")")
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$S.children__wrapper
    }, children), !iconAtBottom && /*#__PURE__*/React.createElement(SelectionIcon, {
      desktop: desktop,
      hideCheckOnSelect: hideCheckOnSelect,
      open: open
    })), bonusText && /*#__PURE__*/React.createElement("div", {
      className: joinClassNames(styles$S.item__bonus, styles$S["item__bonus".concat(open ? '--selected' : '')], styles$S["item__bonus".concat(open && iconAtBottom ? '--selected-withIcon' : '')])
    }, typeof bonusText === 'string' ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Paragraph$1, {
      bold: true
    }, bonusText)) : bonusText, iconAtBottom && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: styles$S['item__bonus--icon-spacer']
    }), /*#__PURE__*/React.createElement(SelectionIcon, {
      desktop: desktop,
      hideCheckOnSelect: true,
      open: open
    })))), promoText && /*#__PURE__*/React.createElement("div", {
      className: joinClassNames(styles$S.item__promoText, open ? "".concat(styles$S['item__promoText--selected']) : '')
    }, typeof promoText === 'string' ? /*#__PURE__*/React.createElement(Paragraph$1, {
      bold: true
    }, promoText) : promoText)), promoTag && /*#__PURE__*/React.createElement(PromotionTag, {
      theme: theme
    }, promoTag), nestedButton), desktop && open && /*#__PURE__*/React.createElement("div", {
      className: styles$S.itemPanelWrapper
    }, /*#__PURE__*/React.createElement(FeaturesPanel, {
      desktop: desktop,
      selectedFeature: features,
      theme: theme,
      fade: fade,
      open: open
    })), !desktop && /*#__PURE__*/React.createElement(FeaturesPanel, {
      desktop: desktop,
      selectedFeature: features,
      open: open
    }));
  });
};
Item.propTypes = {
  /** Content to be displayed. Can be `AccordionList.Item`, other React components, text or HTML elements. */
  children: PropTypes.node.isRequired,
  /** Any bonus text to be applied at the bottom of the Item */
  bonusText: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  /** Color options for the panels. */
  theme: PropTypes.oneOf(['yellow', 'blue', 'green', 'yellowGreen', 'purple', 'pink']),
  /** Determines if a promotion tag will be rendered. */
  promoTag: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  /** Id for the item. This is required for opening and closing functionality. */
  id: PropTypes.string.isRequired,
  /** Content to be displayed in the accordion panel (mobile) or right panel (desktop) */
  features: PropTypes.node.isRequired,
  /** onClick event handler */
  onClick: PropTypes.func,
  /** accessibility items for the button */
  ariaLabelledBy: PropTypes.string,
  /** used to hide the checkmark that appears in place of the chevron when selected */
  hideCheckOnSelect: PropTypes.bool,
  /** renders the chevron in the bonus section */
  iconAtBottom: PropTypes.bool,
  /** Determines if a promotional section is rendered at the bottom of the item. */
  promoText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  //* * Button to be nested within the Clickable element */
  nestedButton: PropTypes.node
};
Item.defaultProps = {
  bonusText: undefined,
  theme: 'yellow',
  promoTag: undefined,
  ariaLabelledBy: undefined,
  onClick: function onClick() {},
  hideCheckOnSelect: false,
  iconAtBottom: false,
  promoText: undefined
};

var lib = {};

var Row$3 = {};

var classNames$1 = {};

var flexboxgrid2 = {"container":"KDS_flexboxgrid2__container___3skQK","container-fluid":"KDS_flexboxgrid2__container-fluid___XKLhm","row":"KDS_flexboxgrid2__row___ZtOZv","reverse":"KDS_flexboxgrid2__reverse___3oCGT","col":"KDS_flexboxgrid2__col___2Z6TW","col-xs":"KDS_flexboxgrid2__col-xs___2PLFU","col-xs-1":"KDS_flexboxgrid2__col-xs-1___1ys2K","col-xs-2":"KDS_flexboxgrid2__col-xs-2___1oFs0","col-xs-3":"KDS_flexboxgrid2__col-xs-3___1Q5cW","col-xs-4":"KDS_flexboxgrid2__col-xs-4___3pHqi","col-xs-5":"KDS_flexboxgrid2__col-xs-5___3JeAf","col-xs-6":"KDS_flexboxgrid2__col-xs-6___1Zplx","col-xs-7":"KDS_flexboxgrid2__col-xs-7___2rjoo","col-xs-8":"KDS_flexboxgrid2__col-xs-8___3Pbgu","col-xs-9":"KDS_flexboxgrid2__col-xs-9___zDP7a","col-xs-10":"KDS_flexboxgrid2__col-xs-10___Zo7_E","col-xs-11":"KDS_flexboxgrid2__col-xs-11___mXqV2","col-xs-12":"KDS_flexboxgrid2__col-xs-12___AdoKE","col-xs-offset-0":"KDS_flexboxgrid2__col-xs-offset-0___3NAsN","col-xs-offset-1":"KDS_flexboxgrid2__col-xs-offset-1___3K_gC","col-xs-offset-2":"KDS_flexboxgrid2__col-xs-offset-2___2Ga73","col-xs-offset-3":"KDS_flexboxgrid2__col-xs-offset-3___3c_Ft","col-xs-offset-4":"KDS_flexboxgrid2__col-xs-offset-4___3TWUy","col-xs-offset-5":"KDS_flexboxgrid2__col-xs-offset-5___1yWoT","col-xs-offset-6":"KDS_flexboxgrid2__col-xs-offset-6___al_7H","col-xs-offset-7":"KDS_flexboxgrid2__col-xs-offset-7___2J_G7","col-xs-offset-8":"KDS_flexboxgrid2__col-xs-offset-8___1RGyW","col-xs-offset-9":"KDS_flexboxgrid2__col-xs-offset-9___3OtIT","col-xs-offset-10":"KDS_flexboxgrid2__col-xs-offset-10___109SK","col-xs-offset-11":"KDS_flexboxgrid2__col-xs-offset-11___1fcLq","col-xs-offset-12":"KDS_flexboxgrid2__col-xs-offset-12___3UGEQ","col-sm":"KDS_flexboxgrid2__col-sm___3UNLq","col-sm-1":"KDS_flexboxgrid2__col-sm-1___2u7Tq","col-sm-2":"KDS_flexboxgrid2__col-sm-2___39LGZ","col-sm-3":"KDS_flexboxgrid2__col-sm-3___1HPMt","col-sm-4":"KDS_flexboxgrid2__col-sm-4___3SO93","col-sm-5":"KDS_flexboxgrid2__col-sm-5___2Buhm","col-sm-6":"KDS_flexboxgrid2__col-sm-6___1l2Kt","col-sm-7":"KDS_flexboxgrid2__col-sm-7___d6sUa","col-sm-8":"KDS_flexboxgrid2__col-sm-8___g6l7V","col-sm-9":"KDS_flexboxgrid2__col-sm-9___etIBb","col-sm-10":"KDS_flexboxgrid2__col-sm-10___Bxvht","col-sm-11":"KDS_flexboxgrid2__col-sm-11___PiXUP","col-sm-12":"KDS_flexboxgrid2__col-sm-12___2sYMg","col-sm-offset-0":"KDS_flexboxgrid2__col-sm-offset-0___oljZ3","col-sm-offset-1":"KDS_flexboxgrid2__col-sm-offset-1___1ywTD","col-sm-offset-2":"KDS_flexboxgrid2__col-sm-offset-2___1X0hd","col-sm-offset-3":"KDS_flexboxgrid2__col-sm-offset-3___2QOr2","col-sm-offset-4":"KDS_flexboxgrid2__col-sm-offset-4___3inAM","col-sm-offset-5":"KDS_flexboxgrid2__col-sm-offset-5___2Ihhn","col-sm-offset-6":"KDS_flexboxgrid2__col-sm-offset-6___21xzL","col-sm-offset-7":"KDS_flexboxgrid2__col-sm-offset-7___1ypYV","col-sm-offset-8":"KDS_flexboxgrid2__col-sm-offset-8___ymjV3","col-sm-offset-9":"KDS_flexboxgrid2__col-sm-offset-9___1SxN0","col-sm-offset-10":"KDS_flexboxgrid2__col-sm-offset-10___2qwiO","col-sm-offset-11":"KDS_flexboxgrid2__col-sm-offset-11___3zRYq","col-sm-offset-12":"KDS_flexboxgrid2__col-sm-offset-12___2fnwd","col-md":"KDS_flexboxgrid2__col-md___srMeB","col-md-1":"KDS_flexboxgrid2__col-md-1___3RdWY","col-md-2":"KDS_flexboxgrid2__col-md-2___3j8qs","col-md-3":"KDS_flexboxgrid2__col-md-3___2Th4S","col-md-4":"KDS_flexboxgrid2__col-md-4___3pbbS","col-md-5":"KDS_flexboxgrid2__col-md-5___1Svz9","col-md-6":"KDS_flexboxgrid2__col-md-6___1wIAi","col-md-7":"KDS_flexboxgrid2__col-md-7___3z1EO","col-md-8":"KDS_flexboxgrid2__col-md-8___2Dm-W","col-md-9":"KDS_flexboxgrid2__col-md-9___1nXvw","col-md-10":"KDS_flexboxgrid2__col-md-10___3Br2r","col-md-11":"KDS_flexboxgrid2__col-md-11___3gKDL","col-md-12":"KDS_flexboxgrid2__col-md-12___2t4Kh","col-md-offset-0":"KDS_flexboxgrid2__col-md-offset-0___1twEm","col-md-offset-1":"KDS_flexboxgrid2__col-md-offset-1___12ZU0","col-md-offset-2":"KDS_flexboxgrid2__col-md-offset-2___1dGCS","col-md-offset-3":"KDS_flexboxgrid2__col-md-offset-3___XMXnG","col-md-offset-4":"KDS_flexboxgrid2__col-md-offset-4___3TnIN","col-md-offset-5":"KDS_flexboxgrid2__col-md-offset-5___EGfBj","col-md-offset-6":"KDS_flexboxgrid2__col-md-offset-6___3Kb3E","col-md-offset-7":"KDS_flexboxgrid2__col-md-offset-7___21XFw","col-md-offset-8":"KDS_flexboxgrid2__col-md-offset-8___qnljU","col-md-offset-9":"KDS_flexboxgrid2__col-md-offset-9___kdDX2","col-md-offset-10":"KDS_flexboxgrid2__col-md-offset-10___284iF","col-md-offset-11":"KDS_flexboxgrid2__col-md-offset-11___WXAgk","col-md-offset-12":"KDS_flexboxgrid2__col-md-offset-12___2XYlU","col-lg":"KDS_flexboxgrid2__col-lg___3u7lk","col-lg-1":"KDS_flexboxgrid2__col-lg-1___2y0lP","col-lg-2":"KDS_flexboxgrid2__col-lg-2___1x6vt","col-lg-3":"KDS_flexboxgrid2__col-lg-3___37wpY","col-lg-4":"KDS_flexboxgrid2__col-lg-4___RwCNM","col-lg-5":"KDS_flexboxgrid2__col-lg-5___37365","col-lg-6":"KDS_flexboxgrid2__col-lg-6___NeTjn","col-lg-7":"KDS_flexboxgrid2__col-lg-7___3bixv","col-lg-8":"KDS_flexboxgrid2__col-lg-8___2YhQ1","col-lg-9":"KDS_flexboxgrid2__col-lg-9___2e0uZ","col-lg-10":"KDS_flexboxgrid2__col-lg-10___3X-8g","col-lg-11":"KDS_flexboxgrid2__col-lg-11___1Ymgu","col-lg-12":"KDS_flexboxgrid2__col-lg-12___p4dm-","col-lg-offset-0":"KDS_flexboxgrid2__col-lg-offset-0___YMDi3","col-lg-offset-1":"KDS_flexboxgrid2__col-lg-offset-1___2mUfM","col-lg-offset-2":"KDS_flexboxgrid2__col-lg-offset-2___2PSlK","col-lg-offset-3":"KDS_flexboxgrid2__col-lg-offset-3___2ZEsJ","col-lg-offset-4":"KDS_flexboxgrid2__col-lg-offset-4___oUBjv","col-lg-offset-5":"KDS_flexboxgrid2__col-lg-offset-5___2_pNE","col-lg-offset-6":"KDS_flexboxgrid2__col-lg-offset-6___1bZES","col-lg-offset-7":"KDS_flexboxgrid2__col-lg-offset-7___26quH","col-lg-offset-8":"KDS_flexboxgrid2__col-lg-offset-8___3kkd3","col-lg-offset-9":"KDS_flexboxgrid2__col-lg-offset-9___22Nlu","col-lg-offset-10":"KDS_flexboxgrid2__col-lg-offset-10___32R4D","col-lg-offset-11":"KDS_flexboxgrid2__col-lg-offset-11___3mcm9","col-lg-offset-12":"KDS_flexboxgrid2__col-lg-offset-12___1CzWw","col-xl":"KDS_flexboxgrid2__col-xl___3OIWS","col-xl-1":"KDS_flexboxgrid2__col-xl-1___1x-yZ","col-xl-2":"KDS_flexboxgrid2__col-xl-2___oe1yn","col-xl-3":"KDS_flexboxgrid2__col-xl-3___1DZkD","col-xl-4":"KDS_flexboxgrid2__col-xl-4___e7X-g","col-xl-5":"KDS_flexboxgrid2__col-xl-5___1K3om","col-xl-6":"KDS_flexboxgrid2__col-xl-6___pj3oz","col-xl-7":"KDS_flexboxgrid2__col-xl-7___2lbXv","col-xl-8":"KDS_flexboxgrid2__col-xl-8___2T9rc","col-xl-9":"KDS_flexboxgrid2__col-xl-9___4Cdy9","col-xl-10":"KDS_flexboxgrid2__col-xl-10___pgLUE","col-xl-11":"KDS_flexboxgrid2__col-xl-11___fOAzP","col-xl-12":"KDS_flexboxgrid2__col-xl-12___1lxVN","col-xl-offset-0":"KDS_flexboxgrid2__col-xl-offset-0___rTVg4","col-xl-offset-1":"KDS_flexboxgrid2__col-xl-offset-1___1KRTF","col-xl-offset-2":"KDS_flexboxgrid2__col-xl-offset-2___3XTdA","col-xl-offset-3":"KDS_flexboxgrid2__col-xl-offset-3___1u7VM","col-xl-offset-4":"KDS_flexboxgrid2__col-xl-offset-4___1U3cj","col-xl-offset-5":"KDS_flexboxgrid2__col-xl-offset-5___1m-Bk","col-xl-offset-6":"KDS_flexboxgrid2__col-xl-offset-6___zqsMR","col-xl-offset-7":"KDS_flexboxgrid2__col-xl-offset-7___8fHBq","col-xl-offset-8":"KDS_flexboxgrid2__col-xl-offset-8___1LruZ","col-xl-offset-9":"KDS_flexboxgrid2__col-xl-offset-9___3oTGD","col-xl-offset-10":"KDS_flexboxgrid2__col-xl-offset-10___2eReq","col-xl-offset-11":"KDS_flexboxgrid2__col-xl-offset-11___kuo4A","col-xl-offset-12":"KDS_flexboxgrid2__col-xl-offset-12___1WvjR","start-xs":"KDS_flexboxgrid2__start-xs___2gtAf","center-xs":"KDS_flexboxgrid2__center-xs___2GJwn","end-xs":"KDS_flexboxgrid2__end-xs___1Jy9a","top-xs":"KDS_flexboxgrid2__top-xs___3ApF9","middle-xs":"KDS_flexboxgrid2__middle-xs___2qJAd","bottom-xs":"KDS_flexboxgrid2__bottom-xs___2sMuK","around-xs":"KDS_flexboxgrid2__around-xs___1h6nu","between-xs":"KDS_flexboxgrid2__between-xs___1Bml9","first-xs":"KDS_flexboxgrid2__first-xs___2ydrY","last-xs":"KDS_flexboxgrid2__last-xs___1TmDf","initial-order-xs":"KDS_flexboxgrid2__initial-order-xs___1lJw5","start-sm":"KDS_flexboxgrid2__start-sm___3I0F0","center-sm":"KDS_flexboxgrid2__center-sm___2tfwT","end-sm":"KDS_flexboxgrid2__end-sm___1Dqio","top-sm":"KDS_flexboxgrid2__top-sm___NTmPJ","middle-sm":"KDS_flexboxgrid2__middle-sm___QLrL0","bottom-sm":"KDS_flexboxgrid2__bottom-sm___3iRAD","around-sm":"KDS_flexboxgrid2__around-sm___2DXbH","between-sm":"KDS_flexboxgrid2__between-sm___1GD_q","first-sm":"KDS_flexboxgrid2__first-sm___AlKeI","last-sm":"KDS_flexboxgrid2__last-sm___1GaXQ","initial-order-sm":"KDS_flexboxgrid2__initial-order-sm___3Ar7f","start-md":"KDS_flexboxgrid2__start-md___3M-iK","center-md":"KDS_flexboxgrid2__center-md___3Ql1d","end-md":"KDS_flexboxgrid2__end-md___STrsQ","top-md":"KDS_flexboxgrid2__top-md___2FX25","middle-md":"KDS_flexboxgrid2__middle-md___YZ6CJ","bottom-md":"KDS_flexboxgrid2__bottom-md___2Ruw8","around-md":"KDS_flexboxgrid2__around-md___1G_h0","between-md":"KDS_flexboxgrid2__between-md___1ik_I","first-md":"KDS_flexboxgrid2__first-md___yFUKj","last-md":"KDS_flexboxgrid2__last-md___1PHhp","initial-order-md":"KDS_flexboxgrid2__initial-order-md___3UvRN","start-lg":"KDS_flexboxgrid2__start-lg___m0vFF","center-lg":"KDS_flexboxgrid2__center-lg___1ppmu","end-lg":"KDS_flexboxgrid2__end-lg___1Cene","top-lg":"KDS_flexboxgrid2__top-lg___3R_GA","middle-lg":"KDS_flexboxgrid2__middle-lg___2vRr_","bottom-lg":"KDS_flexboxgrid2__bottom-lg___1FxHX","around-lg":"KDS_flexboxgrid2__around-lg___24PfH","between-lg":"KDS_flexboxgrid2__between-lg___2a-N0","first-lg":"KDS_flexboxgrid2__first-lg___351pp","last-lg":"KDS_flexboxgrid2__last-lg___2GWNG","initial-order-lg":"KDS_flexboxgrid2__initial-order-lg___3ajeo","start-xl":"KDS_flexboxgrid2__start-xl___2Ur_r","center-xl":"KDS_flexboxgrid2__center-xl___3C4Vx","end-xl":"KDS_flexboxgrid2__end-xl___2UqlC","top-xl":"KDS_flexboxgrid2__top-xl___1tLbF","middle-xl":"KDS_flexboxgrid2__middle-xl___31-ID","bottom-xl":"KDS_flexboxgrid2__bottom-xl___p1SvR","around-xl":"KDS_flexboxgrid2__around-xl___2j28w","between-xl":"KDS_flexboxgrid2__between-xl___xff2E","first-xl":"KDS_flexboxgrid2__first-xl___2QxqG","last-xl":"KDS_flexboxgrid2__last-xl___1v5wI","initial-order-xl":"KDS_flexboxgrid2__initial-order-xl___IYbgP","hidden-xs":"KDS_flexboxgrid2__hidden-xs___3MgtY","hidden-sm":"KDS_flexboxgrid2__hidden-sm___2YMAO","hidden-md":"KDS_flexboxgrid2__hidden-md___FbTYO","hidden-lg":"KDS_flexboxgrid2__hidden-lg___2fkvW","hidden-xl":"KDS_flexboxgrid2__hidden-xl___3hzYJ"};

var flexboxgrid2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': flexboxgrid2
});

var require$$0 = /*@__PURE__*/getAugmentedNamespace(flexboxgrid2$1);

Object.defineProperty(classNames$1, "__esModule", {
  value: true
});
classNames$1.default = getClass;

var _flexboxgrid = require$$0;

var _flexboxgrid2 = _interopRequireDefault$4(_flexboxgrid);

function _interopRequireDefault$4(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getClass(className) {
  return _flexboxgrid2.default && _flexboxgrid2.default[className] ? _flexboxgrid2.default[className] : className;
}

var createProps$1 = {};

Object.defineProperty(createProps$1, "__esModule", {
  value: true
});
createProps$1.default = createProps;
function createProps(propTypes, props, classNames) {
  var newProps = {};

  Object.keys(props).filter(function (key) {
    return key === 'children' || !propTypes[key];
  }).forEach(function (key) {
    return newProps[key] = props[key];
  });

  var className = classNames.filter(function (cn) {
    return cn;
  }).join(' ');
  return Object.assign({}, newProps, { className: className });
}

var types = {};

Object.defineProperty(types, "__esModule", {
  value: true
});
types.ViewportSizeType = types.ColumnSizeType = undefined;

var _propTypes$3 = PropTypes;

var _propTypes2$3 = _interopRequireDefault$3(_propTypes$3);

function _interopRequireDefault$3(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

types.ColumnSizeType = _propTypes2$3.default.oneOfType([_propTypes2$3.default.number, _propTypes2$3.default.bool]);
types.ViewportSizeType = _propTypes2$3.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']);

Object.defineProperty(Row$3, "__esModule", {
  value: true
});
Row$3.getRowProps = getRowProps;
Row$3.default = Row$2;

var _classNames$2 = classNames$1;

var _classNames2$2 = _interopRequireDefault$2(_classNames$2);

var _react$2 = React;

var _react2$2 = _interopRequireDefault$2(_react$2);

var _propTypes$2 = PropTypes;

var _propTypes2$2 = _interopRequireDefault$2(_propTypes$2);

var _createProps$2 = createProps$1;

var _createProps2$2 = _interopRequireDefault$2(_createProps$2);

var _types$1 = types;

function _interopRequireDefault$2(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var rowKeys = ['start', 'center', 'end', 'top', 'middle', 'bottom', 'around', 'between'];

var propTypes$2 = {
  reverse: _propTypes2$2.default.bool,
  start: _types$1.ViewportSizeType,
  center: _types$1.ViewportSizeType,
  end: _types$1.ViewportSizeType,
  top: _types$1.ViewportSizeType,
  middle: _types$1.ViewportSizeType,
  bottom: _types$1.ViewportSizeType,
  around: _types$1.ViewportSizeType,
  between: _types$1.ViewportSizeType,
  className: _propTypes2$2.default.string,
  tagName: _propTypes2$2.default.string,
  children: _propTypes2$2.default.node
};

function getRowClassNames(props) {
  var modificators = [props.className, (0, _classNames2$2.default)('row')];

  for (var i = 0; i < rowKeys.length; ++i) {
    var key = rowKeys[i];
    var value = props[key];
    if (value) {
      modificators.push((0, _classNames2$2.default)(key + '-' + value));
    }
  }

  if (props.reverse) {
    modificators.push((0, _classNames2$2.default)('reverse'));
  }

  return modificators;
}

function getRowProps(props) {
  return (0, _createProps2$2.default)(propTypes$2, props, getRowClassNames(props));
}

function Row$2(props) {
  return _react2$2.default.createElement(props.tagName || 'div', getRowProps(props));
}

Row$2.propTypes = propTypes$2;

var Col$3 = {};

Object.defineProperty(Col$3, "__esModule", {
  value: true
});
Col$3.getColumnProps = getColumnProps;
Col$3.default = Col$2;

var _react$1 = React;

var _react2$1 = _interopRequireDefault$1(_react$1);

var _propTypes$1 = PropTypes;

var _propTypes2$1 = _interopRequireDefault$1(_propTypes$1);

var _createProps$1 = createProps$1;

var _createProps2$1 = _interopRequireDefault$1(_createProps$1);

var _classNames$1 = classNames$1;

var _classNames2$1 = _interopRequireDefault$1(_classNames$1);

var _types = types;

function _interopRequireDefault$1(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var propTypes$1 = {
  xs: _types.ColumnSizeType,
  sm: _types.ColumnSizeType,
  md: _types.ColumnSizeType,
  lg: _types.ColumnSizeType,
  xl: _types.ColumnSizeType,
  xsOffset: _propTypes2$1.default.number,
  smOffset: _propTypes2$1.default.number,
  mdOffset: _propTypes2$1.default.number,
  lgOffset: _propTypes2$1.default.number,
  xlOffset: _propTypes2$1.default.number,
  first: _types.ViewportSizeType,
  last: _types.ViewportSizeType,
  className: _propTypes2$1.default.string,
  tagName: _propTypes2$1.default.string,
  children: _propTypes2$1.default.node
};

var classMap = {
  xs: 'col-xs',
  sm: 'col-sm',
  md: 'col-md',
  lg: 'col-lg',
  xl: 'col-xl',
  xsOffset: 'col-xs-offset',
  smOffset: 'col-sm-offset',
  mdOffset: 'col-md-offset',
  lgOffset: 'col-lg-offset',
  xlOffset: 'col-xl-offset'
};

function isInteger$1(value) {
  return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
}

function getColClassNames(props) {
  var extraClasses = [];

  if (props.className) {
    extraClasses.push(props.className);
  }

  if (props.first) {
    extraClasses.push((0, _classNames2$1.default)('first-' + props.first));
  }

  if (props.last) {
    extraClasses.push((0, _classNames2$1.default)('last-' + props.last));
  }

  return Object.keys(props).filter(function (key) {
    return classMap[key];
  }).map(function (key) {
    return (0, _classNames2$1.default)(isInteger$1(props[key]) ? classMap[key] + '-' + props[key] : classMap[key]);
  }).concat(extraClasses);
}

function getColumnProps(props) {
  return (0, _createProps2$1.default)(propTypes$1, props, getColClassNames(props));
}

function Col$2(props) {
  var tagName = props.tagName,
      columnProps = _objectWithoutProperties(props, ['tagName']);

  return _react2$1.default.createElement(tagName || 'div', getColumnProps(columnProps));
}

Col$2.propTypes = propTypes$1;

var Grid$1 = {};

Object.defineProperty(Grid$1, "__esModule", {
  value: true
});
Grid$1.default = Grid;

var _react = React;

var _react2 = _interopRequireDefault(_react);

var _propTypes = PropTypes;

var _propTypes2 = _interopRequireDefault(_propTypes);

var _createProps = createProps$1;

var _createProps2 = _interopRequireDefault(_createProps);

var _classNames = classNames$1;

var _classNames2 = _interopRequireDefault(_classNames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  fluid: _propTypes2.default.bool,
  className: _propTypes2.default.string,
  tagName: _propTypes2.default.string,
  children: _propTypes2.default.node
};

function Grid(props) {
  var containerClass = (0, _classNames2.default)(props.fluid ? 'container-fluid' : 'container');
  var classNames = [props.className, containerClass];

  return _react2.default.createElement(props.tagName || 'div', (0, _createProps2.default)(propTypes, props, classNames));
}

Grid.propTypes = propTypes;

(function (exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getColumnProps = exports.Col = exports.getRowProps = exports.Row = exports.Grid = undefined;

	var _Row2 = Row$3;

	Object.defineProperty(exports, 'getRowProps', {
	  enumerable: true,
	  get: function get() {
	    return _Row2.getRowProps;
	  }
	});

	var _Col2 = Col$3;

	Object.defineProperty(exports, 'getColumnProps', {
	  enumerable: true,
	  get: function get() {
	    return _Col2.getColumnProps;
	  }
	});

	var _Grid2 = Grid$1;

	var _Grid3 = _interopRequireDefault(_Grid2);

	var _Row3 = _interopRequireDefault(_Row2);

	var _Col3 = _interopRequireDefault(_Col2);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.Grid = _Grid3.default;
	exports.Row = _Row3.default;
	exports.Col = _Col3.default; 
} (lib));

var FlexGridContext = /*#__PURE__*/React.createContext();

var calculateLevel = function calculateLevel(xs, sm, md, lg, xl) {
  var levelToggles = [xs, sm, md, lg, xl];
  var enabledLevels = [false, false, false, false, false];
  for (var toggles = 0; toggles < levelToggles.length; toggles += 1) {
    for (var levels = toggles; levels < enabledLevels.length; levels += 1) {
      if (levelToggles[toggles] !== undefined) {
        enabledLevels[levels] = levelToggles[toggles];
      }
    }
  }
  return enabledLevels;
};

var styles$R = {"padding":"KDS_Col-modules__padding___2jLqQ","gutterless":"KDS_Col-modules__gutterless___12Rri","xsHidden":"KDS_Col-modules__xsHidden___3TnFe","smHidden":"KDS_Col-modules__smHidden___1yiu5","mdHidden":"KDS_Col-modules__mdHidden___tPpMa","lgHidden":"KDS_Col-modules__lgHidden___lNRYE","xlHidden":"KDS_Col-modules__xlHidden___236-p","xsVisible":"KDS_Col-modules__xsVisible___3CMvb","smVisible":"KDS_Col-modules__smVisible___3__I9","mdVisible":"KDS_Col-modules__mdVisible___3-w8g","lgVisible":"KDS_Col-modules__lgVisible___-_t_E","xlVisible":"KDS_Col-modules__xlVisible___BtBh3"};

var _excluded$10 = ["span", "offset", "children"];
var Col$1 = function Col(_ref) {
  var span = _ref.span,
    offset = _ref.offset,
    children = _ref.children,
    rest = _objectWithoutProperties$1(_ref, _excluded$10);
  if (offset) {
    deprecate('core-flex-grid', 'The `offset` prop is deprecated due to the addition of the responsive offset props. Use `xsOffset` instead.');
  }
  if (span) {
    deprecate('core-flex-grid', 'The `span` prop is deprecated due to the addition of the responsive props. Use `xs` instead.');
  }
  var props = _objectSpread2({}, rest);
  var xsOffset = props.xsOffset;
  if (offset && !xsOffset) {
    props.xsOffset = offset;
  }
  var hiddenLevel = calculateLevel(rest.xs, rest.sm, rest.md, rest.lg, rest.xl);
  return /*#__PURE__*/React.createElement(FlexGridContext.Consumer, null, function (gutter) {
    return /*#__PURE__*/React.createElement(lib.Col, _extends$1({}, safeRest(props), {
      xs: rest.xs || span || true,
      className: joinClassNames(hiddenLevel[0] === 0 ? styles$R.xsHidden : styles$R.xsVisible, hiddenLevel[1] === 0 ? styles$R.smHidden : styles$R.smVisible, hiddenLevel[2] === 0 ? styles$R.mdHidden : styles$R.mdVisible, hiddenLevel[3] === 0 ? styles$R.lgHidden : styles$R.lgVisible, hiddenLevel[4] === 0 ? styles$R.xlHidden : styles$R.xlVisible, gutter ? styles$R.padding : styles$R.gutterless)
    }), children);
  });
};

/* eslint-disable react/require-default-props */
/*
 * We're disabling default props since passing undefined props to
 * the react-flexbox-grid component sets up blank classes that may cause
 * styling issues.
*/
Col$1.propTypes = {
  /**
   * Specify number of columns within the 'xs' breakpoint range. `0` hides the column.
   *
   * `true` sets the column width automatically;
   * `false` disables the prop
   *
   * @since 1.2.0
   */
  xs: PropTypes.oneOf([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, true, false]),
  /**
   * Specify number of columns within the 'sm' breakpoint range. `0` hides the column.
   *
   * `true` sets the column width automatically;
   * `false` disables the prop
   *
   * @since 1.2.0
   */
  sm: PropTypes.oneOf([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, true, false]),
  /**
   * Specify number of columns within the 'md' breakpoint range. `0` hides the column.
   *
   * `true` sets the column width automatically;
   * `false` disables the prop
   *
   * @since 1.2.0
   */
  md: PropTypes.oneOf([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, true, false]),
  /**
   * Specify number of columns within the 'lg' breakpoint range. `0` hides the column.
   *
   * `true` sets the column width automatically;
   * `false` disables the prop
   *
   * @since 1.2.0
   */
  lg: PropTypes.oneOf([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, true, false]),
  /**
   * Specify number of columns after the 'xl' breakpoint. `0` hides the column.
   *
   * `true` sets the column width automatically;
   * `false` disables the prop
   *
   * @since 1.2.0
   */
  xl: PropTypes.oneOf([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, true, false]),
  /**
   * Offset the specified number of columns within the 'xs' breakpoint range. `0` hides the column.
   *
   * @since 1.2.0
   */
  xsOffset: PropTypes.oneOf([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]),
  /**
   * Offset the specified number of columns within the 'sm' breakpoint range.
   *
   * @since 1.2.0
   */
  smOffset: PropTypes.oneOf([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]),
  /**
   * Offset the specified number of columns within the 'md' breakpoint range.
   *
   * @since 1.2.0
   */
  mdOffset: PropTypes.oneOf([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]),
  /**
   * Offset the specified number of columns within the 'lg' breakpoint range.
   *
   * @since 1.2.0
   */
  lgOffset: PropTypes.oneOf([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]),
  /**
   * Offset the specified number of columns within the 'xl' breakpoint range.
   *
   * @since 1.2.0
   */
  xlOffset: PropTypes.oneOf([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]),
  /**
   * The columns of the Grid. Will typically be `FlexGrid.Col` components.
   *
   * @since 1.2.0
   */
  children: PropTypes.node.isRequired,
  /**
   * @deprecated Span the specified number of columns.
   * @since 1.2.0
   *
   * Use the xs prop instead for identical functionality.
   */
  span: PropTypes.oneOf([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
  /**
   * @deprecated Offset the specified number of columns.
   * @since 1.2.0
   *
   * Use the xsOffset prop instead for identical functionality.
   */
  offset: PropTypes.oneOf([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11])
};
/* eslint-enable */

Col$1.defaultProps = {
  span: undefined,
  offset: undefined
};

var styles$Q = {"flexRow":"KDS_Row-modules__flexRow___tYrtx","xsReverse":"KDS_Row-modules__xsReverse___1E2nR","smReverse":"KDS_Row-modules__smReverse___2CD1R","mdReverse":"KDS_Row-modules__mdReverse___3O6_6","lgReverse":"KDS_Row-modules__lgReverse___15SxW","xlReverse":"KDS_Row-modules__xlReverse___3Paw5","xsReverseCancel":"KDS_Row-modules__xsReverseCancel___1-ULZ","smReverseCancel":"KDS_Row-modules__smReverseCancel___MfHUF","mdReverseCancel":"KDS_Row-modules__mdReverseCancel___3Ds1p","lgReverseCancel":"KDS_Row-modules__lgReverseCancel___39xLJ","xlReverseCancel":"KDS_Row-modules__xlReverseCancel___1Oxwy"};

var _excluded$$ = ["horizontalAlign", "verticalAlign", "distribute", "xsReverse", "smReverse", "mdReverse", "lgReverse", "xlReverse", "children"];
var Row$1 = function Row(_ref) {
  var horizontalAlign = _ref.horizontalAlign,
    verticalAlign = _ref.verticalAlign,
    distribute = _ref.distribute,
    xsReverse = _ref.xsReverse,
    smReverse = _ref.smReverse,
    mdReverse = _ref.mdReverse,
    lgReverse = _ref.lgReverse,
    xlReverse = _ref.xlReverse,
    children = _ref.children,
    rest = _objectWithoutProperties$1(_ref, _excluded$$);
  var getAlignment = function getAlignment() {
    return {
      start: horizontalAlign === 'start' ? 'xs' : undefined,
      center: horizontalAlign === 'center' ? 'xs' : undefined,
      end: horizontalAlign === 'end' ? 'xs' : undefined,
      top: verticalAlign === 'top' ? 'xs' : undefined,
      middle: verticalAlign === 'middle' ? 'xs' : undefined,
      bottom: verticalAlign === 'bottom' ? 'xs' : undefined
    };
  };
  var getDistribution = function getDistribution() {
    return {
      around: distribute === 'around' ? 'xs' : undefined,
      between: distribute === 'between' ? 'xs' : undefined
    };
  };
  var reverseLevel = calculateLevel(xsReverse, smReverse, mdReverse, lgReverse, xlReverse);
  return /*#__PURE__*/React.createElement(lib.Row, _extends$1({}, safeRest(rest), getAlignment(), getDistribution(), {
    className: joinClassNames(styles$Q.flexRow, reverseLevel[0] ? styles$Q.xsReverse : styles$Q.xsReverseCancel, reverseLevel[1] ? styles$Q.smReverse : styles$Q.smReverseCancel, reverseLevel[2] ? styles$Q.mdReverse : styles$Q.mdReverseCancel, reverseLevel[3] ? styles$Q.lgReverse : styles$Q.lgReverseCancel, reverseLevel[4] ? styles$Q.xlReverse : styles$Q.xlReverseCancel)
  }), children);
};
Row$1.propTypes = {
  /**
   * Align columns horizontally within their row.
   */
  horizontalAlign: PropTypes.oneOf(['start', 'center', 'end']),
  /**
   * Align columns vertically within their row.
   */
  verticalAlign: PropTypes.oneOf(['top', 'middle', 'bottom']),
  /**
   * Distribute empty space around columns.
   */
  distribute: PropTypes.oneOf(['around', 'between']),
  /**
   * Choose if the item order should be reversed from the 'xs' breakpoint. When you pass in false, the order will be normal from the xs breakpoint. By default, it inherits the behaviour set by the preceding prop.
   */
  xsReverse: PropTypes.bool,
  /**
   * Choose if the item order should be reversed from the 'sm' breakpoint. When you pass in false, the order will be normal from the sm breakpoint. By default, it inherits the behaviour set by the preceding prop.
   */
  smReverse: PropTypes.bool,
  /**
   * Choose if the item order should be reversed from the 'md' breakpoint. When you pass in false, the order will be normal from the md breakpoint. By default, it inherits the behaviour set by the preceding prop.
   */
  mdReverse: PropTypes.bool,
  /**
   * Choose if the item order should be reversed from the 'lg' breakpoint. When you pass in false, the order will be normal from the lg breakpoint. By default, it inherits the behaviour set by the preceding prop.
   */
  lgReverse: PropTypes.bool,
  /**
   * Choose if the item order should be reversed from the 'xl' breakpoint. When you pass in false, the order will be normal from the xl breakpoint. By default, it inherits the behaviour set by the preceding prop.
   */
  xlReverse: PropTypes.bool,
  children: PropTypes.node.isRequired
};
Row$1.defaultProps = {
  horizontalAlign: undefined,
  verticalAlign: undefined,
  distribute: undefined,
  xsReverse: undefined,
  smReverse: undefined,
  mdReverse: undefined,
  lgReverse: undefined,
  xlReverse: undefined
};

var styles$P = {"flexGrid":"KDS_FlexGrid-modules__flexGrid___QNlYI","limitWidth":"KDS_FlexGrid-modules__limitWidth___1lJEx","minHeight":"KDS_FlexGrid-modules__minHeight___1uyi1","xsReverse":"KDS_FlexGrid-modules__xsReverse___1gBFL","smReverse":"KDS_FlexGrid-modules__smReverse___10vqS","mdReverse":"KDS_FlexGrid-modules__mdReverse___25J0f","lgReverse":"KDS_FlexGrid-modules__lgReverse___3sGes","xlReverse":"KDS_FlexGrid-modules__xlReverse___2dGG5","xsReverseCancel":"KDS_FlexGrid-modules__xsReverseCancel___3im6Q","smReverseCancel":"KDS_FlexGrid-modules__smReverseCancel___2ndc9","mdReverseCancel":"KDS_FlexGrid-modules__mdReverseCancel___3noYa","lgReverseCancel":"KDS_FlexGrid-modules__lgReverseCancel___1gSBb","xlReverseCancel":"KDS_FlexGrid-modules__xlReverseCancel___1lm3t"};

var _excluded$_ = ["limitWidth", "gutter", "xsReverse", "smReverse", "mdReverse", "lgReverse", "xlReverse", "children", "minHeight"];
var FlexGrid = function FlexGrid(_ref) {
  var limitWidth = _ref.limitWidth,
    gutter = _ref.gutter,
    xsReverse = _ref.xsReverse,
    smReverse = _ref.smReverse,
    mdReverse = _ref.mdReverse,
    lgReverse = _ref.lgReverse,
    xlReverse = _ref.xlReverse,
    children = _ref.children,
    minHeight = _ref.minHeight,
    rest = _objectWithoutProperties$1(_ref, _excluded$_);
  var reverseLevel = calculateLevel(xsReverse, smReverse, mdReverse, lgReverse, xlReverse);
  return /*#__PURE__*/React.createElement(FlexGridContext.Provider, {
    value: gutter
  }, /*#__PURE__*/React.createElement(lib.Grid, _extends$1({}, safeRest(rest), {
    fluid: true,
    className: joinClassNames(styles$P.flexGrid, limitWidth && styles$P.limitWidth, minHeight && styles$P.minHeight, reverseLevel[0] ? styles$P.xsReverse : styles$P.xsReverseCancel, reverseLevel[1] ? styles$P.smReverse : styles$P.smReverseCancel, reverseLevel[2] ? styles$P.mdReverse : styles$P.mdReverseCancel, reverseLevel[3] ? styles$P.lgReverse : styles$P.lgReverseCancel, reverseLevel[4] ? styles$P.xlReverse : styles$P.xlReverseCancel)
  }), children));
};
FlexGrid.propTypes = {
  /**
   * Whether or not to give the grid a fixed width. This also centres the grid horizontally.
   */
  limitWidth: PropTypes.bool,
  /**
   * Whether or not to include gutters in between columns.
   */
  gutter: PropTypes.bool,
  /**
   * Choose if the item order should be reversed from the 'xs' breakpoint. When you pass in false, the order will be normal from the xs breakpoint. By default, it inherits the behaviour set by the preceding prop.
   */
  xsReverse: PropTypes.bool,
  /**
   * Choose if the item order should be reversed from the 'sm' breakpoint. When you pass in false, the order will be normal from the sm breakpoint. By default, it inherits the behaviour set by the preceding prop.
   */
  smReverse: PropTypes.bool,
  /**
   * Choose if the item order should be reversed from the 'md' breakpoint. When you pass in false, the order will be normal from the md breakpoint. By default, it inherits the behaviour set by the preceding prop.
   */
  mdReverse: PropTypes.bool,
  /**
   * Choose if the item order should be reversed from the 'lg' breakpoint. When you pass in false, the order will be normal from the lg breakpoint. By default, it inherits the behaviour set by the preceding prop.
   */
  lgReverse: PropTypes.bool,
  /**
   * Choose if the item order should be reversed from the 'xl' breakpoint. When you pass in false, the order will be normal from the xl breakpoint. By default, it inherits the behaviour set by the preceding prop.
   */
  xlReverse: PropTypes.bool,
  /**
   * The rows and columns of the Grid. Will typically be `FlexGrid.Row` and `FlexGrid.Col` components.
   */
  children: PropTypes.node.isRequired,
  /**
   * Whether or not to give the grid a min height.
   */
  minHeight: PropTypes.bool
};
FlexGrid.defaultProps = {
  limitWidth: true,
  gutter: true,
  xsReverse: undefined,
  smReverse: undefined,
  mdReverse: undefined,
  lgReverse: undefined,
  xlReverse: undefined,
  minHeight: undefined
};
FlexGrid.Row = Row$1;
FlexGrid.Col = Col$1;

var styles$O = {"flirt":"#7c1366","mosque":"#016b6a","texas":"#f9f6a5","amaranth":"#ee2c74","cardinal-pink":"#8c0448","trinidad":"#df3d0c","chestnut":"#bc4850","onahau":"#c3efff","burnt-sienna":"#ed6358","chathams-blue":"#17367d","mid-blue":"#1a347d","well-read":"#b8373e","wattle":"#d5e04d","beeswax":"#feeec7","bilbao":"#258b0b","sea-buckthorn":"#fbaf34","mint-tulip":"#c1f2e8","turquoise":"#39cdc9","hibiscus":"#c53a70","carousel-pink":"#fae6f4","white":"#fff","black":"#000","mortar":"#595959","gallery":"#efefef","silver":"#c9c8c8","dove":"#666666","iceberg":"#cbf0e8","icicle":"#e5f7fb","light-gray":"#fafafa","super-nova":"#fbaf33","expand-yellow":"#fee8b8","expand-yellow-light":"rgba(254, 232, 184, 0.5)","hero-pink":"#a6298c","accordionList":"KDS_AccordionList-modules__accordionList___2tesU","accordionList__grid":"KDS_AccordionList-modules__accordionList__grid___3D6JJ"};

var _excluded$Z = ["children", "defaultFeature", "defaultBorderColor", "repeatDefault", "openPanel", "accessOpenPanels"];
var AccordionList = function AccordionList(_ref) {
  var children = _ref.children,
    defaultFeature = _ref.defaultFeature,
    defaultBorderColor = _ref.defaultBorderColor,
    repeatDefault = _ref.repeatDefault,
    openPanel = _ref.openPanel,
    accessOpenPanels = _ref.accessOpenPanels,
    rest = _objectWithoutProperties$1(_ref, _excluded$Z);
  // An array of all the ids for the children passed into the component.
  var planIds = Children.map(children, function (child) {
    return child.props.id;
  });

  // A function to create an array the length plansId filled with a value of false.
  var closeAllPanels = function closeAllPanels() {
    return Array(planIds.length).fill(false);
  };

  // If there is a default panel to be opened, initialize the openPanelsBool state with the value of that index set to true
  var defaultPanelLoc = openPanel && planIds.indexOf(openPanel);
  var openPanelsBoolWithDefault = closeAllPanels();
  openPanelsBoolWithDefault[defaultPanelLoc] = true;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    fade = _useState2[0],
    setFade = _useState2[1];
  var _useState3 = useState(openPanel ? [openPanel] : ['default']),
    _useState4 = _slicedToArray(_useState3, 2),
    openPanels = _useState4[0],
    setOpenPanels = _useState4[1];

  /* An array of boolean values containing the open/closed state for each panel. Not directly used in the AccordionList component.
   *  Its purpose is to expose the selected state of each panel through the accessOpenPanels callback to the parent component if necessary. */
  var _useState5 = useState(openPanel ? openPanelsBoolWithDefault : closeAllPanels()),
    _useState6 = _slicedToArray(_useState5, 2),
    openPanelsBool = _useState6[0],
    setOpenPanelsBool = _useState6[1];
  var _useWindowDimensions = useWindowDimensions(breakpoints$1),
    width = _useWindowDimensions.width;
  var _getBreakpoints = getBreakpoints(breakpoints$1),
    mdBp = _getBreakpoints.md.lower;
  useEffect(function () {
    accessOpenPanels(openPanelsBool);
  }, [openPanelsBool]);

  /** Used for setting default open */
  var previousOpenPanel = usePreviousState(openPanel);
  useEffect(function () {
    if (previousOpenPanel !== openPanel) {
      setOpenPanels([openPanel]);
      var newOpenPanelBool = closeAllPanels();
      newOpenPanelBool[planIds.indexOf(openPanel)] = true;
      setOpenPanelsBool(newOpenPanelBool);
    }
  }, [openPanel]);
  var handleOnClickItem = function handleOnClickItem(id, desktop) {
    setFade(true);
    var idIndex = planIds.indexOf(id);
    if (!desktop) {
      var newOpenPanels = openPanels[0] === 'default' ? [] : _toConsumableArray(openPanels);
      var newOpenPanelsBool = _toConsumableArray(openPanelsBool);
      if (newOpenPanels.includes(id)) {
        setOpenPanels(newOpenPanels.filter(function (panel) {
          return panel !== id;
        }));
        newOpenPanelsBool[idIndex] = false;
      } else {
        setOpenPanels([].concat(_toConsumableArray(newOpenPanels), [id]));
        if (idIndex >= 0) newOpenPanelsBool[idIndex] = true;
      }
      setOpenPanelsBool(newOpenPanelsBool);
    } else {
      var _newOpenPanels = _toConsumableArray(openPanels);
      var selectedId = _newOpenPanels.pop();
      if (repeatDefault && selectedId === id) {
        _newOpenPanels.push('default');
        setOpenPanelsBool(closeAllPanels());
      } else {
        _newOpenPanels.push(id);
        var _newOpenPanelsBool = closeAllPanels();
        if (idIndex >= 0) _newOpenPanelsBool[idIndex] = true;
        setOpenPanelsBool(_newOpenPanelsBool);
      }
      setOpenPanels(_newOpenPanels);
    }
  };

  /**
   * If multiple panels are open, close all panels and sets to default when changing between mobile and desktop.
   */
  var previousWidth = usePreviousState(width);
  useEffect(function () {
    if (previousWidth < mdBp && width >= mdBp) {
      if (openPanels.length > 1 || openPanels.length === 0) {
        setOpenPanels(['default']);
        setOpenPanelsBool(closeAllPanels());
      }
    }
  }, [width]);
  return /*#__PURE__*/React.createElement(Responsive, {
    minWidth: "md"
  }, function (desktop) {
    return /*#__PURE__*/React.createElement(FlexGrid, {
      limitWidth: false,
      gutter: false
    }, /*#__PURE__*/React.createElement("div", _extends$1({
      className: styles$O.accordionList
    }, safeRest(rest)), desktop && openPanels[0] === 'default' && defaultFeature && /*#__PURE__*/React.createElement(FlexGrid.Row, {
      mdReverse: true
    }, /*#__PURE__*/React.createElement(FlexGrid.Col, {
      xs: 12,
      md: 6
    }, /*#__PURE__*/React.createElement(FeaturesPanel, {
      desktop: desktop,
      theme: "default",
      defaultBorderColor: defaultBorderColor,
      isDefault: true,
      selectedFeature: defaultFeature
    })), /*#__PURE__*/React.createElement(FlexGrid.Col, {
      xs: 12,
      md: 6
    }, Children.map(children, function (child) {
      // If the child is not of type AccordionList.Item then don't pass props.
      if (!child.props.features) {
        return child;
      }
      return /*#__PURE__*/cloneElement(child, {
        handleOnClickItem: handleOnClickItem,
        openPanels: openPanels,
        fade: fade
      });
    }))), desktop && (!defaultFeature || defaultFeature && openPanels[0] !== 'default') && /*#__PURE__*/React.createElement("div", {
      className: desktop ? styles$O.accordionList__grid : ''
    }, Children.map(children, function (child) {
      // If the child is not of type AccordionList.Item then don't pass props.
      if (!child.props.features) {
        return child;
      }
      return /*#__PURE__*/cloneElement(child, {
        handleOnClickItem: handleOnClickItem,
        openPanels: openPanels,
        fade: fade
      });
    })), !desktop && Children.map(children, function (child) {
      // If the child is not of type AccordionList.Item then don't pass props.
      if (!child.props.features) {
        return child;
      }
      return /*#__PURE__*/cloneElement(child, {
        handleOnClickItem: handleOnClickItem,
        openPanels: openPanels,
        fade: fade
      });
    })));
  });
};
AccordionList.propTypes = {
  /** Content to be displayed. Can be `AccordionList.Item`, other React components, text or HTML elements. */
  children: PropTypes.node.isRequired,
  /** Content to be displayed by default on desktop when no item is selected. */
  defaultFeature: PropTypes.node,
  /** When a previously selected item is clicked, render the default again. */
  repeatDefault: PropTypes.bool,
  /** Specify the id of a panel to be opened by default when the page loads. */
  openPanel: PropTypes.string,
  /** Specifies the border color for the default feature. */
  defaultBorderColor: PropTypes.string,
  /** Callback function to return the open/closed state of the panels to the parent component. */
  accessOpenPanels: PropTypes.func
};
AccordionList.defaultProps = {
  repeatDefault: false,
  defaultFeature: undefined,
  openPanel: undefined,
  defaultBorderColor: 'black',
  accessOpenPanels: function accessOpenPanels() {}
};
AccordionList.Item = Item;

var styles$N = {"inline":"KDS_Box-modules__inline___3FoV-","stack":"KDS_Box-modules__stack___2YVn3","verticalPadding-1":"KDS_Box-modules__verticalPadding-1___6YKkH","horizontalPadding-1":"KDS_Box-modules__horizontalPadding-1___3_lUw","bottomMargin-1":"KDS_Box-modules__bottomMargin-1___277Hp","betweenBottomMargin-1":"KDS_Box-modules__betweenBottomMargin-1___3sJRC","betweenRightMargin-1":"KDS_Box-modules__betweenRightMargin-1___1YCv8","verticalPadding-2":"KDS_Box-modules__verticalPadding-2___1Vqoa","horizontalPadding-2":"KDS_Box-modules__horizontalPadding-2___390JF","bottomMargin-2":"KDS_Box-modules__bottomMargin-2___2DdFs","betweenBottomMargin-2":"KDS_Box-modules__betweenBottomMargin-2___3mjY5","betweenRightMargin-2":"KDS_Box-modules__betweenRightMargin-2___soQAP","verticalPadding-3":"KDS_Box-modules__verticalPadding-3___2c_xq","horizontalPadding-3":"KDS_Box-modules__horizontalPadding-3___1-bGG","bottomMargin-3":"KDS_Box-modules__bottomMargin-3___1eEj9","betweenBottomMargin-3":"KDS_Box-modules__betweenBottomMargin-3___jh2kM","betweenRightMargin-3":"KDS_Box-modules__betweenRightMargin-3___15IU7","verticalPadding-4":"KDS_Box-modules__verticalPadding-4___1_FKx","horizontalPadding-4":"KDS_Box-modules__horizontalPadding-4___QiznK","bottomMargin-4":"KDS_Box-modules__bottomMargin-4___1VQLW","betweenBottomMargin-4":"KDS_Box-modules__betweenBottomMargin-4___3zlXh","betweenRightMargin-4":"KDS_Box-modules__betweenRightMargin-4___CG1-T","verticalPadding-5":"KDS_Box-modules__verticalPadding-5___ctuli","horizontalPadding-5":"KDS_Box-modules__horizontalPadding-5___17dy0","bottomMargin-5":"KDS_Box-modules__bottomMargin-5___nYdC1","betweenBottomMargin-5":"KDS_Box-modules__betweenBottomMargin-5___1VNeY","betweenRightMargin-5":"KDS_Box-modules__betweenRightMargin-5___1bMzu","verticalPadding-6":"KDS_Box-modules__verticalPadding-6___3kbMe","horizontalPadding-6":"KDS_Box-modules__horizontalPadding-6___lAgd7","bottomMargin-6":"KDS_Box-modules__bottomMargin-6___1WkJm","betweenBottomMargin-6":"KDS_Box-modules__betweenBottomMargin-6___kBY3s","betweenRightMargin-6":"KDS_Box-modules__betweenRightMargin-6___2bECf","verticalPadding-7":"KDS_Box-modules__verticalPadding-7___1H8PW","horizontalPadding-7":"KDS_Box-modules__horizontalPadding-7___8nfXK","bottomMargin-7":"KDS_Box-modules__bottomMargin-7___23YQL","betweenBottomMargin-7":"KDS_Box-modules__betweenBottomMargin-7___14qrX","betweenRightMargin-7":"KDS_Box-modules__betweenRightMargin-7___b4uAS","verticalPadding-8":"KDS_Box-modules__verticalPadding-8___3V4kT","horizontalPadding-8":"KDS_Box-modules__horizontalPadding-8___2yBqb","bottomMargin-8":"KDS_Box-modules__bottomMargin-8___U3_5c","betweenBottomMargin-8":"KDS_Box-modules__betweenBottomMargin-8___3uZLJ","betweenRightMargin-8":"KDS_Box-modules__betweenRightMargin-8___R8_Tb","verticalPaddingDesktop-1":"KDS_Box-modules__verticalPaddingDesktop-1___3Qgu3","horizontalPaddingDesktop-1":"KDS_Box-modules__horizontalPaddingDesktop-1___1FDQ_","bottomMarginDesktop-1":"KDS_Box-modules__bottomMarginDesktop-1___VeOzV","betweenBottomMarginDesktop-1":"KDS_Box-modules__betweenBottomMarginDesktop-1___2zqEH","betweenRightMarginDesktop-1":"KDS_Box-modules__betweenRightMarginDesktop-1___2AAoz","verticalPaddingDesktop-2":"KDS_Box-modules__verticalPaddingDesktop-2___3vEid","horizontalPaddingDesktop-2":"KDS_Box-modules__horizontalPaddingDesktop-2___2Kl-x","bottomMarginDesktop-2":"KDS_Box-modules__bottomMarginDesktop-2___1KxHU","betweenBottomMarginDesktop-2":"KDS_Box-modules__betweenBottomMarginDesktop-2___4bgi9","betweenRightMarginDesktop-2":"KDS_Box-modules__betweenRightMarginDesktop-2___3PMpw","verticalPaddingDesktop-3":"KDS_Box-modules__verticalPaddingDesktop-3___1_TKm","horizontalPaddingDesktop-3":"KDS_Box-modules__horizontalPaddingDesktop-3___32i0B","bottomMarginDesktop-3":"KDS_Box-modules__bottomMarginDesktop-3___142sm","betweenBottomMarginDesktop-3":"KDS_Box-modules__betweenBottomMarginDesktop-3___CkFj3","betweenRightMarginDesktop-3":"KDS_Box-modules__betweenRightMarginDesktop-3___1EHjU","verticalPaddingDesktop-4":"KDS_Box-modules__verticalPaddingDesktop-4___qUF_5","horizontalPaddingDesktop-4":"KDS_Box-modules__horizontalPaddingDesktop-4___JUoa0","bottomMarginDesktop-4":"KDS_Box-modules__bottomMarginDesktop-4___1mWxG","betweenBottomMarginDesktop-4":"KDS_Box-modules__betweenBottomMarginDesktop-4___mAijf","betweenRightMarginDesktop-4":"KDS_Box-modules__betweenRightMarginDesktop-4___cw4yw","verticalPaddingDesktop-5":"KDS_Box-modules__verticalPaddingDesktop-5___23F0O","horizontalPaddingDesktop-5":"KDS_Box-modules__horizontalPaddingDesktop-5___Yb6m5","bottomMarginDesktop-5":"KDS_Box-modules__bottomMarginDesktop-5___2xH4M","betweenBottomMarginDesktop-5":"KDS_Box-modules__betweenBottomMarginDesktop-5___23dDX","betweenRightMarginDesktop-5":"KDS_Box-modules__betweenRightMarginDesktop-5___2tRUC","verticalPaddingDesktop-6":"KDS_Box-modules__verticalPaddingDesktop-6___xGxBk","horizontalPaddingDesktop-6":"KDS_Box-modules__horizontalPaddingDesktop-6___DwWiU","bottomMarginDesktop-6":"KDS_Box-modules__bottomMarginDesktop-6___-9IH6","betweenBottomMarginDesktop-6":"KDS_Box-modules__betweenBottomMarginDesktop-6___5uynP","betweenRightMarginDesktop-6":"KDS_Box-modules__betweenRightMarginDesktop-6___38ZIa","verticalPaddingDesktop-7":"KDS_Box-modules__verticalPaddingDesktop-7___24QIu","horizontalPaddingDesktop-7":"KDS_Box-modules__horizontalPaddingDesktop-7___1JXCf","bottomMarginDesktop-7":"KDS_Box-modules__bottomMarginDesktop-7___1pRYN","betweenBottomMarginDesktop-7":"KDS_Box-modules__betweenBottomMarginDesktop-7___9wofb","betweenRightMarginDesktop-7":"KDS_Box-modules__betweenRightMarginDesktop-7___3G11L","verticalPaddingDesktop-8":"KDS_Box-modules__verticalPaddingDesktop-8___3xCld","horizontalPaddingDesktop-8":"KDS_Box-modules__horizontalPaddingDesktop-8___3mVdv","bottomMarginDesktop-8":"KDS_Box-modules__bottomMarginDesktop-8___3JP6R","betweenBottomMarginDesktop-8":"KDS_Box-modules__betweenBottomMarginDesktop-8___2P1i2","betweenRightMarginDesktop-8":"KDS_Box-modules__betweenRightMarginDesktop-8___116f-"};

var _excluded$Y = ["tag", "vertical", "horizontal", "inset", "below", "between", "inline", "dangerouslyAddClassName", "children"];
var viewportSuffix = function viewportSuffix(desktop) {
  return desktop ? 'Desktop' : '';
};
var getClassName$8 = function getClassName(spacing, location, scale, desktop) {
  if (!scale) {
    return undefined;
  }
  return styles$N["".concat(location).concat(capitalize(spacing)).concat(viewportSuffix(desktop), "-").concat(scale)];
};
var getBetweenClasses = function getBetweenClasses(scale, inline, desktop) {
  if (!scale) {
    return undefined;
  }
  var direction = inline ? 'Right' : 'Bottom';
  return joinClassNames(styles$N["between".concat(direction, "Margin").concat(viewportSuffix(desktop), "-").concat(scale)], inline ? styles$N.inline : styles$N.stack);
};

/**
 * Apply spacing within or around components.
 */
var Box = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var tag = _ref.tag,
    vertical = _ref.vertical,
    horizontal = _ref.horizontal,
    inset = _ref.inset,
    below = _ref.below,
    between = _ref.between,
    inline = _ref.inline,
    dangerouslyAddClassName = _ref.dangerouslyAddClassName,
    children = _ref.children,
    rest = _objectWithoutProperties$1(_ref, _excluded$Y);
  var xSize = inset || horizontal;
  var ySize = inset || vertical;
  return /*#__PURE__*/React.createElement(Responsive, {
    minWidth: "md"
  }, function (desktop) {
    var classes = joinClassNames(getClassName$8('padding', 'horizontal', xSize, desktop), getClassName$8('padding', 'vertical', ySize, desktop), getClassName$8('margin', 'bottom', below, desktop), getBetweenClasses(between, inline, desktop), dangerouslyAddClassName);
    return /*#__PURE__*/React.createElement(tag, _objectSpread2(_objectSpread2({
      className: classes || undefined
    }, safeRest(rest)), {}, {
      ref: ref
    }), children);
  });
});
Box.displayName = 'Box';
Box.propTypes = {
  /**
   * Specify an HTML element to render, such as `section`.
   */
  tag: PropTypes.string,
  /**
   * Indent content from the container's top and bottom edge by applying padding.
   */
  vertical: PropTypes.oneOf([1, 2, 3, 4, 5, 6, 7, 8]),
  /**
   * Indent content from the container's left and right edge by applying padding.
   */
  horizontal: PropTypes.oneOf([1, 2, 3, 4, 5, 6, 7, 8]),
  /**
   * Indent content from all of the container's edges by applying padding.
   */
  inset: PropTypes.oneOf([1, 2, 3, 4, 5, 6, 7, 8]),
  /**
   * @ignore
   *
   * We are keeping this hidden for now as we are not sold on the necessity.
   * We use it internally still to apply spacing to Markdown components,
   * but would like to use between instead if the library allows it.
   *
   * Sets a `margin-bottom`.
   */
  below: PropTypes.oneOf([1, 2, 3, 4, 5, 6, 7, 8]),
  /**
   * Create either a block or an inline stack, applying margin in between
   * every direct child. Margin will not be applied to the last component
   * in the stack.
   *
   * By default, `between` will arrange the Box's children as a flex column.
   * Combine with `inline` to arrange them as a flex row.
   */
  between: PropTypes.oneOf([1, 2, 3, 4, 5, 6, 7, 8]),
  /**
   * Arrange children in a row. Combine with `between` to apply margins
   * in between the row's elements.
   */
  inline: PropTypes.bool,
  /**
   * Append custom classes to `className`. Use sparingly, and do not
   * attempt to override Box style properties as that may cause unexpected behaviour.
   *
   * You would typically use this feature to apply flex alignment
   * properties in combination with `between`.
   */
  dangerouslyAddClassName: PropTypes.string,
  /**
   * The content. Can be text, any HTML element, or any component.
   */
  children: PropTypes.node.isRequired
};
Box.defaultProps = {
  inline: false,
  tag: 'div',
  vertical: undefined,
  horizontal: undefined,
  inset: undefined,
  below: undefined,
  between: undefined,
  dangerouslyAddClassName: undefined
};

var colors = {"flirt":"#7c1366","mosque":"#016b6a","texas":"#f9f6a5","amaranth":"#ee2c74","cardinal-pink":"#8c0448","trinidad":"#df3d0c","chestnut":"#bc4850","onahau":"#c3efff","burnt-sienna":"#ed6358","chathams-blue":"#17367d","mid-blue":"#1a347d","well-read":"#b8373e","wattle":"#d5e04d","beeswax":"#feeec7","bilbao":"#258b0b","sea-buckthorn":"#fbaf34","mint-tulip":"#c1f2e8","turquoise":"#39cdc9","hibiscus":"#c53a70","carousel-pink":"#fae6f4","white":"#fff","black":"#000","mortar":"#595959","gallery":"#efefef","silver":"#c9c8c8","dove":"#666666","iceberg":"#cbf0e8","icicle":"#e5f7fb","light-gray":"#fafafa","super-nova":"#fbaf33","expand-yellow":"#fee8b8","expand-yellow-light":"rgba(254, 232, 184, 0.5)","hero-pink":"#a6298c"};

var getColors = function getColors() {
  return colors;
};

function getTheme(theme, styles) {
  switch (theme) {
    case 'commerce':
      return styles.commerce;
    case 'secondary':
      return styles.secondary;
    case 'support':
      return styles.support;
    default:
      return undefined;
  }
}
function getThemeColorDark(theme) {
  switch (theme) {
    case 'commerce':
      return 'var(--color-chathams-blue)';
    case 'support':
      return 'var(--color-flirt)';
    case 'secondary':
      return 'var(--color-mosque)';
    default:
      return 'var(--color-chathams-blue)';
  }
}
function getThemeColorLight(theme) {
  switch (theme) {
    case 'commerce':
      return 'var(--color-onahau)';
    case 'support':
      return 'var(--color-onahau)';
    case 'secondary':
      return 'var(--color-mint-tulip)';
    default:
      return 'var(--color-onahau)';
  }
}
function newShade(color, percent) {
  var R = parseInt(color.substring(1, 3), 16);
  var G = parseInt(color.substring(3, 5), 16);
  var B = parseInt(color.substring(5, 7), 16);
  R = parseInt(R * (100 + percent) / 100, 10);
  G = parseInt(G * (100 + percent) / 100, 10);
  B = parseInt(B * (100 + percent) / 100, 10);
  R = R < 255 ? R : 255;
  G = G < 255 ? G : 255;
  B = B < 255 ? B : 255;
  R = Math.round(R);
  G = Math.round(G);
  B = Math.round(B);
  var RR = R.toString(16).length === 1 ? "0".concat(R.toString(16)) : R.toString(16);
  var GG = G.toString(16).length === 1 ? "0".concat(G.toString(16)) : G.toString(16);
  var BB = B.toString(16).length === 1 ? "0".concat(B.toString(16)) : B.toString(16);
  return "#".concat(RR).concat(GG).concat(BB);
}
function getThemeColorHover(theme) {
  var colors = getColors();
  var themeColor;
  switch (theme) {
    case 'commerce':
      themeColor = colors['chathams-blue'];
      break;
    case 'support':
      themeColor = colors.flirt;
      break;
    case 'secondary':
      themeColor = colors.mosque;
      break;
    default:
      themeColor = colors['chathams-blue'];
  }
  return newShade(themeColor, -7);
}

var styles$M = {"flirt":"#7c1366","mosque":"#016b6a","texas":"#f9f6a5","amaranth":"#ee2c74","cardinal-pink":"#8c0448","trinidad":"#df3d0c","chestnut":"#bc4850","onahau":"#c3efff","burnt-sienna":"#ed6358","chathams-blue":"#17367d","mid-blue":"#1a347d","well-read":"#b8373e","wattle":"#d5e04d","beeswax":"#feeec7","bilbao":"#258b0b","sea-buckthorn":"#fbaf34","mint-tulip":"#c1f2e8","turquoise":"#39cdc9","hibiscus":"#c53a70","carousel-pink":"#fae6f4","white":"#fff","black":"#000","mortar":"#595959","gallery":"#efefef","silver":"#c9c8c8","dove":"#666666","iceberg":"#cbf0e8","icicle":"#e5f7fb","light-gray":"#fafafa","super-nova":"#fbaf33","expand-yellow":"#fee8b8","expand-yellow-light":"rgba(254, 232, 184, 0.5)","hero-pink":"#a6298c","button":"KDS_ButtonLink-modules__button___q7dU4","sharp":"KDS_ButtonLink-modules__sharp___1C6gb","primary":"KDS_ButtonLink-modules__primary___1AKQu KDS_ButtonLink-modules__button___q7dU4 KDS_ButtonLink-modules__base___1d_sX","clear":"KDS_ButtonLink-modules__clear___1Y0gb","inactive":"KDS_ButtonLink-modules__inactive___B7G9X KDS_ButtonLink-modules__button___q7dU4","commerce":"KDS_ButtonLink-modules__commerce___1oxAc KDS_ButtonLink-modules__primary___1AKQu KDS_ButtonLink-modules__button___q7dU4 KDS_ButtonLink-modules__base___1d_sX","secondary":"KDS_ButtonLink-modules__secondary___WLtX-","tertiary":"KDS_ButtonLink-modules__tertiary___2Rgi4","support":"KDS_ButtonLink-modules__support___gXHdI KDS_ButtonLink-modules__primary___1AKQu KDS_ButtonLink-modules__button___q7dU4 KDS_ButtonLink-modules__base___1d_sX","disabled":"KDS_ButtonLink-modules__disabled___1ihi_ KDS_ButtonLink-modules__button___q7dU4","fullWidth":"KDS_ButtonLink-modules__fullWidth___iO_O5","smallSize":"KDS_ButtonLink-modules__smallSize___36eAS","customButton":"KDS_ButtonLink-modules__customButton___NQKQz","link":"KDS_ButtonLink-modules__link___2BUYm","legal":"KDS_ButtonLink-modules__legal___2D3Cd","buttonColor":"KDS_ButtonLink-modules__buttonColor___P_EYB KDS_ButtonLink-modules__button___q7dU4","buttonColorOutlined":"KDS_ButtonLink-modules__buttonColorOutlined___3ul-R KDS_ButtonLink-modules__button___q7dU4","buttonColorInverse":"KDS_ButtonLink-modules__buttonColorInverse___1twgg KDS_ButtonLink-modules__button___q7dU4","buttonColorInverseOutlined":"KDS_ButtonLink-modules__buttonColorInverseOutlined___3WtkF KDS_ButtonLink-modules__button___q7dU4","buttonInactive":"KDS_ButtonLink-modules__buttonInactive___1GBj1 KDS_ButtonLink-modules__button___q7dU4","base":"KDS_ButtonLink-modules__base___1d_sX","cancel":"KDS_ButtonLink-modules__cancel___2PV_R undefined KDS_ButtonLink-modules__base___1d_sX","cancelColor":"KDS_ButtonLink-modules__cancelColor___3bneD","timesIcon":"KDS_ButtonLink-modules__timesIcon___2euqV KDS_ChevronLink-modules__chevron___46DvW"};

var _excluded$X = ["reactRouterLinkComponent", "variant", "theme", "children", "target", "sharp", "dangerouslyAddClassName", "clear"];
var getClassName$7 = function getClassName(theme, variant, sharp, clear, dangerouslyAddClassName) {
  return joinClassNames(getTheme(theme, styles$M), styles$M[variant], sharp ? styles$M.sharp : null, clear ? styles$M.clear : null, dangerouslyAddClassName);
};
var ButtonLink = function ButtonLink(_ref) {
  var reactRouterLinkComponent = _ref.reactRouterLinkComponent,
    variant = _ref.variant,
    theme = _ref.theme,
    children = _ref.children,
    target = _ref.target,
    sharp = _ref.sharp,
    dangerouslyAddClassName = _ref.dangerouslyAddClassName,
    clear = _ref.clear,
    rest = _objectWithoutProperties$1(_ref, _excluded$X);
  if ((reactRouterLinkComponent || rest.to) && !(reactRouterLinkComponent && rest.to)) {
    warn('Link Button', 'The props `reactRouterLinkComponent` and `to` must be used together.');
  }
  var innerLink = null;
  if (variant === 'cancel') {
    innerLink = /*#__PURE__*/React.createElement(Box, {
      inline: true,
      between: 2,
      dangerouslyAddClassName: styles$M.cancelColor
    }, /*#__PURE__*/React.createElement("span", null, children));
  } else {
    innerLink = children;
  }
  return /*#__PURE__*/React.createElement(reactRouterLinkComponent || 'a', _objectSpread2(_objectSpread2({}, safeRest(rest)), {}, {
    className: getClassName$7(theme, variant, sharp, clear, dangerouslyAddClassName),
    target: "_".concat(target)
  }), innerLink);
};
ButtonLink.propTypes = {
  /**
   * The style.
   */
  variant: PropTypes.oneOf(['primary', 'secondary', 'tertiary', 'cancel']),
  /**
   * The theme.
   */
  theme: PropTypes.oneOf(['commerce', 'support']),
  /**
   * React Router Link component.
   */
  /** Supplies a clear button with the default color. */
  clear: PropTypes.bool,
  reactRouterLinkComponent: PropTypes.func,
  /**
   * Target URL (if using 'reactRouterLinkComponent')
   */
  to: PropTypes.string,
  /**
   * Target URL
   */
  href: PropTypes.string,
  /**
   * The label.
   */
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  dangerouslyAddClassName: PropTypes.string,
  /**
   * Where to display the linked URL.
   * Options taken from https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#attr-target
   */
  target: PropTypes.oneOf(['self', 'blank', 'parent', 'top']),
  /** The corners of the button where the defaulted border-radius is 4px and sharp is 0px. */
  sharp: PropTypes.bool
};
ButtonLink.defaultProps = {
  variant: 'primary',
  theme: undefined,
  clear: false,
  reactRouterLinkComponent: null,
  to: null,
  href: null,
  dangerouslyAddClassName: undefined,
  target: 'self',
  sharp: false
};

var styles$L = {"flirt":"#7c1366","mosque":"#016b6a","texas":"#f9f6a5","amaranth":"#ee2c74","cardinal-pink":"#8c0448","trinidad":"#df3d0c","chestnut":"#bc4850","onahau":"#c3efff","burnt-sienna":"#ed6358","chathams-blue":"#17367d","mid-blue":"#1a347d","well-read":"#b8373e","wattle":"#d5e04d","beeswax":"#feeec7","bilbao":"#258b0b","sea-buckthorn":"#fbaf34","mint-tulip":"#c1f2e8","turquoise":"#39cdc9","hibiscus":"#c53a70","carousel-pink":"#fae6f4","white":"#fff","black":"#000","mortar":"#595959","gallery":"#efefef","silver":"#c9c8c8","dove":"#666666","iceberg":"#cbf0e8","icicle":"#e5f7fb","light-gray":"#fafafa","super-nova":"#fbaf33","expand-yellow":"#fee8b8","expand-yellow-light":"rgba(254, 232, 184, 0.5)","hero-pink":"#a6298c","sup":"KDS_Heading-modules__sup___2Xl0f KDS_Text-modules__basesupsubscripts___3YKPl","base":"KDS_Heading-modules__base___2SLsB KDS_Typography-modules__wordbreak___2hwoO KDS_Spacing-modules__nospacing___11hAP","h1--selfServe":"KDS_Heading-modules__h1--selfServe___3rakj KDS_Heading-modules__base___2SLsB KDS_Typography-modules__wordbreak___2hwoO KDS_Spacing-modules__nospacing___11hAP","h1--commerce":"KDS_Heading-modules__h1--commerce___3ZRNh KDS_Heading-modules__base___2SLsB KDS_Typography-modules__wordbreak___2hwoO KDS_Spacing-modules__nospacing___11hAP","h1--universal":"KDS_Heading-modules__h1--universal___1cmq9 KDS_Heading-modules__base___2SLsB KDS_Typography-modules__wordbreak___2hwoO KDS_Spacing-modules__nospacing___11hAP","h1Desktop--selfServe":"KDS_Heading-modules__h1Desktop--selfServe___34Xer KDS_Heading-modules__base___2SLsB KDS_Typography-modules__wordbreak___2hwoO KDS_Spacing-modules__nospacing___11hAP","h1Desktop--commerce":"KDS_Heading-modules__h1Desktop--commerce___3UwOL KDS_Heading-modules__base___2SLsB KDS_Typography-modules__wordbreak___2hwoO KDS_Spacing-modules__nospacing___11hAP","h2--selfServe":"KDS_Heading-modules__h2--selfServe___14YtG KDS_Heading-modules__base___2SLsB KDS_Typography-modules__wordbreak___2hwoO KDS_Spacing-modules__nospacing___11hAP","h2--commerce":"KDS_Heading-modules__h2--commerce___1FfEQ KDS_Heading-modules__base___2SLsB KDS_Typography-modules__wordbreak___2hwoO KDS_Spacing-modules__nospacing___11hAP","h2--universal":"KDS_Heading-modules__h2--universal___26L-g KDS_Heading-modules__base___2SLsB KDS_Typography-modules__wordbreak___2hwoO KDS_Spacing-modules__nospacing___11hAP","h2Desktop--selfServe":"KDS_Heading-modules__h2Desktop--selfServe___2qUNY KDS_Heading-modules__base___2SLsB KDS_Typography-modules__wordbreak___2hwoO KDS_Spacing-modules__nospacing___11hAP","h2Desktop--commerce":"KDS_Heading-modules__h2Desktop--commerce___jYE6T KDS_Heading-modules__base___2SLsB KDS_Typography-modules__wordbreak___2hwoO KDS_Spacing-modules__nospacing___11hAP","h3--selfServe":"KDS_Heading-modules__h3--selfServe___1WQ65 KDS_Heading-modules__base___2SLsB KDS_Typography-modules__wordbreak___2hwoO KDS_Spacing-modules__nospacing___11hAP","h4Desktop--selfServe":"KDS_Heading-modules__h4Desktop--selfServe___3xoK9 KDS_Heading-modules__base___2SLsB KDS_Typography-modules__wordbreak___2hwoO KDS_Spacing-modules__nospacing___11hAP","h3Desktop--selfServe":"KDS_Heading-modules__h3Desktop--selfServe___2IaWZ KDS_Heading-modules__base___2SLsB KDS_Typography-modules__wordbreak___2hwoO KDS_Spacing-modules__nospacing___11hAP","h3--commerce":"KDS_Heading-modules__h3--commerce___1fK_b KDS_Heading-modules__base___2SLsB KDS_Typography-modules__wordbreak___2hwoO KDS_Spacing-modules__nospacing___11hAP","h3--universal":"KDS_Heading-modules__h3--universal___38XEz KDS_Heading-modules__base___2SLsB KDS_Typography-modules__wordbreak___2hwoO KDS_Spacing-modules__nospacing___11hAP","h3Desktop--commerce":"KDS_Heading-modules__h3Desktop--commerce___3hLJR KDS_Heading-modules__base___2SLsB KDS_Typography-modules__wordbreak___2hwoO KDS_Spacing-modules__nospacing___11hAP","h4--selfServe":"KDS_Heading-modules__h4--selfServe___1ptZD KDS_Heading-modules__base___2SLsB KDS_Typography-modules__wordbreak___2hwoO KDS_Spacing-modules__nospacing___11hAP","h4--commerce":"KDS_Heading-modules__h4--commerce___1RMTs KDS_Heading-modules__base___2SLsB KDS_Typography-modules__wordbreak___2hwoO KDS_Spacing-modules__nospacing___11hAP","h4--universal":"KDS_Heading-modules__h4--universal___uVVXc KDS_Heading-modules__base___2SLsB KDS_Typography-modules__wordbreak___2hwoO KDS_Spacing-modules__nospacing___11hAP","h4Desktop--commerce":"KDS_Heading-modules__h4Desktop--commerce___sfull KDS_Heading-modules__base___2SLsB KDS_Typography-modules__wordbreak___2hwoO KDS_Spacing-modules__nospacing___11hAP","h5--universal":"KDS_Heading-modules__h5--universal___2IPyv KDS_Heading-modules__base___2SLsB KDS_Typography-modules__wordbreak___2hwoO KDS_Spacing-modules__nospacing___11hAP","h6--universal":"KDS_Heading-modules__h6--universal___2fZQG KDS_Heading-modules__base___2SLsB KDS_Typography-modules__wordbreak___2hwoO KDS_Spacing-modules__nospacing___11hAP","default":"KDS_Heading-modules__default___SYOiV"};

var _excluded$W = ["children"];

/**
 * Superscript text for `Heading` an as HTML `<sup>` element.
 *
 * _This component can only be accessed as a name-spaced component: `Heading.Sup`._
 */
var HeadingSup = function HeadingSup(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties$1(_ref, _excluded$W);
  return /*#__PURE__*/React.createElement("sup", _extends$1({}, safeRest(rest), {
    className: styles$L.sup
  }), children);
};
HeadingSup.propTypes = {
  /**
   * The text.
   */
  children: PropTypes.string.isRequired
};

var _excluded$V = ["level", "theme", "color", "children"];

/**
 * Page headings. Renders an HTML `<h1-h4>` element.
 */
var Heading$1 = function Heading(_ref) {
  var _ref$level = _ref.level,
    level = _ref$level === void 0 ? 'h1' : _ref$level,
    theme = _ref.theme,
    color = _ref.color,
    children = _ref.children,
    rest = _objectWithoutProperties$1(_ref, _excluded$V);
  if (theme === 'universal') {
    return /*#__PURE__*/React.createElement(level, _objectSpread2(_objectSpread2({}, safeRest(rest)), {}, {
      className: joinClassNames(styles$L["".concat(level, "--universal")], "".concat(styles$L["default"])),
      style: {
        '--font-color': "var(--color-".concat(color, ")")
      }
    }), children);
  }
  return /*#__PURE__*/React.createElement(Responsive, {
    minWidth: theme === 'commerce' ? 'lg' : 'md'
  }, function (desktop) {
    return /*#__PURE__*/React.createElement(level, _objectSpread2(_objectSpread2({}, safeRest(rest)), {}, {
      className: joinClassNames(styles$L["".concat(level).concat(desktop ? 'Desktop' : '', "--").concat(theme)], "".concat(styles$L["default"])),
      style: {
        '--font-color': "var(--color-".concat(color, ")")
      }
    }), children);
  });
};
Heading$1.propTypes = {
  /**
   * The heading level.
   */
  level: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4']).isRequired,
  /**
   * Font color. Must be from the list of available [`Colours`](#section-colours).
   */
  color: PropTypes.string,
  /**
   * Determines the font sizes for each heading breakpoint for styling changes.
   */
  theme: PropTypes.oneOf(['selfServe', 'commerce', 'universal']),
  /**
   * The text. Can be text, other components, or HTML elements.
   */
  children: PropTypes.node.isRequired
};
Heading$1.defaultProps = {
  color: 'font',
  theme: 'selfServe'
};
Heading$1.Sup = HeadingSup;

var _excluded$U = ["children", "color"];

/**
 * Superscript text an as HTML `<sup>` element.
 *
 * _This component can only be accessed as a name-spaced component: `Text.Sup`._
 */
var TextSup = function TextSup(_ref) {
  var children = _ref.children,
    color = _ref.color,
    rest = _objectWithoutProperties$1(_ref, _excluded$U);
  return /*#__PURE__*/React.createElement("sup", _extends$1({}, safeRest(rest), {
    className: "".concat(styles$X.sup, " ").concat(!color ? styles$X.inheritColor : styles$X.color),
    style: {
      '--font-color': "var(--color-".concat(color, ")")
    }
  }), children);
};
TextSup.propTypes = {
  /**
   * The text.
   */
  children: PropTypes.node.isRequired,
  /**
   * Font color when not inheriting. Must be from the list of available [`Colours`](#section-colours).
   */
  color: PropTypes.string
};
TextSup.defaultProps = {
  color: undefined
};

var _excluded$T = ["block", "bold", "lightBold", "semiBold", "size", "invert", "children", "color"];

/**
 * Inline text as an HTML `<span>` element.
 */

var Text$2 = function Text(_ref) {
  var block = _ref.block,
    bold = _ref.bold,
    lightBold = _ref.lightBold,
    semiBold = _ref.semiBold,
    size = _ref.size,
    invert = _ref.invert,
    children = _ref.children,
    color = _ref.color,
    rest = _objectWithoutProperties$1(_ref, _excluded$T);
  var classes = joinClassNames(styles$X[size], bold ? styles$X.boldFont : '', semiBold ? styles$X.semiBoldFont : '', lightBold ? styles$X.mediumBoldFont : '', invert ? styles$X.invertedColor : '', color ? styles$X.color : styles$X.inheritColor);
  return /*#__PURE__*/React.createElement(block ? 'div' : 'span', _objectSpread2(_objectSpread2({}, safeRest(rest)), {}, {
    className: classes,
    style: color ? {
      '--font-color': "var(--color-".concat(color, ")")
    } : {}
  }), children);
};
Text$2.propTypes = {
  /**
   * ** *deprecated* ** If true, renders a block level ```<div>``` element.
   * Otherwise, renders an inline ```<span>``` element.
   */
  block: PropTypes.bool,
  /**
   * Embolden text without conveying any special importance or relevance.
   */
  bold: PropTypes.bool,
  /**
   * Lightly embolden text without conveying any special importance or relevance.
   */
  semiBold: PropTypes.bool,
  /**
   * Slightly embolden text without conveying any special importance or relevance.
   */
  lightBold: PropTypes.bool,
  /**
   * The font size.
   */
  size: PropTypes.oneOf(['base', 'small', 'medium', 'large']),
  /**
   * Font color when not inheriting. Must be from the list of available [`Colours`](#section-colours).
   */
  color: PropTypes.string,
  /**
   * Invert the text color to appear white on dark backgrounds.
   */
  invert: PropTypes.bool,
  /**
   * The content. Can be text, other components, or HTML elements.
   */
  children: PropTypes.node.isRequired
};
Text$2.defaultProps = {
  block: false,
  bold: false,
  semiBold: false,
  lightBold: false,
  size: 'base',
  invert: false,
  color: undefined
};
Text$2.Sup = TextSup;

/**
 *
 * A Generic Banner that can be used anywhere (mainly for help pages).
 */
var Banner = function Banner(_ref) {
  var desktop = _ref.desktop,
    mobile = _ref.mobile,
    button = _ref.button;
  return /*#__PURE__*/React.createElement(Responsive, {
    minWidth: "md"
  }, function (matches) {
    return matches ?
    /*#__PURE__*/
    // desktop version
    React.createElement("div", {
      style: {
        backgroundImage: "url(".concat(desktop.backgroundImage, ")"),
        backgroundPosition: "right -".concat(desktop.backgroundImageOffset, "px center"),
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat'
      }
    }, /*#__PURE__*/React.createElement(Box, {
      between: 4,
      inset: 4
    }, /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement("div", {
      style: {
        width: desktop.textBoxWidth
      }
    }, /*#__PURE__*/React.createElement(Heading$1, {
      level: desktop.heading.level
    }, /*#__PURE__*/React.createElement("span", {
      style: desktop.heading.style,
      dangerouslySetInnerHTML: {
        __html: desktop.heading.text
      }
    })), /*#__PURE__*/React.createElement(Text$2, {
      size: desktop.subText.size
    }, /*#__PURE__*/React.createElement("span", {
      style: desktop.subText.style,
      dangerouslySetInnerHTML: {
        __html: desktop.subText.text
      }
    })))), /*#__PURE__*/React.createElement(ButtonLink, {
      href: button.link,
      variant: button.variant,
      target: button.target
    }, button.text))) :
    /*#__PURE__*/
    // mobile version
    React.createElement("div", {
      style: {
        backgroundImage: "url(".concat(mobile.backgroundImage, ")"),
        backgroundPosition: 'right center',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        height: mobile.backgroundImageHeight
      }
    }, /*#__PURE__*/React.createElement(Box, {
      between: 4,
      horizontal: 4,
      vertical: 6
    }, /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Heading$1, {
      level: mobile.heading.level
    }, /*#__PURE__*/React.createElement("span", {
      style: mobile.heading.style,
      dangerouslySetInnerHTML: {
        __html: mobile.heading.text
      }
    })), /*#__PURE__*/React.createElement(Text$2, {
      size: mobile.subText.size
    }, /*#__PURE__*/React.createElement("span", {
      style: mobile.subText.style,
      dangerouslySetInnerHTML: {
        __html: mobile.subText.text
      }
    }))), /*#__PURE__*/React.createElement(ButtonLink, {
      href: button.link,
      variant: button.variant
    }, button.text)));
  });
};
Banner.propTypes = {
  /**
   * Desktop settings
   */
  desktop: PropTypes.shape({
    backgroundImage: PropTypes.string,
    backgroundImageOffset: PropTypes.number,
    heading: PropTypes.shape({
      level: PropTypes.string,
      text: PropTypes.string,
      style: PropTypes.object
    }),
    subText: PropTypes.shape({
      size: PropTypes.string,
      text: PropTypes.string,
      style: PropTypes.object
    }),
    textBoxWidth: PropTypes.string
  }),
  /**
   * Mobile settings
   */
  mobile: PropTypes.shape({
    backgroundImage: PropTypes.string,
    backgroundImageHeight: PropTypes.string,
    heading: PropTypes.shape({
      level: PropTypes.string,
      text: PropTypes.string,
      style: PropTypes.object
    }),
    subText: PropTypes.shape({
      size: PropTypes.string,
      text: PropTypes.string,
      style: PropTypes.object
    })
  }),
  /**
   * The CTA button link
   */
  button: PropTypes.shape({
    text: PropTypes.string,
    link: PropTypes.string,
    variant: PropTypes.oneOf(['primary', 'orange', 'grey', 'white']),
    /**
     * Where to display the linked URL.
     * Options taken from https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#attr-target
     */
    target: PropTypes.oneOf(['self', 'blank', 'parent', 'top'])
  })
};
Banner.defaultProps = {
  desktop: {
    backgroundImage: 'https://images.ctfassets.net/8cecwr1x4jkf/50GIbF6LYxnU6TfqVR7N8s/29258e2d3fee2214771cd3860a5b1f06/heart_desktop.svg',
    backgroundImageOffset: 0,
    heading: {
      level: 'h2',
      text: 'Not fully satisfied with your plan?',
      style: {
        color: '#016B6A'
      }
    },
    subText: {
      size: 'large',
      text: 'Check the Plans page for any offers you might have.',
      style: {
        color: '#016B6A'
      }
    },
    textBoxWidth: '60%'
  },
  mobile: {
    backgroundImage: 'https://images.ctfassets.net/8cecwr1x4jkf/1UevojbUNXtKY3XNcTLfof/00598cacab3b01cc548ff49444e02e97/heart_mobile.svg',
    backgroundImageHeight: '28rem',
    heading: {
      level: 'h1',
      text: 'Not fully satisfied with your plan?',
      style: {
        color: '#016B6A'
      }
    },
    subText: {
      size: 'medium',
      text: 'Check the Plans page for any offers you might have.',
      style: {
        color: '#016B6A'
      }
    }
  },
  button: {
    text: 'Log in to see offers',
    link: 'https://www.telus.com/en',
    variant: 'primary',
    target: 'self'
  }
};

var styles$K = {"flirt":"#7c1366","mosque":"#016b6a","texas":"#f9f6a5","amaranth":"#ee2c74","cardinal-pink":"#8c0448","trinidad":"#df3d0c","chestnut":"#bc4850","onahau":"#c3efff","burnt-sienna":"#ed6358","chathams-blue":"#17367d","mid-blue":"#1a347d","well-read":"#b8373e","wattle":"#d5e04d","beeswax":"#feeec7","bilbao":"#258b0b","sea-buckthorn":"#fbaf34","mint-tulip":"#c1f2e8","turquoise":"#39cdc9","hibiscus":"#c53a70","carousel-pink":"#fae6f4","white":"#fff","black":"#000","mortar":"#595959","gallery":"#efefef","silver":"#c9c8c8","dove":"#666666","iceberg":"#cbf0e8","icicle":"#e5f7fb","light-gray":"#fafafa","super-nova":"#fbaf33","expand-yellow":"#fee8b8","expand-yellow-light":"rgba(254, 232, 184, 0.5)","hero-pink":"#a6298c","button":"KDS_Button-modules__button___iH8KX","sharp":"KDS_Button-modules__sharp___25Yg5","primary":"KDS_Button-modules__primary___2hYEU KDS_Button-modules__button___iH8KX","clear":"KDS_Button-modules__clear___cCWDE","inactive":"KDS_Button-modules__inactive___3uXmv KDS_Button-modules__button___iH8KX","commerce":"KDS_Button-modules__commerce___1_MZ9 KDS_Button-modules__primary___2hYEU KDS_Button-modules__button___iH8KX","secondary":"KDS_Button-modules__secondary___3JPrp","tertiary":"KDS_Button-modules__tertiary___3JyId","support":"KDS_Button-modules__support___3BDK2 KDS_Button-modules__primary___2hYEU KDS_Button-modules__button___iH8KX","disabled":"KDS_Button-modules__disabled___3EaQL KDS_Button-modules__button___iH8KX","fullWidth":"KDS_Button-modules__fullWidth___zWqAD","smallSize":"KDS_Button-modules__smallSize___2lhJf","customButton":"KDS_Button-modules__customButton___1i1cp","link":"KDS_Button-modules__link___HD0-O","legal":"KDS_Button-modules__legal___3ODex","buttonColor":"KDS_Button-modules__buttonColor___1_9Og KDS_Button-modules__button___iH8KX","buttonColorOutlined":"KDS_Button-modules__buttonColorOutlined___1kUyJ KDS_Button-modules__button___iH8KX","buttonColorInverse":"KDS_Button-modules__buttonColorInverse___2pwPN KDS_Button-modules__button___iH8KX","buttonColorInverseOutlined":"KDS_Button-modules__buttonColorInverseOutlined___3oTqY KDS_Button-modules__button___iH8KX","buttonInactive":"KDS_Button-modules__buttonInactive___2Q54h KDS_Button-modules__button___iH8KX"};

var _excluded$S = ["children", "theme", "type", "variant", "sharp", "clear", "disabled", "customType", "textColor", "fullWidth", "color", "inverse", "outlined", "inactive", "smallSize", "version"];
var getColor = function getColor(inverse, outlined, smallSize) {
  var className = inverse ? styles$K.buttonColorInverse : styles$K.buttonColor;
  if (outlined) {
    className = inverse ? styles$K.buttonColorInverseOutlined : styles$K.buttonColorOutlined;
  }
  return joinClassNames(className, smallSize ? styles$K.smallSize : null);
};
var ConditionalSuperScript$1 = function ConditionalSuperScript(_ref) {
  var condition = _ref.condition,
    wrapper = _ref.wrapper,
    children = _ref.children;
  return condition ? wrapper(children) : children;
};
var getClassName$6 = function getClassName(theme, variant, sharp, clear, disabled, fullWidth, inverse, outlined, inactive, smallSize, version) {
  if (disabled) {
    return joinClassNames(styles$K.disabled, fullWidth ? styles$K.fullWidth : null, smallSize ? styles$K.smallSize : null);
  }
  if (version === 2) {
    return joinClassNames(inactive ? styles$K.buttonInactive : getColor(inverse, outlined, smallSize));
  }
  return joinClassNames(getTheme(theme, styles$K), styles$K[variant], sharp ? styles$K.sharp : null, clear ? styles$K.clear : null, fullWidth ? styles$K.fullWidth : null, smallSize ? styles$K.smallSize : null);
};
var buttonWrapper = function buttonWrapper(buttonText) {
  return /*#__PURE__*/React.createElement(Text$2.Sup, null, buttonText);
};
var Button = /*#__PURE__*/forwardRef(function (_ref2, ref) {
  var children = _ref2.children,
    theme = _ref2.theme,
    type = _ref2.type,
    variant = _ref2.variant,
    sharp = _ref2.sharp,
    clear = _ref2.clear,
    disabled = _ref2.disabled,
    customType = _ref2.customType,
    textColor = _ref2.textColor,
    fullWidth = _ref2.fullWidth,
    color = _ref2.color,
    inverse = _ref2.inverse,
    outlined = _ref2.outlined,
    inactive = _ref2.inactive,
    smallSize = _ref2.smallSize,
    version = _ref2.version,
    rest = _objectWithoutProperties$1(_ref2, _excluded$S);
  return /*#__PURE__*/React.createElement(ConditionalSuperScript$1, {
    condition: customType === 'legal',
    wrapper: buttonWrapper
  }, /*#__PURE__*/React.createElement("button", _extends$1({
    className: customType ? "".concat(styles$K.customButton, " ").concat(styles$K[customType]) : getClassName$6(theme, variant, sharp, clear, disabled, fullWidth, inverse, outlined, inactive, smallSize, version),
    ref: ref,
    type: type // eslint-disable-line
  }, safeRest(rest), {
    style: textColor && customType ? {
      '--font-color': "var(--color-".concat(textColor, ")")
    } : {
      '--color': "var(--color-".concat(color, ")")
    },
    "aria-disabled": disabled
  }), children));
});
Button.displayName = 'Button';
Button.propTypes = {
  /** The label inside the button. */
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  /** The HTML button type. */
  type: PropTypes.oneOf(['button', 'submit', 'reset']),
  /** An unspecified themed button will default to a green background. */
  theme: PropTypes.oneOf(['commerce', 'support']),
  /** Each theme (ie. Commerce, Support) has its own variant: Commerce: [primary, secondary, tertiary]. Support: [primary]  */
  variant: PropTypes.oneOf(['primary', 'secondary', 'tertiary', 'inactive']),
  /** The corners of the button where the defaulted border-radius is 4px and sharp is 0px. */
  sharp: PropTypes.bool,
  /** Supplies a clear button with the default color. */
  clear: PropTypes.bool,
  /** Supplies button in a disabled state. */
  disabled: PropTypes.bool,
  /** Custom button types with very specific styling. */
  customType: PropTypes.oneOf(['link', 'legal']),
  /** Color of the text.  *Only applies to custom buttons.* */
  textColor: PropTypes.string,
  /** Full width if enabled */
  fullWidth: PropTypes.bool,
  /** Color - color of the button. Accepts one of KDS standard colors */
  color: PropTypes.string,
  /** Inverse - Inverts (white) the color of the button */
  inverse: PropTypes.bool,
  /** Outlined - Outlined variant */
  outlined: PropTypes.bool,
  /** Inactive - disabled the button and applied inactive styling */
  inactive: PropTypes.bool,
  /** Version - If 2, uses updated version of the button (using color prop instead of theme/variant) */
  version: PropTypes.number,
  /** Small size - makes min-width 86px instead of 180px */
  smallSize: PropTypes.bool
};
Button.defaultProps = {
  theme: undefined,
  type: 'button',
  variant: 'primary',
  sharp: false,
  clear: false,
  disabled: false,
  fullWidth: false,
  customType: undefined,
  textColor: undefined,
  color: 'mosque',
  inverse: false,
  outlined: false,
  inactive: false,
  version: 0,
  smallSize: false
};

var styles$J = {"flirt":"#7c1366","mosque":"#016b6a","texas":"#f9f6a5","amaranth":"#ee2c74","cardinal-pink":"#8c0448","trinidad":"#df3d0c","chestnut":"#bc4850","onahau":"#c3efff","burnt-sienna":"#ed6358","chathams-blue":"#17367d","mid-blue":"#1a347d","well-read":"#b8373e","wattle":"#d5e04d","beeswax":"#feeec7","bilbao":"#258b0b","sea-buckthorn":"#fbaf34","mint-tulip":"#c1f2e8","turquoise":"#39cdc9","hibiscus":"#c53a70","carousel-pink":"#fae6f4","white":"#fff","black":"#000","mortar":"#595959","gallery":"#efefef","silver":"#c9c8c8","dove":"#666666","iceberg":"#cbf0e8","icicle":"#e5f7fb","light-gray":"#fafafa","super-nova":"#fbaf33","expand-yellow":"#fee8b8","expand-yellow-light":"rgba(254, 232, 184, 0.5)","hero-pink":"#a6298c","chevron":"KDS_ChevronLink-modules__chevron___46DvW","chevronRight":"KDS_ChevronLink-modules__chevronRight___1EDhv KDS_ChevronLink-modules__chevron___46DvW","chevronLeft":"KDS_ChevronLink-modules__chevronLeft___1xGaj KDS_ChevronLink-modules__chevron___46DvW","chevronDown":"KDS_ChevronLink-modules__chevronDown___aRkFM KDS_ChevronLink-modules__chevron___46DvW","chevronUp":"KDS_ChevronLink-modules__chevronUp___2SGmV KDS_ChevronLink-modules__chevron___46DvW","link":"KDS_ChevronLink-modules__link___WXk0N KDS_Text-modules__medium___1SwM7 KDS_Typography-modules__wordbreak___2hwoO","link-non-animated":"KDS_ChevronLink-modules__link-non-animated___2jhXZ KDS_Text-modules__medium___1SwM7 KDS_Typography-modules__wordbreak___2hwoO","chevInnerLink":"KDS_ChevronLink-modules__chevInnerLink___3-hjg","chevInnerLink--underline":"KDS_ChevronLink-modules__chevInnerLink--underline___3ghFH","chevInnerLink--left":"KDS_ChevronLink-modules__chevInnerLink--left___m7gyl","align":"KDS_ChevronLink-modules__align___27FtV","right":"KDS_ChevronLink-modules__right___1bhJt KDS_ChevronLink-modules__align___27FtV","center":"KDS_ChevronLink-modules__center___33SI3 KDS_ChevronLink-modules__align___27FtV"};

var _excluded$R = ["reactRouterLinkComponent", "variant", "theme", "direction", "align", "children", "underline", "color", "animated", "newTab"];
var getTextColor$1 = function getTextColor(variant, color) {
  var themeColors = {
    primary: 'var(--color-black)',
    secondary: 'var(--color-mosque)'
  };
  return color ? "var(--color-".concat(color, ")") : themeColors[variant];
};
var getIcon = function getIcon(symbol, classes) {
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
    className: classes
  }, /*#__PURE__*/React.createElement(DecorativeIcon, {
    symbol: symbol,
    size: 14
  })));
};
var getAlignment = function getAlignment(align) {
  switch (align) {
    case 'center':
      return styles$J.center;
    case 'right':
      return styles$J.right;
    default:
      return undefined;
  }
};

/**
 * A call to action link.
 */
var ChevronLink = function ChevronLink(_ref) {
  var reactRouterLinkComponent = _ref.reactRouterLinkComponent,
    variant = _ref.variant;
    _ref.theme;
    var direction = _ref.direction,
    align = _ref.align,
    children = _ref.children,
    underline = _ref.underline,
    color = _ref.color,
    animated = _ref.animated,
    newTab = _ref.newTab,
    rest = _objectWithoutProperties$1(_ref, _excluded$R);
  if ((reactRouterLinkComponent || rest.to) && !(reactRouterLinkComponent && rest.to)) {
    warn('Chevron Link', 'The props `reactRouterLinkComponent` and `to` must be used together.');
  }
  var innerLink = /*#__PURE__*/React.createElement(Box, {
    inline: true,
    between: 1
  }, direction === 'left' && getIcon('chevronLeft', styles$J.chevronLeft), /*#__PURE__*/React.createElement("div", {
    className: "".concat(styles$J.chevInnerLink, " ").concat(underline ? styles$J['chevInnerLink--underline'] : '', " ").concat(direction === 'left' ? styles$J['chevInnerLink--left'] : '')
  }, children), direction === 'right' && getIcon('chevronRight', styles$J.chevronRight), direction === 'down' && getIcon('chevronDown', styles$J.chevronDown), direction === 'up' && getIcon('chevronUp', styles$J.chevronUp));
  var baseClass = animated ? styles$J.link : styles$J['link-non-animated'];
  return /*#__PURE__*/React.createElement(reactRouterLinkComponent || 'a', _objectSpread2(_objectSpread2({}, safeRest(rest)), {}, {
    className: joinClassNames(baseClass, styles$J[variant], getAlignment(align)),
    target: newTab ? '_blank' : '_self',
    style: variant || color ? {
      '--link-color': getTextColor$1(variant, color)
    } : {}
  }), innerLink);
};
ChevronLink.propTypes = {
  /**
   * The style.
   */
  variant: PropTypes.oneOf(['primary', 'secondary']),
  /**
   * Font color. Must be from the list of available [`Colours`](#section-colours).
   */
  color: PropTypes.string,
  /**
   * ** *deprecated - use variant* **.
   */
  theme: PropTypes.oneOf(['commerce']),
  /**
   * The chevron's direction and placement.
   */
  direction: PropTypes.oneOf(['left', 'right', 'down', 'up']),
  /**
   * The link alignment
   */
  align: PropTypes.oneOf(['left', 'right', 'center']),
  /**
   * React Router Link component.
   */
  reactRouterLinkComponent: PropTypes.func,
  /**
   * Target URL (if using 'reactRouterLinkComponent')
   */
  to: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  /**
   * Target URL.
   */
  href: PropTypes.string,
  /**
   * The label.
   *
   * Child can be a `string` or a `<Text/>` component.
   */
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
    type: PropTypes.oneOf([Text$2])
  }), PropTypes.node]).isRequired,
  /**
   * The underline
   */
  underline: PropTypes.bool,
  /**
   * Animation for :hover selector
   */
  animated: PropTypes.bool,
  /**
   * Opens a new tab.
   */
  newTab: PropTypes.bool
};
ChevronLink.defaultProps = {
  variant: 'primary',
  theme: undefined,
  direction: 'right',
  align: null,
  reactRouterLinkComponent: null,
  to: null,
  href: null,
  underline: false,
  color: undefined,
  animated: true,
  newTab: false
};

var styles$I = {"flirt":"#7c1366","mosque":"KDS_Card-modules__mosque___3c2qo","texas":"#f9f6a5","amaranth":"#ee2c74","cardinal-pink":"#8c0448","trinidad":"#df3d0c","chestnut":"#bc4850","onahau":"#c3efff","burnt-sienna":"#ed6358","chathams-blue":"#17367d","mid-blue":"#1a347d","well-read":"#b8373e","wattle":"#d5e04d","beeswax":"#feeec7","bilbao":"#258b0b","sea-buckthorn":"#fbaf34","mint-tulip":"KDS_Card-modules__mint-tulip___25bKC","turquoise":"#39cdc9","hibiscus":"#c53a70","carousel-pink":"#fae6f4","white":"KDS_Card-modules__white___27nkD","black":"#000","mortar":"#595959","gallery":"#efefef","silver":"#c9c8c8","dove":"#666666","iceberg":"#cbf0e8","icicle":"#e5f7fb","light-gray":"#fafafa","super-nova":"#fbaf33","expand-yellow":"#fee8b8","expand-yellow-light":"rgba(254, 232, 184, 0.5)","hero-pink":"#a6298c","cardHeader":"KDS_Card-modules__cardHeader___r_lBw","blue":"KDS_Card-modules__blue___2fnCM","orange":"KDS_Card-modules__orange___3rpEn","grey":"KDS_Card-modules__grey___y1vyb","yellow":"KDS_Card-modules__yellow___NoiHW","light-yellow":"KDS_Card-modules__light-yellow___Z4Rss","pink":"KDS_Card-modules__pink___25qzP","white-tab":"KDS_Card-modules__white-tab___3pGPE","mosque-tab":"KDS_Card-modules__mosque-tab___LBhzM","boxShadow":"KDS_Card-modules__boxShadow___oLjr8","rounded":"KDS_Card-modules__rounded___IYtjn","label":"KDS_Card-modules__label___1RKlq","border-black":"KDS_Card-modules__border-black____7tyb","border-white":"KDS_Card-modules__border-white___1P7xJ","border-silver":"KDS_Card-modules__border-silver___2FvAZ","border-blue":"KDS_Card-modules__border-blue___2FZkA","border-flirt":"KDS_Card-modules__border-flirt___2ZR9y","border-mosque":"KDS_Card-modules__border-mosque___o8l4z","border-radius-0px":"KDS_Card-modules__border-radius-0px___PBnUo","border-radius-4px":"KDS_Card-modules__border-radius-4px___1akPJ","border-radius-8px":"KDS_Card-modules__border-radius-8px___16JfI","arrowUp":"KDS_Card-modules__arrowUp___8AIjc","arrow-white":"KDS_Card-modules__arrow-white___3WYq0","arrow-blue":"KDS_Card-modules__arrow-blue___3EPJQ","arrow-orange":"KDS_Card-modules__arrow-orange___3pvKA","arrow-grey":"KDS_Card-modules__arrow-grey___1ZcDn","arrow-yellow":"KDS_Card-modules__arrow-yellow___1px-7","arrow-light-yellow":"KDS_Card-modules__arrow-light-yellow___ubGRF","arrow-pink":"KDS_Card-modules__arrow-pink___3jp5Y","arrow-mint-tulip":"KDS_Card-modules__arrow-mint-tulip___17TBE","arrow-mosque":"KDS_Card-modules__arrow-mosque___2AUz-","arrow-border-black":"KDS_Card-modules__arrow-border-black___1CGH5","arrow-border-white":"KDS_Card-modules__arrow-border-white___1bS7p","arrow-border-silver":"KDS_Card-modules__arrow-border-silver___2W99F","arrow-border-blue":"KDS_Card-modules__arrow-border-blue___hgOWl","arrow-border-flirt":"KDS_Card-modules__arrow-border-flirt___A3FJZ","arrow-border-mosque":"KDS_Card-modules__arrow-border-mosque___tSMu5"};

var _excluded$Q = ["variant", "children", "boxShadow", "border", "borderRadius", "header", "headerUnderlined", "rounded", "label", "arrowUp"];
var headerExists = function headerExists(header) {
  return Object.keys(header).length > 0;
};
var getClassName$5 = function getClassName(variant, rounded, boxShadow, header, border, borderRadius) {
  return joinClassNames( /* eslint-disable no-nested-ternary, no-extra-boolean-cast */
  headerExists(header) ? styles$I.cardHeader : styles$I[variant], rounded ? styles$I.rounded : '', boxShadow ? styles$I.boxShadow : '', border === true ? styles$I['border-silver'] : !!border ? styles$I["border-".concat(border)] : '', borderRadius ? styles$I["border-radius-".concat(borderRadius)] : '');
};
var getArrowUpClassName = function getArrowUpClassName(variant, border) {
  return joinClassNames(styles$I.arrowUp, border === true ? styles$I['arrow-border-silver'] : !!border ? styles$I["arrow-border-".concat(border)] : '', styles$I["arrow-".concat(variant)]);
};
var headerClicked = function headerClicked(header) {
  if (header && typeof header.headerClick === 'function') {
    header.headerClick();
  }
};

/**
 *
 * A content container.
 */
var Card = function Card(_ref) {
  var variant = _ref.variant,
    children = _ref.children,
    boxShadow = _ref.boxShadow,
    border = _ref.border,
    borderRadius = _ref.borderRadius,
    header = _ref.header,
    headerUnderlined = _ref.headerUnderlined,
    rounded = _ref.rounded,
    label = _ref.label,
    arrowUp = _ref.arrowUp,
    rest = _objectWithoutProperties$1(_ref, _excluded$Q);
  return /*#__PURE__*/React.createElement(React.Fragment, null, headerExists(header) > 0 && /*#__PURE__*/React.createElement(Box, {
    horizontal: 3,
    vertical: 2,
    dangerouslyAddClassName: styles$I[header.colour]
  }, /*#__PURE__*/React.createElement(ChevronLink, {
    onClick: function onClick() {
      return headerClicked(header);
    },
    href: header.link,
    variant: "secondary",
    underline: headerUnderlined || false
  }, header.title)), label ? /*#__PURE__*/React.createElement("span", {
    className: joinClassNames(styles$I[variant], styles$I.label)
  }, /*#__PURE__*/React.createElement("strong", null, children)) : /*#__PURE__*/React.createElement(React.Fragment, null, arrowUp && /*#__PURE__*/React.createElement("div", {
    className: getArrowUpClassName(variant, border),
    "data-testid": "arrowUp"
  }), /*#__PURE__*/React.createElement(Box, _extends$1({}, safeRest(rest), {
    inset: 3,
    dangerouslyAddClassName: getClassName$5(variant, rounded, boxShadow, header, border, borderRadius)
  }), children)));
};
Card.propTypes = {
  /**
   * The style.
   */
  variant: PropTypes.oneOf(['blue', 'orange', 'grey', 'white', 'yellow', 'light-yellow', 'pink', 'mint-tulip', 'mosque', 'mosque-tab', 'white-tab']),
  /**
   *  Underlining the Card header
   */
  headerUnderlined: PropTypes.bool,
  /**
   *  Rounding the corners of the card.
   */
  rounded: PropTypes.bool,
  /**
   *  The label
   */
  label: PropTypes.bool,
  /**
   * The shadow.
   */
  boxShadow: PropTypes.bool,
  /**
   * Adds a border around the container.
   */
  border: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['black', 'white', 'silver', 'blue', 'flirt', 'mosque', ''])]),
  borderRadius: PropTypes.oneOf(['0px', '4px', '8px', '']),
  /**
   * The content. Can be text, any HTML element, or any component.
   */
  children: PropTypes.node.isRequired,
  /**
   * Header
   */
  header: PropTypes.shape({
    title: PropTypes.string,
    link: PropTypes.string,
    colour: PropTypes.oneOf(['blue', 'orange', 'grey', 'white']),
    headerClick: PropTypes.func
  }),
  /**
   * Will render arrow pointing up
   */
  arrowUp: PropTypes.bool
};
Card.defaultProps = {
  label: false,
  variant: 'blue',
  headerUnderlined: false,
  rounded: false,
  boxShadow: false,
  border: false,
  borderRadius: '',
  header: {},
  arrowUp: false
};

var styles$H = {"flirt":"#7c1366","mosque":"#016b6a","texas":"#f9f6a5","amaranth":"#ee2c74","cardinal-pink":"#8c0448","trinidad":"#df3d0c","chestnut":"#bc4850","onahau":"#c3efff","burnt-sienna":"#ed6358","chathams-blue":"#17367d","mid-blue":"#1a347d","well-read":"#b8373e","wattle":"#d5e04d","beeswax":"#feeec7","bilbao":"#258b0b","sea-buckthorn":"#fbaf34","mint-tulip":"#c1f2e8","turquoise":"#39cdc9","hibiscus":"#c53a70","carousel-pink":"#fae6f4","white":"#fff","black":"#000","mortar":"#595959","gallery":"#efefef","silver":"#c9c8c8","dove":"#666666","iceberg":"#cbf0e8","icicle":"#e5f7fb","light-gray":"#fafafa","super-nova":"#fbaf33","expand-yellow":"#fee8b8","expand-yellow-light":"rgba(254, 232, 184, 0.5)","hero-pink":"#a6298c","default":"KDS_InputFeedback-modules__default___2sB0z KDS_Messaging-modules__default___BX07O","error":"KDS_InputFeedback-modules__error___QtCh5 KDS_Messaging-modules__error___uK_Ed","warning":"KDS_InputFeedback-modules__warning___2sORf KDS_Messaging-modules__warning___FGudP","errorArrowUp":"KDS_InputFeedback-modules__errorArrowUp___3-VZ-","defaultArrowUp":"KDS_InputFeedback-modules__defaultArrowUp___2Z1yo","warningArrowUp":"KDS_InputFeedback-modules__warningArrowUp___3785k","arrowUp":"KDS_InputFeedback-modules__arrowUp___2R3FY"};

var _excluded$P = ["feedback", "errorArrowUp", "feedbackArrowUp", "children"];

/**
 * A feedback box commonly used with form fields.
 *
 */

var getFeedbackClassName = function getFeedbackClassName(feedback) {
  switch (feedback) {
    case 'error':
      return styles$H.error;
    case 'warning':
      return styles$H.warning;
    default:
      return styles$H["default"];
  }
};
var InputFeedback = function InputFeedback(_ref) {
  var feedback = _ref.feedback,
    errorArrowUp = _ref.errorArrowUp,
    feedbackArrowUp = _ref.feedbackArrowUp,
    children = _ref.children,
    rest = _objectWithoutProperties$1(_ref, _excluded$P);
  return /*#__PURE__*/React.createElement("div", {
    className: feedbackArrowUp && feedback !== 'error' ? styles$H.arrowUp : ''
  }, feedback === 'error' && (errorArrowUp || feedbackArrowUp) && /*#__PURE__*/React.createElement("div", {
    className: styles$H.errorArrowUp,
    "data-testid": "errorArrowUp"
  }), feedback === 'warning' && feedbackArrowUp && /*#__PURE__*/React.createElement("div", {
    className: styles$H.warningArrowUp,
    "data-testid": "warningArrowUp"
  }), (feedback === 'success' || !feedback && feedbackArrowUp) && /*#__PURE__*/React.createElement("div", {
    className: styles$H.defaultArrowUp,
    "data-testid": "defaultArrowUp"
  }), /*#__PURE__*/React.createElement(Box, _extends$1({}, safeRest(rest), {
    inset: 3,
    dangerouslyAddClassName: getFeedbackClassName(feedback),
    "data-testid": "feedbackMessage"
  }), children));
};
InputFeedback.propTypes = {
  /**
   * A feedback state that changes the background colour.
   */
  feedback: PropTypes.oneOf(['success', 'error', 'warning']),
  /**
   * The content. Can be text, any HTML element, or any component.
   */
  children: PropTypes.node.isRequired,
  /**
   * Will render arrow pointing up if there is an error.
   */
  errorArrowUp: PropTypes.bool,
  /**
   * Will render arrow pointing up for any feedback
   */
  feedbackArrowUp: PropTypes.bool
};
InputFeedback.defaultProps = {
  feedback: undefined,
  errorArrowUp: false,
  feedbackArrowUp: false
};

var styles$G = {"flirt":"#7c1366","mosque":"#016b6a","texas":"#f9f6a5","amaranth":"#ee2c74","cardinal-pink":"#8c0448","trinidad":"#df3d0c","chestnut":"#bc4850","onahau":"#c3efff","burnt-sienna":"#ed6358","chathams-blue":"#17367d","mid-blue":"#1a347d","well-read":"#b8373e","wattle":"#d5e04d","beeswax":"#feeec7","bilbao":"#258b0b","sea-buckthorn":"#fbaf34","mint-tulip":"#c1f2e8","turquoise":"#39cdc9","hibiscus":"#c53a70","carousel-pink":"#fae6f4","white":"#fff","black":"#000","mortar":"#595959","gallery":"#efefef","silver":"#c9c8c8","dove":"#666666","iceberg":"#cbf0e8","icicle":"#e5f7fb","light-gray":"#fafafa","super-nova":"#fbaf33","expand-yellow":"#fee8b8","expand-yellow-light":"rgba(254, 232, 184, 0.5)","hero-pink":"#a6298c","cursor":"KDS_Choice-modules__cursor___1rxgV","circleColorLabel":"KDS_Choice-modules__circleColorLabel___1wUd6","alignCenter":"KDS_Choice-modules__alignCenter___1lhx4","alignFlexStart":"KDS_Choice-modules__alignFlexStart___6Zbf5","circle":"KDS_Choice-modules__circle___17-PO KDS_Borders-modules__circular___2Wn2f","rectangle":"KDS_Choice-modules__rectangle___3wREv","fakeinput":"KDS_Choice-modules__fakeinput___FsUix KDS_Borders-modules__thick___30Kr0","fakeCheckbox__regular":"KDS_Choice-modules__fakeCheckbox__regular___1EURm KDS_Choice-modules__fakeinput___FsUix KDS_Borders-modules__thick___30Kr0","fakeRadio__circle":"KDS_Choice-modules__fakeRadio__circle___3kTda KDS_Choice-modules__fakeinput___FsUix KDS_Borders-modules__thick___30Kr0 KDS_Choice-modules__circle___17-PO KDS_Borders-modules__circular___2Wn2f","fakeRadio__regular":"KDS_Choice-modules__fakeRadio__regular___kCFt0 KDS_Choice-modules__fakeinput___FsUix KDS_Borders-modules__thick___30Kr0 KDS_Choice-modules__circle___17-PO KDS_Borders-modules__circular___2Wn2f","unchecked__circle":"KDS_Choice-modules__unchecked__circle___5kruV","unchecked__regular":"KDS_Choice-modules__unchecked__regular___22eo5","focused__regular":"KDS_Choice-modules__focused__regular___10FXE","focused__circle":"KDS_Choice-modules__focused__circle___1HO1Y","focused__rectangle":"KDS_Choice-modules__focused__rectangle___2NwS2","hiddenInput":"KDS_Choice-modules__hiddenInput___7ERW5","color__circle":"KDS_Choice-modules__color__circle___1T_t8","color__rectangle":"KDS_Choice-modules__color__rectangle___1bO4t","colorDisabled":"KDS_Choice-modules__colorDisabled___DiJQH","disabled__circle":"KDS_Choice-modules__disabled__circle___1gZki KDS_Choice-modules__circle___17-PO KDS_Borders-modules__circular___2Wn2f","disabled__rectangle":"KDS_Choice-modules__disabled__rectangle___25tbP KDS_Choice-modules__rectangle___3wREv"};

var _excluded$O = ["label", "name", "value", "feedback", "error", "type", "inputTypeStyles", "children", "color", "shape", "displayLabel", "theme"];
var getId = function getId(id, name, value) {
  if (id) {
    return generateId(id).identity();
  }
  return generateId(name).postfix(value);
};
var getClassNames$1 = function getClassNames(inputTypeStyles, checked, focus, feedback, disabled, theme, color, shape, type) {
  var typeClass = type === 'radio' ? styles$G["fakeRadio__".concat(shape)] : styles$G["fakeCheckbox__".concat(shape)];
  if (disabled) {
    return joinClassNames(typeClass, checked ? inputTypeStyles.disabledChecked : inputTypeStyles.disabled, color ? styles$G["color__".concat(shape)] : '', styles$G["disabled__".concat(shape)]);
  }
  var className;
  var colorClassName;
  var shapeClassName;
  if (checked) {
    className = inputTypeStyles.checked;
    colorClassName = color ? inputTypeStyles.checked__color : '';
    shapeClassName = inputTypeStyles["checked__".concat(shape)];
  } else {
    className = styles$G["unchecked__".concat(shape)];
    shapeClassName = styles$G[shape];
  }
  return joinClassNames(typeClass, className, colorClassName, shapeClassName, focus && styles$G["focused__".concat(shape)], color ? styles$G["color__".concat(shape)] : '');
};
var renderError$1 = function renderError(error, errorId) {
  return /*#__PURE__*/React.createElement(InputFeedback, {
    id: errorId,
    feedback: "error"
  }, /*#__PURE__*/React.createElement(Paragraph$1, {
    size: "small"
  }, error));
};
var Choice = /*#__PURE__*/function (_React$Component) {
  function Choice() {
    var _this;
    _classCallCheck(this, Choice);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Choice, [].concat(args));
    _defineProperty$1(_this, "state", {
      checked: _this.props.checked,
      focus: false
    });
    _defineProperty$1(_this, "onChange", function (event) {
      var onChange = _this.props.onChange;
      _this.setState(function (_ref) {
        var checked = _ref.checked;
        return {
          checked: !checked
        };
      });
      if (onChange) {
        onChange(event);
      }
    });
    _defineProperty$1(_this, "onFocus", function (event) {
      var onFocus = _this.props.onFocus;
      _this.setState({
        focus: true
      });
      if (onFocus) {
        onFocus(event);
      }
    });
    _defineProperty$1(_this, "onBlur", function (event) {
      var onBlur = _this.props.onBlur;
      _this.setState({
        focus: false
      });
      if (onBlur) {
        onBlur(event);
      }
    });
    return _this;
  }
  _inherits(Choice, _React$Component);
  return _createClass(Choice, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var checked = this.state.checked;
      if (checked !== nextProps.checked) {
        this.setState({
          checked: nextProps.checked
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        label = _this$props.label,
        name = _this$props.name,
        value = _this$props.value,
        feedback = _this$props.feedback,
        error = _this$props.error,
        type = _this$props.type,
        inputTypeStyles = _this$props.inputTypeStyles,
        children = _this$props.children,
        color = _this$props.color,
        shape = _this$props.shape,
        displayLabel = _this$props.displayLabel,
        theme = _this$props.theme,
        rest = _objectWithoutProperties$1(_this$props, _excluded$O);
      var _this$state = this.state,
        checked = _this$state.checked,
        focus = _this$state.focus;
      var choiceId = getId(rest.id, name, value);
      var errorId = error && generateId(choiceId).postfix('error-message');
      var circleColor = color && shape === 'circle';
      var themeColorDark = getThemeColorDark(theme);
      var themeColorLight = getThemeColorLight(theme);
      var themeColorHover = getThemeColorHover(theme);
      return /*#__PURE__*/React.createElement(Box, {
        between: 2
      }, /*#__PURE__*/React.createElement("label", {
        className: circleColor ? styles$G.circleColorLabel : '',
        htmlFor: choiceId
      }, /*#__PURE__*/React.createElement(Box, {
        tag: "span",
        inline: !circleColor,
        between: circleColor ? 1 : 2,
        dangerouslyAddClassName: joinClassNames(!circleColor ? styles$G.alignFlexStart : styles$G.alignCenter, !rest.disabled ? styles$G.cursor : '')
      }, /*#__PURE__*/React.createElement("span", {
        className: getClassNames$1(inputTypeStyles, checked, focus, feedback, rest.disabled, theme, color, shape, type),
        "data-testid": "fake-input",
        style: color ? {
          '--custom-color': color,
          '--theme-color-dark': themeColorDark,
          '--theme-color-light': themeColorLight,
          '--theme-color-hover': themeColorHover
        } : {
          '--custom-color': checked ? 'var(--color-chathams-blue)' : 'var(--color-onahau)',
          '--theme-color-dark': themeColorDark,
          '--theme-color-light': themeColorLight,
          '--theme-color-hover': themeColorHover
        }
      }, /*#__PURE__*/React.createElement("input", _extends$1({}, safeRest(rest), {
        id: choiceId,
        type: type,
        name: name,
        value: value,
        checked: checked,
        className: joinClassNames(styles$G.hiddenInput, !rest.disabled ? styles$G.cursor : ''),
        "aria-invalid": feedback === 'error',
        "aria-describedby": errorId || undefined,
        "aria-label": typeof label === 'string' ? label : name,
        onChange: this.onChange,
        onFocus: this.onFocus,
        onBlur: this.onBlur
      })), children(checked, rest.disabled, theme)), displayLabel && shape !== 'rectangle' && /*#__PURE__*/React.createElement(Text$2, {
        size: circleColor ? 'small' : 'medium'
      }, label))), feedback === 'error' && error && renderError$1(error, errorId));
    }
  }]);
}(React.Component);
Choice.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  checked: PropTypes.bool.isRequired,
  feedback: PropTypes.oneOf(['error']),
  error: PropTypes.string,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  type: PropTypes.oneOf(['checkbox', 'radio']).isRequired,
  inputTypeStyles: PropTypes.object.isRequired,
  children: PropTypes.func.isRequired,
  /**
   * The theme.
   */
  theme: PropTypes.oneOf(['commerce', 'support', 'secondary']),
  /**
   * The shape.
   */
  shape: PropTypes.oneOf(['regular', 'circle', 'rectangle']),
  /**
   * The color.
   */
  color: PropTypes.string,
  /**
   * Whether the label will be displayed.
   */
  displayLabel: PropTypes.bool
};
Choice.defaultProps = {
  feedback: undefined,
  error: undefined,
  onChange: undefined,
  onFocus: undefined,
  onBlur: undefined,
  theme: undefined,
  shape: 'regular',
  color: '',
  displayLabel: true
};

var styles$F = {"flirt":"#7c1366","mosque":"#016b6a","texas":"#f9f6a5","amaranth":"#ee2c74","cardinal-pink":"#8c0448","trinidad":"#df3d0c","chestnut":"#bc4850","onahau":"#c3efff","burnt-sienna":"#ed6358","chathams-blue":"#17367d","mid-blue":"#1a347d","well-read":"#b8373e","wattle":"#d5e04d","beeswax":"#feeec7","bilbao":"#258b0b","sea-buckthorn":"#fbaf34","mint-tulip":"#c1f2e8","turquoise":"#39cdc9","hibiscus":"#c53a70","carousel-pink":"#fae6f4","white":"#fff","black":"#000","mortar":"#595959","gallery":"#efefef","silver":"#c9c8c8","dove":"#666666","iceberg":"#cbf0e8","icicle":"#e5f7fb","light-gray":"#fafafa","super-nova":"#fbaf33","expand-yellow":"#fee8b8","expand-yellow-light":"rgba(254, 232, 184, 0.5)","hero-pink":"#a6298c","disabled":"KDS_Checkbox-modules__disabled___zQfnB","disabledChecked":"KDS_Checkbox-modules__disabledChecked___2Vc_R","checked":"KDS_Checkbox-modules__checked___J2l7S"};

/**
 * @version 1.0.0
 */
var Checkbox = function Checkbox(props) {
  return /*#__PURE__*/React.createElement(Choice, _extends$1({}, props, {
    type: "checkbox",
    inputTypeStyles: styles$F
  }), function (checked) {
    return checked && /*#__PURE__*/React.createElement(DecorativeIcon, {
      symbol: "check",
      size: 16,
      variant: "primary"
    });
  });
};
Checkbox.propTypes = {
  /**
   * The label.
   */
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  /**
   * Associate this checkbox with a group. Set as the HTML name attribute.
   */
  name: PropTypes.string.isRequired,
  /**
   * The value. Must be unique within the group.
   */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  /**
   * The checked state
   */
  checked: PropTypes.bool,
  /**
   * A feedback state.
   */
  feedback: PropTypes.oneOf(['error']),
  /**
   * An error message.
   */
  error: PropTypes.string,
  /**
   * A callback function to be invoked when the checkbox is checked or unchecked.
   *
   * @param {SyntheticEvent} event The React `SyntheticEvent`
   */
  onChange: PropTypes.func,
  /**
   * A callback function to be invoked when the checkbox receives focus.
   *
   * @param {SyntheticEvent} event The React `SyntheticEvent`
   */
  onFocus: PropTypes.func,
  /**
   * A callback function to be invoked when the checkbox loses focus.
   *
   * @param {SyntheticEvent} event The React `SyntheticEvent`
   */
  onBlur: PropTypes.func
};
Checkbox.defaultProps = {
  checked: false,
  feedback: undefined,
  error: undefined,
  onChange: undefined,
  onFocus: undefined,
  onBlur: undefined
};

var styles$E = {"flirt":"#7c1366","mosque":"#016b6a","texas":"#f9f6a5","amaranth":"#ee2c74","cardinal-pink":"#8c0448","trinidad":"#df3d0c","chestnut":"#bc4850","onahau":"#c3efff","burnt-sienna":"#ed6358","chathams-blue":"#17367d","mid-blue":"#1a347d","well-read":"#b8373e","wattle":"#d5e04d","beeswax":"#feeec7","bilbao":"#258b0b","sea-buckthorn":"#fbaf34","mint-tulip":"#c1f2e8","turquoise":"#39cdc9","hibiscus":"#c53a70","carousel-pink":"#fae6f4","white":"#fff","black":"#000","mortar":"#595959","gallery":"#efefef","silver":"#c9c8c8","dove":"#666666","iceberg":"#cbf0e8","icicle":"#e5f7fb","light-gray":"#fafafa","super-nova":"#fbaf33","expand-yellow":"#fee8b8","expand-yellow-light":"rgba(254, 232, 184, 0.5)","hero-pink":"#a6298c","container":"KDS_Container-modules__container___2tuCp","container--small":"KDS_Container-modules__container--small___3AvT9","container--medium":"KDS_Container-modules__container--medium___2Ip23","container--large":"KDS_Container-modules__container--large___2womn","container__inner":"KDS_Container-modules__container__inner___1cz5C","small":"KDS_Container-modules__small___EfLI1 KDS_Container-modules__container__inner___1cz5C","medium":"KDS_Container-modules__medium___2Psvc KDS_Container-modules__container__inner___1cz5C","large":"KDS_Container-modules__large___224HB KDS_Container-modules__container__inner___1cz5C","full":"KDS_Container-modules__full___25brd KDS_Container-modules__container__inner___1cz5C"};

var Container = function Container(_ref) {
  var children = _ref.children,
    size = _ref.size;
  var containerClass = joinClassNames(styles$E.container, styles$E["container--".concat(size)]);
  return /*#__PURE__*/React.createElement("div", {
    className: containerClass
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$E[size]
  }, children));
};
Container.propTypes = {
  children: PropTypes.node.isRequired,
  size: PropTypes.oneOf(['small', 'medium', 'large', 'full'])
};
Container.defaultProps = {
  size: 'small'
};

var styles$D = {"flirt":"#7c1366","mosque":"#016b6a","texas":"#f9f6a5","amaranth":"#ee2c74","cardinal-pink":"#8c0448","trinidad":"#df3d0c","chestnut":"#bc4850","onahau":"#c3efff","burnt-sienna":"#ed6358","chathams-blue":"#17367d","mid-blue":"#1a347d","well-read":"#b8373e","wattle":"#d5e04d","beeswax":"#feeec7","bilbao":"#258b0b","sea-buckthorn":"#fbaf34","mint-tulip":"#c1f2e8","turquoise":"#39cdc9","hibiscus":"#c53a70","carousel-pink":"#fae6f4","white":"#fff","black":"#000","mortar":"#595959","gallery":"#efefef","silver":"#c9c8c8","dove":"#666666","iceberg":"#cbf0e8","icicle":"#e5f7fb","light-gray":"#fafafa","super-nova":"#fbaf33","expand-yellow":"#fee8b8","expand-yellow-light":"rgba(254, 232, 184, 0.5)","hero-pink":"#a6298c","sup":"KDS_DisplayHeading-modules__sup___3oHBq KDS_Text-modules__basesupsubscripts___3YKPl","base":"KDS_DisplayHeading-modules__base___73mVk KDS_Typography-modules__wordbreak___2hwoO","default":"KDS_DisplayHeading-modules__default___1ShkV","headingLarge--commerce":"KDS_DisplayHeading-modules__headingLarge--commerce___uWUnT KDS_DisplayHeading-modules__base___73mVk KDS_Typography-modules__wordbreak___2hwoO","headingLarge--selfServe":"KDS_DisplayHeading-modules__headingLarge--selfServe___2Lzo5 KDS_DisplayHeading-modules__base___73mVk KDS_Typography-modules__wordbreak___2hwoO","headingLarge--universal":"KDS_DisplayHeading-modules__headingLarge--universal___3Eo96 KDS_DisplayHeading-modules__base___73mVk KDS_Typography-modules__wordbreak___2hwoO","headingMedium--selfServe":"KDS_DisplayHeading-modules__headingMedium--selfServe___zIcvQ KDS_DisplayHeading-modules__base___73mVk KDS_Typography-modules__wordbreak___2hwoO","headingMedium--commerce":"KDS_DisplayHeading-modules__headingMedium--commerce___mIOHD KDS_DisplayHeading-modules__base___73mVk KDS_Typography-modules__wordbreak___2hwoO","headingMedium--universal":"KDS_DisplayHeading-modules__headingMedium--universal___3CVQR KDS_DisplayHeading-modules__base___73mVk KDS_Typography-modules__wordbreak___2hwoO","headingDesktopLarge--commerce":"KDS_DisplayHeading-modules__headingDesktopLarge--commerce___2W5Uv KDS_DisplayHeading-modules__base___73mVk KDS_Typography-modules__wordbreak___2hwoO","headingDesktopLarge--selfServe":"KDS_DisplayHeading-modules__headingDesktopLarge--selfServe___2LLpV KDS_DisplayHeading-modules__base___73mVk KDS_Typography-modules__wordbreak___2hwoO","headingDesktopMedium--selfServe":"KDS_DisplayHeading-modules__headingDesktopMedium--selfServe___2onB_ KDS_DisplayHeading-modules__base___73mVk KDS_Typography-modules__wordbreak___2hwoO","headingDesktopMedium--commerce":"KDS_DisplayHeading-modules__headingDesktopMedium--commerce___1m_fV KDS_DisplayHeading-modules__base___73mVk KDS_Typography-modules__wordbreak___2hwoO"};

var _excluded$N = ["children"];

/**
 * Superscript text for headings.
 * _This component can only be accessed as a name-spaced component: `DisplayHeading.Sup`._
 */
var DisplayHeadingSup = function DisplayHeadingSup(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties$1(_ref, _excluded$N);
  return /*#__PURE__*/React.createElement("sup", _extends$1({}, safeRest(rest), {
    className: styles$D.sup
  }), children);
};
DisplayHeadingSup.propTypes = {
  /**
   * The text.
   */
  children: PropTypes.string.isRequired
};

var _excluded$M = ["children", "color", "size", "theme"];
var getClassName$4 = function getClassName(desktop, size, theme) {
  return joinClassNames(desktop ? styles$D["headingDesktop".concat(capitalize(size), "--").concat(theme)] : styles$D["heading".concat(capitalize(size), "--").concat(theme)], styles$D["default"]);
};
/**
 * Large page titles. Renders an HTML `<h1>` element.
 */
var DisplayHeading = function DisplayHeading(_ref) {
  var children = _ref.children,
    color = _ref.color,
    size = _ref.size,
    theme = _ref.theme,
    rest = _objectWithoutProperties$1(_ref, _excluded$M);
  if (theme === 'universal') {
    return /*#__PURE__*/React.createElement("h1", _extends$1({}, safeRest(rest), {
      className: getClassName$4(false, size, theme),
      style: {
        '--font-color': "var(--color-".concat(color, ")")
      }
    }), children);
  }
  return /*#__PURE__*/React.createElement(Responsive, {
    minWidth: theme === 'commerce' ? 'lg' : 'md'
  }, function (desktop) {
    return /*#__PURE__*/React.createElement("h1", _extends$1({}, safeRest(rest), {
      className: getClassName$4(desktop, size, theme),
      style: {
        '--font-color': "var(--color-".concat(color, ")")
      }
    }), children);
  });
};
DisplayHeading.propTypes = {
  /**
   * The text. Can be text, other components, or HTML elements.
   */
  children: PropTypes.node.isRequired,
  /**
   * Font color. Must be from the list of available [`Colours`](#section-colours).
   */
  color: PropTypes.string,
  /**
   * Describes the size of display heading to be rendered.
   */
  size: PropTypes.oneOf(['large', 'medium']),
  /**
   * Determines the font sizes for each heading breakpoint for styling changes.
   */
  theme: PropTypes.oneOf(['selfServe', 'commerce', 'universal'])
};
DisplayHeading.defaultProps = {
  color: 'font',
  size: 'medium',
  theme: 'selfServe'
};
DisplayHeading.Sup = DisplayHeadingSup;

var useToggleDrawer = function useToggleDrawer(initState, ref, triggerElements, highlight, render) {
  var drawerRef = useRef(null);
  var _useState = useState(initState),
    _useState2 = _slicedToArray(_useState, 2),
    show = _useState2[0],
    setShow = _useState2[1];
  var _useState3 = useState('visible'),
    _useState4 = _slicedToArray(_useState3, 2),
    initialBodyOverflowX = _useState4[0],
    setInitialBodyOverflowX = _useState4[1];
  var _useState5 = useState('visible'),
    _useState6 = _slicedToArray(_useState5, 2),
    initialBodyOverflowY = _useState6[0],
    setInitialBodyOverflowY = _useState6[1];

  // Returned to the drawer component to pass down to the List component.
  var _useState7 = useState(undefined),
    _useState8 = _slicedToArray(_useState7, 2),
    highlightElement = _useState8[0],
    setHighlightElement = _useState8[1];

  //  There will most likely be multiple triggers on the page, used to track which element triggered.
  var _useState9 = useState(undefined),
    _useState10 = _slicedToArray(_useState9, 2),
    trigger = _useState10[0],
    setTrigger = _useState10[1];
  var handleClickOutside = function handleClickOutside(event) {
    // if drawer is open and click is outside drawer, close it
    if (drawerRef.current && !drawerRef.current.contains(event.target)) {
      setHighlightElement(undefined);
      setShow(false);
      // Return scrolling outside element when closed.
      document.body.style.overflow = "".concat(initialBodyOverflowX, " ").concat(initialBodyOverflowY);
    }
  };
  var manageTabIndex = function manageTabIndex(open) {
    var focusableBodyElements = document.body.querySelectorAll('body *');
    // When the drawer is open remove the ability to tab through body elements, return it once closed.
    focusableBodyElements.forEach(function (child) {
      if (open && child.tabIndex > -1) {
        child.setAttribute('tabindex', -1);
      } else if (!open) {
        child.removeAttribute('tabindex');
      }
    });

    // Sets tabbing ability to all elements in the drawer when open.
    if (drawerRef.current) {
      var focusableDrawerElements = document.body.querySelectorAll('#expanded-drawer * ');
      var nonFocusableDrawerElements = document.body.querySelectorAll('#expanded-drawer > div, #expanded-drawer > div > button *, #expanded-drawer > ol');
      focusableDrawerElements.forEach(function (child) {
        return child.setAttribute('tabindex', 0);
      });
      nonFocusableDrawerElements.forEach(function (child) {
        return child.setAttribute('tabindex', -1);
      });
      // Sets focus to the heading element when the drawer opens.
      drawerRef.current.firstChild.firstChild.focus();
    }
  };

  // Waits for the delayed render to manage the tab index.
  useEffect(function () {
    manageTabIndex(show);
  }, [render]);
  var handleClickOpen = function handleClickOpen(dataId, elementId) {
    setShow(true);
    if (highlight) {
      setHighlightElement(dataId);
    }

    // Lock scrolling outside element when open.
    document.body.style.overflow = 'hidden';

    // Set which element triggered the opening so focus can be returned when drawer closed.
    if (Array.isArray(triggerElements.current)) {
      setTrigger(triggerElements.current.find(function (el) {
        return el.id === elementId;
      }));
    } else {
      setTrigger(triggerElements.current);
    }
  };
  var handleClickClose = function handleClickClose() {
    setShow(false);
    manageTabIndex(false);
    // Return scrolling outside element when closed.
    document.body.style.overflow = "".concat(initialBodyOverflowX, " ").concat(initialBodyOverflowY);
    setHighlightElement(undefined);
    if (trigger) {
      trigger.focus();
    }
  };
  var handleKeyDown = function handleKeyDown(event) {
    if (event.key === 'Escape') {
      event.stopPropagation();
      setShow(false);

      // Return scrolling outside element when closed.
      document.body.style.overflow = "".concat(initialBodyOverflowX, " ").concat(initialBodyOverflowY);
      setHighlightElement(undefined);
      if (trigger) {
        trigger.focus();
      }
    }
  };

  // Allows outside elements to open and close node.
  useImperativeHandle(ref, function () {
    return {
      openDrawer: function openDrawer(dataId, elementId) {
        handleClickOpen(dataId, elementId);
      },
      closeDrawer: function closeDrawer() {
        handleClickClose();
      }
    };
  });
  useEffect(function () {
    // Close drawer clicking outside of drawer.
    document.addEventListener('click', handleClickOutside, true);
    // Close drawer with esc.
    document.addEventListener('keydown', handleKeyDown, true);
    return function () {
      document.removeEventListener('click', handleClickOutside, true);
      document.removeEventListener('keydown', handleKeyDown, true);
    };
  });
  useEffect(function () {
    setInitialBodyOverflowX(getComputedStyle(document.body).overflowX);
    setInitialBodyOverflowY(getComputedStyle(document.body).overflowY);
  }, []);
  return {
    drawerRef: drawerRef,
    show: show,
    handleClickClose: handleClickClose,
    handleKeyDown: handleKeyDown,
    highlightElement: highlightElement,
    trigger: trigger,
    setShow: setShow
  };
};

var styles$C = {"flirt":"#7c1366","mosque":"#016b6a","texas":"#f9f6a5","amaranth":"#ee2c74","cardinal-pink":"#8c0448","trinidad":"#df3d0c","chestnut":"#bc4850","onahau":"#c3efff","burnt-sienna":"#ed6358","chathams-blue":"#17367d","mid-blue":"#1a347d","well-read":"#b8373e","wattle":"#d5e04d","beeswax":"#feeec7","bilbao":"#258b0b","sea-buckthorn":"#fbaf34","mint-tulip":"#c1f2e8","turquoise":"#39cdc9","hibiscus":"#c53a70","carousel-pink":"#fae6f4","white":"#fff","black":"#000","mortar":"#595959","gallery":"#efefef","silver":"#c9c8c8","dove":"#666666","iceberg":"#cbf0e8","icicle":"#e5f7fb","light-gray":"#fafafa","super-nova":"#fbaf33","expand-yellow":"#fee8b8","expand-yellow-light":"rgba(254, 232, 184, 0.5)","hero-pink":"#a6298c","base":"KDS_OrderedList-modules__base___3RrgY","decimal":"KDS_OrderedList-modules__decimal___3xYPW KDS_OrderedList-modules__base___3RrgY","circled":"KDS_OrderedList-modules__circled___2PghD KDS_OrderedList-modules__base___3RrgY","highlight":"KDS_OrderedList-modules__highlight___1a5p8","fadeHighlight":"KDS_OrderedList-modules__fadeHighlight___1B-H6"};

var _excluded$L = ["size", "children", "highlight"];

/**
 * A single list item for an OrderedList.
 *
 * This component can only be used as a child of `OrderedList`, and must be accessed as a
 * name-spaced component: `OrderedList.Item`.
 *
 */

var OrderedItem = function OrderedItem(_ref) {
  var size = _ref.size,
    children = _ref.children,
    highlight = _ref.highlight,
    rest = _objectWithoutProperties$1(_ref, _excluded$L);
  return /*#__PURE__*/React.createElement("li", _extends$1({}, safeRest(rest), {
    className: "".concat(styles$X[size], " ").concat(styles$C["".concat(highlight ? 'highlight' : '')])
  }), children);
};
OrderedItem.propTypes = {
  /**
   * The font size passed down from the OrderItemList component.
   */
  size: PropTypes.oneOf(['base', 'small']),
  /**
   * The content
   */
  children: PropTypes.node.isRequired,
  /**
   * Determines if the list item should be highlighted with a fading yellow background.
   */
  highlight: PropTypes.bool
};
OrderedItem.defaultProps = {
  size: undefined,
  highlight: false
};
OrderedItem.displayName = 'OrderedItem';

var _excluded$K = ["listStyle", "size", "children", "color"];
var OrderedList = function OrderedList(_ref) {
  var listStyle = _ref.listStyle,
    size = _ref.size,
    children = _ref.children,
    color = _ref.color,
    rest = _objectWithoutProperties$1(_ref, _excluded$K);
  var classes = "\n    ".concat(styles$C[listStyle], "\n  ");
  var sizeChildren = function sizeChildren(child) {
    return /*#__PURE__*/React.cloneElement(child, {
      size: size
    });
  };
  var items = React.Children.map(children, sizeChildren);
  return /*#__PURE__*/React.createElement("ol", _extends$1({}, safeRest(rest), {
    className: classes,
    style: listStyle === 'circled' ? {
      '--circled-color': "var(--color-".concat(color, ")")
    } : {}
  }), items);
};
OrderedList.propTypes = {
  /**
   * The list items
   */
  children: PropTypes.node.isRequired,
  /**
   * The type of list.
   */
  listStyle: PropTypes.oneOf(['decimal', 'circled']),
  /**
   * The font size
   */
  size: PropTypes.oneOf(['base', 'small']),
  /**
   * Color when not inheriting. Must be from the list of available [`Colours`](#section-colours).
   */
  color: PropTypes.string
};
OrderedList.defaultProps = {
  listStyle: 'decimal',
  size: 'base',
  color: 'flirt'
};
OrderedList.Item = OrderedItem;

var _excluded$J = ["highlightElement", "children"],
  _excluded2$1 = ["children", "id"];

/**
 *
 * _This component can only be accessed as a name-spaced component: `Drawer.List`._
 */

var List = function List(_ref) {
  var highlightElement = _ref.highlightElement,
    children = _ref.children,
    rest = _objectWithoutProperties$1(_ref, _excluded$J);
  return /*#__PURE__*/React.createElement(OrderedList, _extends$1({
    size: "small"
  }, safeRest(rest)), Children.map(children, function (_ref2) {
    var _ref2$props = _ref2.props,
      text = _ref2$props.children,
      id = _ref2$props.id,
      childrenRest = _objectWithoutProperties$1(_ref2$props, _excluded2$1);
    return /*#__PURE__*/React.createElement(OrderedList.Item, _extends$1({
      key: id,
      highlight: highlightElement ? id === highlightElement : false,
      id: id
    }, childrenRest), text);
  }));
};
List.propTypes = {
  /** The id of the element to highlight */
  highlightElement: PropTypes.string,
  /** Elements to  be added to the list */
  children: PropTypes.node.isRequired
};
List.defaultProps = {
  highlightElement: undefined
};

var styles$B = {"flirt":"#7c1366","mosque":"#016b6a","texas":"#f9f6a5","amaranth":"#ee2c74","cardinal-pink":"#8c0448","trinidad":"#df3d0c","chestnut":"#bc4850","onahau":"#c3efff","burnt-sienna":"#ed6358","chathams-blue":"#17367d","mid-blue":"#1a347d","well-read":"#b8373e","wattle":"#d5e04d","beeswax":"#feeec7","bilbao":"#258b0b","sea-buckthorn":"#fbaf34","mint-tulip":"#c1f2e8","turquoise":"#39cdc9","hibiscus":"#c53a70","carousel-pink":"#fae6f4","white":"#fff","black":"#000","mortar":"#595959","gallery":"#efefef","silver":"#c9c8c8","dove":"#666666","iceberg":"#cbf0e8","icicle":"#e5f7fb","light-gray":"#fafafa","super-nova":"#fbaf33","expand-yellow":"#fee8b8","expand-yellow-light":"rgba(254, 232, 184, 0.5)","hero-pink":"#a6298c","interactive":"KDS_StandaloneIcon-modules__interactive___VU7Il KDS_Text-modules__color___Qi2FL","appLikeInteraction":"KDS_StandaloneIcon-modules__appLikeInteraction___3g3k0","appLikeInteraction--active":"KDS_StandaloneIcon-modules__appLikeInteraction--active___1_zFa"};

var _excluded$I = ["a11yText", "appLikeInteraction", "onClick", "size", "symbol", "variant", "darkenOnHover", "color"];
var mobileDeviceTapArea = 32; // https://www.w3.org/TR/mobile-accessibility-mapping/#touch-target-size-and-spacing
var touchAreaStyles = function touchAreaStyles(iconSize) {
  var length = (mobileDeviceTapArea - iconSize) / 2;
  return {
    padding: "".concat(length, "px"),
    margin: "-".concat(length, "px 0")
  };
};

/**
 * An icon that has meaning within the context of the page, which should be
 * communicated to screen readers.
 */

var StandaloneIcon = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var a11yText = _ref.a11yText,
    appLikeInteraction = _ref.appLikeInteraction,
    onClick = _ref.onClick,
    size = _ref.size,
    symbol = _ref.symbol,
    variant = _ref.variant,
    darkenOnHover = _ref.darkenOnHover,
    color = _ref.color,
    rest = _objectWithoutProperties$1(_ref, _excluded$I);
  var iconProps = {
    symbol: symbol,
    variant: variant,
    size: size,
    darkenOnHover: darkenOnHover,
    color: color,
    'aria-label': a11yText
  };
  var className = joinClassNames(styles$B.interactive, appLikeInteraction ? styles$B.appLikeInteraction : undefined, appLikeInteraction && appLikeInteraction.active ? styles$B['appLikeInteraction--active'] : undefined);
  if (onClick) {
    var needsExpandedTouchArea = size < mobileDeviceTapArea;
    return /*#__PURE__*/React.createElement("button", _extends$1({
      className: className,
      onClick: onClick,
      ref: ref,
      style: needsExpandedTouchArea ? touchAreaStyles(size) : undefined,
      type: "button"
    }, safeRest(rest)), /*#__PURE__*/React.createElement(Icon, iconProps));
  }
  return /*#__PURE__*/React.createElement(Icon, _extends$1({}, safeRest(rest), iconProps));
});
StandaloneIcon.displayName = 'StandaloneIcon';
StandaloneIcon.propTypes = {
  /**
   * Apply sublte colours for CSS :focus/:hover states and for when the button is active.
   */
  appLikeInteraction: PropTypes.shape({
    active: PropTypes.bool
  }),
  /**
   * Name of the icon symbol.
   */
  symbol: PropTypes.oneOf(['chevronUp', 'chevronRight', 'chevronDown', 'chevronLeft', 'chevronRightFilled', 'cart', 'circledLine', 'times', 'shipping', 'timesCircled', 'check', 'checkCircledFilled', 'checkCircledNotFilled', 'arrowDownCircled', 'exclamationTriangle', 'exclamationOctagon', 'informationCircled', 'boxOutline', 'boxOutlineChecked', 'radialOutline', 'radialOutlineChecked', 'hamburger', 'spyglass', 'refresh', 'bullet', 'kebab', 'eyeOpened', 'eyeClosed', 'tag', 'tagOutline', 'offerStar', 'info', 'infoSelected', 'profile', 'lock', 'gift', 'caution', 'perks', 'filledCart', 'phone', 'plan']).isRequired,
  /**
   * The appearance of the Icon.
   */
  variant: PropTypes.oneOf(['primary', 'secondary', 'success', 'error', 'black', 'white', 'flirt', 'silver']),
  /**
   * The icon size in pixels.
   */
  size: PropTypes.oneOf([12, 14, 16, 24, 30, 40]),
  /**
   * Pass a handler to the icon to make it interactive. Wraps the icon with a `<button>`.
   */
  onClick: PropTypes.func,
  /**
   * A description of the icon for screen readers.
   */
  a11yText: PropTypes.string.isRequired,
  /**
   * Darken icon color on hover
   */
  darkenOnHover: PropTypes.bool,
  /**
   * Color string. Explicitly set the color.
   */
  color: PropTypes.string
};
StandaloneIcon.defaultProps = {
  appLikeInteraction: undefined,
  variant: undefined,
  size: 16,
  onClick: undefined,
  darkenOnHover: false,
  color: undefined
};

var styles$A = {"flirt":"#7c1366","mosque":"#016b6a","texas":"#f9f6a5","amaranth":"#ee2c74","cardinal-pink":"#8c0448","trinidad":"#df3d0c","chestnut":"#bc4850","onahau":"#c3efff","burnt-sienna":"#ed6358","chathams-blue":"#17367d","mid-blue":"#1a347d","well-read":"#b8373e","wattle":"#d5e04d","beeswax":"#feeec7","bilbao":"#258b0b","sea-buckthorn":"#fbaf34","mint-tulip":"#c1f2e8","turquoise":"#39cdc9","hibiscus":"#c53a70","carousel-pink":"#fae6f4","white":"#fff","black":"#000","mortar":"#595959","gallery":"#efefef","silver":"#c9c8c8","dove":"#666666","iceberg":"#cbf0e8","icicle":"#e5f7fb","light-gray":"#fafafa","super-nova":"#fbaf33","expand-yellow":"#fee8b8","expand-yellow-light":"rgba(254, 232, 184, 0.5)","hero-pink":"#a6298c","drawer":"KDS_Drawer-modules__drawer___SQI6P","drawer--open":"KDS_Drawer-modules__drawer--open___39GOt","drawer__close":"KDS_Drawer-modules__drawer__close___1yeqk","drawer__heading":"KDS_Drawer-modules__drawer__heading___1Lmrc","windowOverlay":"KDS_Drawer-modules__windowOverlay___1masj","windowOverlay--show":"KDS_Drawer-modules__windowOverlay--show___28WW-"};

var _excluded$H = ["heading", "children", "triggerElements", "highlight", "theme"];
var Drawer = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var heading = _ref.heading,
    children = _ref.children,
    triggerElements = _ref.triggerElements,
    highlight = _ref.highlight,
    theme = _ref.theme,
    rest = _objectWithoutProperties$1(_ref, _excluded$H);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    render = _useState2[0],
    setRender = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    runAnimations = _useState4[0],
    setRunAnimations = _useState4[1];
  var _useToggleDrawer = useToggleDrawer(false, ref, triggerElements, highlight, render),
    show = _useToggleDrawer.show,
    drawerRef = _useToggleDrawer.drawerRef,
    handleClickClose = _useToggleDrawer.handleClickClose,
    highlightElement = _useToggleDrawer.highlightElement;

  // Used to offset the timing of conditional rendering and css animations.
  useEffect(function () {
    var toggleDrawerTimer;
    if (show) {
      setRender(true);
      toggleDrawerTimer = setTimeout(function () {
        setRunAnimations(true);
      }, 10);
    } else {
      setRunAnimations(false);
      toggleDrawerTimer = setTimeout(function () {
        setRender(false);
      }, 500);
    }
    return function () {
      return clearInterval(toggleDrawerTimer);
    };
  }, [show, render]);
  return (
    /*#__PURE__*/
    /* eslint-disable react/jsx-no-useless-fragment */
    // jsx fragment created around createPortal for styleguidist to recognize export
    React.createElement(React.Fragment, null, isClient() && /*#__PURE__*/createPortal(render && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      role: "presentation",
      className: "".concat(styles$A.windowOverlay, " ").concat(runAnimations ? "".concat(styles$A['windowOverlay--show']) : '')
    }), /*#__PURE__*/React.createElement("div", _extends$1({}, safeRest(rest), {
      className: "".concat(styles$A.drawer, " ").concat(runAnimations ? "".concat(styles$A['drawer--open']) : ''),
      ref: drawerRef,
      id: show ? 'expanded-drawer' : 'closed-drawer'
    }), heading && /*#__PURE__*/React.createElement("div", {
      className: styles$A.drawer__heading
    }, /*#__PURE__*/React.createElement(Heading$1, {
      level: "h1",
      theme: theme
    }, heading)), /*#__PURE__*/React.createElement("div", {
      className: styles$A.drawer__close
    }, /*#__PURE__*/React.createElement(StandaloneIcon, {
      a11yText: "Close Drawer",
      onClick: handleClickClose,
      size: 24,
      symbol: "times",
      variant: "black"
    })), highlight ? /*#__PURE__*/React.cloneElement(children, {
      highlightElement: highlightElement
    }) : children)), document.body))
  );
});
Drawer.propTypes = {
  /** The content. Can be text, any HTML element, or any component. */
  children: PropTypes.node,
  /** The Heading to be displayed at the top of the drawer. */
  heading: PropTypes.string,
  /** Determines the correct font sizes for the heading. */
  theme: PropTypes.oneOf(['selfServe', 'commerce']),
  /** All the elements on the page that can be used to open the drawer. */
  triggerElements: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
  /** Indicates if a list element should be highlighted when [Drawer.List](#list) is the content. */
  highlight: PropTypes.bool
};
Drawer.defaultProps = {
  children: undefined,
  heading: undefined,
  highlight: false,
  theme: 'selfServe'
};
Drawer.displayName = 'Drawer';
Drawer.List = List;

var mocks;
var hasRequiredMocks;

function requireMocks () {
	if (hasRequiredMocks) return mocks;
	hasRequiredMocks = 1;

	function noop() {
	  return null;
	}

	noop.isRequired = noop;

	function noopThunk() {
	  return noop;
	}

	mocks = {
	  and: noopThunk,
	  between: noopThunk,
	  booleanSome: noopThunk,
	  childrenHavePropXorChildren: noopThunk,
	  childrenOf: noopThunk,
	  childrenOfType: noopThunk,
	  childrenSequenceOf: noopThunk,
	  componentWithName: noopThunk,
	  disallowedIf: noopThunk,
	  elementType: noopThunk,
	  empty: noopThunk,
	  explicitNull: noopThunk,
	  forbidExtraProps: Object,
	  integer: noopThunk,
	  keysOf: noopThunk,
	  mutuallyExclusiveProps: noopThunk,
	  mutuallyExclusiveTrueProps: noopThunk,
	  nChildren: noopThunk,
	  nonNegativeInteger: noop,
	  nonNegativeNumber: noopThunk,
	  numericString: noopThunk,
	  object: noopThunk,
	  or: noopThunk,
	  predicate: noopThunk,
	  range: noopThunk,
	  ref: noopThunk,
	  requiredBy: noopThunk,
	  restrictedProp: noopThunk,
	  sequenceOf: noopThunk,
	  shape: noopThunk,
	  stringEndsWith: noopThunk,
	  stringStartsWith: noopThunk,
	  uniqueArray: noopThunk,
	  uniqueArrayOf: noopThunk,
	  valuesOf: noopThunk,
	  withShape: noopThunk
	};
	
	return mocks;
}

var build$1 = {exports: {}};

var isArguments;
var hasRequiredIsArguments;

function requireIsArguments () {
	if (hasRequiredIsArguments) return isArguments;
	hasRequiredIsArguments = 1;

	var toStr = Object.prototype.toString;

	isArguments = function isArguments(value) {
		var str = toStr.call(value);
		var isArgs = str === '[object Arguments]';
		if (!isArgs) {
			isArgs = str !== '[object Array]' &&
				value !== null &&
				typeof value === 'object' &&
				typeof value.length === 'number' &&
				value.length >= 0 &&
				toStr.call(value.callee) === '[object Function]';
		}
		return isArgs;
	};
	return isArguments;
}

var implementation$7;
var hasRequiredImplementation$7;

function requireImplementation$7 () {
	if (hasRequiredImplementation$7) return implementation$7;
	hasRequiredImplementation$7 = 1;

	var keysShim;
	if (!Object.keys) {
		// modified from https://github.com/es-shims/es5-shim
		var has = Object.prototype.hasOwnProperty;
		var toStr = Object.prototype.toString;
		var isArgs = requireIsArguments(); // eslint-disable-line global-require
		var isEnumerable = Object.prototype.propertyIsEnumerable;
		var hasDontEnumBug = !isEnumerable.call({ toString: null }, 'toString');
		var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
		var dontEnums = [
			'toString',
			'toLocaleString',
			'valueOf',
			'hasOwnProperty',
			'isPrototypeOf',
			'propertyIsEnumerable',
			'constructor'
		];
		var equalsConstructorPrototype = function (o) {
			var ctor = o.constructor;
			return ctor && ctor.prototype === o;
		};
		var excludedKeys = {
			$applicationCache: true,
			$console: true,
			$external: true,
			$frame: true,
			$frameElement: true,
			$frames: true,
			$innerHeight: true,
			$innerWidth: true,
			$onmozfullscreenchange: true,
			$onmozfullscreenerror: true,
			$outerHeight: true,
			$outerWidth: true,
			$pageXOffset: true,
			$pageYOffset: true,
			$parent: true,
			$scrollLeft: true,
			$scrollTop: true,
			$scrollX: true,
			$scrollY: true,
			$self: true,
			$webkitIndexedDB: true,
			$webkitStorageInfo: true,
			$window: true
		};
		var hasAutomationEqualityBug = (function () {
			/* global window */
			if (typeof window === 'undefined') { return false; }
			for (var k in window) {
				try {
					if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
						try {
							equalsConstructorPrototype(window[k]);
						} catch (e) {
							return true;
						}
					}
				} catch (e) {
					return true;
				}
			}
			return false;
		}());
		var equalsConstructorPrototypeIfNotBuggy = function (o) {
			/* global window */
			if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
				return equalsConstructorPrototype(o);
			}
			try {
				return equalsConstructorPrototype(o);
			} catch (e) {
				return false;
			}
		};

		keysShim = function keys(object) {
			var isObject = object !== null && typeof object === 'object';
			var isFunction = toStr.call(object) === '[object Function]';
			var isArguments = isArgs(object);
			var isString = isObject && toStr.call(object) === '[object String]';
			var theKeys = [];

			if (!isObject && !isFunction && !isArguments) {
				throw new TypeError('Object.keys called on a non-object');
			}

			var skipProto = hasProtoEnumBug && isFunction;
			if (isString && object.length > 0 && !has.call(object, 0)) {
				for (var i = 0; i < object.length; ++i) {
					theKeys.push(String(i));
				}
			}

			if (isArguments && object.length > 0) {
				for (var j = 0; j < object.length; ++j) {
					theKeys.push(String(j));
				}
			} else {
				for (var name in object) {
					if (!(skipProto && name === 'prototype') && has.call(object, name)) {
						theKeys.push(String(name));
					}
				}
			}

			if (hasDontEnumBug) {
				var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);

				for (var k = 0; k < dontEnums.length; ++k) {
					if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
						theKeys.push(dontEnums[k]);
					}
				}
			}
			return theKeys;
		};
	}
	implementation$7 = keysShim;
	return implementation$7;
}

var objectKeys;
var hasRequiredObjectKeys;

function requireObjectKeys () {
	if (hasRequiredObjectKeys) return objectKeys;
	hasRequiredObjectKeys = 1;

	var slice = Array.prototype.slice;
	var isArgs = requireIsArguments();

	var origKeys = Object.keys;
	var keysShim = origKeys ? function keys(o) { return origKeys(o); } : requireImplementation$7();

	var originalKeys = Object.keys;

	keysShim.shim = function shimObjectKeys() {
		if (Object.keys) {
			var keysWorksWithArguments = (function () {
				// Safari 5.0 bug
				var args = Object.keys(arguments);
				return args && args.length === arguments.length;
			}(1, 2));
			if (!keysWorksWithArguments) {
				Object.keys = function keys(object) { // eslint-disable-line func-name-matching
					if (isArgs(object)) {
						return originalKeys(slice.call(object));
					}
					return originalKeys(object);
				};
			}
		} else {
			Object.keys = keysShim;
		}
		return Object.keys || keysShim;
	};

	objectKeys = keysShim;
	return objectKeys;
}

var esErrors;
var hasRequiredEsErrors;

function requireEsErrors () {
	if (hasRequiredEsErrors) return esErrors;
	hasRequiredEsErrors = 1;

	/** @type {import('.')} */
	esErrors = Error;
	return esErrors;
}

var _eval;
var hasRequired_eval;

function require_eval () {
	if (hasRequired_eval) return _eval;
	hasRequired_eval = 1;

	/** @type {import('./eval')} */
	_eval = EvalError;
	return _eval;
}

var range$1;
var hasRequiredRange$1;

function requireRange$1 () {
	if (hasRequiredRange$1) return range$1;
	hasRequiredRange$1 = 1;

	/** @type {import('./range')} */
	range$1 = RangeError;
	return range$1;
}

var ref$1;
var hasRequiredRef$1;

function requireRef$1 () {
	if (hasRequiredRef$1) return ref$1;
	hasRequiredRef$1 = 1;

	/** @type {import('./ref')} */
	ref$1 = ReferenceError;
	return ref$1;
}

var syntax;
var hasRequiredSyntax;

function requireSyntax () {
	if (hasRequiredSyntax) return syntax;
	hasRequiredSyntax = 1;

	/** @type {import('./syntax')} */
	syntax = SyntaxError;
	return syntax;
}

var type;
var hasRequiredType$2;

function requireType$2 () {
	if (hasRequiredType$2) return type;
	hasRequiredType$2 = 1;

	/** @type {import('./type')} */
	type = TypeError;
	return type;
}

var uri;
var hasRequiredUri;

function requireUri () {
	if (hasRequiredUri) return uri;
	hasRequiredUri = 1;

	/** @type {import('./uri')} */
	uri = URIError;
	return uri;
}

var shams$1;
var hasRequiredShams$1;

function requireShams$1 () {
	if (hasRequiredShams$1) return shams$1;
	hasRequiredShams$1 = 1;

	/* eslint complexity: [2, 18], max-statements: [2, 33] */
	shams$1 = function hasSymbols() {
		if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
		if (typeof Symbol.iterator === 'symbol') { return true; }

		var obj = {};
		var sym = Symbol('test');
		var symObj = Object(sym);
		if (typeof sym === 'string') { return false; }

		if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
		if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }

		// temp disabled per https://github.com/ljharb/object.assign/issues/17
		// if (sym instanceof Symbol) { return false; }
		// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
		// if (!(symObj instanceof Symbol)) { return false; }

		// if (typeof Symbol.prototype.toString !== 'function') { return false; }
		// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

		var symVal = 42;
		obj[sym] = symVal;
		for (sym in obj) { return false; } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
		if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }

		if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }

		var syms = Object.getOwnPropertySymbols(obj);
		if (syms.length !== 1 || syms[0] !== sym) { return false; }

		if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }

		if (typeof Object.getOwnPropertyDescriptor === 'function') {
			var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
			if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
		}

		return true;
	};
	return shams$1;
}

var hasSymbols;
var hasRequiredHasSymbols;

function requireHasSymbols () {
	if (hasRequiredHasSymbols) return hasSymbols;
	hasRequiredHasSymbols = 1;

	var origSymbol = typeof Symbol !== 'undefined' && Symbol;
	var hasSymbolSham = requireShams$1();

	hasSymbols = function hasNativeSymbols() {
		if (typeof origSymbol !== 'function') { return false; }
		if (typeof Symbol !== 'function') { return false; }
		if (typeof origSymbol('foo') !== 'symbol') { return false; }
		if (typeof Symbol('bar') !== 'symbol') { return false; }

		return hasSymbolSham();
	};
	return hasSymbols;
}

var hasProto;
var hasRequiredHasProto;

function requireHasProto () {
	if (hasRequiredHasProto) return hasProto;
	hasRequiredHasProto = 1;

	var test = {
		__proto__: null,
		foo: {}
	};

	var $Object = Object;

	/** @type {import('.')} */
	hasProto = function hasProto() {
		// @ts-expect-error: TS errors on an inherited property for some reason
		return { __proto__: test }.foo === test.foo
			&& !(test instanceof $Object);
	};
	return hasProto;
}

var implementation$6;
var hasRequiredImplementation$6;

function requireImplementation$6 () {
	if (hasRequiredImplementation$6) return implementation$6;
	hasRequiredImplementation$6 = 1;

	/* eslint no-invalid-this: 1 */

	var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
	var toStr = Object.prototype.toString;
	var max = Math.max;
	var funcType = '[object Function]';

	var concatty = function concatty(a, b) {
	    var arr = [];

	    for (var i = 0; i < a.length; i += 1) {
	        arr[i] = a[i];
	    }
	    for (var j = 0; j < b.length; j += 1) {
	        arr[j + a.length] = b[j];
	    }

	    return arr;
	};

	var slicy = function slicy(arrLike, offset) {
	    var arr = [];
	    for (var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1) {
	        arr[j] = arrLike[i];
	    }
	    return arr;
	};

	var joiny = function (arr, joiner) {
	    var str = '';
	    for (var i = 0; i < arr.length; i += 1) {
	        str += arr[i];
	        if (i + 1 < arr.length) {
	            str += joiner;
	        }
	    }
	    return str;
	};

	implementation$6 = function bind(that) {
	    var target = this;
	    if (typeof target !== 'function' || toStr.apply(target) !== funcType) {
	        throw new TypeError(ERROR_MESSAGE + target);
	    }
	    var args = slicy(arguments, 1);

	    var bound;
	    var binder = function () {
	        if (this instanceof bound) {
	            var result = target.apply(
	                this,
	                concatty(args, arguments)
	            );
	            if (Object(result) === result) {
	                return result;
	            }
	            return this;
	        }
	        return target.apply(
	            that,
	            concatty(args, arguments)
	        );

	    };

	    var boundLength = max(0, target.length - args.length);
	    var boundArgs = [];
	    for (var i = 0; i < boundLength; i++) {
	        boundArgs[i] = '$' + i;
	    }

	    bound = Function('binder', 'return function (' + joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);

	    if (target.prototype) {
	        var Empty = function Empty() {};
	        Empty.prototype = target.prototype;
	        bound.prototype = new Empty();
	        Empty.prototype = null;
	    }

	    return bound;
	};
	return implementation$6;
}

var functionBind;
var hasRequiredFunctionBind;

function requireFunctionBind () {
	if (hasRequiredFunctionBind) return functionBind;
	hasRequiredFunctionBind = 1;

	var implementation = requireImplementation$6();

	functionBind = Function.prototype.bind || implementation;
	return functionBind;
}

var hasown;
var hasRequiredHasown;

function requireHasown () {
	if (hasRequiredHasown) return hasown;
	hasRequiredHasown = 1;

	var call = Function.prototype.call;
	var $hasOwn = Object.prototype.hasOwnProperty;
	var bind = requireFunctionBind();

	/** @type {import('.')} */
	hasown = bind.call(call, $hasOwn);
	return hasown;
}

var getIntrinsic;
var hasRequiredGetIntrinsic;

function requireGetIntrinsic () {
	if (hasRequiredGetIntrinsic) return getIntrinsic;
	hasRequiredGetIntrinsic = 1;

	var undefined$1;

	var $Error = requireEsErrors();
	var $EvalError = require_eval();
	var $RangeError = requireRange$1();
	var $ReferenceError = requireRef$1();
	var $SyntaxError = requireSyntax();
	var $TypeError = requireType$2();
	var $URIError = requireUri();

	var $Function = Function;

	// eslint-disable-next-line consistent-return
	var getEvalledConstructor = function (expressionSyntax) {
		try {
			return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
		} catch (e) {}
	};

	var $gOPD = Object.getOwnPropertyDescriptor;
	if ($gOPD) {
		try {
			$gOPD({}, '');
		} catch (e) {
			$gOPD = null; // this is IE 8, which has a broken gOPD
		}
	}

	var throwTypeError = function () {
		throw new $TypeError();
	};
	var ThrowTypeError = $gOPD
		? (function () {
			try {
				// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
				arguments.callee; // IE 8 does not throw here
				return throwTypeError;
			} catch (calleeThrows) {
				try {
					// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
					return $gOPD(arguments, 'callee').get;
				} catch (gOPDthrows) {
					return throwTypeError;
				}
			}
		}())
		: throwTypeError;

	var hasSymbols = requireHasSymbols()();
	var hasProto = requireHasProto()();

	var getProto = Object.getPrototypeOf || (
		hasProto
			? function (x) { return x.__proto__; } // eslint-disable-line no-proto
			: null
	);

	var needsEval = {};

	var TypedArray = typeof Uint8Array === 'undefined' || !getProto ? undefined$1 : getProto(Uint8Array);

	var INTRINSICS = {
		__proto__: null,
		'%AggregateError%': typeof AggregateError === 'undefined' ? undefined$1 : AggregateError,
		'%Array%': Array,
		'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined$1 : ArrayBuffer,
		'%ArrayIteratorPrototype%': hasSymbols && getProto ? getProto([][Symbol.iterator]()) : undefined$1,
		'%AsyncFromSyncIteratorPrototype%': undefined$1,
		'%AsyncFunction%': needsEval,
		'%AsyncGenerator%': needsEval,
		'%AsyncGeneratorFunction%': needsEval,
		'%AsyncIteratorPrototype%': needsEval,
		'%Atomics%': typeof Atomics === 'undefined' ? undefined$1 : Atomics,
		'%BigInt%': typeof BigInt === 'undefined' ? undefined$1 : BigInt,
		'%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined$1 : BigInt64Array,
		'%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined$1 : BigUint64Array,
		'%Boolean%': Boolean,
		'%DataView%': typeof DataView === 'undefined' ? undefined$1 : DataView,
		'%Date%': Date,
		'%decodeURI%': decodeURI,
		'%decodeURIComponent%': decodeURIComponent,
		'%encodeURI%': encodeURI,
		'%encodeURIComponent%': encodeURIComponent,
		'%Error%': $Error,
		'%eval%': eval, // eslint-disable-line no-eval
		'%EvalError%': $EvalError,
		'%Float32Array%': typeof Float32Array === 'undefined' ? undefined$1 : Float32Array,
		'%Float64Array%': typeof Float64Array === 'undefined' ? undefined$1 : Float64Array,
		'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined$1 : FinalizationRegistry,
		'%Function%': $Function,
		'%GeneratorFunction%': needsEval,
		'%Int8Array%': typeof Int8Array === 'undefined' ? undefined$1 : Int8Array,
		'%Int16Array%': typeof Int16Array === 'undefined' ? undefined$1 : Int16Array,
		'%Int32Array%': typeof Int32Array === 'undefined' ? undefined$1 : Int32Array,
		'%isFinite%': isFinite,
		'%isNaN%': isNaN,
		'%IteratorPrototype%': hasSymbols && getProto ? getProto(getProto([][Symbol.iterator]())) : undefined$1,
		'%JSON%': typeof JSON === 'object' ? JSON : undefined$1,
		'%Map%': typeof Map === 'undefined' ? undefined$1 : Map,
		'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols || !getProto ? undefined$1 : getProto(new Map()[Symbol.iterator]()),
		'%Math%': Math,
		'%Number%': Number,
		'%Object%': Object,
		'%parseFloat%': parseFloat,
		'%parseInt%': parseInt,
		'%Promise%': typeof Promise === 'undefined' ? undefined$1 : Promise,
		'%Proxy%': typeof Proxy === 'undefined' ? undefined$1 : Proxy,
		'%RangeError%': $RangeError,
		'%ReferenceError%': $ReferenceError,
		'%Reflect%': typeof Reflect === 'undefined' ? undefined$1 : Reflect,
		'%RegExp%': RegExp,
		'%Set%': typeof Set === 'undefined' ? undefined$1 : Set,
		'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols || !getProto ? undefined$1 : getProto(new Set()[Symbol.iterator]()),
		'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined$1 : SharedArrayBuffer,
		'%String%': String,
		'%StringIteratorPrototype%': hasSymbols && getProto ? getProto(''[Symbol.iterator]()) : undefined$1,
		'%Symbol%': hasSymbols ? Symbol : undefined$1,
		'%SyntaxError%': $SyntaxError,
		'%ThrowTypeError%': ThrowTypeError,
		'%TypedArray%': TypedArray,
		'%TypeError%': $TypeError,
		'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined$1 : Uint8Array,
		'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined$1 : Uint8ClampedArray,
		'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined$1 : Uint16Array,
		'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined$1 : Uint32Array,
		'%URIError%': $URIError,
		'%WeakMap%': typeof WeakMap === 'undefined' ? undefined$1 : WeakMap,
		'%WeakRef%': typeof WeakRef === 'undefined' ? undefined$1 : WeakRef,
		'%WeakSet%': typeof WeakSet === 'undefined' ? undefined$1 : WeakSet
	};

	if (getProto) {
		try {
			null.error; // eslint-disable-line no-unused-expressions
		} catch (e) {
			// https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
			var errorProto = getProto(getProto(e));
			INTRINSICS['%Error.prototype%'] = errorProto;
		}
	}

	var doEval = function doEval(name) {
		var value;
		if (name === '%AsyncFunction%') {
			value = getEvalledConstructor('async function () {}');
		} else if (name === '%GeneratorFunction%') {
			value = getEvalledConstructor('function* () {}');
		} else if (name === '%AsyncGeneratorFunction%') {
			value = getEvalledConstructor('async function* () {}');
		} else if (name === '%AsyncGenerator%') {
			var fn = doEval('%AsyncGeneratorFunction%');
			if (fn) {
				value = fn.prototype;
			}
		} else if (name === '%AsyncIteratorPrototype%') {
			var gen = doEval('%AsyncGenerator%');
			if (gen && getProto) {
				value = getProto(gen.prototype);
			}
		}

		INTRINSICS[name] = value;

		return value;
	};

	var LEGACY_ALIASES = {
		__proto__: null,
		'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
		'%ArrayPrototype%': ['Array', 'prototype'],
		'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
		'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
		'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
		'%ArrayProto_values%': ['Array', 'prototype', 'values'],
		'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
		'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
		'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
		'%BooleanPrototype%': ['Boolean', 'prototype'],
		'%DataViewPrototype%': ['DataView', 'prototype'],
		'%DatePrototype%': ['Date', 'prototype'],
		'%ErrorPrototype%': ['Error', 'prototype'],
		'%EvalErrorPrototype%': ['EvalError', 'prototype'],
		'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
		'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
		'%FunctionPrototype%': ['Function', 'prototype'],
		'%Generator%': ['GeneratorFunction', 'prototype'],
		'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
		'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
		'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
		'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
		'%JSONParse%': ['JSON', 'parse'],
		'%JSONStringify%': ['JSON', 'stringify'],
		'%MapPrototype%': ['Map', 'prototype'],
		'%NumberPrototype%': ['Number', 'prototype'],
		'%ObjectPrototype%': ['Object', 'prototype'],
		'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
		'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
		'%PromisePrototype%': ['Promise', 'prototype'],
		'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
		'%Promise_all%': ['Promise', 'all'],
		'%Promise_reject%': ['Promise', 'reject'],
		'%Promise_resolve%': ['Promise', 'resolve'],
		'%RangeErrorPrototype%': ['RangeError', 'prototype'],
		'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
		'%RegExpPrototype%': ['RegExp', 'prototype'],
		'%SetPrototype%': ['Set', 'prototype'],
		'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
		'%StringPrototype%': ['String', 'prototype'],
		'%SymbolPrototype%': ['Symbol', 'prototype'],
		'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
		'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
		'%TypeErrorPrototype%': ['TypeError', 'prototype'],
		'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
		'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
		'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
		'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
		'%URIErrorPrototype%': ['URIError', 'prototype'],
		'%WeakMapPrototype%': ['WeakMap', 'prototype'],
		'%WeakSetPrototype%': ['WeakSet', 'prototype']
	};

	var bind = requireFunctionBind();
	var hasOwn = requireHasown();
	var $concat = bind.call(Function.call, Array.prototype.concat);
	var $spliceApply = bind.call(Function.apply, Array.prototype.splice);
	var $replace = bind.call(Function.call, String.prototype.replace);
	var $strSlice = bind.call(Function.call, String.prototype.slice);
	var $exec = bind.call(Function.call, RegExp.prototype.exec);

	/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
	var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
	var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
	var stringToPath = function stringToPath(string) {
		var first = $strSlice(string, 0, 1);
		var last = $strSlice(string, -1);
		if (first === '%' && last !== '%') {
			throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
		} else if (last === '%' && first !== '%') {
			throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
		}
		var result = [];
		$replace(string, rePropName, function (match, number, quote, subString) {
			result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
		});
		return result;
	};
	/* end adaptation */

	var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
		var intrinsicName = name;
		var alias;
		if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
			alias = LEGACY_ALIASES[intrinsicName];
			intrinsicName = '%' + alias[0] + '%';
		}

		if (hasOwn(INTRINSICS, intrinsicName)) {
			var value = INTRINSICS[intrinsicName];
			if (value === needsEval) {
				value = doEval(intrinsicName);
			}
			if (typeof value === 'undefined' && !allowMissing) {
				throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
			}

			return {
				alias: alias,
				name: intrinsicName,
				value: value
			};
		}

		throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
	};

	getIntrinsic = function GetIntrinsic(name, allowMissing) {
		if (typeof name !== 'string' || name.length === 0) {
			throw new $TypeError('intrinsic name must be a non-empty string');
		}
		if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
			throw new $TypeError('"allowMissing" argument must be a boolean');
		}

		if ($exec(/^%?[^%]*%?$/, name) === null) {
			throw new $SyntaxError('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
		}
		var parts = stringToPath(name);
		var intrinsicBaseName = parts.length > 0 ? parts[0] : '';

		var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
		var intrinsicRealName = intrinsic.name;
		var value = intrinsic.value;
		var skipFurtherCaching = false;

		var alias = intrinsic.alias;
		if (alias) {
			intrinsicBaseName = alias[0];
			$spliceApply(parts, $concat([0, 1], alias));
		}

		for (var i = 1, isOwn = true; i < parts.length; i += 1) {
			var part = parts[i];
			var first = $strSlice(part, 0, 1);
			var last = $strSlice(part, -1);
			if (
				(
					(first === '"' || first === "'" || first === '`')
					|| (last === '"' || last === "'" || last === '`')
				)
				&& first !== last
			) {
				throw new $SyntaxError('property names with quotes must have matching quotes');
			}
			if (part === 'constructor' || !isOwn) {
				skipFurtherCaching = true;
			}

			intrinsicBaseName += '.' + part;
			intrinsicRealName = '%' + intrinsicBaseName + '%';

			if (hasOwn(INTRINSICS, intrinsicRealName)) {
				value = INTRINSICS[intrinsicRealName];
			} else if (value != null) {
				if (!(part in value)) {
					if (!allowMissing) {
						throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
					}
					return void undefined$1;
				}
				if ($gOPD && (i + 1) >= parts.length) {
					var desc = $gOPD(value, part);
					isOwn = !!desc;

					// By convention, when a data property is converted to an accessor
					// property to emulate a data property that does not suffer from
					// the override mistake, that accessor's getter is marked with
					// an `originalValue` property. Here, when we detect this, we
					// uphold the illusion by pretending to see that original data
					// property, i.e., returning the value rather than the getter
					// itself.
					if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
						value = desc.get;
					} else {
						value = value[part];
					}
				} else {
					isOwn = hasOwn(value, part);
					value = value[part];
				}

				if (isOwn && !skipFurtherCaching) {
					INTRINSICS[intrinsicRealName] = value;
				}
			}
		}
		return value;
	};
	return getIntrinsic;
}

var esDefineProperty;
var hasRequiredEsDefineProperty;

function requireEsDefineProperty () {
	if (hasRequiredEsDefineProperty) return esDefineProperty;
	hasRequiredEsDefineProperty = 1;

	var GetIntrinsic = requireGetIntrinsic();

	/** @type {import('.')} */
	var $defineProperty = GetIntrinsic('%Object.defineProperty%', true) || false;
	if ($defineProperty) {
		try {
			$defineProperty({}, 'a', { value: 1 });
		} catch (e) {
			// IE 8 has a broken defineProperty
			$defineProperty = false;
		}
	}

	esDefineProperty = $defineProperty;
	return esDefineProperty;
}

var gopd;
var hasRequiredGopd;

function requireGopd () {
	if (hasRequiredGopd) return gopd;
	hasRequiredGopd = 1;

	var GetIntrinsic = requireGetIntrinsic();

	var $gOPD = GetIntrinsic('%Object.getOwnPropertyDescriptor%', true);

	if ($gOPD) {
		try {
			$gOPD([], 'length');
		} catch (e) {
			// IE 8 has a broken gOPD
			$gOPD = null;
		}
	}

	gopd = $gOPD;
	return gopd;
}

var defineDataProperty;
var hasRequiredDefineDataProperty;

function requireDefineDataProperty () {
	if (hasRequiredDefineDataProperty) return defineDataProperty;
	hasRequiredDefineDataProperty = 1;

	var $defineProperty = requireEsDefineProperty();

	var $SyntaxError = requireSyntax();
	var $TypeError = requireType$2();

	var gopd = requireGopd();

	/** @type {import('.')} */
	defineDataProperty = function defineDataProperty(
		obj,
		property,
		value
	) {
		if (!obj || (typeof obj !== 'object' && typeof obj !== 'function')) {
			throw new $TypeError('`obj` must be an object or a function`');
		}
		if (typeof property !== 'string' && typeof property !== 'symbol') {
			throw new $TypeError('`property` must be a string or a symbol`');
		}
		if (arguments.length > 3 && typeof arguments[3] !== 'boolean' && arguments[3] !== null) {
			throw new $TypeError('`nonEnumerable`, if provided, must be a boolean or null');
		}
		if (arguments.length > 4 && typeof arguments[4] !== 'boolean' && arguments[4] !== null) {
			throw new $TypeError('`nonWritable`, if provided, must be a boolean or null');
		}
		if (arguments.length > 5 && typeof arguments[5] !== 'boolean' && arguments[5] !== null) {
			throw new $TypeError('`nonConfigurable`, if provided, must be a boolean or null');
		}
		if (arguments.length > 6 && typeof arguments[6] !== 'boolean') {
			throw new $TypeError('`loose`, if provided, must be a boolean');
		}

		var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
		var nonWritable = arguments.length > 4 ? arguments[4] : null;
		var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
		var loose = arguments.length > 6 ? arguments[6] : false;

		/* @type {false | TypedPropertyDescriptor<unknown>} */
		var desc = !!gopd && gopd(obj, property);

		if ($defineProperty) {
			$defineProperty(obj, property, {
				configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
				enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
				value: value,
				writable: nonWritable === null && desc ? desc.writable : !nonWritable
			});
		} else if (loose || (!nonEnumerable && !nonWritable && !nonConfigurable)) {
			// must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
			obj[property] = value; // eslint-disable-line no-param-reassign
		} else {
			throw new $SyntaxError('This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.');
		}
	};
	return defineDataProperty;
}

var hasPropertyDescriptors_1;
var hasRequiredHasPropertyDescriptors;

function requireHasPropertyDescriptors () {
	if (hasRequiredHasPropertyDescriptors) return hasPropertyDescriptors_1;
	hasRequiredHasPropertyDescriptors = 1;

	var $defineProperty = requireEsDefineProperty();

	var hasPropertyDescriptors = function hasPropertyDescriptors() {
		return !!$defineProperty;
	};

	hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
		// node v0.6 has a bug where array lengths can be Set but not Defined
		if (!$defineProperty) {
			return null;
		}
		try {
			return $defineProperty([], 'length', { value: 1 }).length !== 1;
		} catch (e) {
			// In Firefox 4-22, defining length on an array throws an exception.
			return true;
		}
	};

	hasPropertyDescriptors_1 = hasPropertyDescriptors;
	return hasPropertyDescriptors_1;
}

var defineProperties_1;
var hasRequiredDefineProperties;

function requireDefineProperties () {
	if (hasRequiredDefineProperties) return defineProperties_1;
	hasRequiredDefineProperties = 1;

	var keys = requireObjectKeys();
	var hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';

	var toStr = Object.prototype.toString;
	var concat = Array.prototype.concat;
	var defineDataProperty = requireDefineDataProperty();

	var isFunction = function (fn) {
		return typeof fn === 'function' && toStr.call(fn) === '[object Function]';
	};

	var supportsDescriptors = requireHasPropertyDescriptors()();

	var defineProperty = function (object, name, value, predicate) {
		if (name in object) {
			if (predicate === true) {
				if (object[name] === value) {
					return;
				}
			} else if (!isFunction(predicate) || !predicate()) {
				return;
			}
		}

		if (supportsDescriptors) {
			defineDataProperty(object, name, value, true);
		} else {
			defineDataProperty(object, name, value);
		}
	};

	var defineProperties = function (object, map) {
		var predicates = arguments.length > 2 ? arguments[2] : {};
		var props = keys(map);
		if (hasSymbols) {
			props = concat.call(props, Object.getOwnPropertySymbols(map));
		}
		for (var i = 0; i < props.length; i += 1) {
			defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
		}
	};

	defineProperties.supportsDescriptors = !!supportsDescriptors;

	defineProperties_1 = defineProperties;
	return defineProperties_1;
}

var callBind = {exports: {}};

var setFunctionLength;
var hasRequiredSetFunctionLength;

function requireSetFunctionLength () {
	if (hasRequiredSetFunctionLength) return setFunctionLength;
	hasRequiredSetFunctionLength = 1;

	var GetIntrinsic = requireGetIntrinsic();
	var define = requireDefineDataProperty();
	var hasDescriptors = requireHasPropertyDescriptors()();
	var gOPD = requireGopd();

	var $TypeError = requireType$2();
	var $floor = GetIntrinsic('%Math.floor%');

	/** @type {import('.')} */
	setFunctionLength = function setFunctionLength(fn, length) {
		if (typeof fn !== 'function') {
			throw new $TypeError('`fn` is not a function');
		}
		if (typeof length !== 'number' || length < 0 || length > 0xFFFFFFFF || $floor(length) !== length) {
			throw new $TypeError('`length` must be a positive 32-bit integer');
		}

		var loose = arguments.length > 2 && !!arguments[2];

		var functionLengthIsConfigurable = true;
		var functionLengthIsWritable = true;
		if ('length' in fn && gOPD) {
			var desc = gOPD(fn, 'length');
			if (desc && !desc.configurable) {
				functionLengthIsConfigurable = false;
			}
			if (desc && !desc.writable) {
				functionLengthIsWritable = false;
			}
		}

		if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
			if (hasDescriptors) {
				define(/** @type {Parameters<define>[0]} */ (fn), 'length', length, true, true);
			} else {
				define(/** @type {Parameters<define>[0]} */ (fn), 'length', length);
			}
		}
		return fn;
	};
	return setFunctionLength;
}

callBind.exports;

var hasRequiredCallBind;

function requireCallBind () {
	if (hasRequiredCallBind) return callBind.exports;
	hasRequiredCallBind = 1;
	(function (module) {

		var bind = requireFunctionBind();
		var GetIntrinsic = requireGetIntrinsic();
		var setFunctionLength = requireSetFunctionLength();

		var $TypeError = requireType$2();
		var $apply = GetIntrinsic('%Function.prototype.apply%');
		var $call = GetIntrinsic('%Function.prototype.call%');
		var $reflectApply = GetIntrinsic('%Reflect.apply%', true) || bind.call($call, $apply);

		var $defineProperty = requireEsDefineProperty();
		var $max = GetIntrinsic('%Math.max%');

		module.exports = function callBind(originalFunction) {
			if (typeof originalFunction !== 'function') {
				throw new $TypeError('a function is required');
			}
			var func = $reflectApply(bind, $call, arguments);
			return setFunctionLength(
				func,
				1 + $max(0, originalFunction.length - (arguments.length - 1)),
				true
			);
		};

		var applyBind = function applyBind() {
			return $reflectApply(bind, $apply, arguments);
		};

		if ($defineProperty) {
			$defineProperty(module.exports, 'apply', { value: applyBind });
		} else {
			module.exports.apply = applyBind;
		} 
	} (callBind));
	return callBind.exports;
}

var callBound;
var hasRequiredCallBound;

function requireCallBound () {
	if (hasRequiredCallBound) return callBound;
	hasRequiredCallBound = 1;

	var GetIntrinsic = requireGetIntrinsic();

	var callBind = requireCallBind();

	var $indexOf = callBind(GetIntrinsic('String.prototype.indexOf'));

	callBound = function callBoundIntrinsic(name, allowMissing) {
		var intrinsic = GetIntrinsic(name, !!allowMissing);
		if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
			return callBind(intrinsic);
		}
		return intrinsic;
	};
	return callBound;
}

var implementation$5;
var hasRequiredImplementation$5;

function requireImplementation$5 () {
	if (hasRequiredImplementation$5) return implementation$5;
	hasRequiredImplementation$5 = 1;

	// modified from https://github.com/es-shims/es6-shim
	var objectKeys = requireObjectKeys();
	var hasSymbols = requireShams$1()();
	var callBound = requireCallBound();
	var toObject = Object;
	var $push = callBound('Array.prototype.push');
	var $propIsEnumerable = callBound('Object.prototype.propertyIsEnumerable');
	var originalGetSymbols = hasSymbols ? Object.getOwnPropertySymbols : null;

	// eslint-disable-next-line no-unused-vars
	implementation$5 = function assign(target, source1) {
		if (target == null) { throw new TypeError('target must be an object'); }
		var to = toObject(target); // step 1
		if (arguments.length === 1) {
			return to; // step 2
		}
		for (var s = 1; s < arguments.length; ++s) {
			var from = toObject(arguments[s]); // step 3.a.i

			// step 3.a.ii:
			var keys = objectKeys(from);
			var getSymbols = hasSymbols && (Object.getOwnPropertySymbols || originalGetSymbols);
			if (getSymbols) {
				var syms = getSymbols(from);
				for (var j = 0; j < syms.length; ++j) {
					var key = syms[j];
					if ($propIsEnumerable(from, key)) {
						$push(keys, key);
					}
				}
			}

			// step 3.a.iii:
			for (var i = 0; i < keys.length; ++i) {
				var nextKey = keys[i];
				if ($propIsEnumerable(from, nextKey)) { // step 3.a.iii.2
					var propValue = from[nextKey]; // step 3.a.iii.2.a
					to[nextKey] = propValue; // step 3.a.iii.2.b
				}
			}
		}

		return to; // step 4
	};
	return implementation$5;
}

var polyfill$5;
var hasRequiredPolyfill$5;

function requirePolyfill$5 () {
	if (hasRequiredPolyfill$5) return polyfill$5;
	hasRequiredPolyfill$5 = 1;

	var implementation = requireImplementation$5();

	var lacksProperEnumerationOrder = function () {
		if (!Object.assign) {
			return false;
		}
		/*
		 * v8, specifically in node 4.x, has a bug with incorrect property enumeration order
		 * note: this does not detect the bug unless there's 20 characters
		 */
		var str = 'abcdefghijklmnopqrst';
		var letters = str.split('');
		var map = {};
		for (var i = 0; i < letters.length; ++i) {
			map[letters[i]] = letters[i];
		}
		var obj = Object.assign({}, map);
		var actual = '';
		for (var k in obj) {
			actual += k;
		}
		return str !== actual;
	};

	var assignHasPendingExceptions = function () {
		if (!Object.assign || !Object.preventExtensions) {
			return false;
		}
		/*
		 * Firefox 37 still has "pending exception" logic in its Object.assign implementation,
		 * which is 72% slower than our shim, and Firefox 40's native implementation.
		 */
		var thrower = Object.preventExtensions({ 1: 2 });
		try {
			Object.assign(thrower, 'xy');
		} catch (e) {
			return thrower[1] === 'y';
		}
		return false;
	};

	polyfill$5 = function getPolyfill() {
		if (!Object.assign) {
			return implementation;
		}
		if (lacksProperEnumerationOrder()) {
			return implementation;
		}
		if (assignHasPendingExceptions()) {
			return implementation;
		}
		return Object.assign;
	};
	return polyfill$5;
}

var shim$5;
var hasRequiredShim$5;

function requireShim$5 () {
	if (hasRequiredShim$5) return shim$5;
	hasRequiredShim$5 = 1;

	var define = requireDefineProperties();
	var getPolyfill = requirePolyfill$5();

	shim$5 = function shimAssign() {
		var polyfill = getPolyfill();
		define(
			Object,
			{ assign: polyfill },
			{ assign: function () { return Object.assign !== polyfill; } }
		);
		return polyfill;
	};
	return shim$5;
}

var object_assign;
var hasRequiredObject_assign;

function requireObject_assign () {
	if (hasRequiredObject_assign) return object_assign;
	hasRequiredObject_assign = 1;

	var defineProperties = requireDefineProperties();
	var callBind = requireCallBind();

	var implementation = requireImplementation$5();
	var getPolyfill = requirePolyfill$5();
	var shim = requireShim$5();

	var polyfill = callBind.apply(getPolyfill());
	// eslint-disable-next-line no-unused-vars
	var bound = function assign(target, source1) {
		return polyfill(Object, arguments);
	};

	defineProperties(bound, {
		getPolyfill: getPolyfill,
		implementation: implementation,
		shim: shim
	});

	object_assign = bound;
	return object_assign;
}

var src;
var hasRequiredSrc;

function requireSrc () {
	if (hasRequiredSrc) return src;
	hasRequiredSrc = 1;

	var hasOwnProperty = {}.hasOwnProperty;
	var call = Function.prototype.call;

	src = call.bind ? call.bind(hasOwnProperty) : function (O, P) {
	  return call.call(hasOwnProperty, O, P);
	};
	return src;
}

var isPlainObject$1 = {exports: {}};

isPlainObject$1.exports;

var hasRequiredIsPlainObject$1;

function requireIsPlainObject$1 () {
	if (hasRequiredIsPlainObject$1) return isPlainObject$1.exports;
	hasRequiredIsPlainObject$1 = 1;
	(function (module, exports) {
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});

		var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

		exports['default'] = isPlainObject;
		function isPlainObject(x) {
		  return x && (typeof x === 'undefined' ? 'undefined' : _typeof(x)) === 'object' && !Array.isArray(x);
		}
		module.exports = exports['default'];
		
	} (isPlainObject$1, isPlainObject$1.exports));
	return isPlainObject$1.exports;
}

build$1.exports;

var hasRequiredBuild$1;

function requireBuild$1 () {
	if (hasRequiredBuild$1) return build$1.exports;
	hasRequiredBuild$1 = 1;
	(function (module, exports) {
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports['default'] = forbidExtraProps;

		var _object = requireObject_assign();

		var _object2 = _interopRequireDefault(_object);

		var _has = requireSrc();

		var _has2 = _interopRequireDefault(_has);

		var _isPlainObject = requireIsPlainObject$1();

		var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

		function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

		var zeroWidthSpace = '\u200B';
		var specialProperty = 'prop-types-exact: ' + zeroWidthSpace;
		var semaphore = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' ? Symbol['for'](specialProperty) : /* istanbul ignore next */specialProperty;

		function brand(fn) {
		  return (0, _object2['default'])(fn, _defineProperty({}, specialProperty, semaphore));
		}

		function isBranded(value) {
		  return value && value[specialProperty] === semaphore;
		}

		function forbidExtraProps(propTypes) {
		  if (!(0, _isPlainObject2['default'])(propTypes)) {
		    throw new TypeError('given propTypes must be an object');
		  }
		  if ((0, _has2['default'])(propTypes, specialProperty) && !isBranded(propTypes[specialProperty])) {
		    throw new TypeError('Against all odds, you created a propType for a prop that uses both the zero-width space and our custom string - which, sadly, conflicts with `prop-types-exact`');
		  }

		  return (0, _object2['default'])({}, propTypes, _defineProperty({}, specialProperty, brand(function () {
		    function forbidUnknownProps(props, _, componentName) {
		      var unknownProps = Object.keys(props).filter(function (prop) {
		        return !(0, _has2['default'])(propTypes, prop);
		      });
		      if (unknownProps.length > 0) {
		        return new TypeError(String(componentName) + ': unknown props found: ' + String(unknownProps.join(', ')));
		      }
		      return null;
		    }

		    return forbidUnknownProps;
		  }())));
		}
		module.exports = exports['default'];
		
	} (build$1, build$1.exports));
	return build$1.exports;
}

var and = {};

var wrapValidator = {};

var hasRequiredWrapValidator;

function requireWrapValidator () {
	if (hasRequiredWrapValidator) return wrapValidator;
	hasRequiredWrapValidator = 1;
	(function (exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports["default"] = wrapValidator;

		var _object = _interopRequireDefault(requireObject_assign());

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

		function wrapValidator(validator, typeName) {
		  var typeChecker = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
		  return (0, _object["default"])(validator.bind(), {
		    typeName: typeName,
		    typeChecker: typeChecker,
		    isRequired: (0, _object["default"])(validator.isRequired.bind(), {
		      typeName: typeName,
		      typeChecker: typeChecker,
		      typeRequired: true
		    })
		  });
		}
		
	} (wrapValidator));
	return wrapValidator;
}

var hasRequiredAnd;

function requireAnd () {
	if (hasRequiredAnd) return and;
	hasRequiredAnd = 1;
	(function (exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports["default"] = andValidator;

		var _wrapValidator = _interopRequireDefault(requireWrapValidator());

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

		function andValidator(validators) {
		  var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'and';

		  if (!Array.isArray(validators)) {
		    throw new TypeError('and: 2 or more validators are required');
		  }

		  if (validators.length <= 1) {
		    throw new RangeError('and: 2 or more validators are required');
		  }

		  var validator = function and() {
		    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
		      args[_key] = arguments[_key];
		    }

		    var firstError = null;
		    validators.some(function (validatorFn) {
		      firstError = validatorFn.apply(void 0, args);
		      return firstError != null;
		    });
		    return firstError == null ? null : firstError;
		  };

		  validator.isRequired = function andIsRequired() {
		    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
		      args[_key2] = arguments[_key2];
		    }

		    var firstError = null;
		    validators.some(function (validatorFn) {
		      firstError = validatorFn.isRequired.apply(validatorFn, args);
		      return firstError != null;
		    });
		    return firstError == null ? null : firstError;
		  };

		  return (0, _wrapValidator["default"])(validator, name, validators);
		}
		
	} (and));
	return and;
}

var between = {};

var RequireObjectCoercible;
var hasRequiredRequireObjectCoercible;

function requireRequireObjectCoercible () {
	if (hasRequiredRequireObjectCoercible) return RequireObjectCoercible;
	hasRequiredRequireObjectCoercible = 1;

	var $TypeError = requireType$2();

	/** @type {import('./RequireObjectCoercible')} */
	RequireObjectCoercible = function RequireObjectCoercible(value) {
		if (value == null) {
			throw new $TypeError((arguments.length > 0 && arguments[1]) || ('Cannot call method on ' + value));
		}
		return value;
	};
	return RequireObjectCoercible;
}

var implementation$4;
var hasRequiredImplementation$4;

function requireImplementation$4 () {
	if (hasRequiredImplementation$4) return implementation$4;
	hasRequiredImplementation$4 = 1;

	var RequireObjectCoercible = requireRequireObjectCoercible();
	var callBound = requireCallBound();
	var $isEnumerable = callBound('Object.prototype.propertyIsEnumerable');
	var $push = callBound('Array.prototype.push');

	implementation$4 = function entries(O) {
		var obj = RequireObjectCoercible(O);
		var entrys = [];
		for (var key in obj) {
			if ($isEnumerable(obj, key)) { // checks own-ness as well
				$push(entrys, [key, obj[key]]);
			}
		}
		return entrys;
	};
	return implementation$4;
}

var polyfill$4;
var hasRequiredPolyfill$4;

function requirePolyfill$4 () {
	if (hasRequiredPolyfill$4) return polyfill$4;
	hasRequiredPolyfill$4 = 1;

	var implementation = requireImplementation$4();

	polyfill$4 = function getPolyfill() {
		return typeof Object.entries === 'function' ? Object.entries : implementation;
	};
	return polyfill$4;
}

var shim$4;
var hasRequiredShim$4;

function requireShim$4 () {
	if (hasRequiredShim$4) return shim$4;
	hasRequiredShim$4 = 1;

	var getPolyfill = requirePolyfill$4();
	var define = requireDefineProperties();

	shim$4 = function shimEntries() {
		var polyfill = getPolyfill();
		define(Object, { entries: polyfill }, {
			entries: function testEntries() {
				return Object.entries !== polyfill;
			}
		});
		return polyfill;
	};
	return shim$4;
}

var object_entries;
var hasRequiredObject_entries;

function requireObject_entries () {
	if (hasRequiredObject_entries) return object_entries;
	hasRequiredObject_entries = 1;

	var define = requireDefineProperties();
	var callBind = requireCallBind();

	var implementation = requireImplementation$4();
	var getPolyfill = requirePolyfill$4();
	var shim = requireShim$4();

	var polyfill = callBind(getPolyfill(), Object);

	define(polyfill, {
		getPolyfill: getPolyfill,
		implementation: implementation,
		shim: shim
	});

	object_entries = polyfill;
	return object_entries;
}

var shape = {};

var isPlainObject = {};

var hasRequiredIsPlainObject;

function requireIsPlainObject () {
	if (hasRequiredIsPlainObject) return isPlainObject;
	hasRequiredIsPlainObject = 1;
	(function (exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports["default"] = void 0;

		var _isPlainObject = _interopRequireDefault(requireIsPlainObject$1());

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

		var _default = _isPlainObject["default"];
		exports["default"] = _default;
		
	} (isPlainObject));
	return isPlainObject;
}

var hasRequiredShape;

function requireShape () {
	if (hasRequiredShape) return shape;
	hasRequiredShape = 1;
	(function (exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports["default"] = shapeValidator;

		var _isPlainObject = _interopRequireDefault(requireIsPlainObject());

		var _wrapValidator = _interopRequireDefault(requireWrapValidator());

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

		function shapeValidator(shapeTypes) {
		  if (!(0, _isPlainObject["default"])(shapeTypes)) {
		    throw new TypeError('shape must be a normal object');
		  }

		  function shape(props, propName, componentName, location) {
		    var propValue = props[propName];

		    if (propValue == null) {
		      return null;
		    } // code adapted from PropTypes.shape: https://github.com/facebook/react/blob/14156e56b9cf18ac86963185c5af4abddf3ff811/src/isomorphic/classic/types/ReactPropTypes.js#L381
		    // eslint-disable-next-line guard-for-in, no-restricted-syntax


		    for (var _len = arguments.length, rest = new Array(_len > 4 ? _len - 4 : 0), _key = 4; _key < _len; _key++) {
		      rest[_key - 4] = arguments[_key];
		    }

		    for (var key in shapeTypes) {
		      var checker = shapeTypes[key];

		      if (checker) {
		        var error = checker.apply(void 0, [propValue, key, componentName, location].concat(rest));

		        if (error) {
		          return error;
		        }
		      }
		    }

		    return null;
		  }

		  shape.isRequired = function shapeRequired(props, propName, componentName) {
		    var propValue = props[propName];

		    if (propValue == null) {
		      return new TypeError("".concat(componentName, ": ").concat(propName, " is required."));
		    }

		    for (var _len2 = arguments.length, rest = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
		      rest[_key2 - 3] = arguments[_key2];
		    }

		    return shape.apply(void 0, [props, propName, componentName].concat(rest));
		  };

		  return (0, _wrapValidator["default"])(shape, 'shape', shapeTypes);
		}
		
	} (shape));
	return shape;
}

var valuesOf = {};

var isPrimitive$2 = {};

var hasRequiredIsPrimitive$2;

function requireIsPrimitive$2 () {
	if (hasRequiredIsPrimitive$2) return isPrimitive$2;
	hasRequiredIsPrimitive$2 = 1;
	(function (exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports["default"] = isPrimitive;

		function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

		function isPrimitive(x) {
		  return !x || _typeof(x) !== 'object' && typeof x !== 'function';
		}
		
	} (isPrimitive$2));
	return isPrimitive$2;
}

var hasRequiredValuesOf;

function requireValuesOf () {
	if (hasRequiredValuesOf) return valuesOf;
	hasRequiredValuesOf = 1;
	(function (exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports["default"] = valuesOfValidator;

		var _isPrimitive = _interopRequireDefault(requireIsPrimitive$2());

		var _wrapValidator = _interopRequireDefault(requireWrapValidator());

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

		// code adapted from https://github.com/facebook/react/blob/14156e56b9cf18ac86963185c5af4abddf3ff811/src/isomorphic/classic/types/ReactPropTypes.js#L307-L340
		function valuesOfValidator(propType) {
		  if (typeof propType !== 'function') {
		    throw new TypeError('objectOf: propType must be a function');
		  }

		  var validator = function valuesOf(props, propName, componentName, location, propFullName) {
		    for (var _len = arguments.length, rest = new Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
		      rest[_key - 5] = arguments[_key];
		    }

		    var propValue = props[propName];

		    if (propValue == null || (0, _isPrimitive["default"])(propValue)) {
		      return null;
		    }

		    var firstError;
		    Object.keys(propValue).some(function (key) {
		      firstError = propType.apply(void 0, [propValue, key, componentName, location, "".concat(propFullName, ".").concat(key)].concat(rest));
		      return firstError;
		    });
		    return firstError || null;
		  };

		  validator.isRequired = function valuesOfRequired(props, propName, componentName) {
		    var propValue = props[propName];

		    if (propValue == null) {
		      return new TypeError("".concat(componentName, ": ").concat(propName, " is required."));
		    }

		    for (var _len2 = arguments.length, rest = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
		      rest[_key2 - 3] = arguments[_key2];
		    }

		    return validator.apply(void 0, [props, propName, componentName].concat(rest));
		  };

		  return (0, _wrapValidator["default"])(validator, 'valuesOf', propType);
		}
		
	} (valuesOf));
	return valuesOf;
}

var hasRequiredBetween;

function requireBetween () {
	if (hasRequiredBetween) return between;
	hasRequiredBetween = 1;
	(function (exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports["default"] = betweenValidator;

		var _object = _interopRequireDefault(requireObject_entries());

		var _shape = _interopRequireDefault(requireShape());

		var _valuesOf = _interopRequireDefault(requireValuesOf());

		var _wrapValidator = _interopRequireDefault(requireWrapValidator());

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

		function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

		function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

		function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

		function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

		function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

		function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

		function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

		function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

		function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

		function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

		function number(props, propName, componentName) {
		  var value = props[propName];

		  if (typeof value === 'number' && !isNaN(value)) {
		    return null;
		  }

		  return new TypeError("".concat(componentName, ": ").concat(propName, " must be a non-NaN number."));
		}

		function numberOrPropsFunc(props, propName) {
		  var value = props[propName];

		  if (typeof value === 'function') {
		    return null;
		  }

		  if (typeof value === 'number' && !isNaN(value)) {
		    return null;
		  }

		  return new TypeError("".concat(propName, ": a function, or a non-NaN number is required"));
		}

		function lowerCompare(value, _ref) {
		  var gt = _ref.gt,
		      gte = _ref.gte;

		  if (typeof gt === 'number') {
		    return value > gt;
		  }

		  if (typeof gte === 'number') {
		    return value >= gte;
		  }

		  return true;
		}

		function upperCompare(value, _ref2) {
		  var lt = _ref2.lt,
		      lte = _ref2.lte;

		  if (typeof lt === 'number') {
		    return value < lt;
		  }

		  if (typeof lte === 'number') {
		    return value <= lte;
		  }

		  return true;
		}

		function greaterThanError(_ref3) {
		  var gt = _ref3.gt,
		      gte = _ref3.gte;

		  if (typeof gt === 'number') {
		    return "greater than ".concat(gt);
		  }

		  if (typeof gte === 'number') {
		    return "greater than or equal to ".concat(gte);
		  }

		  return '';
		}

		function lessThanError(_ref4) {
		  var lt = _ref4.lt,
		      lte = _ref4.lte;

		  if (typeof lt === 'number') {
		    return "less than ".concat(lt);
		  }

		  if (typeof lte === 'number') {
		    return "less than or equal to ".concat(lte);
		  }

		  return '';
		}

		function errorMessage(componentName, propName, opts) {
		  var errors = [greaterThanError(opts), lessThanError(opts)].filter(Boolean).join(' and ');
		  return "".concat(componentName, ": ").concat(propName, " must be ").concat(errors);
		}

		function propsThunkify(opts) {
		  return (0, _object["default"])(opts).reduce(function (acc, _ref5) {
		    var _ref6 = _slicedToArray(_ref5, 2),
		        key = _ref6[0],
		        value = _ref6[1];

		    var numberThunk = typeof value === 'number' ? function () {
		      return value;
		    } : value;
		    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, key, numberThunk));
		  }, {});
		}

		function invokeWithProps(optsThunks, props) {
		  return (0, _object["default"])(optsThunks).reduce(function (acc, _ref7) {
		    var _ref8 = _slicedToArray(_ref7, 2),
		        key = _ref8[0],
		        thunk = _ref8[1];

		    var value = thunk(props);
		    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, key, value));
		  }, {});
		}

		var argValidators = [(0, _shape["default"])({
		  lt: numberOrPropsFunc,
		  gt: numberOrPropsFunc
		}).isRequired, (0, _shape["default"])({
		  lte: numberOrPropsFunc,
		  gt: numberOrPropsFunc
		}).isRequired, (0, _shape["default"])({
		  lt: numberOrPropsFunc,
		  gte: numberOrPropsFunc
		}).isRequired, (0, _shape["default"])({
		  lte: numberOrPropsFunc,
		  gte: numberOrPropsFunc
		}).isRequired, (0, _shape["default"])({
		  lt: numberOrPropsFunc
		}).isRequired, (0, _shape["default"])({
		  lte: numberOrPropsFunc
		}).isRequired, (0, _shape["default"])({
		  gt: numberOrPropsFunc
		}).isRequired, (0, _shape["default"])({
		  gte: numberOrPropsFunc
		}).isRequired];

		function argValidator(props, propName) {
		  return argValidators.every(function (validator) {
		    return !!validator(props, propName);
		  });
		}

		var thunkValueValidator = (0, _valuesOf["default"])(number).isRequired;

		function betweenValidator(options) {
		  var argError = argValidator({
		    options: options
		  }, 'options');

		  if (argError) {
		    throw new TypeError('between: only one of the pairs of `lt`/`lte`, and `gt`/`gte`, may be supplied, and at least one pair must be provided.');
		  }

		  var optsThunks = propsThunkify(options);

		  var validator = function between(props, propName, componentName) {
		    var propValue = props[propName];

		    if (propValue == null) {
		      return null;
		    }

		    if (typeof propValue !== 'number') {
		      return new RangeError("".concat(componentName, ": ").concat(propName, " must be a number, got \"").concat(_typeof(propValue), "\""));
		    }

		    var opts = invokeWithProps(optsThunks, props);

		    for (var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
		      rest[_key - 3] = arguments[_key];
		    }

		    var thunkValuesError = thunkValueValidator.apply(void 0, [_defineProperty({}, propName, opts), propName, componentName].concat(rest));

		    if (thunkValuesError) {
		      return thunkValuesError;
		    }

		    if (!lowerCompare(propValue, opts) || !upperCompare(propValue, opts)) {
		      return new RangeError(errorMessage(componentName, propName, opts));
		    }

		    return null;
		  };

		  validator.isRequired = function betweenRequired(props, propName, componentName) {
		    var propValue = props[propName];

		    if (typeof propValue !== 'number') {
		      return new RangeError("".concat(componentName, ": ").concat(propName, " must be a number, got \"").concat(_typeof(propValue), "\""));
		    }

		    var opts = invokeWithProps(optsThunks, props);

		    for (var _len2 = arguments.length, rest = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
		      rest[_key2 - 3] = arguments[_key2];
		    }

		    var thunkValuesError = thunkValueValidator.apply(void 0, [_defineProperty({}, propName, opts), propName, componentName].concat(rest));

		    if (thunkValuesError) {
		      return thunkValuesError;
		    }

		    if (!lowerCompare(propValue, opts) || !upperCompare(propValue, opts)) {
		      return new RangeError(errorMessage(componentName, propName, opts));
		    }

		    return null;
		  };

		  return (0, _wrapValidator["default"])(validator, 'between', options);
		}
		
	} (between));
	return between;
}

var booleanSome = {};

var hasRequiredBooleanSome;

function requireBooleanSome () {
	if (hasRequiredBooleanSome) return booleanSome;
	hasRequiredBooleanSome = 1;
	(function (exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports["default"] = booleanSomeValidator;

		var _propTypes = PropTypes;

		var _wrapValidator = _interopRequireDefault(requireWrapValidator());

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

		function booleanSomeValidator() {
		  for (var _len = arguments.length, notAllPropsFalse = new Array(_len), _key = 0; _key < _len; _key++) {
		    notAllPropsFalse[_key] = arguments[_key];
		  }

		  if (notAllPropsFalse.length < 1) {
		    throw new TypeError('at least one prop (one of which must be `true`) is required');
		  }

		  if (!notAllPropsFalse.every(function (x) {
		    return typeof x === 'string';
		  })) {
		    throw new TypeError('all booleanSome props must be strings');
		  }

		  var propsList = notAllPropsFalse.join(', or ');

		  var validator = function booleanSome(props, propName, componentName) {
		    var countFalse = function countFalse(count, prop) {
		      return count + (props[prop] === false ? 1 : 0);
		    };

		    var falsePropCount = notAllPropsFalse.reduce(countFalse, 0);

		    if (falsePropCount === notAllPropsFalse.length) {
		      return new Error("A ".concat(componentName, " must have at least one of these boolean props be `true`: ").concat(propsList));
		    }

		    for (var _len2 = arguments.length, rest = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
		      rest[_key2 - 3] = arguments[_key2];
		    }

		    return _propTypes.bool.apply(void 0, [props, propName, componentName].concat(rest));
		  };

		  validator.isRequired = function booleanSomeRequired(props, propName, componentName) {
		    var countFalse = function countFalse(count, prop) {
		      return count + (props[prop] === false ? 1 : 0);
		    };

		    var falsePropCount = notAllPropsFalse.reduce(countFalse, 0);

		    if (falsePropCount === notAllPropsFalse.length) {
		      return new Error("A ".concat(componentName, " must have at least one of these boolean props be `true`: ").concat(propsList));
		    }

		    for (var _len3 = arguments.length, rest = new Array(_len3 > 3 ? _len3 - 3 : 0), _key3 = 3; _key3 < _len3; _key3++) {
		      rest[_key3 - 3] = arguments[_key3];
		    }

		    return _propTypes.bool.isRequired.apply(_propTypes.bool, [props, propName, componentName].concat(rest));
		  };

		  return (0, _wrapValidator["default"])(validator, "booleanSome: ".concat(propsList), notAllPropsFalse);
		}
		
	} (booleanSome));
	return booleanSome;
}

var childrenHavePropXorChildren = {};

var hasRequiredChildrenHavePropXorChildren;

function requireChildrenHavePropXorChildren () {
	if (hasRequiredChildrenHavePropXorChildren) return childrenHavePropXorChildren;
	hasRequiredChildrenHavePropXorChildren = 1;
	(function (exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports["default"] = childrenHavePropXorChildren;

		var _react = _interopRequireDefault(React);

		var _wrapValidator = _interopRequireDefault(requireWrapValidator());

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

		function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

		function childrenHavePropXorChildren(prop) {
		  if (typeof prop !== 'string' && _typeof(prop) !== 'symbol') {
		    throw new TypeError('invalid prop: must be string or symbol');
		  }

		  var validator = function childrenHavePropXorChildrenWithProp(_ref, _, componentName) {
		    var children = _ref.children;
		    var truthyChildrenCount = 0;
		    var propCount = 0;
		    var grandchildrenCount = 0;

		    _react["default"].Children.forEach(children, function (child) {
		      if (!child) {
		        return;
		      }

		      truthyChildrenCount += 1;

		      if (child.props[prop]) {
		        propCount += 1;
		      }

		      if (_react["default"].Children.count(child.props.children)) {
		        grandchildrenCount += 1;
		      }
		    });

		    if (propCount === truthyChildrenCount && grandchildrenCount === 0 || propCount === 0 && grandchildrenCount === truthyChildrenCount || propCount === 0 && grandchildrenCount === 0) {
		      return null;
		    }

		    return new TypeError("`".concat(componentName, "` requires children to all have prop \u201C").concat(prop, "\u201D, all have children, or all have neither."));
		  };

		  validator.isRequired = validator;
		  return (0, _wrapValidator["default"])(validator, "childrenHavePropXorChildrenWithProp:".concat(prop), prop);
		}
		
	} (childrenHavePropXorChildren));
	return childrenHavePropXorChildren;
}

var childrenOf = {};

var renderableChildren = {};

var hasRequiredRenderableChildren;

function requireRenderableChildren () {
	if (hasRequiredRenderableChildren) return renderableChildren;
	hasRequiredRenderableChildren = 1;
	(function (exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports["default"] = renderableChildren;

		var _react = _interopRequireDefault(React);

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

		function renderableChildren(childrenProp) {
		  return _react["default"].Children.toArray(childrenProp).filter(function (child) {
		    return child === 0 || child;
		  });
		}
		
	} (renderableChildren));
	return renderableChildren;
}

var hasRequiredChildrenOf;

function requireChildrenOf () {
	if (hasRequiredChildrenOf) return childrenOf;
	hasRequiredChildrenOf = 1;
	(function (exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports["default"] = childrenOf;

		var _renderableChildren = _interopRequireDefault(requireRenderableChildren());

		var _wrapValidator = _interopRequireDefault(requireWrapValidator());

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

		function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

		function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

		function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

		function validateChildren(propType, children, props) {
		  for (var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
		    rest[_key - 3] = arguments[_key];
		  }

		  var error;
		  children.some(function (child) {
		    error = propType.apply(void 0, [_objectSpread(_objectSpread({}, props), {}, {
		      children: child
		    }), 'children'].concat(rest));
		    return error;
		  });
		  return error || null;
		}

		function childrenOf(propType) {
		  function childrenOfPropType(props, propName, componentName) {
		    if (propName !== 'children') {
		      return new TypeError("".concat(componentName, " is using the childrenOf validator on non-children prop \"").concat(propName, "\""));
		    }

		    var propValue = props[propName];

		    if (propValue == null) {
		      return null;
		    }

		    var children = (0, _renderableChildren["default"])(propValue);

		    if (children.length === 0) {
		      return null;
		    }

		    for (var _len2 = arguments.length, rest = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
		      rest[_key2 - 3] = arguments[_key2];
		    }

		    return validateChildren.apply(void 0, [propType, children, props, componentName].concat(rest));
		  }

		  childrenOfPropType.isRequired = function (props, propName, componentName) {
		    if (propName !== 'children') {
		      return new TypeError("".concat(componentName, " is using the childrenOf validator on non-children prop \"").concat(propName, "\""));
		    }

		    var children = (0, _renderableChildren["default"])(props[propName]);

		    if (children.length === 0) {
		      return new TypeError("`".concat(componentName, "` requires at least one node of type ").concat(propType.typeName || propType.name));
		    }

		    for (var _len3 = arguments.length, rest = new Array(_len3 > 3 ? _len3 - 3 : 0), _key3 = 3; _key3 < _len3; _key3++) {
		      rest[_key3 - 3] = arguments[_key3];
		    }

		    return validateChildren.apply(void 0, [propType, children, props, componentName].concat(rest));
		  };

		  return (0, _wrapValidator["default"])(childrenOfPropType, 'childrenOf', propType);
		}
		
	} (childrenOf));
	return childrenOf;
}

var childrenOfType = {};

var esObjectAtoms;
var hasRequiredEsObjectAtoms;

function requireEsObjectAtoms () {
	if (hasRequiredEsObjectAtoms) return esObjectAtoms;
	hasRequiredEsObjectAtoms = 1;

	/** @type {import('.')} */
	esObjectAtoms = Object;
	return esObjectAtoms;
}

var ToObject;
var hasRequiredToObject;

function requireToObject () {
	if (hasRequiredToObject) return ToObject;
	hasRequiredToObject = 1;

	var $Object = requireEsObjectAtoms();
	var RequireObjectCoercible = requireRequireObjectCoercible();

	/** @type {import('./ToObject')} */
	ToObject = function ToObject(value) {
		RequireObjectCoercible(value);
		return $Object(value);
	};
	return ToObject;
}

var maxSafeInteger;
var hasRequiredMaxSafeInteger;

function requireMaxSafeInteger () {
	if (hasRequiredMaxSafeInteger) return maxSafeInteger;
	hasRequiredMaxSafeInteger = 1;

	maxSafeInteger = Number.MAX_SAFE_INTEGER || 9007199254740991; // Math.pow(2, 53) - 1;
	return maxSafeInteger;
}

var isPrimitive$1;
var hasRequiredIsPrimitive$1;

function requireIsPrimitive$1 () {
	if (hasRequiredIsPrimitive$1) return isPrimitive$1;
	hasRequiredIsPrimitive$1 = 1;

	isPrimitive$1 = function isPrimitive(value) {
		return value === null || (typeof value !== 'function' && typeof value !== 'object');
	};
	return isPrimitive$1;
}

var isPrimitive;
var hasRequiredIsPrimitive;

function requireIsPrimitive () {
	if (hasRequiredIsPrimitive) return isPrimitive;
	hasRequiredIsPrimitive = 1;

	isPrimitive = function isPrimitive(value) {
		return value === null || (typeof value !== 'function' && typeof value !== 'object');
	};
	return isPrimitive;
}

var isCallable;
var hasRequiredIsCallable$2;

function requireIsCallable$2 () {
	if (hasRequiredIsCallable$2) return isCallable;
	hasRequiredIsCallable$2 = 1;

	var fnToStr = Function.prototype.toString;
	var reflectApply = typeof Reflect === 'object' && Reflect !== null && Reflect.apply;
	var badArrayLike;
	var isCallableMarker;
	if (typeof reflectApply === 'function' && typeof Object.defineProperty === 'function') {
		try {
			badArrayLike = Object.defineProperty({}, 'length', {
				get: function () {
					throw isCallableMarker;
				}
			});
			isCallableMarker = {};
			// eslint-disable-next-line no-throw-literal
			reflectApply(function () { throw 42; }, null, badArrayLike);
		} catch (_) {
			if (_ !== isCallableMarker) {
				reflectApply = null;
			}
		}
	} else {
		reflectApply = null;
	}

	var constructorRegex = /^\s*class\b/;
	var isES6ClassFn = function isES6ClassFunction(value) {
		try {
			var fnStr = fnToStr.call(value);
			return constructorRegex.test(fnStr);
		} catch (e) {
			return false; // not a function
		}
	};

	var tryFunctionObject = function tryFunctionToStr(value) {
		try {
			if (isES6ClassFn(value)) { return false; }
			fnToStr.call(value);
			return true;
		} catch (e) {
			return false;
		}
	};
	var toStr = Object.prototype.toString;
	var objectClass = '[object Object]';
	var fnClass = '[object Function]';
	var genClass = '[object GeneratorFunction]';
	var ddaClass = '[object HTMLAllCollection]'; // IE 11
	var ddaClass2 = '[object HTML document.all class]';
	var ddaClass3 = '[object HTMLCollection]'; // IE 9-10
	var hasToStringTag = typeof Symbol === 'function' && !!Symbol.toStringTag; // better: use `has-tostringtag`

	var isIE68 = !(0 in [,]); // eslint-disable-line no-sparse-arrays, comma-spacing

	var isDDA = function isDocumentDotAll() { return false; };
	if (typeof document === 'object') {
		// Firefox 3 canonicalizes DDA to undefined when it's not accessed directly
		var all = document.all;
		if (toStr.call(all) === toStr.call(document.all)) {
			isDDA = function isDocumentDotAll(value) {
				/* globals document: false */
				// in IE 6-8, typeof document.all is "object" and it's truthy
				if ((isIE68 || !value) && (typeof value === 'undefined' || typeof value === 'object')) {
					try {
						var str = toStr.call(value);
						return (
							str === ddaClass
							|| str === ddaClass2
							|| str === ddaClass3 // opera 12.16
							|| str === objectClass // IE 6-8
						) && value('') == null; // eslint-disable-line eqeqeq
					} catch (e) { /**/ }
				}
				return false;
			};
		}
	}

	isCallable = reflectApply
		? function isCallable(value) {
			if (isDDA(value)) { return true; }
			if (!value) { return false; }
			if (typeof value !== 'function' && typeof value !== 'object') { return false; }
			try {
				reflectApply(value, null, badArrayLike);
			} catch (e) {
				if (e !== isCallableMarker) { return false; }
			}
			return !isES6ClassFn(value) && tryFunctionObject(value);
		}
		: function isCallable(value) {
			if (isDDA(value)) { return true; }
			if (!value) { return false; }
			if (typeof value !== 'function' && typeof value !== 'object') { return false; }
			if (hasToStringTag) { return tryFunctionObject(value); }
			if (isES6ClassFn(value)) { return false; }
			var strClass = toStr.call(value);
			if (strClass !== fnClass && strClass !== genClass && !(/^\[object HTML/).test(strClass)) { return false; }
			return tryFunctionObject(value);
		};
	return isCallable;
}

var shams;
var hasRequiredShams;

function requireShams () {
	if (hasRequiredShams) return shams;
	hasRequiredShams = 1;

	var hasSymbols = requireShams$1();

	/** @type {import('.')} */
	shams = function hasToStringTagShams() {
		return hasSymbols() && !!Symbol.toStringTag;
	};
	return shams;
}

var isDateObject;
var hasRequiredIsDateObject;

function requireIsDateObject () {
	if (hasRequiredIsDateObject) return isDateObject;
	hasRequiredIsDateObject = 1;

	var getDay = Date.prototype.getDay;
	var tryDateObject = function tryDateGetDayCall(value) {
		try {
			getDay.call(value);
			return true;
		} catch (e) {
			return false;
		}
	};

	var toStr = Object.prototype.toString;
	var dateClass = '[object Date]';
	var hasToStringTag = requireShams()();

	isDateObject = function isDateObject(value) {
		if (typeof value !== 'object' || value === null) {
			return false;
		}
		return hasToStringTag ? tryDateObject(value) : toStr.call(value) === dateClass;
	};
	return isDateObject;
}

var isSymbol$2 = {exports: {}};

var hasRequiredIsSymbol;

function requireIsSymbol () {
	if (hasRequiredIsSymbol) return isSymbol$2.exports;
	hasRequiredIsSymbol = 1;

	var toStr = Object.prototype.toString;
	var hasSymbols = requireHasSymbols()();

	if (hasSymbols) {
		var symToStr = Symbol.prototype.toString;
		var symStringRegex = /^Symbol\(.*\)$/;
		var isSymbolObject = function isRealSymbolObject(value) {
			if (typeof value.valueOf() !== 'symbol') {
				return false;
			}
			return symStringRegex.test(symToStr.call(value));
		};

		isSymbol$2.exports = function isSymbol(value) {
			if (typeof value === 'symbol') {
				return true;
			}
			if (toStr.call(value) !== '[object Symbol]') {
				return false;
			}
			try {
				return isSymbolObject(value);
			} catch (e) {
				return false;
			}
		};
	} else {

		isSymbol$2.exports = function isSymbol(value) {
			// this environment does not support Symbols.
			return false ;
		};
	}
	return isSymbol$2.exports;
}

var es2015;
var hasRequiredEs2015;

function requireEs2015 () {
	if (hasRequiredEs2015) return es2015;
	hasRequiredEs2015 = 1;

	var hasSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol';

	var isPrimitive = requireIsPrimitive();
	var isCallable = requireIsCallable$2();
	var isDate = requireIsDateObject();
	var isSymbol = requireIsSymbol();

	var ordinaryToPrimitive = function OrdinaryToPrimitive(O, hint) {
		if (typeof O === 'undefined' || O === null) {
			throw new TypeError('Cannot call method on ' + O);
		}
		if (typeof hint !== 'string' || (hint !== 'number' && hint !== 'string')) {
			throw new TypeError('hint must be "string" or "number"');
		}
		var methodNames = hint === 'string' ? ['toString', 'valueOf'] : ['valueOf', 'toString'];
		var method, result, i;
		for (i = 0; i < methodNames.length; ++i) {
			method = O[methodNames[i]];
			if (isCallable(method)) {
				result = method.call(O);
				if (isPrimitive(result)) {
					return result;
				}
			}
		}
		throw new TypeError('No default value');
	};

	var GetMethod = function GetMethod(O, P) {
		var func = O[P];
		if (func !== null && typeof func !== 'undefined') {
			if (!isCallable(func)) {
				throw new TypeError(func + ' returned for property ' + P + ' of object ' + O + ' is not a function');
			}
			return func;
		}
		return void 0;
	};

	// http://www.ecma-international.org/ecma-262/6.0/#sec-toprimitive
	es2015 = function ToPrimitive(input) {
		if (isPrimitive(input)) {
			return input;
		}
		var hint = 'default';
		if (arguments.length > 1) {
			if (arguments[1] === String) {
				hint = 'string';
			} else if (arguments[1] === Number) {
				hint = 'number';
			}
		}

		var exoticToPrim;
		if (hasSymbols) {
			if (Symbol.toPrimitive) {
				exoticToPrim = GetMethod(input, Symbol.toPrimitive);
			} else if (isSymbol(input)) {
				exoticToPrim = Symbol.prototype.valueOf;
			}
		}
		if (typeof exoticToPrim !== 'undefined') {
			var result = exoticToPrim.call(input, hint);
			if (isPrimitive(result)) {
				return result;
			}
			throw new TypeError('unable to convert exotic object to primitive');
		}
		if (hint === 'default' && (isDate(input) || isSymbol(input))) {
			hint = 'string';
		}
		return ordinaryToPrimitive(input, hint === 'default' ? 'number' : hint);
	};
	return es2015;
}

var ToPrimitive;
var hasRequiredToPrimitive;

function requireToPrimitive () {
	if (hasRequiredToPrimitive) return ToPrimitive;
	hasRequiredToPrimitive = 1;

	var toPrimitive = requireEs2015();

	// https://262.ecma-international.org/6.0/#sec-toprimitive

	ToPrimitive = function ToPrimitive(input) {
		if (arguments.length > 1) {
			return toPrimitive(input, arguments[1]);
		}
		return toPrimitive(input);
	};
	return ToPrimitive;
}

var isRegex;
var hasRequiredIsRegex;

function requireIsRegex () {
	if (hasRequiredIsRegex) return isRegex;
	hasRequiredIsRegex = 1;

	var callBound = requireCallBound();
	var hasToStringTag = requireShams()();
	var has;
	var $exec;
	var isRegexMarker;
	var badStringifier;

	if (hasToStringTag) {
		has = callBound('Object.prototype.hasOwnProperty');
		$exec = callBound('RegExp.prototype.exec');
		isRegexMarker = {};

		var throwRegexMarker = function () {
			throw isRegexMarker;
		};
		badStringifier = {
			toString: throwRegexMarker,
			valueOf: throwRegexMarker
		};

		if (typeof Symbol.toPrimitive === 'symbol') {
			badStringifier[Symbol.toPrimitive] = throwRegexMarker;
		}
	}

	var $toString = callBound('Object.prototype.toString');
	var gOPD = Object.getOwnPropertyDescriptor;
	var regexClass = '[object RegExp]';

	isRegex = hasToStringTag
		// eslint-disable-next-line consistent-return
		? function isRegex(value) {
			if (!value || typeof value !== 'object') {
				return false;
			}

			var descriptor = gOPD(value, 'lastIndex');
			var hasLastIndexDataProperty = descriptor && has(descriptor, 'value');
			if (!hasLastIndexDataProperty) {
				return false;
			}

			try {
				$exec(value, badStringifier);
			} catch (e) {
				return e === isRegexMarker;
			}
		}
		: function isRegex(value) {
			// In older browsers, typeof regex incorrectly returns 'function'
			if (!value || (typeof value !== 'object' && typeof value !== 'function')) {
				return false;
			}

			return $toString(value) === regexClass;
		};
	return isRegex;
}

var safeRegexTest;
var hasRequiredSafeRegexTest;

function requireSafeRegexTest () {
	if (hasRequiredSafeRegexTest) return safeRegexTest;
	hasRequiredSafeRegexTest = 1;

	var callBound = requireCallBound();
	var isRegex = requireIsRegex();

	var $exec = callBound('RegExp.prototype.exec');
	var $TypeError = requireType$2();

	safeRegexTest = function regexTester(regex) {
		if (!isRegex(regex)) {
			throw new $TypeError('`regex` must be a RegExp');
		}
		return function test(s) {
			return $exec(regex, s) !== null;
		};
	};
	return safeRegexTest;
}

var ToString;
var hasRequiredToString;

function requireToString () {
	if (hasRequiredToString) return ToString;
	hasRequiredToString = 1;

	var GetIntrinsic = requireGetIntrinsic();

	var $String = GetIntrinsic('%String%');
	var $TypeError = requireType$2();

	// https://262.ecma-international.org/6.0/#sec-tostring

	ToString = function ToString(argument) {
		if (typeof argument === 'symbol') {
			throw new $TypeError('Cannot convert a Symbol value to a string');
		}
		return $String(argument);
	};
	return ToString;
}

var implementation$3;
var hasRequiredImplementation$3;

function requireImplementation$3 () {
	if (hasRequiredImplementation$3) return implementation$3;
	hasRequiredImplementation$3 = 1;

	var RequireObjectCoercible = requireRequireObjectCoercible();
	var ToString = requireToString();
	var callBound = requireCallBound();
	var $replace = callBound('String.prototype.replace');

	var mvsIsWS = (/^\s$/).test('\u180E');
	/* eslint-disable no-control-regex */
	var leftWhitespace = mvsIsWS
		? /^[\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF]+/
		: /^[\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF]+/;
	var rightWhitespace = mvsIsWS
		? /[\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF]+$/
		: /[\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF]+$/;
	/* eslint-enable no-control-regex */

	implementation$3 = function trim() {
		var S = ToString(RequireObjectCoercible(this));
		return $replace($replace(S, leftWhitespace, ''), rightWhitespace, '');
	};
	return implementation$3;
}

var polyfill$3;
var hasRequiredPolyfill$3;

function requirePolyfill$3 () {
	if (hasRequiredPolyfill$3) return polyfill$3;
	hasRequiredPolyfill$3 = 1;

	var implementation = requireImplementation$3();

	var zeroWidthSpace = '\u200b';
	var mongolianVowelSeparator = '\u180E';

	polyfill$3 = function getPolyfill() {
		if (
			String.prototype.trim
			&& zeroWidthSpace.trim() === zeroWidthSpace
			&& mongolianVowelSeparator.trim() === mongolianVowelSeparator
			&& ('_' + mongolianVowelSeparator).trim() === ('_' + mongolianVowelSeparator)
			&& (mongolianVowelSeparator + '_').trim() === (mongolianVowelSeparator + '_')
		) {
			return String.prototype.trim;
		}
		return implementation;
	};
	return polyfill$3;
}

var shim$3;
var hasRequiredShim$3;

function requireShim$3 () {
	if (hasRequiredShim$3) return shim$3;
	hasRequiredShim$3 = 1;

	var define = requireDefineProperties();
	var getPolyfill = requirePolyfill$3();

	shim$3 = function shimStringTrim() {
		var polyfill = getPolyfill();
		define(String.prototype, { trim: polyfill }, {
			trim: function testTrim() {
				return String.prototype.trim !== polyfill;
			}
		});
		return polyfill;
	};
	return shim$3;
}

var string_prototype_trim;
var hasRequiredString_prototype_trim;

function requireString_prototype_trim () {
	if (hasRequiredString_prototype_trim) return string_prototype_trim;
	hasRequiredString_prototype_trim = 1;

	var callBind = requireCallBind();
	var define = requireDefineProperties();
	var RequireObjectCoercible = requireRequireObjectCoercible();

	var implementation = requireImplementation$3();
	var getPolyfill = requirePolyfill$3();
	var shim = requireShim$3();

	var bound = callBind(getPolyfill());
	var boundMethod = function trim(receiver) {
		RequireObjectCoercible(receiver);
		return bound(receiver);
	};

	define(boundMethod, {
		getPolyfill: getPolyfill,
		implementation: implementation,
		shim: shim
	});

	string_prototype_trim = boundMethod;
	return string_prototype_trim;
}

var StringToNumber;
var hasRequiredStringToNumber;

function requireStringToNumber () {
	if (hasRequiredStringToNumber) return StringToNumber;
	hasRequiredStringToNumber = 1;

	var GetIntrinsic = requireGetIntrinsic();

	var $Number = GetIntrinsic('%Number%');
	var $RegExp = GetIntrinsic('%RegExp%');
	var $TypeError = requireType$2();
	var $parseInteger = GetIntrinsic('%parseInt%');

	var callBound = requireCallBound();
	var regexTester = requireSafeRegexTest();

	var $strSlice = callBound('String.prototype.slice');
	var isBinary = regexTester(/^0b[01]+$/i);
	var isOctal = regexTester(/^0o[0-7]+$/i);
	var isInvalidHexLiteral = regexTester(/^[-+]0x[0-9a-f]+$/i);
	var nonWS = ['\u0085', '\u200b', '\ufffe'].join('');
	var nonWSregex = new $RegExp('[' + nonWS + ']', 'g');
	var hasNonWS = regexTester(nonWSregex);

	var $trim = requireString_prototype_trim();

	// https://262.ecma-international.org/13.0/#sec-stringtonumber

	StringToNumber = function StringToNumber(argument) {
		if (typeof argument !== 'string') {
			throw new $TypeError('Assertion failed: `argument` is not a String');
		}
		if (isBinary(argument)) {
			return $Number($parseInteger($strSlice(argument, 2), 2));
		}
		if (isOctal(argument)) {
			return $Number($parseInteger($strSlice(argument, 2), 8));
		}
		if (hasNonWS(argument) || isInvalidHexLiteral(argument)) {
			return NaN;
		}
		var trimmed = $trim(argument);
		if (trimmed !== argument) {
			return StringToNumber(trimmed);
		}
		return $Number(argument);
	};
	return StringToNumber;
}

var ToNumber;
var hasRequiredToNumber;

function requireToNumber () {
	if (hasRequiredToNumber) return ToNumber;
	hasRequiredToNumber = 1;

	var GetIntrinsic = requireGetIntrinsic();

	var $TypeError = requireType$2();
	var $Number = GetIntrinsic('%Number%');
	var isPrimitive = requireIsPrimitive$1();

	var ToPrimitive = requireToPrimitive();
	var StringToNumber = requireStringToNumber();

	// https://262.ecma-international.org/13.0/#sec-tonumber

	ToNumber = function ToNumber(argument) {
		var value = isPrimitive(argument) ? argument : ToPrimitive(argument, $Number);
		if (typeof value === 'symbol') {
			throw new $TypeError('Cannot convert a Symbol value to a number');
		}
		if (typeof value === 'bigint') {
			throw new $TypeError('Conversion from \'BigInt\' to \'number\' is not allowed.');
		}
		if (typeof value === 'string') {
			return StringToNumber(value);
		}
		return $Number(value);
	};
	return ToNumber;
}

var floor;
var hasRequiredFloor;

function requireFloor () {
	if (hasRequiredFloor) return floor;
	hasRequiredFloor = 1;

	// var modulo = require('./modulo');
	var $floor = Math.floor;

	// http://262.ecma-international.org/11.0/#eqn-floor

	floor = function floor(x) {
		// return x - modulo(x, 1);
		if (typeof x === 'bigint') {
			return x;
		}
		return $floor(x);
	};
	return floor;
}

var truncate;
var hasRequiredTruncate;

function requireTruncate () {
	if (hasRequiredTruncate) return truncate;
	hasRequiredTruncate = 1;

	var floor = requireFloor();

	var $TypeError = requireType$2();

	// https://262.ecma-international.org/14.0/#eqn-truncate

	truncate = function truncate(x) {
		if (typeof x !== 'number' && typeof x !== 'bigint') {
			throw new $TypeError('argument must be a Number or a BigInt');
		}
		var result = x < 0 ? -floor(-x) : floor(x);
		return result === 0 ? 0 : result; // in the spec, these are math values, so we filter out -0 here
	};
	return truncate;
}

var _isNaN;
var hasRequired_isNaN;

function require_isNaN () {
	if (hasRequired_isNaN) return _isNaN;
	hasRequired_isNaN = 1;

	_isNaN = Number.isNaN || function isNaN(a) {
		return a !== a;
	};
	return _isNaN;
}

var _isFinite;
var hasRequired_isFinite;

function require_isFinite () {
	if (hasRequired_isFinite) return _isFinite;
	hasRequired_isFinite = 1;

	var $isNaN = require_isNaN();

	_isFinite = function (x) { return (typeof x === 'number' || typeof x === 'bigint') && !$isNaN(x) && x !== Infinity && x !== -Infinity; };
	return _isFinite;
}

var ToIntegerOrInfinity;
var hasRequiredToIntegerOrInfinity;

function requireToIntegerOrInfinity () {
	if (hasRequiredToIntegerOrInfinity) return ToIntegerOrInfinity;
	hasRequiredToIntegerOrInfinity = 1;

	var ToNumber = requireToNumber();
	var truncate = requireTruncate();

	var $isNaN = require_isNaN();
	var $isFinite = require_isFinite();

	// https://262.ecma-international.org/14.0/#sec-tointegerorinfinity

	ToIntegerOrInfinity = function ToIntegerOrInfinity(value) {
		var number = ToNumber(value);
		if ($isNaN(number) || number === 0) { return 0; }
		if (!$isFinite(number)) { return number; }
		return truncate(number);
	};
	return ToIntegerOrInfinity;
}

var ToLength;
var hasRequiredToLength;

function requireToLength () {
	if (hasRequiredToLength) return ToLength;
	hasRequiredToLength = 1;

	var MAX_SAFE_INTEGER = requireMaxSafeInteger();

	var ToIntegerOrInfinity = requireToIntegerOrInfinity();

	ToLength = function ToLength(argument) {
		var len = ToIntegerOrInfinity(argument);
		if (len <= 0) { return 0; } // includes converting -0 to +0
		if (len > MAX_SAFE_INTEGER) { return MAX_SAFE_INTEGER; }
		return len;
	};
	return ToLength;
}

var IsCallable$1;
var hasRequiredIsCallable$1;

function requireIsCallable$1 () {
	if (hasRequiredIsCallable$1) return IsCallable$1;
	hasRequiredIsCallable$1 = 1;

	// http://262.ecma-international.org/5.1/#sec-9.11

	IsCallable$1 = requireIsCallable$2();
	return IsCallable$1;
}

var implementation$2;
var hasRequiredImplementation$2;

function requireImplementation$2 () {
	if (hasRequiredImplementation$2) return implementation$2;
	hasRequiredImplementation$2 = 1;

	var ToObject = requireToObject();
	var ToLength = requireToLength();
	var IsCallable = requireIsCallable$1();

	implementation$2 = function find(predicate) {
		var list = ToObject(this);
		var length = ToLength(list.length);
		if (!IsCallable(predicate)) {
			throw new TypeError('Array#find: predicate must be a function');
		}
		if (length === 0) {
			return void 0;
		}
		var thisArg;
		if (arguments.length > 0) {
			thisArg = arguments[1];
		}

		for (var i = 0, value; i < length; i++) {
			value = list[i];
			// inlined for performance: if (Call(predicate, thisArg, [value, i, list])) {
			if (predicate.apply(thisArg, [value, i, list])) {
				return value;
			}
		}
		return void 0;
	};
	return implementation$2;
}

var polyfill$2;
var hasRequiredPolyfill$2;

function requirePolyfill$2 () {
	if (hasRequiredPolyfill$2) return polyfill$2;
	hasRequiredPolyfill$2 = 1;

	polyfill$2 = function getPolyfill() {
		// Detect if an implementation exists
		// Detect early implementations which skipped holes in sparse arrays
		// eslint-disable-next-line no-sparse-arrays
		var implemented = Array.prototype.find && [, 1].find(function () {
			return true;
		}) !== 1;

		// eslint-disable-next-line global-require
		return implemented ? Array.prototype.find : requireImplementation$2();
	};
	return polyfill$2;
}

var esShimUnscopables;
var hasRequiredEsShimUnscopables;

function requireEsShimUnscopables () {
	if (hasRequiredEsShimUnscopables) return esShimUnscopables;
	hasRequiredEsShimUnscopables = 1;

	var hasOwn = requireHasown();

	var hasUnscopables = typeof Symbol === 'function' && typeof Symbol.unscopables === 'symbol';

	var map = hasUnscopables && Array.prototype[Symbol.unscopables];

	var $TypeError = TypeError;

	esShimUnscopables = function shimUnscopables(method) {
		if (typeof method !== 'string' || !method) {
			throw new $TypeError('method must be a non-empty string');
		}
		if (!hasOwn(Array.prototype, method)) {
			throw new $TypeError('method must be on Array.prototype');
		}
		if (hasUnscopables) {
			map[method] = true;
		}
	};
	return esShimUnscopables;
}

var shim$2;
var hasRequiredShim$2;

function requireShim$2 () {
	if (hasRequiredShim$2) return shim$2;
	hasRequiredShim$2 = 1;

	var define = requireDefineProperties();
	var shimUnscopables = requireEsShimUnscopables();

	var getPolyfill = requirePolyfill$2();

	shim$2 = function shimArrayPrototypeFind() {
		var polyfill = getPolyfill();

		define(
			Array.prototype,
			{ find: polyfill },
			{
				find: function () { return Array.prototype.find !== polyfill; }
			}
		);

		shimUnscopables('find');

		return polyfill;
	};
	return shim$2;
}

var array_prototype_find;
var hasRequiredArray_prototype_find;

function requireArray_prototype_find () {
	if (hasRequiredArray_prototype_find) return array_prototype_find;
	hasRequiredArray_prototype_find = 1;

	var define = requireDefineProperties();
	var callBound = requireCallBound();
	var RequireObjectCoercible = requireRequireObjectCoercible();

	var implementation = requireImplementation$2();
	var getPolyfill = requirePolyfill$2();
	var shim = requireShim$2();

	var $slice = callBound('Array.prototype.slice');

	var polyfill = getPolyfill();

	var boundFindShim = function find(array, predicate) { // eslint-disable-line no-unused-vars
		RequireObjectCoercible(array);
		var args = $slice(arguments, 1);
		return polyfill.apply(array, args);
	};

	define(boundFindShim, {
		getPolyfill: getPolyfill,
		implementation: implementation,
		shim: shim
	});

	array_prototype_find = boundFindShim;
	return array_prototype_find;
}

var getComponentName = {};

var IsCallable;
var hasRequiredIsCallable;

function requireIsCallable () {
	if (hasRequiredIsCallable) return IsCallable;
	hasRequiredIsCallable = 1;

	// http://262.ecma-international.org/5.1/#sec-9.11

	IsCallable = requireIsCallable$2();
	return IsCallable;
}

var IsPropertyKey;
var hasRequiredIsPropertyKey;

function requireIsPropertyKey () {
	if (hasRequiredIsPropertyKey) return IsPropertyKey;
	hasRequiredIsPropertyKey = 1;

	// https://262.ecma-international.org/6.0/#sec-ispropertykey

	IsPropertyKey = function IsPropertyKey(argument) {
		return typeof argument === 'string' || typeof argument === 'symbol';
	};
	return IsPropertyKey;
}

var Type$1;
var hasRequiredType$1;

function requireType$1 () {
	if (hasRequiredType$1) return Type$1;
	hasRequiredType$1 = 1;

	// https://262.ecma-international.org/5.1/#sec-8

	Type$1 = function Type(x) {
		if (x === null) {
			return 'Null';
		}
		if (typeof x === 'undefined') {
			return 'Undefined';
		}
		if (typeof x === 'function' || typeof x === 'object') {
			return 'Object';
		}
		if (typeof x === 'number') {
			return 'Number';
		}
		if (typeof x === 'boolean') {
			return 'Boolean';
		}
		if (typeof x === 'string') {
			return 'String';
		}
	};
	return Type$1;
}

var Type;
var hasRequiredType;

function requireType () {
	if (hasRequiredType) return Type;
	hasRequiredType = 1;

	var ES5Type = requireType$1();

	// https://262.ecma-international.org/11.0/#sec-ecmascript-data-types-and-values

	Type = function Type(x) {
		if (typeof x === 'symbol') {
			return 'Symbol';
		}
		if (typeof x === 'bigint') {
			return 'BigInt';
		}
		return ES5Type(x);
	};
	return Type;
}

var HasOwnProperty;
var hasRequiredHasOwnProperty;

function requireHasOwnProperty () {
	if (hasRequiredHasOwnProperty) return HasOwnProperty;
	hasRequiredHasOwnProperty = 1;

	var $TypeError = requireType$2();

	var hasOwn = requireHasown();

	var IsPropertyKey = requireIsPropertyKey();
	var Type = requireType();

	// https://262.ecma-international.org/6.0/#sec-hasownproperty

	HasOwnProperty = function HasOwnProperty(O, P) {
		if (Type(O) !== 'Object') {
			throw new $TypeError('Assertion failed: `O` must be an Object');
		}
		if (!IsPropertyKey(P)) {
			throw new $TypeError('Assertion failed: `P` must be a Property Key');
		}
		return hasOwn(O, P);
	};
	return HasOwnProperty;
}

var functionsHaveNames_1;
var hasRequiredFunctionsHaveNames;

function requireFunctionsHaveNames () {
	if (hasRequiredFunctionsHaveNames) return functionsHaveNames_1;
	hasRequiredFunctionsHaveNames = 1;

	var functionsHaveNames = function functionsHaveNames() {
		return typeof function f() {}.name === 'string';
	};

	var gOPD = Object.getOwnPropertyDescriptor;
	if (gOPD) {
		try {
			gOPD([], 'length');
		} catch (e) {
			// IE 8 has a broken gOPD
			gOPD = null;
		}
	}

	functionsHaveNames.functionsHaveConfigurableNames = function functionsHaveConfigurableNames() {
		if (!functionsHaveNames() || !gOPD) {
			return false;
		}
		var desc = gOPD(function () {}, 'name');
		return !!desc && !!desc.configurable;
	};

	var $bind = Function.prototype.bind;

	functionsHaveNames.boundFunctionsHaveNames = function boundFunctionsHaveNames() {
		return functionsHaveNames() && typeof $bind === 'function' && function f() {}.bind().name !== '';
	};

	functionsHaveNames_1 = functionsHaveNames;
	return functionsHaveNames_1;
}

var implementation$1;
var hasRequiredImplementation$1;

function requireImplementation$1 () {
	if (hasRequiredImplementation$1) return implementation$1;
	hasRequiredImplementation$1 = 1;

	var IsCallable = requireIsCallable();
	var HasOwnProperty = requireHasOwnProperty();
	var functionsHaveNames = requireFunctionsHaveNames()();
	var callBound = requireCallBound();
	var $functionToString = callBound('Function.prototype.toString');
	var $stringMatch = callBound('String.prototype.match');
	var toStr = callBound('Object.prototype.toString');

	var classRegex = /^class /;

	var isClass = function isClassConstructor(fn) {
		if (IsCallable(fn)) {
			return false;
		}
		if (typeof fn !== 'function') {
			return false;
		}
		try {
			var match = $stringMatch($functionToString(fn), classRegex);
			return !!match;
		} catch (e) {}
		return false;
	};

	var regex = /\s*function\s+([^(\s]*)\s*/;

	var isIE68 = !(0 in [,]); // eslint-disable-line no-sparse-arrays, comma-spacing

	var objectClass = '[object Object]';
	var ddaClass = '[object HTMLAllCollection]';

	var functionProto = Function.prototype;

	var isDDA = function isDocumentDotAll() {
		return false;
	};
	if (typeof document === 'object') {
		// Firefox 3 canonicalizes DDA to undefined when it's not accessed directly
		var all = document.all;
		if (toStr(all) === toStr(document.all)) {
			isDDA = function isDocumentDotAll(value) {
				/* globals document: false */
				// in IE 6-8, typeof document.all is "object" and it's truthy
				if ((isIE68 || !value) && (typeof value === 'undefined' || typeof value === 'object')) {
					try {
						var str = toStr(value);
						// IE 6-8 uses `objectClass`
						return (str === ddaClass || str === objectClass) && value('') == null; // eslint-disable-line eqeqeq
					} catch (e) { /**/ }
				}
				return false;
			};
		}
	}

	implementation$1 = function getName() {
		if (isDDA(this) || (!isClass(this) && !IsCallable(this))) {
			throw new TypeError('Function.prototype.name sham getter called on non-function');
		}
		if (functionsHaveNames && HasOwnProperty(this, 'name')) {
			return this.name;
		}
		if (this === functionProto) {
			return '';
		}
		var str = $functionToString(this);
		var match = $stringMatch(str, regex);
		var name = match && match[1];
		return name;
	};
	return implementation$1;
}

var polyfill$1;
var hasRequiredPolyfill$1;

function requirePolyfill$1 () {
	if (hasRequiredPolyfill$1) return polyfill$1;
	hasRequiredPolyfill$1 = 1;

	var implementation = requireImplementation$1();

	polyfill$1 = function getPolyfill() {
		return implementation;
	};
	return polyfill$1;
}

var shim$1;
var hasRequiredShim$1;

function requireShim$1 () {
	if (hasRequiredShim$1) return shim$1;
	hasRequiredShim$1 = 1;

	var supportsDescriptors = requireDefineProperties().supportsDescriptors;
	var functionsHaveNames = requireFunctionsHaveNames()();
	var getPolyfill = requirePolyfill$1();
	var defineProperty = Object.defineProperty;
	var TypeErr = TypeError;

	shim$1 = function shimName() {
		var polyfill = getPolyfill();
		if (functionsHaveNames) {
			return polyfill;
		}
		if (!supportsDescriptors) {
			throw new TypeErr('Shimming Function.prototype.name support requires ES5 property descriptor support.');
		}
		var functionProto = Function.prototype;
		defineProperty(functionProto, 'name', {
			configurable: true,
			enumerable: false,
			get: function () {
				var name = polyfill.call(this);
				if (this !== functionProto) {
					defineProperty(this, 'name', {
						configurable: true,
						enumerable: false,
						value: name,
						writable: false
					});
				}
				return name;
			}
		});
		return polyfill;
	};
	return shim$1;
}

var function_prototype_name;
var hasRequiredFunction_prototype_name;

function requireFunction_prototype_name () {
	if (hasRequiredFunction_prototype_name) return function_prototype_name;
	hasRequiredFunction_prototype_name = 1;

	var define = requireDefineProperties();
	var callBind = requireCallBind();

	var implementation = requireImplementation$1();
	var getPolyfill = requirePolyfill$1();
	var shim = requireShim$1();

	var bound = callBind(implementation);

	define(bound, {
		getPolyfill: getPolyfill,
		implementation: implementation,
		shim: shim
	});

	function_prototype_name = bound;
	return function_prototype_name;
}

var reactIs = {exports: {}};

var reactIs_production_min = {};

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_production_min;

function requireReactIs_production_min () {
	if (hasRequiredReactIs_production_min) return reactIs_production_min;
	hasRequiredReactIs_production_min = 1;
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
	Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
	function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}reactIs_production_min.AsyncMode=l;reactIs_production_min.ConcurrentMode=m;reactIs_production_min.ContextConsumer=k;reactIs_production_min.ContextProvider=h;reactIs_production_min.Element=c;reactIs_production_min.ForwardRef=n;reactIs_production_min.Fragment=e;reactIs_production_min.Lazy=t;reactIs_production_min.Memo=r;reactIs_production_min.Portal=d;
	reactIs_production_min.Profiler=g;reactIs_production_min.StrictMode=f;reactIs_production_min.Suspense=p;reactIs_production_min.isAsyncMode=function(a){return A(a)||z(a)===l};reactIs_production_min.isConcurrentMode=A;reactIs_production_min.isContextConsumer=function(a){return z(a)===k};reactIs_production_min.isContextProvider=function(a){return z(a)===h};reactIs_production_min.isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c};reactIs_production_min.isForwardRef=function(a){return z(a)===n};reactIs_production_min.isFragment=function(a){return z(a)===e};reactIs_production_min.isLazy=function(a){return z(a)===t};
	reactIs_production_min.isMemo=function(a){return z(a)===r};reactIs_production_min.isPortal=function(a){return z(a)===d};reactIs_production_min.isProfiler=function(a){return z(a)===g};reactIs_production_min.isStrictMode=function(a){return z(a)===f};reactIs_production_min.isSuspense=function(a){return z(a)===p};
	reactIs_production_min.isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};reactIs_production_min.typeOf=z;
	return reactIs_production_min;
}

var reactIs_development = {};

/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_development;

function requireReactIs_development () {
	if (hasRequiredReactIs_development) return reactIs_development;
	hasRequiredReactIs_development = 1;



	if (process.env.NODE_ENV !== "production") {
	  (function() {

	// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	var hasSymbol = typeof Symbol === 'function' && Symbol.for;
	var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
	var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
	var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
	var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
	var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
	var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
	var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
	// (unstable) APIs that have been removed. Can we remove the symbols?

	var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
	var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
	var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
	var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
	var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
	var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
	var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
	var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
	var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
	var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
	var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

	function isValidElementType(type) {
	  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
	  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
	}

	function typeOf(object) {
	  if (typeof object === 'object' && object !== null) {
	    var $$typeof = object.$$typeof;

	    switch ($$typeof) {
	      case REACT_ELEMENT_TYPE:
	        var type = object.type;

	        switch (type) {
	          case REACT_ASYNC_MODE_TYPE:
	          case REACT_CONCURRENT_MODE_TYPE:
	          case REACT_FRAGMENT_TYPE:
	          case REACT_PROFILER_TYPE:
	          case REACT_STRICT_MODE_TYPE:
	          case REACT_SUSPENSE_TYPE:
	            return type;

	          default:
	            var $$typeofType = type && type.$$typeof;

	            switch ($$typeofType) {
	              case REACT_CONTEXT_TYPE:
	              case REACT_FORWARD_REF_TYPE:
	              case REACT_LAZY_TYPE:
	              case REACT_MEMO_TYPE:
	              case REACT_PROVIDER_TYPE:
	                return $$typeofType;

	              default:
	                return $$typeof;
	            }

	        }

	      case REACT_PORTAL_TYPE:
	        return $$typeof;
	    }
	  }

	  return undefined;
	} // AsyncMode is deprecated along with isAsyncMode

	var AsyncMode = REACT_ASYNC_MODE_TYPE;
	var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
	var ContextConsumer = REACT_CONTEXT_TYPE;
	var ContextProvider = REACT_PROVIDER_TYPE;
	var Element = REACT_ELEMENT_TYPE;
	var ForwardRef = REACT_FORWARD_REF_TYPE;
	var Fragment = REACT_FRAGMENT_TYPE;
	var Lazy = REACT_LAZY_TYPE;
	var Memo = REACT_MEMO_TYPE;
	var Portal = REACT_PORTAL_TYPE;
	var Profiler = REACT_PROFILER_TYPE;
	var StrictMode = REACT_STRICT_MODE_TYPE;
	var Suspense = REACT_SUSPENSE_TYPE;
	var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

	function isAsyncMode(object) {
	  {
	    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
	      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

	      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
	    }
	  }

	  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
	}
	function isConcurrentMode(object) {
	  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
	}
	function isContextConsumer(object) {
	  return typeOf(object) === REACT_CONTEXT_TYPE;
	}
	function isContextProvider(object) {
	  return typeOf(object) === REACT_PROVIDER_TYPE;
	}
	function isElement(object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	}
	function isForwardRef(object) {
	  return typeOf(object) === REACT_FORWARD_REF_TYPE;
	}
	function isFragment(object) {
	  return typeOf(object) === REACT_FRAGMENT_TYPE;
	}
	function isLazy(object) {
	  return typeOf(object) === REACT_LAZY_TYPE;
	}
	function isMemo(object) {
	  return typeOf(object) === REACT_MEMO_TYPE;
	}
	function isPortal(object) {
	  return typeOf(object) === REACT_PORTAL_TYPE;
	}
	function isProfiler(object) {
	  return typeOf(object) === REACT_PROFILER_TYPE;
	}
	function isStrictMode(object) {
	  return typeOf(object) === REACT_STRICT_MODE_TYPE;
	}
	function isSuspense(object) {
	  return typeOf(object) === REACT_SUSPENSE_TYPE;
	}

	reactIs_development.AsyncMode = AsyncMode;
	reactIs_development.ConcurrentMode = ConcurrentMode;
	reactIs_development.ContextConsumer = ContextConsumer;
	reactIs_development.ContextProvider = ContextProvider;
	reactIs_development.Element = Element;
	reactIs_development.ForwardRef = ForwardRef;
	reactIs_development.Fragment = Fragment;
	reactIs_development.Lazy = Lazy;
	reactIs_development.Memo = Memo;
	reactIs_development.Portal = Portal;
	reactIs_development.Profiler = Profiler;
	reactIs_development.StrictMode = StrictMode;
	reactIs_development.Suspense = Suspense;
	reactIs_development.isAsyncMode = isAsyncMode;
	reactIs_development.isConcurrentMode = isConcurrentMode;
	reactIs_development.isContextConsumer = isContextConsumer;
	reactIs_development.isContextProvider = isContextProvider;
	reactIs_development.isElement = isElement;
	reactIs_development.isForwardRef = isForwardRef;
	reactIs_development.isFragment = isFragment;
	reactIs_development.isLazy = isLazy;
	reactIs_development.isMemo = isMemo;
	reactIs_development.isPortal = isPortal;
	reactIs_development.isProfiler = isProfiler;
	reactIs_development.isStrictMode = isStrictMode;
	reactIs_development.isSuspense = isSuspense;
	reactIs_development.isValidElementType = isValidElementType;
	reactIs_development.typeOf = typeOf;
	  })();
	}
	return reactIs_development;
}

var hasRequiredReactIs;

function requireReactIs () {
	if (hasRequiredReactIs) return reactIs.exports;
	hasRequiredReactIs = 1;

	if (process.env.NODE_ENV === 'production') {
	  reactIs.exports = requireReactIs_production_min();
	} else {
	  reactIs.exports = requireReactIs_development();
	}
	return reactIs.exports;
}

var hasRequiredGetComponentName;

function requireGetComponentName () {
	if (hasRequiredGetComponentName) return getComponentName;
	hasRequiredGetComponentName = 1;
	(function (exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports["default"] = getComponentName;

		var _functionPrototype = _interopRequireDefault(requireFunction_prototype_name());

		var _reactIs = requireReactIs();

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

		function getComponentName(Component) {
		  if (typeof Component === 'string') {
		    return Component;
		  }

		  if (typeof Component === 'function') {
		    return Component.displayName || (0, _functionPrototype["default"])(Component);
		  }

		  if ((0, _reactIs.isForwardRef)({
		    type: Component,
		    $$typeof: _reactIs.Element
		  })) {
		    return Component.displayName;
		  }

		  if ((0, _reactIs.isMemo)(Component)) {
		    return getComponentName(Component.type);
		  }

		  return null;
		}
		
	} (getComponentName));
	return getComponentName;
}

var hasRequiredChildrenOfType;

function requireChildrenOfType () {
	if (hasRequiredChildrenOfType) return childrenOfType;
	hasRequiredChildrenOfType = 1;
	(function (exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports["default"] = void 0;

		var _arrayPrototype = _interopRequireDefault(requireArray_prototype_find());

		var _getComponentName = _interopRequireDefault(requireGetComponentName());

		var _renderableChildren = _interopRequireDefault(requireRenderableChildren());

		var _wrapValidator = _interopRequireDefault(requireWrapValidator());

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

		function onlyTypes(types, children, componentName) {
		  if (!children.every(function (child) {
		    return child && (0, _arrayPrototype["default"])(types, function (Type) {
		      return Type === '*' || child.type === Type;
		    });
		  })) {
		    var typeNames = types.map(_getComponentName["default"]).join(', or ');
		    return new TypeError("`".concat(componentName, "` only accepts children of type ").concat(typeNames));
		  }

		  return null;
		}

		function isRequired(types, children, componentName) {
		  if (children.length === 0) {
		    var typeNames = types.map(_getComponentName["default"]).join(', or ');
		    return new TypeError("`".concat(componentName, "` requires at least one node of type ").concat(typeNames));
		  }

		  return null;
		}

		function childrenOfType() {
		  for (var _len = arguments.length, types = new Array(_len), _key = 0; _key < _len; _key++) {
		    types[_key] = arguments[_key];
		  }

		  if (types.length < 1) {
		    throw new TypeError('childrenOfType: at least 1 type is required');
		  }

		  function validator(props, propName, componentName) {
		    return onlyTypes(types, (0, _renderableChildren["default"])(props[propName]), componentName);
		  }

		  validator.isRequired = function (props, propName, componentName) {
		    var children = (0, _renderableChildren["default"])(props[propName]);
		    return isRequired(types, children, componentName) || onlyTypes(types, children, componentName);
		  };

		  return (0, _wrapValidator["default"])(validator, 'childrenOfType', types);
		}

		var _default = childrenOfType;
		exports["default"] = _default;
		
	} (childrenOfType));
	return childrenOfType;
}

var childrenSequenceOf = {};

var sequenceOf = {};

var nonNegativeInteger = {};

var integer = {};

var isInteger = {};

var hasRequiredIsInteger;

function requireIsInteger () {
	if (hasRequiredIsInteger) return isInteger;
	hasRequiredIsInteger = 1;
	(function (exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports["default"] = void 0;
		var floor = Math.floor;
		var finite = isFinite;

		var _default = Number.isInteger ||
		/* istanbul ignore next */
		function (x) {
		  return typeof x === 'number' && finite(x) && floor(x) === x;
		};

		exports["default"] = _default;
		
	} (isInteger));
	return isInteger;
}

var hasRequiredInteger;

function requireInteger () {
	if (hasRequiredInteger) return integer;
	hasRequiredInteger = 1;
	(function (exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports["default"] = void 0;

		var _isInteger = _interopRequireDefault(requireIsInteger());

		var _wrapValidator = _interopRequireDefault(requireWrapValidator());

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

		function requiredInteger(props, propName, componentName) {
		  var propValue = props[propName];

		  if (propValue == null || !(0, _isInteger["default"])(propValue)) {
		    return new RangeError("".concat(propName, " in ").concat(componentName, " must be an integer"));
		  }

		  return null;
		}

		var validator = function integer(props, propName) {
		  var propValue = props[propName];

		  if (propValue == null) {
		    return null;
		  }

		  for (var _len = arguments.length, rest = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
		    rest[_key - 2] = arguments[_key];
		  }

		  return requiredInteger.apply(void 0, [props, propName].concat(rest));
		};

		validator.isRequired = requiredInteger;

		var _default = function _default() {
		  return (0, _wrapValidator["default"])(validator, 'integer');
		};

		exports["default"] = _default;
		
	} (integer));
	return integer;
}

var nonNegativeNumber = {};

var implementation;
var hasRequiredImplementation;

function requireImplementation () {
	if (hasRequiredImplementation) return implementation;
	hasRequiredImplementation = 1;

	var numberIsNaN = function (value) {
		return value !== value;
	};

	implementation = function is(a, b) {
		if (a === 0 && b === 0) {
			return 1 / a === 1 / b;
		}
		if (a === b) {
			return true;
		}
		if (numberIsNaN(a) && numberIsNaN(b)) {
			return true;
		}
		return false;
	};
	return implementation;
}

var polyfill;
var hasRequiredPolyfill;

function requirePolyfill () {
	if (hasRequiredPolyfill) return polyfill;
	hasRequiredPolyfill = 1;

	var implementation = requireImplementation();

	polyfill = function getPolyfill() {
		return typeof Object.is === 'function' ? Object.is : implementation;
	};
	return polyfill;
}

var shim;
var hasRequiredShim;

function requireShim () {
	if (hasRequiredShim) return shim;
	hasRequiredShim = 1;

	var getPolyfill = requirePolyfill();
	var define = requireDefineProperties();

	shim = function shimObjectIs() {
		var polyfill = getPolyfill();
		define(Object, { is: polyfill }, {
			is: function testObjectIs() {
				return Object.is !== polyfill;
			}
		});
		return polyfill;
	};
	return shim;
}

var objectIs;
var hasRequiredObjectIs;

function requireObjectIs () {
	if (hasRequiredObjectIs) return objectIs;
	hasRequiredObjectIs = 1;

	var define = requireDefineProperties();
	var callBind = requireCallBind();

	var implementation = requireImplementation();
	var getPolyfill = requirePolyfill();
	var shim = requireShim();

	var polyfill = callBind(getPolyfill(), Object);

	define(polyfill, {
		getPolyfill: getPolyfill,
		implementation: implementation,
		shim: shim
	});

	objectIs = polyfill;
	return objectIs;
}

var hasRequiredNonNegativeNumber;

function requireNonNegativeNumber () {
	if (hasRequiredNonNegativeNumber) return nonNegativeNumber;
	hasRequiredNonNegativeNumber = 1;
	(function (exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports["default"] = void 0;

		var _objectIs = _interopRequireDefault(requireObjectIs());

		var _wrapValidator = _interopRequireDefault(requireWrapValidator());

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

		function isNonNegative(x) {
		  return typeof x === 'number' && isFinite(x) && x >= 0 && !(0, _objectIs["default"])(x, -0);
		}

		function nonNegativeNumber(props, propName, componentName) {
		  var value = props[propName];

		  if (value == null || isNonNegative(value)) {
		    return null;
		  }

		  return new RangeError("".concat(propName, " in ").concat(componentName, " must be a non-negative number"));
		}

		function requiredNonNegativeNumber(props, propName, componentName) {
		  var value = props[propName];

		  if (isNonNegative(value)) {
		    return null;
		  }

		  return new RangeError("".concat(propName, " in ").concat(componentName, " must be a non-negative number"));
		}

		nonNegativeNumber.isRequired = requiredNonNegativeNumber;

		var _default = function _default() {
		  return (0, _wrapValidator["default"])(nonNegativeNumber, 'nonNegativeNumber');
		};

		exports["default"] = _default;
		
	} (nonNegativeNumber));
	return nonNegativeNumber;
}

var hasRequiredNonNegativeInteger;

function requireNonNegativeInteger () {
	if (hasRequiredNonNegativeInteger) return nonNegativeInteger;
	hasRequiredNonNegativeInteger = 1;
	(function (exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports["default"] = void 0;

		var _and = _interopRequireDefault(requireAnd());

		var _integer = _interopRequireDefault(requireInteger());

		var _nonNegativeNumber = _interopRequireDefault(requireNonNegativeNumber());

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

		var _default = (0, _and["default"])([(0, _integer["default"])(), (0, _nonNegativeNumber["default"])()], 'nonNegativeInteger');

		exports["default"] = _default;
		
	} (nonNegativeInteger));
	return nonNegativeInteger;
}

var object = {};

var typeOf = {};

var hasRequiredTypeOf;

function requireTypeOf () {
	if (hasRequiredTypeOf) return typeOf;
	hasRequiredTypeOf = 1;
	(function (exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports["default"] = typeOf;

		var _react = _interopRequireDefault(React);

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

		function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

		function typeOf(child) {
		  if (child === null) {
		    return 'null';
		  }

		  if (Array.isArray(child)) {
		    return 'array';
		  }

		  if (_typeof(child) !== 'object') {
		    return _typeof(child);
		  }

		  if ( /*#__PURE__*/_react["default"].isValidElement(child)) {
		    return child.type;
		  }

		  return child;
		}
		
	} (typeOf));
	return typeOf;
}

var hasRequiredObject;

function requireObject () {
	if (hasRequiredObject) return object;
	hasRequiredObject = 1;
	(function (exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports["default"] = void 0;

		var _isPlainObject = _interopRequireDefault(requireIsPlainObject());

		var _typeOf = _interopRequireDefault(requireTypeOf());

		var _wrapValidator = _interopRequireDefault(requireWrapValidator());

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

		/*
		  code adapted from https://github.com/facebook/react/blob/14156e56b9cf18ac86963185c5af4abddf3ff811/src/isomorphic/classic/types/ReactPropTypes.js#L202-L206
		  so that it can be called outside of React's normal PropType flow
		*/
		var ReactPropTypeLocationNames = {
		  prop: 'prop',
		  context: 'context',
		  childContext: 'child context'
		};

		function object(props, propName, componentName, location, propFullName) {
		  var propValue = props[propName];

		  if (propValue == null) {
		    return null;
		  }

		  if ((0, _isPlainObject["default"])(propValue)) {
		    return null;
		  }

		  var locationName = ReactPropTypeLocationNames[location] || location;
		  return new TypeError("Invalid ".concat(locationName, " `").concat(propFullName, "` of type `").concat((0, _typeOf["default"])(propValue), "` supplied to `").concat(componentName, "`, expected `object`."));
		}

		object.isRequired = function objectRequired(props, propName, componentName, location, propFullName) {
		  var propValue = props[propName];

		  if (propValue == null) {
		    var locationName = ReactPropTypeLocationNames[location] || location;
		    return new TypeError("The ".concat(locationName, " `").concat(propFullName, "` is marked as required in `").concat(componentName, "`, but its value is `").concat(propValue, "`."));
		  }

		  for (var _len = arguments.length, rest = new Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
		    rest[_key - 5] = arguments[_key];
		  }

		  return object.apply(void 0, [props, propName, componentName, location, propFullName].concat(rest));
		};

		var _default = function _default() {
		  return (0, _wrapValidator["default"])(object, 'object');
		};

		exports["default"] = _default;
		
	} (object));
	return object;
}

var withShape = {};

var hasRequiredWithShape;

function requireWithShape () {
	if (hasRequiredWithShape) return withShape;
	hasRequiredWithShape = 1;
	(function (exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports["default"] = withShape;

		var _and = _interopRequireDefault(requireAnd());

		var _shape = _interopRequireDefault(requireShape());

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

		function withShape(type, shapeTypes) {
		  if (typeof type !== 'function') {
		    throw new TypeError('type must be a valid PropType');
		  }

		  var shapeValidator = (0, _shape["default"])(shapeTypes);
		  return (0, _and["default"])([type, shapeValidator], 'withShape');
		}
		
	} (withShape));
	return withShape;
}

var hasRequiredSequenceOf;

function requireSequenceOf () {
	if (hasRequiredSequenceOf) return sequenceOf;
	hasRequiredSequenceOf = 1;
	(function (exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports["default"] = sequenceOfValidator;

		var _propTypes = PropTypes;

		var _and = _interopRequireDefault(requireAnd());

		var _between = _interopRequireDefault(requireBetween());

		var _nonNegativeInteger = _interopRequireDefault(requireNonNegativeInteger());

		var _object = _interopRequireDefault(requireObject());

		var _withShape = _interopRequireDefault(requireWithShape());

		var _typeOf = _interopRequireDefault(requireTypeOf());

		var _wrapValidator = _interopRequireDefault(requireWrapValidator());

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

		function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

		function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

		function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

		var minValidator = _nonNegativeInteger["default"];
		var maxValidator = (0, _and["default"])([_nonNegativeInteger["default"], (0, _between["default"])({
		  gte: 1
		})]);

		function validateRange(min, max) {
		  if (typeof max !== 'number' || typeof min !== 'number') {
		    return null; // no additional checking needed unless both are present
		  }

		  if (min <= max) {
		    return null;
		  }

		  return new RangeError('min must be less than or equal to max');
		}

		var specifierShape = {
		  validator: function validator(props, propName) {
		    var propValue = props[propName];

		    if (typeof propValue !== 'function') {
		      return new TypeError('"validator" must be a propType validator function');
		    }

		    return null;
		  },
		  min: function min(props, propName) {
		    return minValidator(props, propName) || validateRange(props.min, props.max);
		  },
		  max: function max(props, propName) {
		    return maxValidator(props, propName) || validateRange(props.min, props.max);
		  }
		};

		function getMinMax(_ref) {
		  var min = _ref.min,
		      max = _ref.max;
		  var minimum;
		  var maximum;

		  if (typeof min !== 'number' && typeof max !== 'number') {
		    // neither provided, default to "1"
		    minimum = 1;
		    maximum = 1;
		  } else {
		    minimum = typeof min === 'number' ? min : 1;
		    maximum = typeof max === 'number' ? max : Infinity;
		  }

		  return {
		    minimum: minimum,
		    maximum: maximum
		  };
		}

		function chunkByType(items) {
		  var chunk = [];
		  var lastType;
		  return items.reduce(function (chunks, item) {
		    var itemType = (0, _typeOf["default"])(item);

		    if (!lastType || itemType === lastType) {
		      chunk.push(item);
		    } else {
		      chunks.push(chunk);
		      chunk = [item];
		    }

		    lastType = itemType;
		    return chunks;
		  }, []).concat(chunk.length > 0 ? [chunk] : []);
		}

		function validateChunks(specifiers, props, propName, componentName) {
		  var items = props[propName];
		  var chunks = chunkByType(items);

		  for (var _len = arguments.length, rest = new Array(_len > 4 ? _len - 4 : 0), _key = 4; _key < _len; _key++) {
		    rest[_key - 4] = arguments[_key];
		  }

		  for (var i = 0; i < specifiers.length; i += 1) {
		    var _specifiers$i = specifiers[i],
		        validator = _specifiers$i.validator,
		        min = _specifiers$i.min,
		        max = _specifiers$i.max;

		    var _getMinMax = getMinMax({
		      min: min,
		      max: max
		    }),
		        minimum = _getMinMax.minimum,
		        maximum = _getMinMax.maximum;

		    if (chunks.length === 0 && minimum === 0) {
		      // no chunks left, but this specifier does not require any items
		      continue; // eslint-disable-line no-continue
		    }

		    var arrayOfValidator = (0, _propTypes.arrayOf)(validator).isRequired;
		    var chunk = chunks.shift(); // extract the next chunk to test

		    var chunkError = arrayOfValidator.apply(void 0, [_objectSpread(_objectSpread({}, props), {}, _defineProperty({}, propName, chunk)), propName, componentName].concat(rest));

		    if (chunkError) {
		      // this chunk is invalid
		      if (minimum === 0) {
		        // but, specifier has a min of 0 and can be skipped
		        chunks.unshift(chunk); // put the chunk back, for the next iteration

		        continue; // eslint-disable-line no-continue
		      }

		      return chunkError;
		    } // chunk is valid!


		    if (chunk.length < minimum) {
		      return new RangeError("".concat(componentName, ": specifier index ").concat(i, " requires a minimum of ").concat(min, " items, but only has ").concat(chunk.length, "."));
		    }

		    if (chunk.length > maximum) {
		      return new RangeError("".concat(componentName, ": specifier index ").concat(i, " requires a maximum of ").concat(max, " items, but has ").concat(chunk.length, "."));
		    }
		  }

		  if (chunks.length > 0) {
		    return new TypeError("".concat(componentName, ": after all ").concat(specifiers.length, " specifiers matched, ").concat(chunks.length, " types of items were remaining."));
		  }

		  return null;
		}

		var specifierValidator = (0, _withShape["default"])((0, _object["default"])(), specifierShape).isRequired;

		function sequenceOfValidator() {
		  for (var _len2 = arguments.length, specifiers = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
		    specifiers[_key2] = arguments[_key2];
		  }

		  if (specifiers.length === 0) {
		    throw new RangeError('sequenceOf: at least one specifier is required');
		  }

		  var errors = specifiers.map(function (specifier, i) {
		    return specifierValidator({
		      specifier: specifier
		    }, 'specifier', 'sequenceOf specifier', "suequenceOf specifier, index ".concat(i), "specifier, index ".concat(i));
		  });

		  if (errors.some(Boolean)) {
		    throw new TypeError("\n      sequenceOf: all specifiers must match the appropriate shape.\n\n      Errors:\n        ".concat(errors.map(function (e, i) {
		      return " - Argument index ".concat(i, ": ").concat(e.message);
		    }).join(',\n        '), "\n    "));
		  }

		  var validator = function sequenceOf(props, propName) {
		    var propValue = props[propName];

		    if (propValue == null) {
		      return null;
		    }

		    for (var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
		      rest[_key3 - 2] = arguments[_key3];
		    }

		    var error = _propTypes.array.apply(void 0, [props, propName].concat(rest));

		    if (error) {
		      return error;
		    }

		    return validateChunks.apply(void 0, [specifiers, props, propName].concat(rest));
		  };

		  validator.isRequired = function sequenceOfRequired(props, propName, componentName) {
		    for (var _len4 = arguments.length, rest = new Array(_len4 > 3 ? _len4 - 3 : 0), _key4 = 3; _key4 < _len4; _key4++) {
		      rest[_key4 - 3] = arguments[_key4];
		    }

		    var error = _propTypes.array.isRequired.apply(_propTypes.array, [props, propName, componentName].concat(rest));

		    if (error) {
		      return error;
		    }

		    return validateChunks.apply(void 0, [specifiers, props, propName, componentName].concat(rest));
		  };

		  return (0, _wrapValidator["default"])(validator, 'sequenceOf', specifiers);
		}
		
	} (sequenceOf));
	return sequenceOf;
}

var hasRequiredChildrenSequenceOf;

function requireChildrenSequenceOf () {
	if (hasRequiredChildrenSequenceOf) return childrenSequenceOf;
	hasRequiredChildrenSequenceOf = 1;
	(function (exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports["default"] = childrenSequenceOfValidator;

		var _sequenceOf = _interopRequireDefault(requireSequenceOf());

		var _renderableChildren = _interopRequireDefault(requireRenderableChildren());

		var _wrapValidator = _interopRequireDefault(requireWrapValidator());

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

		function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

		function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

		function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

		function childrenSequenceOfValidator() {
		  for (var _len = arguments.length, specifiers = new Array(_len), _key = 0; _key < _len; _key++) {
		    specifiers[_key] = arguments[_key];
		  }

		  var seq = _sequenceOf["default"].apply(void 0, specifiers);

		  var validator = function childrenSequenceOf(props, propName, componentName) {
		    if (propName !== 'children') {
		      return new TypeError("".concat(componentName, " is using the childrenSequenceOf validator on non-children prop \"").concat(propName, "\""));
		    }

		    var propValue = props[propName];
		    var children = (0, _renderableChildren["default"])(propValue);

		    if (children.length === 0) {
		      return null;
		    }

		    for (var _len2 = arguments.length, rest = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
		      rest[_key2 - 3] = arguments[_key2];
		    }

		    return seq.apply(void 0, [_objectSpread(_objectSpread({}, props), {}, {
		      children: children
		    }), propName, componentName].concat(rest));
		  };

		  validator.isRequired = function childrenSequenceOfRequired(props, propName, componentName) {
		    if (propName !== 'children') {
		      return new TypeError("".concat(componentName, " is using the childrenSequenceOf validator on non-children prop \"").concat(propName, "\""));
		    }

		    var propValue = props[propName];
		    var children = (0, _renderableChildren["default"])(propValue);

		    if (children.length === 0) {
		      return new TypeError("".concat(componentName, ": renderable children are required."));
		    }

		    for (var _len3 = arguments.length, rest = new Array(_len3 > 3 ? _len3 - 3 : 0), _key3 = 3; _key3 < _len3; _key3++) {
		      rest[_key3 - 3] = arguments[_key3];
		    }

		    return seq.isRequired.apply(seq, [_objectSpread(_objectSpread({}, props), {}, {
		      children: children
		    }), propName, componentName].concat(rest));
		  };

		  return (0, _wrapValidator["default"])(validator, 'childrenSequenceOf', specifiers);
		}
		
	} (childrenSequenceOf));
	return childrenSequenceOf;
}

var componentWithName = {};

var hasRequiredComponentWithName;

function requireComponentWithName () {
	if (hasRequiredComponentWithName) return componentWithName;
	hasRequiredComponentWithName = 1;
	(function (exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports["default"] = componentWithName;

		var _react = _interopRequireDefault(React);

		var _isRegex = _interopRequireDefault(requireIsRegex());

		var _arrayPrototype = _interopRequireDefault(requireArray_prototype_find());

		var _getComponentName = _interopRequireDefault(requireGetComponentName());

		var _wrapValidator = _interopRequireDefault(requireWrapValidator());

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

		function stripHOCs(fullName, namesOfHOCsToStrip) {
		  var innerName = fullName;

		  while (/\([^()]*\)/g.test(innerName)) {
		    var HOC = innerName;
		    var previousHOC = void 0;

		    do {
		      previousHOC = HOC;
		      HOC = previousHOC.replace(/\([^()]*\)/g, '');
		    } while (previousHOC !== HOC);

		    if (namesOfHOCsToStrip.indexOf(HOC) === -1) {
		      return innerName;
		    }

		    innerName = innerName.replace(RegExp("^".concat(HOC, "\\(|\\)$"), 'g'), '');
		  }

		  return innerName;
		}

		function hasName(name, namesOfHOCsToStrip, propValue, propName, componentName) {
		  for (var _len = arguments.length, rest = new Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
		    rest[_key - 5] = arguments[_key];
		  }

		  if (Array.isArray(propValue)) {
		    return (0, _arrayPrototype["default"])(propValue.map(function (item) {
		      return hasName.apply(void 0, [name, namesOfHOCsToStrip, item, propName, componentName].concat(rest));
		    }), Boolean) || null;
		  }

		  if (! /*#__PURE__*/_react["default"].isValidElement(propValue)) {
		    return new TypeError("".concat(componentName, ".").concat(propName, " is not a valid React element"));
		  }

		  var type = propValue.type;
		  var componentNameFromType = (0, _getComponentName["default"])(type);
		  var innerComponentName = namesOfHOCsToStrip.length > 0 ? stripHOCs(componentNameFromType, namesOfHOCsToStrip) : componentNameFromType;

		  if ((0, _isRegex["default"])(name) && !name.test(innerComponentName)) {
		    return new TypeError("`".concat(componentName, ".").concat(propName, "` only accepts components matching the regular expression ").concat(name));
		  }

		  if (!(0, _isRegex["default"])(name) && innerComponentName !== name) {
		    return new TypeError("`".concat(componentName, ".").concat(propName, "` only accepts components named ").concat(name, ", got ").concat(innerComponentName));
		  }

		  return null;
		}

		function componentWithName(name) {
		  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

		  if (typeof name !== 'string' && !(0, _isRegex["default"])(name)) {
		    throw new TypeError('name must be a string or a regex');
		  }

		  var passedOptions = Object.keys(options);

		  if (passedOptions.length > 1 || passedOptions.length === 1 && passedOptions[0] !== 'stripHOCs') {
		    throw new TypeError("The only options supported are: \u201CstripHOCs\u201D, got: \u201C".concat(passedOptions.join('”, “'), "\u201D"));
		  }

		  var _options$stripHOCs = options.stripHOCs,
		      namesOfHOCsToStrip = _options$stripHOCs === void 0 ? [] : _options$stripHOCs;
		  var allHOCNamesAreValid = namesOfHOCsToStrip.every(function (x) {
		    if (typeof x !== 'string' || /[()]/g.test(x)) {
		      return false;
		    }

		    return /^(?:[a-z][a-zA-Z0-9]+|[A-Z][a-z][a-zA-Z0-9]+)$/.test(x);
		  });

		  if (!allHOCNamesAreValid) {
		    throw new TypeError('every provided HOC name must be a string with no parens, and in camelCase');
		  }

		  function componentWithNameValidator(props, propName, componentName) {
		    var propValue = props[propName];

		    if (props[propName] == null) {
		      return null;
		    }

		    for (var _len2 = arguments.length, rest = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
		      rest[_key2 - 3] = arguments[_key2];
		    }

		    return hasName.apply(void 0, [name, namesOfHOCsToStrip, propValue, propName, componentName].concat(rest));
		  }

		  componentWithNameValidator.isRequired = function componentWithNameRequired(props, propName, componentName) {
		    var propValue = props[propName];

		    if (propValue == null) {
		      return new TypeError("`".concat(componentName, ".").concat(propName, "` requires at least one component named ").concat(name));
		    }

		    for (var _len3 = arguments.length, rest = new Array(_len3 > 3 ? _len3 - 3 : 0), _key3 = 3; _key3 < _len3; _key3++) {
		      rest[_key3 - 3] = arguments[_key3];
		    }

		    return hasName.apply(void 0, [name, namesOfHOCsToStrip, propValue, propName, componentName].concat(rest));
		  };

		  return (0, _wrapValidator["default"])(componentWithNameValidator, "componentWithName:".concat(name), name);
		}
		
	} (componentWithName));
	return componentWithName;
}

var disallowedIf = {};

var hasRequiredDisallowedIf;

function requireDisallowedIf () {
	if (hasRequiredDisallowedIf) return disallowedIf;
	hasRequiredDisallowedIf = 1;
	(function (exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports["default"] = disallowedIf;

		var _wrapValidator = _interopRequireDefault(requireWrapValidator());

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

		function disallowedIf(propType, otherPropName, otherPropType) {
		  if (typeof propType !== 'function' || typeof propType.isRequired !== 'function') {
		    throw new TypeError('a propType validator is required; propType validators must also provide `.isRequired`');
		  }

		  if (typeof otherPropName !== 'string') {
		    throw new TypeError('other prop name must be a string');
		  }

		  if (typeof otherPropType !== 'function') {
		    throw new TypeError('other prop type validator is required');
		  }

		  function disallowedIfRequired(props, propName, componentName) {
		    for (var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
		      rest[_key - 3] = arguments[_key];
		    }

		    var error = propType.isRequired.apply(propType, [props, propName, componentName].concat(rest));

		    if (error) {
		      return error;
		    }

		    if (props[otherPropName] == null) {
		      return null;
		    }

		    var otherError = otherPropType.apply(void 0, [props, otherPropName, componentName].concat(rest));

		    if (otherError) {
		      return null;
		    }

		    return new Error("prop \u201C".concat(propName, "\u201D is disallowed when \u201C").concat(otherPropName, "\u201D matches the provided validator"));
		  }

		  var validator = function disallowedIfPropType(props, propName) {
		    if (props[propName] == null) {
		      return null;
		    }

		    for (var _len2 = arguments.length, rest = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
		      rest[_key2 - 2] = arguments[_key2];
		    }

		    return disallowedIfRequired.apply(void 0, [props, propName].concat(rest));
		  };

		  validator.isRequired = disallowedIfRequired;
		  return (0, _wrapValidator["default"])(validator, 'disallowedIf', {
		    propType: propType,
		    otherPropName: otherPropName,
		    otherPropType: otherPropType
		  });
		}
		
	} (disallowedIf));
	return disallowedIf;
}

var elementType = {};

var hasRequiredElementType;

function requireElementType () {
	if (hasRequiredElementType) return elementType;
	hasRequiredElementType = 1;
	(function (exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports["default"] = elementTypeValidator;

		var _propTypes = PropTypes;

		var _reactIs = requireReactIs();

		var _and = _interopRequireDefault(requireAnd());

		var _getComponentName = _interopRequireDefault(requireGetComponentName());

		var _wrapValidator = _interopRequireDefault(requireWrapValidator());

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

		function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

		function getTypeName(Type) {
		  if (typeof Type === 'string') {
		    return Type;
		  }

		  var type = (0, _getComponentName["default"])(Type);
		  /* istanbul ignore next */
		  // in environments where functions do not have names

		  return type || 'Anonymous Component';
		}

		function validateElementType(Type, props, propName, componentName) {
		  var type = props[propName].type;

		  if (type === Type) {
		    return null;
		  }

		  return new TypeError("".concat(componentName, ".").concat(propName, " must be a React element of type ").concat(getTypeName(Type)));
		}

		function elementTypeValidator(Type) {
		  if (Type === '*') {
		    return (0, _wrapValidator["default"])(_propTypes.element, 'elementType(*)', Type);
		  }

		  if (!(0, _reactIs.isValidElementType)(Type)) {
		    throw new TypeError("Type must be a React Component, an HTML element tag name, or \"*\". Got an ".concat(_typeof(Type)));
		  }

		  function elementType(props, propName, componentName) {
		    if (props[propName] == null) {
		      return null;
		    }

		    for (var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
		      rest[_key - 3] = arguments[_key];
		    }

		    return validateElementType.apply(void 0, [Type, props, propName, componentName].concat(rest));
		  }

		  elementType.isRequired = elementType; // covered by and + element

		  var typeName = getTypeName(Type);
		  var validatorName = "elementType(".concat(typeName, ")");
		  return (0, _wrapValidator["default"])((0, _and["default"])([_propTypes.element, elementType], validatorName), validatorName, Type);
		}
		
	} (elementType));
	return elementType;
}

var empty = {};

var or = {};

var hasRequiredOr;

function requireOr () {
	if (hasRequiredOr) return or;
	hasRequiredOr = 1;
	(function (exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports["default"] = or;

		var _propTypes = PropTypes;

		var _wrapValidator = _interopRequireDefault(requireWrapValidator());

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

		function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

		function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

		function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

		function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

		function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

		function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

		function oneOfTypeValidator(validators) {
		  var validator = function oneOfType(props, propName, componentName) {
		    for (var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
		      rest[_key - 3] = arguments[_key];
		    }

		    var propValue = props[propName];

		    if (typeof propValue === 'undefined') {
		      return null;
		    }

		    var errors = validators.map(function (v) {
		      return v.apply(void 0, [props, propName, componentName].concat(rest));
		    }).filter(Boolean);

		    if (errors.length < validators.length) {
		      return null;
		    }

		    return new TypeError("".concat(componentName, ": invalid value supplied to ").concat(propName, "."));
		  };

		  validator.isRequired = function oneOfTypeRequired(props, propName, componentName) {
		    for (var _len2 = arguments.length, rest = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
		      rest[_key2 - 3] = arguments[_key2];
		    }

		    var propValue = props[propName];

		    if (typeof propValue === 'undefined') {
		      return new TypeError("".concat(componentName, ": missing value for required ").concat(propName, "."));
		    }

		    var errors = validators.map(function (v) {
		      return v.apply(void 0, [props, propName, componentName].concat(rest));
		    }).filter(Boolean);

		    if (errors.length === validators.length) {
		      return new TypeError("".concat(componentName, ": invalid value ").concat(errors, " supplied to required ").concat(propName, "."));
		    }

		    return null;
		  };

		  return (0, _wrapValidator["default"])(validator, 'oneOfType', validators);
		}

		function or(validators) {
		  var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'or';

		  if (!Array.isArray(validators)) {
		    throw new TypeError('or: 2 or more validators are required');
		  }

		  if (validators.length <= 1) {
		    throw new RangeError('or: 2 or more validators are required');
		  }

		  var validator = oneOfTypeValidator([(0, _propTypes.arrayOf)(oneOfTypeValidator(validators))].concat(_toConsumableArray(validators)));
		  return (0, _wrapValidator["default"])(validator, name, validators);
		}
		
	} (or));
	return or;
}

var explicitNull = {};

var hasRequiredExplicitNull;

function requireExplicitNull () {
	if (hasRequiredExplicitNull) return explicitNull;
	hasRequiredExplicitNull = 1;
	(function (exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports["default"] = void 0;

		var _wrapValidator = _interopRequireDefault(requireWrapValidator());

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

		function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

		function explicitNull(props, propName, componentName) {
		  if (props[propName] == null) {
		    return null;
		  }

		  return new TypeError("".concat(componentName, ": prop \u201C").concat(propName, "\u201D must be null or undefined; received ").concat(_typeof(props[propName])));
		}

		explicitNull.isRequired = function explicitNullRequired(props, propName, componentName) {
		  if (props[propName] === null) {
		    return null;
		  }

		  return new TypeError("".concat(componentName, ": prop \u201C").concat(propName, "\u201D must be null; received ").concat(_typeof(props[propName])));
		};

		var _default = function _default() {
		  return (0, _wrapValidator["default"])(explicitNull, 'explicitNull');
		};

		exports["default"] = _default;
		
	} (explicitNull));
	return explicitNull;
}

var hasRequiredEmpty;

function requireEmpty () {
	if (hasRequiredEmpty) return empty;
	hasRequiredEmpty = 1;
	(function (exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports["default"] = void 0;

		var _propTypes = PropTypes;

		var _or = _interopRequireDefault(requireOr());

		var _explicitNull = _interopRequireDefault(requireExplicitNull());

		var _withShape = _interopRequireDefault(requireWithShape());

		var _wrapValidator = _interopRequireDefault(requireWrapValidator());

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

		var arrayOfValidator;
		var validator = (0, _or["default"])([_explicitNull["default"], // null/undefined
		(0, _propTypes.oneOf)([false, '', NaN]), (0, _withShape["default"])(_propTypes.array, {
		  length: (0, _propTypes.oneOf)([0]).isRequired
		}).isRequired, function () {
		  return arrayOfValidator.apply(void 0, arguments);
		}]);
		arrayOfValidator = (0, _propTypes.arrayOf)(validator).isRequired;

		var _default = function _default() {
		  return (0, _wrapValidator["default"])(validator, 'empty');
		};

		exports["default"] = _default;
		
	} (empty));
	return empty;
}

var keysOf = {};

var hasRequiredKeysOf;

function requireKeysOf () {
	if (hasRequiredKeysOf) return keysOf;
	hasRequiredKeysOf = 1;
	(function (exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports["default"] = keysOfValidator;

		var _isPrimitive = _interopRequireDefault(requireIsPrimitive$2());

		var _wrapValidator = _interopRequireDefault(requireWrapValidator());

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

		function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

		function keysOfValidator(propType) {
		  var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'keysOf';

		  if (typeof propType !== 'function') {
		    throw new TypeError('argument to keysOf must be a valid PropType function');
		  }

		  var validator = function keysOf(props, propName, componentName, location, propFullName) {
		    for (var _len = arguments.length, rest = new Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
		      rest[_key - 5] = arguments[_key];
		    }

		    var propValue = props[propName];

		    if (propValue == null || (0, _isPrimitive["default"])(propValue)) {
		      return null;
		    }

		    var firstError = null;
		    Object.keys(propValue).some(function (key) {
		      firstError = propType.apply(void 0, [_defineProperty({}, key, key), key, componentName, location, "(".concat(propFullName, ").").concat(key)].concat(rest));
		      return firstError != null;
		    });
		    return firstError || null;
		  };

		  validator.isRequired = function keyedByRequired(props, propName, componentName) {
		    var propValue = props[propName];

		    if (propValue == null) {
		      return new TypeError("".concat(componentName, ": ").concat(propName, " is required, but value is ").concat(propValue));
		    }

		    for (var _len2 = arguments.length, rest = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
		      rest[_key2 - 3] = arguments[_key2];
		    }

		    return validator.apply(void 0, [props, propName, componentName].concat(rest));
		  };

		  return (0, _wrapValidator["default"])(validator, name, propType);
		}
		
	} (keysOf));
	return keysOf;
}

var mutuallyExclusiveProps = {};

var hasRequiredMutuallyExclusiveProps;

function requireMutuallyExclusiveProps () {
	if (hasRequiredMutuallyExclusiveProps) return mutuallyExclusiveProps;
	hasRequiredMutuallyExclusiveProps = 1;
	(function (exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports["default"] = mutuallyExclusiveOfType;

		var _wrapValidator = _interopRequireDefault(requireWrapValidator());

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

		function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

		function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

		function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

		function mutuallyExclusiveOfType(propType) {
		  if (typeof propType !== 'function') {
		    throw new TypeError('a propType is required');
		  }

		  for (var _len = arguments.length, exclusiveProps = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
		    exclusiveProps[_key - 1] = arguments[_key];
		  }

		  if (exclusiveProps.length < 1) {
		    throw new TypeError('at least one prop that is mutually exclusive with this propType is required');
		  }

		  var propList = exclusiveProps.join(', or ');
		  var map = exclusiveProps.reduce(function (acc, prop) {
		    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, prop, true));
		  }, {});

		  var countProps = function countProps(count, prop) {
		    return count + (map[prop] ? 1 : 0);
		  };

		  var validator = function mutuallyExclusiveProps(props, propName, componentName) {
		    var exclusivePropCount = Object.keys(props).filter(function (prop) {
		      return props[prop] != null;
		    }).reduce(countProps, 0);

		    if (exclusivePropCount > 1) {
		      return new Error("A ".concat(componentName, " cannot have more than one of these props: ").concat(propList));
		    }

		    for (var _len2 = arguments.length, rest = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
		      rest[_key2 - 3] = arguments[_key2];
		    }

		    return propType.apply(void 0, [props, propName, componentName].concat(rest));
		  };

		  validator.isRequired = function mutuallyExclusivePropsRequired(props, propName, componentName) {
		    var exclusivePropCount = Object.keys(props).filter(function (prop) {
		      return prop === propName || props[prop] != null;
		    }).reduce(countProps, 0);

		    if (exclusivePropCount > 1) {
		      return new Error("A ".concat(componentName, " cannot have more than one of these props: ").concat(propList));
		    }

		    for (var _len3 = arguments.length, rest = new Array(_len3 > 3 ? _len3 - 3 : 0), _key3 = 3; _key3 < _len3; _key3++) {
		      rest[_key3 - 3] = arguments[_key3];
		    }

		    return propType.apply(void 0, [props, propName, componentName].concat(rest));
		  };

		  return (0, _wrapValidator["default"])(validator, "mutuallyExclusiveProps:".concat(propList), exclusiveProps);
		}
		
	} (mutuallyExclusiveProps));
	return mutuallyExclusiveProps;
}

var mutuallyExclusiveTrueProps = {};

var hasRequiredMutuallyExclusiveTrueProps;

function requireMutuallyExclusiveTrueProps () {
	if (hasRequiredMutuallyExclusiveTrueProps) return mutuallyExclusiveTrueProps;
	hasRequiredMutuallyExclusiveTrueProps = 1;
	(function (exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports["default"] = mutuallyExclusiveTrue;

		var _propTypes = PropTypes;

		var _wrapValidator = _interopRequireDefault(requireWrapValidator());

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

		function mutuallyExclusiveTrue() {
		  for (var _len = arguments.length, exclusiveProps = new Array(_len), _key = 0; _key < _len; _key++) {
		    exclusiveProps[_key] = arguments[_key];
		  }

		  if (exclusiveProps.length < 1) {
		    throw new TypeError('at least one prop that is mutually exclusive is required');
		  }

		  if (!exclusiveProps.every(function (x) {
		    return typeof x === 'string';
		  })) {
		    throw new TypeError('all exclusive true props must be strings');
		  }

		  var propsList = exclusiveProps.join(', or ');

		  var validator = function mutuallyExclusiveTrueProps(props, propName, componentName) {
		    var countProps = function countProps(count, prop) {
		      return count + (props[prop] ? 1 : 0);
		    };

		    var exclusivePropCount = exclusiveProps.reduce(countProps, 0);

		    if (exclusivePropCount > 1) {
		      return new Error("A ".concat(componentName, " cannot have more than one of these boolean props be true: ").concat(propsList));
		    }

		    for (var _len2 = arguments.length, rest = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
		      rest[_key2 - 3] = arguments[_key2];
		    }

		    return _propTypes.bool.apply(void 0, [props, propName, componentName].concat(rest));
		  };

		  validator.isRequired = function mutuallyExclusiveTruePropsRequired(props, propName, componentName) {
		    var countProps = function countProps(count, prop) {
		      return count + (props[prop] ? 1 : 0);
		    };

		    var exclusivePropCount = exclusiveProps.reduce(countProps, 0);

		    if (exclusivePropCount > 1) {
		      return new Error("A ".concat(componentName, " cannot have more than one of these boolean props be true: ").concat(propsList));
		    }

		    for (var _len3 = arguments.length, rest = new Array(_len3 > 3 ? _len3 - 3 : 0), _key3 = 3; _key3 < _len3; _key3++) {
		      rest[_key3 - 3] = arguments[_key3];
		    }

		    return _propTypes.bool.isRequired.apply(_propTypes.bool, [props, propName, componentName].concat(rest));
		  };

		  return (0, _wrapValidator["default"])(validator, "mutuallyExclusiveTrueProps: ".concat(propsList), exclusiveProps);
		}
		
	} (mutuallyExclusiveTrueProps));
	return mutuallyExclusiveTrueProps;
}

var nChildren = {};

var hasRequiredNChildren;

function requireNChildren () {
	if (hasRequiredNChildren) return nChildren;
	hasRequiredNChildren = 1;
	(function (exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports["default"] = nChildren;

		var _react = _interopRequireDefault(React);

		var _propTypes = PropTypes;

		var _wrapValidator = _interopRequireDefault(requireWrapValidator());

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

		function nChildren(n) {
		  var propType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _propTypes.node;

		  if (typeof n !== 'number' || isNaN(n) || n < 0) {
		    throw new TypeError('a non-negative number is required');
		  }

		  var validator = function nChildrenValidator(props, propName, componentName) {
		    if (propName !== 'children') {
		      return new TypeError("".concat(componentName, " is using the nChildren validator on a non-children prop"));
		    }

		    var children = props.children;

		    var childrenCount = _react["default"].Children.count(children);

		    if (childrenCount !== n) {
		      return new RangeError("".concat(componentName, " expects to receive ").concat(n, " children, but received ").concat(childrenCount, " children."));
		    }

		    for (var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
		      rest[_key - 3] = arguments[_key];
		    }

		    return propType.apply(void 0, [props, propName, componentName].concat(rest));
		  };

		  validator.isRequired = validator;
		  return (0, _wrapValidator["default"])(validator, "nChildren:".concat(n), n);
		}
		
	} (nChildren));
	return nChildren;
}

var numericString = {};

var hasRequiredNumericString;

function requireNumericString () {
	if (hasRequiredNumericString) return numericString;
	hasRequiredNumericString = 1;
	(function (exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports["default"] = void 0;

		var _propTypes = PropTypes;

		var _wrapValidator = _interopRequireDefault(requireWrapValidator());

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

		var validNumericChars = /^[-+]?(?:[1-9][0-9]*(?:\.[0-9]+)?|0|0\.[0-9]+)$/;

		var validator = function numericString(props, propName, componentName) {
		  if (props[propName] == null) {
		    return null;
		  }

		  for (var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
		    rest[_key - 3] = arguments[_key];
		  }

		  var stringError = _propTypes.string.apply(void 0, [props, propName, componentName].concat(rest));

		  if (stringError) {
		    return stringError;
		  }

		  var value = props[propName];
		  var passesRegex = validNumericChars.test(value);

		  if (passesRegex) {
		    return null;
		  }

		  return new TypeError("".concat(componentName, ": prop \"").concat(propName, "\" (value \"").concat(value, "\") must be a numeric string:\n    - starting with an optional + or -\n    - that does not have a leading zero\n    - with an optional decimal part (that contains only one decimal point, if present)\n    - that otherwise only contains digits (0-9)\n    - not +-NaN, or +-Infinity\n  "));
		};

		validator.isRequired = function numericStringRequired(props, propName, componentName) {
		  if (props[propName] == null) {
		    return new TypeError("".concat(componentName, ": ").concat(propName, " is required"));
		  }

		  for (var _len2 = arguments.length, rest = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
		    rest[_key2 - 3] = arguments[_key2];
		  }

		  return validator.apply(void 0, [props, propName, componentName].concat(rest));
		};

		var _default = function _default() {
		  return (0, _wrapValidator["default"])(validator, 'numericString');
		};

		exports["default"] = _default;
		
	} (numericString));
	return numericString;
}

var predicate = {};

var hasRequiredPredicate;

function requirePredicate () {
	if (hasRequiredPredicate) return predicate;
	hasRequiredPredicate = 1;
	(function (exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports["default"] = predicate;

		var _wrapValidator = _interopRequireDefault(requireWrapValidator());

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

		function predicate(fn) {
		  var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

		  if (typeof fn !== 'function') {
		    throw new TypeError('`fn` must be a function');
		  }

		  if (typeof message !== 'string') {
		    throw new TypeError('`message`, if provided, must be a string');
		  }

		  function requiredValidator(props, propName, componentName) {
		    var result = fn(props[propName]);

		    if (result) {
		      return null;
		    }

		    return new TypeError("`".concat(componentName, "` requires that `").concat(propName, "` pass a predicate function").concat(message ? ": ".concat(message) : '', "."));
		  }

		  function validator(props, propName) {
		    if (props[propName] == null) {
		      return null;
		    }

		    for (var _len = arguments.length, rest = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
		      rest[_key - 2] = arguments[_key];
		    }

		    return requiredValidator.apply(void 0, [props, propName].concat(rest));
		  }

		  validator.isRequired = requiredValidator;
		  return (0, _wrapValidator["default"])(validator, 'predicate', fn);
		}
		
	} (predicate));
	return predicate;
}

var range = {};

var hasRequiredRange;

function requireRange () {
	if (hasRequiredRange) return range;
	hasRequiredRange = 1;
	(function (exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports["default"] = range;

		var _and = _interopRequireDefault(requireAnd());

		var _between = _interopRequireDefault(requireBetween());

		var _integer = _interopRequireDefault(requireInteger());

		var _isInteger = _interopRequireDefault(requireIsInteger());

		var _wrapValidator = _interopRequireDefault(requireWrapValidator());

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

		var MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER ||
		/* istanbul ignore next */
		Math.pow(2, 53) - 1;

		function isValidLength(x) {
		  return (0, _isInteger["default"])(x) && Math.abs(x) < MAX_SAFE_INTEGER;
		}

		function range(min, max) {
		  if (!isValidLength(min) || !isValidLength(max)) {
		    throw new RangeError("\"range\" requires two integers: ".concat(min, " and ").concat(max, " given"));
		  }

		  if (min === max) {
		    throw new RangeError('min and max must not be the same');
		  }

		  return (0, _wrapValidator["default"])((0, _and["default"])([(0, _integer["default"])(), (0, _between["default"])({
		    gte: min,
		    lt: max
		  })], 'range'), 'range', {
		    min: min,
		    max: max
		  });
		}
		
	} (range));
	return range;
}

var ref = {};

var hasRequiredRef;

function requireRef () {
	if (hasRequiredRef) return ref;
	hasRequiredRef = 1;
	(function (exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports["default"] = void 0;

		var _react = React;

		var _isPlainObject = _interopRequireDefault(requireIsPlainObject());

		var _wrapValidator = _interopRequireDefault(requireWrapValidator());

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

		var isPrototypeOf = Object.prototype.isPrototypeOf;

		function isNewRef(prop) {
		  if (!(0, _isPlainObject["default"])(prop)) {
		    return false;
		  }

		  var ownProperties = Object.keys(prop);
		  return ownProperties.length === 1 && ownProperties[0] === 'current';
		}

		function isCallbackRef(prop) {
		  return typeof prop === 'function' && !isPrototypeOf.call(_react.Component, prop) && (!_react.PureComponent || !isPrototypeOf.call(_react.PureComponent, prop));
		}

		function requiredRef(props, propName, componentName) {
		  var propValue = props[propName];

		  if (isCallbackRef(propValue) || isNewRef(propValue)) {
		    return null;
		  }

		  return new TypeError("".concat(propName, " in ").concat(componentName, " must be a ref"));
		}

		function ref(props, propName, componentName) {
		  var propValue = props[propName];

		  if (propValue == null) {
		    return null;
		  }

		  for (var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
		    rest[_key - 3] = arguments[_key];
		  }

		  return requiredRef.apply(void 0, [props, propName, componentName].concat(rest));
		}

		ref.isRequired = requiredRef;

		var _default = function _default() {
		  return (0, _wrapValidator["default"])(ref, 'ref');
		};

		exports["default"] = _default;
		
	} (ref));
	return ref;
}

var requiredBy = {};

var hasRequiredRequiredBy;

function requireRequiredBy () {
	if (hasRequiredRequiredBy) return requiredBy;
	hasRequiredRequiredBy = 1;
	(function (exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports["default"] = getRequiredBy;

		var _objectIs = _interopRequireDefault(requireObjectIs());

		var _wrapValidator = _interopRequireDefault(requireWrapValidator());

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

		function getRequiredBy(requiredByPropName, propType) {
		  var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

		  function requiredBy(props, propName, componentName) {
		    if (props[requiredByPropName]) {
		      var propValue = props[propName];

		      if ((0, _objectIs["default"])(propValue, defaultValue) || typeof propValue === 'undefined') {
		        return new TypeError("".concat(componentName, ": when ").concat(requiredByPropName, " is true, prop \u201C").concat(propName, "\u201D must be present."));
		      }
		    }

		    for (var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
		      rest[_key - 3] = arguments[_key];
		    }

		    return propType.apply(void 0, [props, propName, componentName].concat(rest));
		  }

		  requiredBy.isRequired = function requiredByRequired(props, propName, componentName) {
		    var propValue = props[propName];

		    if ((0, _objectIs["default"])(propValue, defaultValue)) {
		      return new TypeError("".concat(componentName, ": prop \u201C").concat(propName, "\u201D must be present."));
		    }

		    for (var _len2 = arguments.length, rest = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
		      rest[_key2 - 3] = arguments[_key2];
		    }

		    return propType.isRequired.apply(propType, [props, propName, componentName].concat(rest));
		  };

		  return (0, _wrapValidator["default"])(requiredBy, "requiredBy \u201C".concat(requiredByPropName, "\u201D"), [requiredByPropName, defaultValue]);
		}
		
	} (requiredBy));
	return requiredBy;
}

var restrictedProp = {};

var hasRequiredRestrictedProp;

function requireRestrictedProp () {
	if (hasRequiredRestrictedProp) return restrictedProp;
	hasRequiredRestrictedProp = 1;
	(function (exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports["default"] = void 0;

		var _wrapValidator = _interopRequireDefault(requireWrapValidator());

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

		function customMessageWrapper(messsageFunction) {
		  function restrictedProp(props, propName, componentName, location) {
		    if (props[propName] == null) {
		      return null;
		    }

		    if (messsageFunction && typeof messsageFunction === 'function') {
		      for (var _len = arguments.length, rest = new Array(_len > 4 ? _len - 4 : 0), _key = 4; _key < _len; _key++) {
		        rest[_key - 4] = arguments[_key];
		      }

		      return new TypeError(messsageFunction.apply(void 0, [props, propName, componentName, location].concat(rest)));
		    }

		    return new TypeError("The ".concat(propName, " ").concat(location, " on ").concat(componentName, " is not allowed."));
		  }

		  restrictedProp.isRequired = restrictedProp;
		  return restrictedProp;
		}

		var _default = function _default() {
		  var messsageFunction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
		  return (0, _wrapValidator["default"])(customMessageWrapper(messsageFunction), 'restrictedProp');
		};

		exports["default"] = _default;
		
	} (restrictedProp));
	return restrictedProp;
}

var stringEndsWith = {};

var hasRequiredStringEndsWith;

function requireStringEndsWith () {
	if (hasRequiredStringEndsWith) return stringEndsWith;
	hasRequiredStringEndsWith = 1;
	(function (exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports["default"] = stringEndsWithValidator;

		var _propTypes = PropTypes;

		var _wrapValidator = _interopRequireDefault(requireWrapValidator());

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

		function stringEndsWithValidator(end) {
		  if (typeof end !== 'string' || end.length === 0) {
		    throw new TypeError('a non-empty string is required');
		  }

		  var validator = function stringEndsWith(props, propName, componentName) {
		    var propValue = props[propName];

		    if (propValue == null) {
		      return null;
		    }

		    for (var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
		      rest[_key - 3] = arguments[_key];
		    }

		    var stringError = _propTypes.string.apply(void 0, [props, propName, componentName].concat(rest));

		    if (stringError) {
		      return stringError;
		    }

		    if (!propValue.endsWith(end) || propValue.length <= end.length) {
		      return new TypeError("".concat(componentName, ": ").concat(propName, " does not end with \"").concat(end, "\""));
		    }

		    return null;
		  };

		  validator.isRequired = function requiredStringEndsWith() {
		    var stringError = _propTypes.string.isRequired.apply(_propTypes.string, arguments);

		    if (stringError) {
		      return stringError;
		    }

		    return validator.apply(void 0, arguments);
		  };

		  return (0, _wrapValidator["default"])(validator, "stringEndsWith: ".concat(end));
		}
		
	} (stringEndsWith));
	return stringEndsWith;
}

var stringStartsWith = {};

var hasRequiredStringStartsWith;

function requireStringStartsWith () {
	if (hasRequiredStringStartsWith) return stringStartsWith;
	hasRequiredStringStartsWith = 1;
	(function (exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports["default"] = stringStartsWithValidator;

		var _propTypes = PropTypes;

		var _wrapValidator = _interopRequireDefault(requireWrapValidator());

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

		function stringStartsWithValidator(start) {
		  if (typeof start !== 'string' || start.length === 0) {
		    throw new TypeError('a non-empty string is required');
		  }

		  var validator = function stringStartsWith(props, propName, componentName) {
		    var propValue = props[propName];

		    if (propValue == null) {
		      return null;
		    }

		    for (var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
		      rest[_key - 3] = arguments[_key];
		    }

		    var stringError = _propTypes.string.apply(void 0, [props, propName, componentName].concat(rest));

		    if (stringError) {
		      return stringError;
		    }

		    if (!propValue.startsWith(start) || propValue.length <= start.length) {
		      return new TypeError("".concat(componentName, ": ").concat(propName, " does not start with \"").concat(start, "\""));
		    }

		    return null;
		  };

		  validator.isRequired = function requiredStringStartsWith() {
		    var stringError = _propTypes.string.isRequired.apply(_propTypes.string, arguments);

		    if (stringError) {
		      return stringError;
		    }

		    return validator.apply(void 0, arguments);
		  };

		  return (0, _wrapValidator["default"])(validator, "stringStartsWith: ".concat(start));
		}
		
	} (stringStartsWith));
	return stringStartsWith;
}

var uniqueArray = {};

var hasRequiredUniqueArray;

function requireUniqueArray () {
	if (hasRequiredUniqueArray) return uniqueArray;
	hasRequiredUniqueArray = 1;
	(function (exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports["default"] = void 0;

		var _propTypes = PropTypes;

		var _wrapValidator = _interopRequireDefault(requireWrapValidator());

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

		function uniqueCountWithSet(arr) {
		  return new Set(arr).size;
		}
		/* istanbul ignore next */


		function uniqueCountLegacy(arr) {
		  var seen = [];
		  arr.forEach(function (item) {
		    if (seen.indexOf(item) === -1) {
		      seen.push(item);
		    }
		  });
		  return seen.length;
		}

		var getUniqueCount = typeof Set === 'function' ? uniqueCountWithSet :
		/* istanbul ignore next */
		uniqueCountLegacy;

		function requiredUniqueArray(props, propName, componentName) {
		  for (var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
		    rest[_key - 3] = arguments[_key];
		  }

		  var result = _propTypes.array.isRequired.apply(_propTypes.array, [props, propName, componentName].concat(rest));

		  if (result != null) {
		    return result;
		  }

		  var propValue = props[propName];
		  var uniqueCount = getUniqueCount(propValue);

		  if (uniqueCount !== propValue.length) {
		    return new RangeError("".concat(componentName, ": values must be unique. ").concat(propValue.length - uniqueCount, " duplicate values found."));
		  }

		  return null;
		}

		function uniqueArray(props, propName) {
		  var propValue = props[propName];

		  if (propValue == null) {
		    return null;
		  }

		  for (var _len2 = arguments.length, rest = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
		    rest[_key2 - 2] = arguments[_key2];
		  }

		  return requiredUniqueArray.apply(void 0, [props, propName].concat(rest));
		}

		uniqueArray.isRequired = requiredUniqueArray;

		var _default = function _default() {
		  return (0, _wrapValidator["default"])(uniqueArray, 'uniqueArray');
		};

		exports["default"] = _default;
		
	} (uniqueArray));
	return uniqueArray;
}

var uniqueArrayOf = {};

var hasRequiredUniqueArrayOf;

function requireUniqueArrayOf () {
	if (hasRequiredUniqueArrayOf) return uniqueArrayOf;
	hasRequiredUniqueArrayOf = 1;
	(function (exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports["default"] = uniqueArrayOfTypeValidator;

		var _propTypes = PropTypes;

		var _and = _interopRequireDefault(requireAnd());

		var _uniqueArray = _interopRequireDefault(requireUniqueArray());

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

		function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

		function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

		function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

		var unique = (0, _uniqueArray["default"])();

		function uniqueArrayOfTypeValidator(type) {
		  if (typeof type !== 'function') {
		    throw new TypeError('type must be a validator function');
		  }

		  var mapper = null;
		  var name = 'uniqueArrayOfType';

		  for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
		    rest[_key - 1] = arguments[_key];
		  }

		  if (rest.length === 1) {
		    if (typeof rest[0] === 'function') {
		      mapper = rest[0];
		    } else if (typeof rest[0] === 'string') {
		      name = rest[0];
		    } else {
		      throw new TypeError('single input must either be string or function');
		    }
		  } else if (rest.length === 2) {
		    if (typeof rest[0] === 'function' && typeof rest[1] === 'string') {
		      mapper = rest[0];
		      name = rest[1];
		    } else {
		      throw new TypeError('multiple inputs must be in [function, string] order');
		    }
		  } else if (rest.length > 2) {
		    throw new TypeError('only [], [name], [mapper], and [mapper, name] are valid inputs');
		  }

		  function uniqueArrayOfMapped(props, propName) {
		    var propValue = props[propName];

		    if (propValue == null) {
		      return null;
		    }

		    var values = propValue.map(mapper);

		    for (var _len2 = arguments.length, args = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
		      args[_key2 - 2] = arguments[_key2];
		    }

		    return unique.apply(void 0, [_objectSpread(_objectSpread({}, props), {}, _defineProperty({}, propName, values)), propName].concat(args));
		  }

		  uniqueArrayOfMapped.isRequired = function isRequired(props, propName) {
		    var propValue = props[propName];

		    for (var _len3 = arguments.length, args = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
		      args[_key3 - 2] = arguments[_key3];
		    }

		    if (propValue == null) {
		      return _propTypes.array.isRequired.apply(_propTypes.array, [props, propName].concat(args));
		    }

		    return uniqueArrayOfMapped.apply(void 0, [props, propName].concat(args));
		  };

		  var arrayValidator = (0, _propTypes.arrayOf)(type);
		  var uniqueValidator = mapper ? uniqueArrayOfMapped : unique;
		  var validator = (0, _and["default"])([arrayValidator, uniqueValidator], name);
		  validator.isRequired = (0, _and["default"])([uniqueValidator.isRequired, arrayValidator.isRequired], "".concat(name, ".isRequired"));
		  return validator;
		}
		
	} (uniqueArrayOf));
	return uniqueArrayOf;
}

var build;
var hasRequiredBuild;

function requireBuild () {
	if (hasRequiredBuild) return build;
	hasRequiredBuild = 1;

	var _propTypesExact = _interopRequireDefault(requireBuild$1());

	var _and = _interopRequireDefault(requireAnd());

	var _between = _interopRequireDefault(requireBetween());

	var _booleanSome = _interopRequireDefault(requireBooleanSome());

	var _childrenHavePropXorChildren = _interopRequireDefault(requireChildrenHavePropXorChildren());

	var _childrenOf = _interopRequireDefault(requireChildrenOf());

	var _childrenOfType = _interopRequireDefault(requireChildrenOfType());

	var _childrenSequenceOf = _interopRequireDefault(requireChildrenSequenceOf());

	var _componentWithName = _interopRequireDefault(requireComponentWithName());

	var _disallowedIf = _interopRequireDefault(requireDisallowedIf());

	var _elementType = _interopRequireDefault(requireElementType());

	var _empty = _interopRequireDefault(requireEmpty());

	var _explicitNull = _interopRequireDefault(requireExplicitNull());

	var _integer = _interopRequireDefault(requireInteger());

	var _keysOf = _interopRequireDefault(requireKeysOf());

	var _mutuallyExclusiveProps = _interopRequireDefault(requireMutuallyExclusiveProps());

	var _mutuallyExclusiveTrueProps = _interopRequireDefault(requireMutuallyExclusiveTrueProps());

	var _nChildren = _interopRequireDefault(requireNChildren());

	var _nonNegativeInteger = _interopRequireDefault(requireNonNegativeInteger());

	var _nonNegativeNumber = _interopRequireDefault(requireNonNegativeNumber());

	var _numericString = _interopRequireDefault(requireNumericString());

	var _object = _interopRequireDefault(requireObject());

	var _or = _interopRequireDefault(requireOr());

	var _predicate = _interopRequireDefault(requirePredicate());

	var _range = _interopRequireDefault(requireRange());

	var _ref = _interopRequireDefault(requireRef());

	var _requiredBy = _interopRequireDefault(requireRequiredBy());

	var _restrictedProp = _interopRequireDefault(requireRestrictedProp());

	var _sequenceOf = _interopRequireDefault(requireSequenceOf());

	var _shape = _interopRequireDefault(requireShape());

	var _stringEndsWith = _interopRequireDefault(requireStringEndsWith());

	var _stringStartsWith = _interopRequireDefault(requireStringStartsWith());

	var _uniqueArray = _interopRequireDefault(requireUniqueArray());

	var _uniqueArrayOf = _interopRequireDefault(requireUniqueArrayOf());

	var _valuesOf = _interopRequireDefault(requireValuesOf());

	var _withShape = _interopRequireDefault(requireWithShape());

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

	build = {
	  and: _and["default"],
	  between: _between["default"],
	  booleanSome: _booleanSome["default"],
	  childrenHavePropXorChildren: _childrenHavePropXorChildren["default"],
	  childrenOf: _childrenOf["default"],
	  childrenOfType: _childrenOfType["default"],
	  childrenSequenceOf: _childrenSequenceOf["default"],
	  componentWithName: _componentWithName["default"],
	  disallowedIf: _disallowedIf["default"],
	  elementType: _elementType["default"],
	  empty: _empty["default"],
	  explicitNull: _explicitNull["default"],
	  forbidExtraProps: _propTypesExact["default"],
	  integer: _integer["default"],
	  keysOf: _keysOf["default"],
	  mutuallyExclusiveProps: _mutuallyExclusiveProps["default"],
	  mutuallyExclusiveTrueProps: _mutuallyExclusiveTrueProps["default"],
	  nChildren: _nChildren["default"],
	  nonNegativeInteger: _nonNegativeInteger["default"],
	  nonNegativeNumber: _nonNegativeNumber["default"],
	  numericString: _numericString["default"],
	  object: _object["default"],
	  or: _or["default"],
	  predicate: _predicate["default"],
	  range: _range["default"],
	  ref: _ref["default"],
	  requiredBy: _requiredBy["default"],
	  restrictedProp: _restrictedProp["default"],
	  sequenceOf: _sequenceOf["default"],
	  shape: _shape["default"],
	  stringEndsWith: _stringEndsWith["default"],
	  stringStartsWith: _stringStartsWith["default"],
	  uniqueArray: _uniqueArray["default"],
	  uniqueArrayOf: _uniqueArrayOf["default"],
	  valuesOf: _valuesOf["default"],
	  withShape: _withShape["default"]
	};
	
	return build;
}

var airbnbPropTypes = process.env.NODE_ENV === 'production' ? requireMocks() : requireBuild();

var styles$z = {"flirt":"#7c1366","mosque":"#016b6a","texas":"#f9f6a5","amaranth":"#ee2c74","cardinal-pink":"#8c0448","trinidad":"#df3d0c","chestnut":"#bc4850","onahau":"#c3efff","burnt-sienna":"#ed6358","chathams-blue":"#17367d","mid-blue":"#1a347d","well-read":"#b8373e","wattle":"#d5e04d","beeswax":"#feeec7","bilbao":"#258b0b","sea-buckthorn":"#fbaf34","mint-tulip":"#c1f2e8","turquoise":"#39cdc9","hibiscus":"#c53a70","carousel-pink":"#fae6f4","white":"#fff","black":"#000","mortar":"#595959","gallery":"#efefef","silver":"#c9c8c8","dove":"#666666","iceberg":"#cbf0e8","icicle":"#e5f7fb","light-gray":"#fafafa","super-nova":"#fbaf33","expand-yellow":"#fee8b8","expand-yellow-light":"rgba(254, 232, 184, 0.5)","hero-pink":"#a6298c","base":"KDS_ExpandCollapse-modules__base___22j3F","containerFlexCollapse":"KDS_ExpandCollapse-modules__containerFlexCollapse___3DSfs","row":"KDS_ExpandCollapse-modules__row___1EfQL","column":"KDS_ExpandCollapse-modules__column___1C0MQ","item":"KDS_ExpandCollapse-modules__item___2wxEA","xs-1":"KDS_ExpandCollapse-modules__xs-1___R0ITl","xs-2":"KDS_ExpandCollapse-modules__xs-2___RxXBJ","xs-3":"KDS_ExpandCollapse-modules__xs-3___s2dRS","xs-4":"KDS_ExpandCollapse-modules__xs-4___3mTvw","sm-1":"KDS_ExpandCollapse-modules__sm-1___2quEc","sm-2":"KDS_ExpandCollapse-modules__sm-2___81-wS","sm-3":"KDS_ExpandCollapse-modules__sm-3___2NfyX","sm-4":"KDS_ExpandCollapse-modules__sm-4___2a9OX","md-1":"KDS_ExpandCollapse-modules__md-1___gjCb-","md-2":"KDS_ExpandCollapse-modules__md-2___leODK","md-3":"KDS_ExpandCollapse-modules__md-3___TqDXy","md-4":"KDS_ExpandCollapse-modules__md-4___1Ku17","lg-1":"KDS_ExpandCollapse-modules__lg-1___C3DiZ","lg-2":"KDS_ExpandCollapse-modules__lg-2___1o-tP","lg-3":"KDS_ExpandCollapse-modules__lg-3___3JTMs","lg-4":"KDS_ExpandCollapse-modules__lg-4___3lsqi","xl-1":"KDS_ExpandCollapse-modules__xl-1___d73JM","xl-2":"KDS_ExpandCollapse-modules__xl-2___1rWhE","xl-3":"KDS_ExpandCollapse-modules__xl-3___3WzuK","xl-4":"KDS_ExpandCollapse-modules__xl-4___3qtv9","tabBorder":"KDS_ExpandCollapse-modules__tabBorder___13FjY"};

/* eslint-disable react/no-unused-prop-types */

/**
 * Expandable content areas for use with the `ExpandCollapse` or `Accordion`
 *
 * _This component can only be accessed as a name-spaced component: `ExpandCollapse.Panel` or `Accordion.Panel`._
 */
var Panel$3 = function Panel(_ref) {
  var children = _ref.children,
    contentBackground = _ref.contentBackground;
  return /*#__PURE__*/React.createElement("div", {
    className: contentBackground ? styles$z.tabBorder : ''
  }, children);
};
Panel$3.propTypes = {
  /**
   * The identifier of the panel. Must be unique within the `ExpandCollapse` panels.
   */
  id: PropTypes.string.isRequired,
  /**
   * The title.
   */
  header: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  subheader: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  /**
   * The helper that appears above the panel.
   */
  helper: PropTypes.string,
  /**
   * The theme of the accordion.
   */
  theme: PropTypes.oneOf(['pink', 'pinkBlue', 'green', 'darkGreen', 'gray', 'lightGray', 'yellow', 'white', 'beeswax', 'yellowBlue', 'beeswaxBlue', 'beeswaxFlirt', 'blueGreen', undefined]),
  /**
   * Whether or not to disable the panel from being opened or closed.
   */
  disabled: PropTypes.bool,
  /**
   * A callback function to be invoked when the panel is opened or closed.
   *
   * @param {boolean} open Whether or not the panel is open or closed.
   */
  onToggle: PropTypes.func,
  /**
   * The content. Can be text, any HTML element, or any component.
   */
  children: PropTypes.node.isRequired,
  /**
   * Describes if the panelWrapper styles are applied. "plain" does not apply styles.
   */
  type: PropTypes.oneOf([undefined, 'plain']),
  /**
   * Toggles the panel's border radius between 4px (rounded) and 0px (sharp).
   */
  sharp: PropTypes.bool,
  /**
   * Colors for the panel border.  Must be from the list of available [`Colours`](#section-colours).
   */
  borderColor: PropTypes.string,
  /**
   * The icon size in pixels.
   */
  iconSize: PropTypes.oneOf([12, 14, 16, 24, 30, 40]),
  /**
   * Colors for the panel background.  Must be from the list of available [`Colours`](#section-colours).
   */
  backgroundColor: PropTypes.string,
  /**
   * Adds a vertical band of color to the left hand side of the Panel content
   */
  contentBackground: PropTypes.bool,
  /**
   * Adds a promotional Text below the panel header
   */
  promoText: PropTypes.string,
  /**
   * Adds a background color to promoText
   */
  promoTextTheme: PropTypes.oneOf(['pink', 'green', 'orange'])
};
Panel$3.defaultProps = {
  header: undefined,
  subheader: undefined,
  disabled: false,
  onToggle: undefined,
  helper: undefined,
  type: undefined,
  theme: undefined,
  sharp: false,
  borderColor: 'gallery',
  backgroundColor: 'white',
  iconSize: 16,
  contentBackground: false
};

var useWindowSize = function useWindowSize() {
  var throttlingDelay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 200;
  var _useState = useState({
      width: undefined,
      height: undefined
    }),
    _useState2 = _slicedToArray(_useState, 2),
    windowSize = _useState2[0],
    setWindowSize = _useState2[1];

  // throttle for performance
  var timer = useRef();
  useEffect(function () {
    var handleResize = function handleResize() {
      clearTimeout(timer.current);
      timer.current = setTimeout(function () {
        setWindowSize({
          width: window.innerWidth,
          height: window.innerHeight
        });
      }, throttlingDelay);
    };
    window.addEventListener('resize', handleResize);
    handleResize();
    return function () {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  return windowSize;
};

var _excluded$G = ["direction", "distance", "children"];
var defaultStyle$1 = function defaultStyle(timeout) {
  return {
    transition: "transform ".concat(timeout, "ms")
  };
};
var transitionStyles$1 = function transitionStyles(direction, distance) {
  var styles = {
    transform: "translate".concat(direction.toUpperCase(), "(").concat(distance, ")")
  };
  return {
    entering: styles,
    entered: styles
  };
};
var Translate = function Translate(_ref) {
  var direction = _ref.direction,
    distance = _ref.distance,
    children = _ref.children,
    rest = _objectWithoutProperties$1(_ref, _excluded$G);
  return /*#__PURE__*/React.createElement(Transition$1, rest, function (status) {
    return /*#__PURE__*/React.createElement("div", {
      style: _objectSpread2(_objectSpread2({}, defaultStyle$1(rest.timeout)), transitionStyles$1(direction, distance)[status])
    }, children());
  });
};
Translate.propTypes = {
  timeout: PropTypes.number.isRequired,
  direction: PropTypes.oneOf(['x', 'y']).isRequired,
  distance: PropTypes.string.isRequired,
  children: PropTypes.func.isRequired
};

var displayStyles = {"hide":"KDS_Display-modules__hide___2m-zT","invisible":"KDS_Display-modules__invisible___s0Zuo"};

var styles$y = {"flirt":"#7c1366","mosque":"#016b6a","texas":"#f9f6a5","amaranth":"#ee2c74","cardinal-pink":"#8c0448","trinidad":"#df3d0c","chestnut":"#bc4850","onahau":"#c3efff","burnt-sienna":"#ed6358","chathams-blue":"#17367d","mid-blue":"#1a347d","well-read":"#b8373e","wattle":"#d5e04d","beeswax":"KDS_PanelWrapper-modules__beeswax___2lNxU","bilbao":"#258b0b","sea-buckthorn":"#fbaf34","mint-tulip":"#c1f2e8","turquoise":"#39cdc9","hibiscus":"#c53a70","carousel-pink":"#fae6f4","white":"KDS_PanelWrapper-modules__white___1pEQ3","black":"#000","mortar":"#595959","gallery":"#efefef","silver":"#c9c8c8","dove":"#666666","iceberg":"#cbf0e8","icicle":"#e5f7fb","light-gray":"#fafafa","super-nova":"#fbaf33","expand-yellow":"#fee8b8","expand-yellow-light":"rgba(254, 232, 184, 0.5)","hero-pink":"#a6298c","fullwidth":"KDS_PanelWrapper-modules__fullwidth___1w4pt","header":"KDS_PanelWrapper-modules__header___3k3hV KDS_PanelWrapper-modules__fullwidth___1w4pt","headerContainer":"KDS_PanelWrapper-modules__headerContainer___q_Ot9","headerAlign":"KDS_PanelWrapper-modules__headerAlign___1XgoR KDS_PanelWrapper-modules__fullwidth___1w4pt","disabled":"KDS_PanelWrapper-modules__disabled___1dYrR","alignSelfFlexEnd":"KDS_PanelWrapper-modules__alignSelfFlexEnd___3lFKr","panelWrapper":"KDS_PanelWrapper-modules__panelWrapper___3aiwk","panelWrapper--sharp":"KDS_PanelWrapper-modules__panelWrapper--sharp___2WGgR","showFromMd":"KDS_PanelWrapper-modules__showFromMd___vKaDj","showUntilMd":"KDS_PanelWrapper-modules__showUntilMd___qRVz6","green":"KDS_PanelWrapper-modules__green___XAtvL","pink":"KDS_PanelWrapper-modules__pink___2ZnB9","pinkBlue":"KDS_PanelWrapper-modules__pinkBlue___sDpQ7","darkGreen":"KDS_PanelWrapper-modules__darkGreen___3bAfy","yellow":"KDS_PanelWrapper-modules__yellow___3zi79","beeswaxBlue":"KDS_PanelWrapper-modules__beeswaxBlue___2IB9k","beeswaxFlirt":"KDS_PanelWrapper-modules__beeswaxFlirt___2fhuv","lightGray":"KDS_PanelWrapper-modules__lightGray___3LFKq","gray":"KDS_PanelWrapper-modules__gray___UH5Zx","blueGreen":"KDS_PanelWrapper-modules__blueGreen___1BYsI","plainWrapper":"KDS_PanelWrapper-modules__plainWrapper___bT6lt","plainWrapperHeader":"KDS_PanelWrapper-modules__plainWrapperHeader___2D4N_","expandYellowDark":"KDS_PanelWrapper-modules__expandYellowDark___1Aa2h","expandYellowLight":"KDS_PanelWrapper-modules__expandYellowLight___3JCur","tabContainer":"KDS_PanelWrapper-modules__tabContainer___3l1_k","chevron":"KDS_PanelWrapper-modules__chevron___1R7Af","promoText-pink":"KDS_PanelWrapper-modules__promoText-pink___1wy4l","promoText-green":"KDS_PanelWrapper-modules__promoText-green___1UeVw","promoText-orange":"KDS_PanelWrapper-modules__promoText-orange___1gftk","promoTextContainer":"KDS_PanelWrapper-modules__promoTextContainer___389LR"};

var Chevron = function Chevron(_ref) {
  var disabled = _ref.disabled,
    hover = _ref.hover,
    open = _ref.open,
    size = _ref.size,
    iconTextSize = _ref.iconTextSize,
    iconSelfAlign = _ref.iconSelfAlign;
  return /*#__PURE__*/React.createElement("div", {
    className: joinClassNames(disabled ? displayStyles.invisible : undefined, styles$y.chevron),
    style: {
      '--self-align': iconSelfAlign
    }
  }, /*#__PURE__*/React.createElement(Translate, {
    timeout: 300,
    "in": hover,
    direction: "y",
    distance: open ? '-0.25rem' : '0.25rem'
  }, function () {
    return /*#__PURE__*/React.createElement(Text$2, {
      size: iconTextSize
    }, /*#__PURE__*/React.createElement(DecorativeIcon, {
      symbol: open ? 'chevronUp' : 'chevronDown',
      variant: "silver",
      size: size
    }));
  }));
};
Chevron.propTypes = {
  disabled: bool,
  hover: bool,
  open: bool,
  size: number,
  iconTextSize: oneOf(['base', 'small', 'medium', 'large']),
  iconSelfAlign: string
};
Chevron.defaultProps = {
  iconTextSize: 'large',
  iconSelfAlign: 'auto'
};

var HeaderSuperscript = function HeaderSuperscript(_ref) {
  var text = _ref.text;
  var t = text.replace('&trade;', "\u2122").replace('&reg;', "\xAE").split('^^').map(function (line, index) {
    if (line === '') {
      return '';
    }
    if (index % 2 === 0) {
      return line;
    }
    return /*#__PURE__*/React.createElement(Text$2.Sup, {
      key: line
    }, line);
  });
  return t;
};
HeaderSuperscript.propTypes = {
  text: string
};

var Header = function Header(_ref) {
  var header = _ref.header,
    subheader = _ref.subheader,
    headerVertical = _ref.headerVertical;
  return /*#__PURE__*/React.createElement("div", {
    className: styles$y.fullwidth
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column'
    }
  }, typeof header !== 'string' ? /*#__PURE__*/React.createElement(Box, {
    vertical: headerVertical
  }, header) : /*#__PURE__*/React.createElement(Text$2, {
    size: "medium"
  }, /*#__PURE__*/React.createElement(HeaderSuperscript, {
    text: header
  })), subheader && (typeof subheader !== 'string' ? /*#__PURE__*/React.createElement(Box, null, subheader) : /*#__PURE__*/React.createElement(Text$2, {
    size: "small"
  }, /*#__PURE__*/React.createElement(HeaderSuperscript, {
    text: subheader
  })))));
};
Header.propTypes = {
  header: node,
  subheader: node,
  headerVertical: number
};

var HeaderButton = function HeaderButton(_ref) {
  var panelId = _ref.panelId,
    panelPreHeader = _ref.panelPreHeader,
    panelHeader = _ref.panelHeader,
    panelSubHeader = _ref.panelSubHeader,
    panelPostHeader = _ref.panelPostHeader,
    panelDisabled = _ref.panelDisabled,
    onPanelClick = _ref.onPanelClick,
    helper = _ref.helper,
    theme = _ref.theme,
    borderRadius = _ref.borderRadius,
    type = _ref.type,
    iconSize = _ref.iconSize,
    headerInset = _ref.headerInset,
    headerVertical = _ref.headerVertical,
    iconTextSize = _ref.iconTextSize,
    iconSelfAlign = _ref.iconSelfAlign,
    open = _ref.open,
    promoText = _ref.promoText,
    promoTextTheme = _ref.promoTextTheme;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    hover = _useState2[0],
    setHover = _useState2[1];
  var mouseEnter = function mouseEnter() {
    setHover(true);
  };
  var mouseLeave = function mouseLeave() {
    setHover(false);
  };
  return /*#__PURE__*/React.createElement(Clickable, {
    onClick: onPanelClick,
    onMouseEnter: mouseEnter,
    onMouseLeave: mouseLeave,
    dangerouslyAddClassName: joinClassNames(styles$y.header, panelDisabled && styles$y.disabled, type !== 'plain' && styles$y[theme], type === 'plain' && styles$y.plainWrapper),
    dangerouslyAddStyle: {
      '--border-radius': borderRadius
    },
    disabled: panelDisabled,
    "aria-expanded": open,
    "aria-label": open ? 'Open' : 'Closed',
    "aria-labelledby": "panel-".concat(panelId)
  }, !type && helper && /*#__PURE__*/React.createElement("div", {
    className: styles$y[theme]
  }, helper), type === 'plain' ? /*#__PURE__*/React.createElement(Box, {
    inline: true,
    between: 2,
    dangerouslyAddClassName: styles$y.headerContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$y.plainWrapperHeader,
    id: "panel-".concat(panelId)
  }, /*#__PURE__*/React.createElement(Text$2, null, /*#__PURE__*/React.createElement(HeaderSuperscript, {
    text: panelHeader
  }))), /*#__PURE__*/React.createElement(Chevron, {
    disabled: panelDisabled,
    hover: hover,
    open: open,
    size: 12
  })) : /*#__PURE__*/React.createElement(Box, {
    inset: headerInset,
    between: 3
  }, panelPreHeader, /*#__PURE__*/React.createElement(Box, {
    inline: true,
    between: 3,
    dangerouslyAddClassName: styles$y.headerContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$y.headerAlign
  }, panelHeader && /*#__PURE__*/React.createElement(Header, {
    header: panelHeader,
    subheader: panelSubHeader,
    headerVertical: headerVertical
  }), /*#__PURE__*/React.createElement(Chevron, {
    disabled: panelDisabled,
    hover: hover,
    open: open,
    size: iconSize,
    iconTextSize: iconTextSize,
    iconSelfAlign: iconSelfAlign
  }))), panelPostHeader), promoText && /*#__PURE__*/React.createElement(Box, {
    dangerouslyAddClassName: joinClassNames(styles$y.promoTextContainer, styles$y["promoText-".concat(promoTextTheme)])
  }, promoText));
};
HeaderButton.propTypes = {
  panelId: string.isRequired,
  onPanelClick: func.isRequired,
  panelPreHeader: node,
  panelHeader: oneOfType([string, object$1]),
  panelSubHeader: oneOfType([string, object$1]),
  panelPostHeader: node,
  panelDisabled: bool,
  helper: string,
  theme: oneOf(['pink', 'pinkBlue', 'green', 'darkGreen', 'gray', 'lightGray', 'yellow', 'white', 'yellowBlue', 'expandYellowDark', 'expandYellowLight', 'beeswaxBlue', 'beeswaxFlirt', 'blueGreen', undefined]),
  type: string,
  iconSize: oneOf([12, 14, 16, 24, 30, 40]),
  headerInset: number,
  headerVertical: number,
  iconTextSize: string,
  iconSelfAlign: string,
  open: bool,
  borderRadius: string,
  promoText: oneOfType([string, object$1]),
  promoTextTheme: oneOf(['pink', 'green', 'orange', undefined])
};
HeaderButton.defaultProps = {
  panelPreHeader: undefined,
  panelHeader: undefined,
  panelSubHeader: undefined,
  panelPostHeader: undefined,
  panelDisabled: false,
  helper: undefined,
  type: undefined,
  theme: undefined,
  iconSize: 16,
  headerInset: 3,
  headerVertical: 3,
  iconTextSize: 'large',
  iconSelfAlign: 'auto',
  open: false,
  borderRadius: '3px',
  promoText: undefined
};

var PanelIdsContext = /*#__PURE__*/React.createContext({
  open: undefined,
  togglePanel: function togglePanel() {}
});

var PanelWrapper$3 = function PanelWrapper(_ref) {
  var panelId = _ref.panelId,
    panelPreHeader = _ref.panelPreHeader,
    panelHeader = _ref.panelHeader,
    panelSubHeader = _ref.panelSubHeader,
    panelPostHeader = _ref.panelPostHeader,
    panelDisabled = _ref.panelDisabled,
    tag = _ref.tag,
    children = _ref.children,
    helper = _ref.helper,
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? 'green' : _ref$theme,
    type = _ref.type,
    iconSize = _ref.iconSize,
    headerInset = _ref.headerInset,
    headerVertical = _ref.headerVertical,
    panelVertical = _ref.panelVertical,
    sharp = _ref.sharp,
    borderColor = _ref.borderColor,
    borderRadius = _ref.borderRadius,
    backgroundColor = _ref.backgroundColor,
    contentBackground = _ref.contentBackground,
    iconTextSize = _ref.iconTextSize,
    iconSelfAlign = _ref.iconSelfAlign,
    promoText = _ref.promoText,
    promoTextTheme = _ref.promoTextTheme;
  var _useContext = useContext(PanelIdsContext),
    openPanelIds = _useContext.open,
    onClick = _useContext.togglePanel,
    parentType = _useContext.parentType;
  var open = parentType === 'accordion' ? openPanelIds === panelId : openPanelIds.includes(panelId);
  var contentWrapper = useRef();
  var onPanelClick = function onPanelClick() {
    if (onClick) onClick(panelId);
  };
  var headerButton = /*#__PURE__*/React.createElement(HeaderButton, {
    onPanelClick: onPanelClick,
    panelId: panelId,
    panelPreHeader: panelPreHeader,
    panelHeader: panelHeader,
    panelSubHeader: panelSubHeader,
    panelPostHeader: panelPostHeader,
    panelDisabled: panelDisabled,
    tag: tag,
    helper: helper,
    theme: theme,
    type: type,
    iconSize: iconSize,
    headerInset: headerInset,
    headerVertical: headerVertical,
    iconTextSize: iconTextSize,
    iconSelfAlign: iconSelfAlign,
    open: open,
    borderRadius: borderRadius,
    promoText: promoText,
    promoTextTheme: promoTextTheme
  });
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": panelId,
    className: joinClassNames(type !== 'plain' && styles$y.panelWrapper, sharp ? styles$y['panelWrapper--sharp'] : ''),
    style: {
      '--border-color': "var(--color-".concat(borderColor, ")"),
      '--border-radius': borderRadius,
      '--background-color': "var(--color-".concat(backgroundColor, ")")
    }
  }, /*#__PURE__*/React.createElement("div", null, tag ? /*#__PURE__*/React.createElement(tag, {
    'data-testid': 'headerWrapper'
  }, headerButton) : headerButton, /*#__PURE__*/React.createElement(Reveal, {
    timeout: open ? 500 : 0,
    duration: 500,
    "in": open,
    height: contentWrapper !== null && contentWrapper !== void 0 && contentWrapper.current ? contentWrapper.current.offsetHeight : 0
  }, function () {
    return /*#__PURE__*/React.createElement("div", {
      ref: contentWrapper,
      "data-testid": "content",
      className: contentBackground ? styles$y.tabContainer : ''
    }, /*#__PURE__*/React.createElement(Box, {
      horizontal: 3,
      vertical: panelVertical
    }, children));
  })));
};
PanelWrapper$3.propTypes = {
  panelId: string.isRequired,
  panelPreHeader: node,
  panelHeader: oneOfType([string, object$1]),
  panelSubHeader: oneOfType([string, object$1]),
  panelPostHeader: node,
  panelDisabled: bool,
  tag: oneOf(['h1', 'h2', 'h3', 'h4']),
  children: airbnbPropTypes.childrenOfType(Panel$3).isRequired,
  helper: string,
  theme: oneOf(['pink', 'pinkBlue', 'green', 'darkGreen', 'gray', 'lightGray', 'yellow', 'white', 'yellowBlue', 'expandYellowDark', 'expandYellowLight', 'beeswaxBlue', 'beeswaxFlirt', 'blueGreen', undefined]),
  type: string,
  sharp: bool,
  borderColor: string,
  borderRadius: string,
  iconSize: oneOf([12, 14, 16, 24, 30, 40]),
  headerInset: number,
  headerVertical: number,
  panelVertical: number,
  backgroundColor: string,
  contentBackground: bool,
  iconTextSize: string,
  iconSelfAlign: string,
  promoText: string,
  promoTextTheme: oneOf(['green', 'pink', 'orange'])
};
PanelWrapper$3.defaultProps = {
  panelPreHeader: undefined,
  panelHeader: undefined,
  panelSubHeader: undefined,
  panelPostHeader: undefined,
  panelDisabled: false,
  tag: undefined,
  helper: undefined,
  type: undefined,
  theme: undefined,
  sharp: false,
  borderColor: 'gallery',
  borderRadius: '4px',
  iconSize: 16,
  headerInset: 3,
  headerVertical: 3,
  panelVertical: 3,
  backgroundColor: 'white',
  contentBackground: false,
  iconTextSize: 'large',
  iconSelfAlign: 'auto',
  promoText: undefined,
  promoTextTheme: 'green'
};

var _excluded$F = ["open", "togglePanel", "tag", "children", "xsColumn", "smColumn", "mdColumn", "lgColumn", "xlColumn", "contentBackground"];
var AlternateLayout = function AlternateLayout(_ref) {
  var open = _ref.open,
    togglePanel = _ref.togglePanel,
    tag = _ref.tag,
    children = _ref.children,
    xsColumn = _ref.xsColumn,
    smColumn = _ref.smColumn,
    mdColumn = _ref.mdColumn,
    lgColumn = _ref.lgColumn,
    xlColumn = _ref.xlColumn,
    contentBackground = _ref.contentBackground,
    rest = _objectWithoutProperties$1(_ref, _excluded$F);
  var _useWindowSize = useWindowSize(),
    width = _useWindowSize.width;
  var _useMemo = useMemo(function () {
      var panelItems = React.Children.toArray(children);
      var classNameToReturn = [styles$z.column, styles$z["xs-".concat(xsColumn)], styles$z["sm-".concat(smColumn)], styles$z["md-".concat(mdColumn)], styles$z["lg-".concat(lgColumn)], styles$z["xl-".concat(xlColumn)]].join(' ');
      var themeOptions = ['expandYellowDark', 'expandYellowLight'];
      var currentThemeIndex = 0;
      var columnsPerRow = xsColumn;
      var _getBreakpoints = getBreakpoints(breakpoints$1),
        sm = _getBreakpoints.sm,
        md = _getBreakpoints.md,
        lg = _getBreakpoints.lg,
        xl = _getBreakpoints.xl;
      switch (true) {
        case width > sm.lower && width <= sm.upper:
          columnsPerRow = smColumn;
          break;
        case width > md.lower && width <= md.upper:
          columnsPerRow = mdColumn;
          break;
        case width > lg.lower && width <= lg.upper:
          columnsPerRow = lgColumn;
          break;
        case width > xl.lower:
          columnsPerRow = xlColumn;
          break;
      }
      var colsToReturn = [];
      var numRows = Math.ceil(panelItems.length / columnsPerRow);
      for (var j = 0; j < columnsPerRow; j += 1) {
        colsToReturn[j] = [];
        for (var i = 0; i < numRows; i += 1) {
          var panelIndex = j + i * columnsPerRow;
          if (panelItems[panelIndex]) {
            colsToReturn[j][i] = {
              item: panelItems[panelIndex],
              theme: themeOptions[currentThemeIndex]
            };
          }
          if (i < numRows - 1) {
            currentThemeIndex = Math.abs(currentThemeIndex - 1);
          } else {
            var _colsToReturn$j$;
            var lastStartIndex = themeOptions.indexOf((_colsToReturn$j$ = colsToReturn[j][0]) === null || _colsToReturn$j$ === void 0 ? void 0 : _colsToReturn$j$.theme);
            currentThemeIndex = Math.abs(lastStartIndex - 1);
          }
        }
      }
      return {
        className: classNameToReturn,
        columnsToReturn: colsToReturn
      };
    }, [width, xsColumn, smColumn, mdColumn, lgColumn, xlColumn, children]),
    className = _useMemo.className,
    columnsToReturn = _useMemo.columnsToReturn;
  return /*#__PURE__*/React.createElement("div", _extends$1({}, safeRest(rest), {
    className: styles$z.row
  }), columnsToReturn.map(function (col, index) {
    return (
      /*#__PURE__*/
      // eslint-disable-next-line react/no-array-index-key
      React.createElement("div", {
        className: className,
        key: "col-".concat(index)
      }, col.map(function (row) {
        var _row$item$props = row.item.props,
          id = _row$item$props.id,
          header = _row$item$props.header,
          subheader = _row$item$props.subheader,
          disabled = _row$item$props.disabled,
          onToggle = _row$item$props.onToggle,
          helper = _row$item$props.helper,
          type = _row$item$props.type,
          sharp = _row$item$props.sharp,
          borderColor = _row$item$props.borderColor,
          iconSize = _row$item$props.iconSize,
          headerInset = _row$item$props.headerInset,
          backgroundColor = _row$item$props.backgroundColor,
          theme = _row$item$props.theme,
          promoText = _row$item$props.promoText,
          promoTextTheme = _row$item$props.promoTextTheme;
        return /*#__PURE__*/React.createElement("div", {
          key: id,
          className: styles$z.item
        }, /*#__PURE__*/React.createElement(PanelWrapper$3, {
          panelId: id,
          panelHeader: header,
          panelSubHeader: subheader,
          panelOnToggle: onToggle,
          panelDisabled: disabled,
          tag: tag,
          open: open,
          onClick: togglePanel,
          helper: helper,
          theme: theme || row.theme,
          type: type,
          sharp: sharp,
          borderColor: borderColor,
          backgroundColor: backgroundColor,
          iconSize: iconSize,
          headerInset: headerInset,
          promoText: promoText,
          promoTextTheme: promoTextTheme
        }, /*#__PURE__*/React.cloneElement(row.item, {
          contentBackground: contentBackground
        })));
      }))
    );
  }));
};
AlternateLayout.propTypes = {
  open: oneOfType([string, arrayOf(string)]),
  togglePanel: func,
  children: airbnbPropTypes.childrenOfType(Panel$3).isRequired,
  tag: oneOf(['h1', 'h2', 'h3', 'h4']),
  xsColumn: number,
  smColumn: number,
  mdColumn: number,
  lgColumn: number,
  xlColumn: number,
  contentBackground: boolean
};
AlternateLayout.defaultProps = {
  tag: undefined,
  xsColumn: 1,
  smColumn: 1,
  mdColumn: 2,
  lgColumn: 2,
  xlColumn: 2,
  contentBackground: false
};

var _excluded$E = ["open", "tag", "children", "contentBackground"];
var StandardLayout = function StandardLayout(_ref) {
  var open = _ref.open,
    tag = _ref.tag,
    children = _ref.children,
    contentBackground = _ref.contentBackground,
    rest = _objectWithoutProperties$1(_ref, _excluded$E);
  return /*#__PURE__*/React.createElement("div", _extends$1({}, safeRest(rest), {
    className: styles$z.base
  }), /*#__PURE__*/React.createElement(Box, {
    between: 3
  }, React.Children.toArray(children).filter(Boolean).map(function (panel, index) {
    var _panel$props = panel.props,
      id = _panel$props.id,
      panelPreHeader = _panel$props.panelPreHeader,
      header = _panel$props.header,
      subheader = _panel$props.subheader,
      panelPostHeader = _panel$props.panelPostHeader,
      disabled = _panel$props.disabled,
      helper = _panel$props.helper,
      _panel$props$theme = _panel$props.theme,
      theme = _panel$props$theme === void 0 ? 'green' : _panel$props$theme,
      type = _panel$props.type,
      sharp = _panel$props.sharp,
      borderColor = _panel$props.borderColor,
      borderRadius = _panel$props.borderRadius,
      backgroundColor = _panel$props.backgroundColor,
      iconSize = _panel$props.iconSize,
      headerInset = _panel$props.headerInset,
      headerVertical = _panel$props.headerVertical,
      panelVertical = _panel$props.panelVertical,
      iconTextSize = _panel$props.iconTextSize,
      iconSelfAlign = _panel$props.iconSelfAlign,
      promoText = _panel$props.promoText,
      promoTextTheme = _panel$props.promoTextTheme;
    return /*#__PURE__*/React.createElement(PanelWrapper$3, {
      key: id,
      panelId: id,
      index: index,
      panelPreHeader: panelPreHeader,
      panelHeader: header,
      panelSubHeader: subheader,
      panelPostHeader: panelPostHeader,
      panelDisabled: disabled,
      tag: tag,
      open: open,
      helper: helper,
      theme: theme,
      type: type,
      sharp: sharp,
      borderColor: borderColor,
      borderRadius: borderRadius,
      backgroundColor: backgroundColor,
      iconSize: iconSize,
      headerInset: headerInset,
      headerVertical: headerVertical,
      panelVertical: panelVertical,
      contentBackground: contentBackground,
      iconTextSize: iconTextSize,
      iconSelfAlign: iconSelfAlign,
      promoText: promoText,
      promoTextTheme: promoTextTheme
    }, /*#__PURE__*/React.cloneElement(panel, {
      contentBackground: contentBackground
    }));
  })));
};
StandardLayout.propTypes = {
  open: oneOfType([string, arrayOf(string)]),
  children: airbnbPropTypes.childrenOfType(Panel$3).isRequired,
  tag: oneOf(['h1', 'h2', 'h3', 'h4']),
  contentBackground: PropTypes.bool
};
StandardLayout.defaultProps = {
  tag: undefined,
  contentBackground: false
};

var _excluded$D = ["themeAlternate", "open", "togglePanel", "parentType", "xsColumn", "smColumn", "mdColumn", "lgColumn", "xlColumn"];
var PanelListContainer = function PanelListContainer(_ref) {
  var themeAlternate = _ref.themeAlternate,
    open = _ref.open,
    togglePanel = _ref.togglePanel,
    parentType = _ref.parentType,
    xsColumn = _ref.xsColumn,
    smColumn = _ref.smColumn,
    mdColumn = _ref.mdColumn,
    lgColumn = _ref.lgColumn,
    xlColumn = _ref.xlColumn,
    rest = _objectWithoutProperties$1(_ref, _excluded$D);
  var themeComponent = themeAlternate ? /*#__PURE__*/React.createElement(AlternateLayout, _extends$1({}, rest, {
    xsColumn: xsColumn,
    smColumn: smColumn,
    mdColumn: mdColumn,
    lgColumn: lgColumn,
    xlColumn: xlColumn
  })) : /*#__PURE__*/React.createElement(StandardLayout, rest);
  return (
    /*#__PURE__*/
    // eslint-disable-next-line react/jsx-no-constructed-context-values
    React.createElement(PanelIdsContext.Provider, {
      value: {
        open: open,
        togglePanel: togglePanel,
        parentType: parentType
      }
    }, themeComponent)
  );
};
PanelListContainer.propTypes = {
  open: oneOfType([string, arrayOf(string)]),
  parentType: oneOf(['accordion', 'expand-collapse']),
  themeAlternate: bool,
  togglePanel: func,
  xsColumn: number,
  smColumn: number,
  mdColumn: number,
  lgColumn: number,
  xlColumn: number
};

var _excluded$C = ["tag", "children", "themeAlternate", "xsColumn", "smColumn", "mdColumn", "lgColumn", "xlColumn", "open", "onToggle"];

/**
 * A connected series of expandable content areas.
 */
var ExpandCollapse = function ExpandCollapse(_ref) {
  var tag = _ref.tag,
    children = _ref.children,
    themeAlternate = _ref.themeAlternate,
    xsColumn = _ref.xsColumn,
    smColumn = _ref.smColumn,
    mdColumn = _ref.mdColumn,
    lgColumn = _ref.lgColumn,
    xlColumn = _ref.xlColumn,
    _ref$open = _ref.open,
    openPanelIds = _ref$open === void 0 ? [] : _ref$open,
    onToggle = _ref.onToggle,
    rest = _objectWithoutProperties$1(_ref, _excluded$C);
  var _useState = useState(openPanelIds),
    _useState2 = _slicedToArray(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  var lastOpenRef = useRef(); // last state of open panels useful for onToggle

  useEffect(function () {
    setOpen(openPanelIds);
    // on prop change, re-initialize lastOpenRef
    lastOpenRef.current = undefined;
  }, [openPanelIds]);
  useEffect(function () {
    if (onToggle) {
      // open set on mount or prop change
      if (lastOpenRef.current === undefined) {
        // fire onToggle if `open` prop changes only if its non empty
        // only one argument to onToggle as there are no panel clicks on init
        if (open.length) onToggle(open);

        // set Reference to current state
        lastOpenRef.current = open;
      }
      // open set on panel click
      else if (lastOpenRef.current.length !== open.length) {
        // since ExpandCollapse stores array of panelIds
        // We need to compare arrays of current and last states
        // to determine what changed
        var _ref2 = lastOpenRef.current.length > open.length ? [open, lastOpenRef.current] : [lastOpenRef.current, open],
          _ref3 = _slicedToArray(_ref2, 2),
          smaller = _ref3[0],
          greater = _ref3[1];
        var diff = greater.find(function (id) {
          return !smaller.includes(id);
        });

        // fire on toggle with current state `open` and reference to what changed `diff`
        onToggle(open, diff);

        // set Reference to current state
        lastOpenRef.current = open;
      }
    }
  }, [open]);
  var togglePanel = function togglePanel(panelId) {
    var openSet = new Set(open);
    if (openSet.has(panelId)) {
      openSet["delete"](panelId);
    } else {
      openSet.add(panelId);
    }
    setOpen(Array.from(openSet));
  };
  return /*#__PURE__*/React.createElement(PanelListContainer, _extends$1({}, rest, {
    tag: tag,
    themeAlternate: themeAlternate,
    xsColumn: xsColumn,
    smColumn: smColumn,
    mdColumn: mdColumn,
    lgColumn: lgColumn,
    xlColumn: xlColumn,
    parentType: "expand-collapse",
    togglePanel: togglePanel,
    open: open
  }), children);
};
ExpandCollapse.propTypes = {
  /**
   * A list of panel identifiers to programmatically open.
   */
  open: PropTypes.arrayOf(PropTypes.string),
  /**
   * A callback function to be invoked when any panel is opened or closed.
   * Useful for purposes like analytics.
   * Has signature onToggle(openPanels, lastUpdate).
   * @param {Array} openPanels A list of the currently open panel identifiers.
   * @param {string|undefined} lastUpdate panelId of last toggled panel
   */
  onToggle: PropTypes.func,
  /**
   * Wrap each ExpandCollapse button in a heading tag. This adds context for screen readers, and does not affect text style.
   */
  tag: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4']),
  /**
   * The expandable panels. Must be at least one `ExpandCollapse.Panel`.
   */
  children: airbnbPropTypes.childrenOfType(Panel$3).isRequired,
  /**
   * Alternate Background Color theme.
   */
  themeAlternate: PropTypes.bool,
  xsColumn: PropTypes.number,
  smColumn: PropTypes.number,
  mdColumn: PropTypes.number,
  lgColumn: PropTypes.number,
  xlColumn: PropTypes.number,
  /**
  * Adds gray background color to content.
  */
  contentBackground: PropTypes.bool
};
ExpandCollapse.defaultProps = {
  open: [],
  tag: undefined,
  themeAlternate: false,
  xsColumn: 1,
  smColumn: 1,
  mdColumn: 2,
  lgColumn: 2,
  xlColumn: 2,
  contentBackground: false
};
ExpandCollapse.Panel = Panel$3;

var styles$x = {"flirt":"#7c1366","mosque":"#016b6a","texas":"#f9f6a5","amaranth":"#ee2c74","cardinal-pink":"#8c0448","trinidad":"#df3d0c","chestnut":"#bc4850","onahau":"#c3efff","burnt-sienna":"#ed6358","chathams-blue":"#17367d","mid-blue":"#1a347d","well-read":"#b8373e","wattle":"#d5e04d","beeswax":"#feeec7","bilbao":"#258b0b","sea-buckthorn":"#fbaf34","mint-tulip":"#c1f2e8","turquoise":"#39cdc9","hibiscus":"#c53a70","carousel-pink":"#fae6f4","white":"#fff","black":"#000","mortar":"#595959","gallery":"#efefef","silver":"#c9c8c8","dove":"#666666","iceberg":"#cbf0e8","icicle":"#e5f7fb","light-gray":"#fafafa","super-nova":"#fbaf33","expand-yellow":"#fee8b8","expand-yellow-light":"rgba(254, 232, 184, 0.5)","hero-pink":"#a6298c","reset":"KDS_HairlineDivider-modules__reset___2_iiR undefined KDS_Borders-modules__none___uTgzs","horizontal":"KDS_HairlineDivider-modules__horizontal___2xDCo KDS_HairlineDivider-modules__reset___2_iiR undefined KDS_Borders-modules__none___uTgzs","vertical":"KDS_HairlineDivider-modules__vertical___jGQ6H KDS_HairlineDivider-modules__reset___2_iiR undefined KDS_Borders-modules__none___uTgzs","horizontalThin":"KDS_HairlineDivider-modules__horizontalThin___nKpx8 KDS_HairlineDivider-modules__horizontal___2xDCo KDS_HairlineDivider-modules__reset___2_iiR undefined KDS_Borders-modules__none___uTgzs","verticalThin":"KDS_HairlineDivider-modules__verticalThin___18gN1 KDS_HairlineDivider-modules__vertical___jGQ6H KDS_HairlineDivider-modules__reset___2_iiR undefined KDS_Borders-modules__none___uTgzs"};

var _excluded$B = ["vertical"];
var getClassName$3 = function getClassName(vertical) {
  var hrClass;
  if (vertical) {
    hrClass = 'verticalThin';
  } else {
    hrClass = 'horizontalThin';
  }
  return hrClass;
};

/**
 * Separate content within modules.
 */
var HairlineDivider = function HairlineDivider(_ref) {
  var vertical = _ref.vertical,
    rest = _objectWithoutProperties$1(_ref, _excluded$B);
  return /*#__PURE__*/React.createElement("hr", _extends$1({}, safeRest(rest), {
    className: styles$x[getClassName$3(vertical)]
  }));
};
HairlineDivider.propTypes = {
  /**
   * Draw the divider vertically.
   */
  vertical: PropTypes.bool
};
HairlineDivider.defaultProps = {
  vertical: false
};

var styles$w = {"triColorHeroText":"KDS_Text-modules__triColorHeroText___18LPs","triColorHeroText--disableBottomMargin":"KDS_Text-modules__triColorHeroText--disableBottomMargin___19hT_"};

var _excluded$A = ["children", "className", "displayImageOnMobile"];

/**
 *
 * _This component can only be accessed as a name-spaced component: `HeroBanner.Text`._
 */

var Text$1 = function Text(_ref) {
  var children = _ref.children,
    className = _ref.className,
    displayImageOnMobile = _ref.displayImageOnMobile,
    rest = _objectWithoutProperties$1(_ref, _excluded$A);
  return /*#__PURE__*/React.createElement("div", _extends$1({
    className: "\n      ".concat(!className ? styles$w.triColorHeroText : className, "\n      ").concat(displayImageOnMobile ? styles$w['triColorHeroText--disableBottomMargin'] : '', "\n    ")
  }, safeRest(rest)), children);
};
Text$1.propTypes = {
  /** Content to be displayed within the text wrapper. Can be text, other components, or HTML elements. */
  children: PropTypes.node,
  /** Customize the styles used for hero variants */
  className: PropTypes.string,
  /** Used to remove bottom margin when Hero displays image on mobile */
  displayImageOnMobile: PropTypes.bool
};
Text$1.defaultProps = {
  children: undefined,
  className: undefined,
  displayImageOnMobile: false
};

var styles$v = {"triColorHeroImage":"KDS_Image-modules__triColorHeroImage___bWGZA"};

var _excluded$z = ["children", "displayImageOnMobile"];

/**
 *
 * _This component can only be accessed as a name-spaced component: `HeroBanner.Image`._
 */

var Image = function Image(_ref) {
  var children = _ref.children;
    _ref.displayImageOnMobile;
    var rest = _objectWithoutProperties$1(_ref, _excluded$z);
  return /*#__PURE__*/React.createElement("figure", _extends$1({
    className: styles$v.triColorHeroImage
  }, safeRest(rest)), children);
};
Image.propTypes = {
  children: PropTypes.node.isRequired,
  displayImageOnMobile: PropTypes.bool
};
Image.defaultProps = {
  displayImageOnMobile: false
};

var styles$u = {"triColorHeroLabel":"KDS_Label-modules__triColorHeroLabel___e-7GP"};

var _excluded$y = ["color", "children"];

/**
 *
 * _This component can only be accessed as a name-spaced component: `HeroBanner.Label`._
 */

var Label = function Label(_ref) {
  var color = _ref.color,
    children = _ref.children,
    rest = _objectWithoutProperties$1(_ref, _excluded$y);
  return /*#__PURE__*/React.createElement("div", _extends$1({
    style: {
      '--font-color': "var(--color-".concat(color, ")")
    }
  }, safeRest(rest)), /*#__PURE__*/React.createElement(Text$1, {
    className: styles$u.triColorHeroLabel
  }, children));
};
Label.propTypes = {
  /** Content to be displayed within the label. */
  children: PropTypes.string.isRequired,
  /** Variant */
  color: PropTypes.string
};
Label.defaultProps = {
  color: 'flirt'
};

var styles$t = {"triColorHero":"KDS_HeroBanner-modules__triColorHero___1eNRR","triColorHero__wrapper":"KDS_HeroBanner-modules__triColorHero__wrapper___2uUB0","triColorHero__container":"KDS_HeroBanner-modules__triColorHero__container___38Awe","triColorHero--disableBottomPadding":"KDS_HeroBanner-modules__triColorHero--disableBottomPadding___2F9Uj","triColorHero--label":"KDS_HeroBanner-modules__triColorHero--label___I-86l","triColorHero--mobileImage":"KDS_HeroBanner-modules__triColorHero--mobileImage___1HH8s"};

var _excluded$x = ["backgroundColors", "children", "disableBottomPadding", "displayImageOnMobile"];
var HeroBanner = function HeroBanner(_ref) {
  var backgroundColors = _ref.backgroundColors,
    children = _ref.children,
    disableBottomPadding = _ref.disableBottomPadding,
    displayImageOnMobile = _ref.displayImageOnMobile,
    rest = _objectWithoutProperties$1(_ref, _excluded$x);
  // check if a label was included in children
  // if so, render hero to support breadcrumb style label
  var label = React.Children.map(children, function (child) {
    return child && child.type === Label ? child : null;
  });
  var hasLabel = label.length > 0;
  return /*#__PURE__*/React.createElement("div", _extends$1({
    className: "".concat(styles$t.triColorHero__wrapper),
    style: {
      '--bg-color-one': "var(--color-".concat(backgroundColors[0] || 'beeswax', ")"),
      '--bg-color-two': "var(--color-".concat(backgroundColors[1] || 'wattle', ")"),
      '--bg-color-three': "var(--color-".concat(backgroundColors[2] || 'flirt', ")")
    }
  }, safeRest(rest)), /*#__PURE__*/React.createElement("div", {
    className: "\n          ".concat(styles$t.triColorHero, "\n          ").concat(disableBottomPadding ? styles$t['triColorHero--disableBottomPadding'] : '', "\n          ").concat(hasLabel ? styles$t['triColorHero--label'] : '', "\n          ").concat(displayImageOnMobile ? styles$t['triColorHero--mobileImage'] : '', "\n          ")
  }, /*#__PURE__*/React.createElement(FlexGrid, {
    limitWidth: true
  }, /*#__PURE__*/React.createElement(FlexGrid.Row, null, /*#__PURE__*/React.createElement(FlexGrid.Col, null, label && /*#__PURE__*/React.createElement("div", {
    className: styles$t.triColorHero__label
  }, label), /*#__PURE__*/React.createElement("div", {
    className: styles$t.triColorHero__container
  }, React.Children.map(children, function (child) {
    // exclude any labels
    if (child && child.type === Label) return null;
    // pass props to other hero components
    if (child && (child.type === Text$1 || child.type === Image)) return /*#__PURE__*/React.cloneElement(child, {
      displayImageOnMobile: displayImageOnMobile
    });
    return child;
  })))))));
};
HeroBanner.propTypes = {
  /** Three colors used for the background. Colors must be from the list of available [`Colours`](#section-colours). */
  backgroundColors: PropTypes.array,
  /** Used to remove the bottom padding to allow images to extend to bottom of container. */
  disableBottomPadding: PropTypes.bool,
  /** Content to be displayed within the hero banner. */
  children: PropTypes.node.isRequired,
  /** Content to be displayed within the hero banner. */
  displayImageOnMobile: PropTypes.bool
};
HeroBanner.defaultProps = {
  backgroundColors: ['beeswax', 'wattle', 'flirt'],
  disableBottomPadding: false,
  displayImageOnMobile: false
};
HeroBanner.Text = Text$1;
HeroBanner.Image = Image;
HeroBanner.Label = Label;

// Returns a selector for requested prop kinds as well as the propTypes for
// those props merged into one object
function selectSystemProps(systemPropHelpers) {
  var selectProps = function selectProps(props) {
    return systemPropHelpers.reduce(function (acc, propHelper) {
      if (typeof (propHelper === null || propHelper === void 0 ? void 0 : propHelper.select) !== 'function') {
        throw new Error("An invalid system prop helper has been passed to 'selectSystemProps': prop selector ('.select') is missing in ".concat(propHelper));
      }
      return _objectSpread2(_objectSpread2({}, acc), propHelper.select(props));
    }, {});
  };
  var selectedPropTypes = systemPropHelpers.reduce(function (acc, propHelper) {
    if (!(propHelper !== null && propHelper !== void 0 && propHelper.types)) {
      throw new Error("An invalid system prop helper has been passed to 'selectSystemProps': types selector ('.types') is missing in ".concat(propHelper));
    }
    return _objectSpread2(_objectSpread2({}, acc), propHelper.types);
  }, {});
  return [selectProps, selectedPropTypes];
}

var htmlAttrTypes = {
  dataSet: PropTypes.object,
  id: PropTypes.string,
  // @todo figure out if we need to enum all the possible roles or maybe use
  // an npm package
  loading: PropTypes.oneOf(['eager', 'lazy']),
  role: PropTypes.string,
  src: PropTypes.string,
  tabIndex: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  testID: PropTypes.string,
  title: PropTypes.string
};
var htmlAttrs = {
  types: htmlAttrTypes,
  select: function select(props) {
    return Object.entries(props).reduce(function (items, _ref) {
      var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];
      return Object.keys(htmlAttrTypes).includes(key) || /^(data|aria)-/.test(key) ? _objectSpread2(_objectSpread2({}, items), {}, _defineProperty$1({}, key, value)) : items;
    }, {});
  }
};

var _excluded$w = ["xsSrc", "smSrc", "mdSrc", "lgSrc", "xlSrc", "fallbackSrc", "alt", "loading", "sizeByHeight"];
var _selectSystemProps$1 = selectSystemProps([htmlAttrs]),
  _selectSystemProps2$1 = _slicedToArray(_selectSystemProps$1, 2),
  selectProps$1 = _selectSystemProps2$1[0],
  selectedSystemPropTypes$1 = _selectSystemProps2$1[1];
var staticStyles = {
  sizeByHeight: {
    display: 'block',
    height: '100%'
  },
  sizeByWidth: {
    display: 'block',
    width: '100%'
  }
};
var _getBreakpoints = getBreakpoints(breakpoints$1),
  smBp = _getBreakpoints.sm.lower,
  mdBp = _getBreakpoints.md.lower,
  lgBp = _getBreakpoints.lg.lower,
  xlBp = _getBreakpoints.xl.lower;

/**
 * Provide different image sources for different screen sizes.
 */
var ResponsiveImage = function ResponsiveImage(_ref) {
  var xsSrc = _ref.xsSrc,
    smSrc = _ref.smSrc,
    mdSrc = _ref.mdSrc,
    lgSrc = _ref.lgSrc,
    xlSrc = _ref.xlSrc,
    fallbackSrc = _ref.fallbackSrc,
    alt = _ref.alt,
    _ref$loading = _ref.loading,
    loading = _ref$loading === void 0 ? 'eager' : _ref$loading,
    _ref$sizeByHeight = _ref.sizeByHeight,
    sizeByHeight = _ref$sizeByHeight === void 0 ? false : _ref$sizeByHeight,
    rest = _objectWithoutProperties$1(_ref, _excluded$w);
  var staticStylesBySize = sizeByHeight ? staticStyles.sizeByHeight : staticStyles.sizeByWidth;
  return /*#__PURE__*/React.createElement("picture", selectProps$1(rest), /*#__PURE__*/React.createElement("source", {
    srcSet: xlSrc,
    media: "(min-width: ".concat(xlBp, "px)")
  }), /*#__PURE__*/React.createElement("source", {
    srcSet: lgSrc,
    media: "(min-width: ".concat(lgBp, "px)")
  }), /*#__PURE__*/React.createElement("source", {
    srcSet: mdSrc,
    media: "(min-width: ".concat(mdBp, "px)")
  }), /*#__PURE__*/React.createElement("source", {
    srcSet: smSrc,
    media: "(min-width: ".concat(smBp, "px)")
  }), /*#__PURE__*/React.createElement("source", {
    srcSet: xsSrc,
    media: "(max-width: ".concat(smBp - 1, "px)")
  }), /*#__PURE__*/React.createElement("img", {
    src: fallbackSrc,
    alt: alt,
    style: staticStylesBySize,
    loading: loading
  }));
};
ResponsiveImage.propTypes = _objectSpread2(_objectSpread2({}, selectedSystemPropTypes$1), {}, {
  /**
   * The src attribute used for screen widths up to 575px
   */
  xsSrc: PropTypes.string.isRequired,
  /**
   * The src attribute used for screen widths greater than 576px
   */
  smSrc: PropTypes.string.isRequired,
  /**
   * The src attribute used for screen widths greater than 768px
   */
  mdSrc: PropTypes.string.isRequired,
  /**
   * The src attribute used for screen widths greater than 992px
   */
  lgSrc: PropTypes.string.isRequired,
  /**
   * The src attribute used for screen widths greater than 1200px
   */
  xlSrc: PropTypes.string.isRequired,
  /**
   * The src attribute used for browsers that don't support responsive images (InternetExplorer)
   */
  fallbackSrc: PropTypes.string.isRequired,
  /**
   * The alt attribute for the HTML img element. Setting this attribute to an empty string (alt="") indicates that this image is not a key part of the content, and that non-visual browsers may omit it from rendering.
   */
  alt: PropTypes.string.isRequired,
  /**
   * Loading strategy.
   * @default 'eager'
   * @see https://developer.mozilla.org/en-US/docs/Web/HTML/Element/img#attr-loading
   */
  loading: PropTypes.oneOf(['eager', 'lazy']),
  /**
   * Switches size dimension to height, default is false
   */
  sizeByHeight: PropTypes.bool
});
ResponsiveImage.defaultProps = {
  loading: 'eager',
  sizeByHeight: false
};

function isSvgUrl(url) {
  return !!url.match(/\.svg$/i);
}

function getOptimizedUrl(url, dimension, size, quality, disableRetina, supportsWebp) {
  if (!isSvgUrl(url)) {
    var format = '';
    if (supportsWebp) {
      format = 'fm=webp';
    } else if (url.match(/\.jpe?g$/i)) {
      format = 'fm=jpg&fl=progressive';
    }
    var optimizedUrl = "".concat(url, "?").concat(dimension, "=").concat(size, "&q=").concat(quality, "&").concat(format);
    if (!disableRetina) {
      optimizedUrl += ", ".concat(url, "?").concat(dimension, "=").concat(size * 2, "&q=").concat(quality, "&").concat(format, " 2x");
    }
    return optimizedUrl;
  }
  return url;
}

function getFallbackUrl(url, width, quality) {
  if (!isSvgUrl(url)) {
    return "".concat(url, "?w=").concat(width, "&q=").concat(quality);
  }
  return url;
}

var promise;

/**
 * Taken directly from Google developers guide on how to detect browser support for WebP.
 *
 * @see https://developers.google.com/speed/webp/faq#in_your_own_javascript
 * @return {Promise<boolean>}
 */
function hasWebpSupport() {
  // cache the result, so that this function runs only once
  if (!promise) {
    promise = new Promise(function (resolve) {
      // basic support. other test forms exist for lossless, alpha, and animation types.
      // check google guide if data strings are needed
      var lossy = 'UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA';
      var img = document.createElement('img');
      img.onload = function onLoad() {
        var result = img.width > 0 && img.height > 0;
        resolve(result);
      };
      img.onerror = function onError() {
        resolve(false);
      };
      img.src = "data:image/webp;base64,".concat(lossy);
    });
  }
  return promise;
}

var _excluded$v = ["contentfulAssetUrl", "alt", "quality", "xs", "sm", "md", "lg", "xl", "sizeByHeight", "disableRetina"];
var _selectSystemProps = selectSystemProps([htmlAttrs]),
  _selectSystemProps2 = _slicedToArray(_selectSystemProps, 2),
  selectProps = _selectSystemProps2[0],
  selectedSystemPropTypes = _selectSystemProps2[1];

/**
 * Used to optimize image files based on screen size.
 */
var OptimizeImage$1 = function OptimizeImage(_ref) {
  var contentfulAssetUrl = _ref.contentfulAssetUrl,
    alt = _ref.alt,
    quality = _ref.quality,
    xs = _ref.xs,
    sm = _ref.sm,
    md = _ref.md,
    lg = _ref.lg,
    xl = _ref.xl,
    sizeByHeight = _ref.sizeByHeight,
    disableRetina = _ref.disableRetina,
    rest = _objectWithoutProperties$1(_ref, _excluded$v);
  if (!isClient()) return null;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    imgUrls = _useState2[0],
    setImgUrls = _useState2[1];
  var dimension = sizeByHeight || rest.useHeight ? 'h' : 'w';
  useEffect(function () {
    // Currently not all browsers support webP
    hasWebpSupport().then(function (supportsWebp) {
      setImgUrls({
        xsSrc: getOptimizedUrl(contentfulAssetUrl, dimension, xs, quality, disableRetina, supportsWebp),
        smSrc: getOptimizedUrl(contentfulAssetUrl, dimension, sm, quality, disableRetina, supportsWebp),
        mdSrc: getOptimizedUrl(contentfulAssetUrl, dimension, md, quality, disableRetina, supportsWebp),
        lgSrc: getOptimizedUrl(contentfulAssetUrl, dimension, lg, quality, disableRetina, supportsWebp),
        xlSrc: getOptimizedUrl(contentfulAssetUrl, dimension, xl, quality, disableRetina, supportsWebp),
        fallbackSrc: getFallbackUrl(contentfulAssetUrl, xl, quality)
      });
    });
  }, [contentfulAssetUrl, dimension, disableRetina, lg, md, quality, sm, xl, xs]);
  if (!imgUrls) return null;
  return /*#__PURE__*/React.createElement(ResponsiveImage, _extends$1({}, imgUrls, {
    alt: alt,
    sizeByHeight: sizeByHeight
  }, selectProps(rest)));
};
OptimizeImage$1.propTypes = _objectSpread2(_objectSpread2({}, selectedSystemPropTypes), {}, {
  /**
   * The source to load the image. Only contentful image urls are supported. See https://www.contentful.com/developers/docs/references/images-api/ for details.
   */
  contentfulAssetUrl: PropTypes.string.isRequired,
  /**
   * Alternative text to display if image cannot be loaded or a screen reader is used.
   */
  alt: PropTypes.string.isRequired,
  /**
   * Customize quality as a percentage between 1 and 100.
   */
  quality: PropTypes.number,
  /**
   * Customize width for xs screen size in px, this may affect the quality of the image.
   */
  xs: PropTypes.number,
  /**
   * Customize width for sm screen size in px, this may affect the quality of the image.
   */
  sm: PropTypes.number,
  /**
   * Customize width for md screen size in px, this may affect the quality of the image.
   */
  md: PropTypes.number,
  /**
   * Customize width for lg screen size in px, this may affect the quality of the image.
   */
  lg: PropTypes.number,
  /**
   * Customize width for xl screen size in px, this may affect the quality of the image.
   */
  xl: PropTypes.number,
  /**
   * Switches size dimension to height, default is false
   */
  sizeByHeight: PropTypes.bool,
  /**
   * Turns off retina display functionality
   */
  disableRetina: PropTypes.bool,
  /**
   * Loading strategy.
   * @default 'eager'
   * @see https://developer.mozilla.org/en-US/docs/Web/HTML/Element/img#attr-loading
   */
  loading: PropTypes.oneOf(['eager', 'lazy'])
});
OptimizeImage$1.defaultProps = {
  quality: 80,
  xs: 320,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
  sizeByHeight: false,
  disableRetina: false,
  loading: 'eager'
};

var styles$s = {"flirt":"#7c1366","mosque":"#016b6a","texas":"#f9f6a5","amaranth":"#ee2c74","cardinal-pink":"#8c0448","trinidad":"#df3d0c","chestnut":"#bc4850","onahau":"#c3efff","burnt-sienna":"#ed6358","chathams-blue":"#17367d","mid-blue":"#1a347d","well-read":"#b8373e","wattle":"#d5e04d","beeswax":"#feeec7","bilbao":"#258b0b","sea-buckthorn":"#fbaf34","mint-tulip":"#c1f2e8","turquoise":"#39cdc9","hibiscus":"#c53a70","carousel-pink":"#fae6f4","white":"#fff","black":"#000","mortar":"#595959","gallery":"#efefef","silver":"#c9c8c8","dove":"#666666","iceberg":"#cbf0e8","icicle":"#e5f7fb","light-gray":"#fafafa","super-nova":"#fbaf33","expand-yellow":"#fee8b8","expand-yellow-light":"rgba(254, 232, 184, 0.5)","hero-pink":"#a6298c","slidesContainer":"KDS_ImageCarousel-modules__slidesContainer___1zppY","slideContainer":"KDS_ImageCarousel-modules__slideContainer___GcpeY","activeSlideContainer":"KDS_ImageCarousel-modules__activeSlideContainer___OrfZg","thumbnailsContainer":"KDS_ImageCarousel-modules__thumbnailsContainer___3ojq7","thumbnailContainer":"KDS_ImageCarousel-modules__thumbnailContainer___2obIr","thumbnail":"KDS_ImageCarousel-modules__thumbnail___19cVP","mobileThumbnail":"KDS_ImageCarousel-modules__mobileThumbnail___3F5Xq","mobileThumbnailActive":"KDS_ImageCarousel-modules__mobileThumbnailActive___3wW5O","thumbnailActive":"KDS_ImageCarousel-modules__thumbnailActive___2UuDY"};

var ImageCarousel = function ImageCarousel(_ref) {
  var imageSlides = _ref.imageSlides;
  var _useState = useState(imageSlides[0].id),
    _useState2 = _slicedToArray(_useState, 2),
    openSlideId = _useState2[0],
    setOpenSlideId = _useState2[1];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    touchStart = _useState4[0],
    setTouchStart = _useState4[1];
  var _useState5 = useState(0),
    _useState6 = _slicedToArray(_useState5, 2),
    touchEnd = _useState6[0],
    setTouchEnd = _useState6[1];
  useEffect(function () {
    setOpenSlideId(imageSlides[0].id);
  }, [imageSlides]);
  var toggleSlide = function toggleSlide(slideId) {
    setOpenSlideId(slideId);
  };
  var isSlideOpen = function isSlideOpen(slideId) {
    return openSlideId === slideId;
  };
  var activeSlide = imageSlides && imageSlides.find(function (slide) {
    return isSlideOpen(slide.id);
  });
  var minSwipeDistance = 20;
  var handleTouchEnd = function handleTouchEnd() {
    if (touchStart !== 0) {
      // Right swipe.
      if (touchStart - touchEnd > minSwipeDistance) {
        var next = imageSlides.indexOf(activeSlide) + 1;
        if (next === imageSlides.length) {
          next = 0;
        }
        toggleSlide(imageSlides[next].id);
        setTouchStart(0);
        // Left swipe.
      } else if (touchStart - touchEnd <= -minSwipeDistance) {
        var _next = imageSlides.indexOf(activeSlide) - 1;
        if (_next === -1) {
          _next = imageSlides.length - 1;
        }
        toggleSlide(imageSlides[_next].id);
        setTouchStart(0);
      }
    }
  };
  var handleTouchStart = function handleTouchStart(e) {
    if (typeof e.clientX !== 'undefined') {
      setTouchStart(e.clientX);
    } else {
      setTouchStart(e.touches[0].clientX);
    }
  };
  var handleTouchMove = function handleTouchMove(e) {
    if (typeof e.clientX !== 'undefined') {
      setTouchEnd(e.clientX);
      handleTouchEnd();
    } else {
      setTouchEnd(e.touches[0].clientX);
    }
  };
  var thumbnail = function thumbnail(item) {
    return /*#__PURE__*/React.createElement(Responsive, {
      key: item.id,
      minWidth: "lg"
    }, function (matches) {
      return matches ? /*#__PURE__*/React.createElement("div", {
        className: joinClassNames(styles$s.thumbnailContainer, isSlideOpen(item.id) ? styles$s.thumbnailActive : '')
      }, /*#__PURE__*/React.createElement(Clickable, {
        "aria-label": item.alt ? "".concat(item.alt, " thumbnail") : 'thumbnail',
        dangerouslyAddClassName: styles$s.thumbnail,
        onClick: function onClick() {
          return toggleSlide(item.id);
        }
      }, /*#__PURE__*/React.createElement("img", {
        src: item.url,
        alt: item.alt
      }))) : /*#__PURE__*/React.createElement(Clickable, {
        "aria-label": item.alt ? "".concat(item.alt, " thumbnail") : 'thumbnail',
        dangerouslyAddClassName: joinClassNames(styles$s.mobileThumbnail, isSlideOpen(item.id) ? styles$s.mobileThumbnailActive : ''),
        onClick: function onClick() {
          return toggleSlide(item.id);
        }
      }, item.id);
    });
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: styles$s.slidesContainer,
    role: "listbox",
    "aria-label": "Koodo Carousel Thumbnails"
  }, imageSlides && imageSlides.map(function (item) {
    return /*#__PURE__*/React.createElement("div", {
      key: item.id,
      className: joinClassNames(activeSlide === item ? styles$s.activeSlideContainer : '', styles$s.slideContainer),
      role: "option",
      "aria-hidden": activeSlide !== item,
      "aria-selected": activeSlide === item,
      onTouchStart: handleTouchStart,
      onTouchMove: handleTouchMove,
      onTouchEnd: handleTouchEnd,
      onMouseDown: handleTouchStart,
      onMouseMove: handleTouchMove,
      onMouseUp: handleTouchEnd
    }, /*#__PURE__*/React.createElement(OptimizeImage$1, {
      contentfulAssetUrl: item.url,
      alt: item.alt,
      sizeByHeight: true
    }));
  })), imageSlides && imageSlides.length > 1 && /*#__PURE__*/React.createElement("div", {
    className: styles$s.thumbnailsContainer
  }, imageSlides.map(function (item, key) {
    return thumbnail(item);
  })));
};
ImageCarousel.propTypes = {
  /**
   * Accepts an array of objects each of which contain the id, URL and alt text to be used for each slide.
   */
  imageSlides: PropTypes.arrayOf(PropTypes.shape({
    /** A unique ID for the slide. */
    id: PropTypes.string,
    /** Text to be used in the alt attribute. */
    alt: PropTypes.string,
    /** The image URL. */
    url: PropTypes.string
  })).isRequired
};

var styles$r = {"flirt":"#7c1366","mosque":"#016b6a","texas":"#f9f6a5","amaranth":"#ee2c74","cardinal-pink":"#8c0448","trinidad":"#df3d0c","chestnut":"#bc4850","onahau":"#c3efff","burnt-sienna":"#ed6358","chathams-blue":"#17367d","mid-blue":"#1a347d","well-read":"#b8373e","wattle":"#d5e04d","beeswax":"#feeec7","bilbao":"#258b0b","sea-buckthorn":"#fbaf34","mint-tulip":"#c1f2e8","turquoise":"#39cdc9","hibiscus":"#c53a70","carousel-pink":"#fae6f4","white":"#fff","black":"#000","mortar":"#595959","gallery":"#efefef","silver":"#c9c8c8","dove":"#666666","iceberg":"#cbf0e8","icicle":"#e5f7fb","light-gray":"#fafafa","super-nova":"#fbaf33","expand-yellow":"#fee8b8","expand-yellow-light":"rgba(254, 232, 184, 0.5)","hero-pink":"#a6298c","color-flirt":"#7c1366","color-mosque":"#016b6a","color-texas":"#f9f6a5","color-amaranth":"#ee2c74","color-cardinal-pink":"#8c0448","color-trinidad":"#df3d0c","color-chestnut":"#bc4850","color-onahau":"#c3efff","color-burnt-sienna":"#ed6358","color-chathams-blue":"#17367d","color-mid-blue":"#1a347d","color-well-read":"#b8373e","color-wattle":"#d5e04d","color-beeswax":"#feeec7","color-bilbao":"#258b0b","color-sea-buckthorn":"#fbaf34","color-mint-tulip":"#c1f2e8","color-turquoise":"#39cdc9","color-hibiscus":"#c53a70","color-carousel-pink":"#fae6f4","color-white":"#fff","color-black":"#000","color-mortar":"#595959","color-gallery":"#efefef","color-silver":"#c9c8c8","color-dove":"#666666","color-iceberg":"#cbf0e8","color-icicle":"#e5f7fb","color-light-gray":"#fafafa","color-super-nova":"#fbaf33","color-expand-yellow":"#fee8b8","color-expand-yellow-light":"rgba(254, 232, 184, 0.5)","color-hero-pink":"#a6298c"};

var getColorPropTypes = function getColorPropTypes() {
  return Object.keys(styles$r).map(function (key) {
    return key.slice(6);
  });
};

var iconWrapperStyles = {"fixLineHeight":"KDS_IconWrapper-modules__fixLineHeight___2aWbs"};

var styles$q = {"flirt":"#7c1366","mosque":"#016b6a","texas":"#f9f6a5","amaranth":"#ee2c74","cardinal-pink":"#8c0448","trinidad":"#df3d0c","chestnut":"#bc4850","onahau":"#c3efff","burnt-sienna":"#ed6358","chathams-blue":"#17367d","mid-blue":"#1a347d","well-read":"#b8373e","wattle":"#d5e04d","beeswax":"#feeec7","bilbao":"#258b0b","sea-buckthorn":"#fbaf34","mint-tulip":"#c1f2e8","turquoise":"#39cdc9","hibiscus":"#c53a70","carousel-pink":"#fae6f4","white":"#fff","black":"#000","mortar":"#595959","gallery":"#efefef","silver":"#c9c8c8","dove":"#666666","iceberg":"#cbf0e8","icicle":"#e5f7fb","light-gray":"#fafafa","super-nova":"#fbaf33","expand-yellow":"#fee8b8","expand-yellow-light":"rgba(254, 232, 184, 0.5)","hero-pink":"#a6298c","tooltip":"KDS_Tooltip-modules__tooltip___3LUc-","messageContainer":"KDS_Tooltip-modules__messageContainer___28wMW","messageContainer--left":"KDS_Tooltip-modules__messageContainer--left___2lotg","messageContainer--right":"KDS_Tooltip-modules__messageContainer--right___1xdLN","messageContainer--below":"KDS_Tooltip-modules__messageContainer--below___3OxfN","messageContainer--above":"KDS_Tooltip-modules__messageContainer--above___3KU4s","message":"KDS_Tooltip-modules__message___2OAEO","message--center":"KDS_Tooltip-modules__message--center___2sHc4","message--left":"KDS_Tooltip-modules__message--left___1dazQ","message--right":"KDS_Tooltip-modules__message--right___2ZCx6","message--below":"KDS_Tooltip-modules__message--below___3j6Ye","message--above":"KDS_Tooltip-modules__message--above___3nrpV","message--blueberryWhiteIce":"KDS_Tooltip-modules__message--blueberryWhiteIce___1IlNL","message--white":"KDS_Tooltip-modules__message--white___2thkm","message--gray":"KDS_Tooltip-modules__message--gray___3cAVc","message--overlay":"KDS_Tooltip-modules__message--overlay___3yB6s","sharp":"KDS_Tooltip-modules__sharp___TUw4A"};

var _excluded$u = ["children", "appearance", "extendMessageFrom", "positionMessageAbove", "theme", "width", "connectedFieldLabel", "triggerEventType", "closeDelay", "icon", "iconColor", "iconActiveColor", "iconSize", "sharp", "bindToParentWidth"];
var getTriggerA11yText = function getTriggerA11yText(connectedFieldLabel) {
  if (!connectedFieldLabel) {
    return 'Reveal additional information.';
  }
  return "Reveal additional information about ".concat(connectedFieldLabel, ".");
};
var getIds = function getIds(connectedFieldLabel) {
  var id = generateId(connectedFieldLabel, 'unknown-field');
  return {
    bubbleId: id.postfix('tooltip'),
    triggerId: id.postfix('trigger')
  };
};

/**
 * Provide an explanation or instructions for a form field that most users do not need.
 */
var Tooltip = function Tooltip(_ref) {
  var children = _ref.children,
    appearance = _ref.appearance,
    extendMessageFrom = _ref.extendMessageFrom,
    positionMessageAbove = _ref.positionMessageAbove,
    theme = _ref.theme,
    width = _ref.width,
    connectedFieldLabel = _ref.connectedFieldLabel,
    triggerEventType = _ref.triggerEventType,
    closeDelay = _ref.closeDelay,
    icon = _ref.icon,
    iconColor = _ref.iconColor,
    iconActiveColor = _ref.iconActiveColor,
    iconSize = _ref.iconSize,
    sharp = _ref.sharp,
    bindToParentWidth = _ref.bindToParentWidth,
    rest = _objectWithoutProperties$1(_ref, _excluded$u);
  var tooltipRef = useRef(null);
  var iconRef = useRef(null);
  var messageRef = useRef(null);
  var _useState = useState(undefined),
    _useState2 = _slicedToArray(_useState, 2),
    centerPosition = _useState2[0],
    setCenterPosition = _useState2[1];
  var _useState3 = useState(undefined),
    _useState4 = _slicedToArray(_useState3, 2),
    dynamicWidth = _useState4[0],
    setDynamicWidth = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    open = _useState6[0],
    setOpen = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    hovered = _useState8[0],
    setHovered = _useState8[1];
  var _useState9 = useState(undefined),
    _useState10 = _slicedToArray(_useState9, 2),
    tooltipMargin = _useState10[0],
    setTooltipMargin = _useState10[1];
  var _useState11 = useState(),
    _useState12 = _slicedToArray(_useState11, 2),
    triangleAnchor = _useState12[0],
    setTriangleAnchor = _useState12[1];
  var _getIds = getIds(connectedFieldLabel),
    bubbleId = _getIds.bubbleId,
    triggerId = _getIds.triggerId;
  var timeout = null;

  // generate class names
  var tooltipClass = joinClassNames(styles$q.tooltip, iconWrapperStyles.fixLineHeight);
  var getTooltipStyle = function getTooltipStyle() {
    var baseStyle = {
      '--trianglePosition': "".concat(triangleAnchor, "px"),
      '--tooltipPosition': "".concat(bindToParentWidth ? 'static' : 'relative')
    };
    if (open && appearance === 'inline' && !positionMessageAbove) return _objectSpread2(_objectSpread2({}, baseStyle), {}, {
      marginBottom: tooltipMargin
    });
    if (open && appearance === 'inline' && positionMessageAbove) return _objectSpread2(_objectSpread2({}, baseStyle), {}, {
      marginTop: tooltipMargin
    });
    return baseStyle;
  };
  var messageContainerClass = joinClassNames(styles$q.messageContainer, extendMessageFrom !== 'center' ? styles$q["messageContainer--".concat(extendMessageFrom)] : undefined, styles$q["messageContainer--".concat(positionMessageAbove ? 'above' : 'below')]);
  var messageClass = joinClassNames(styles$q.message, appearance === 'overlay' ? styles$q['message--overlay'] : undefined, styles$q["message--".concat(extendMessageFrom)], styles$q["message--".concat(positionMessageAbove ? 'above' : 'below')], theme ? styles$q["message--".concat(theme)] : undefined, sharp ? styles$q.sharp : '');
  var getMessageWidth = function getMessageWidth() {
    if (!bindToParentWidth) {
      if (width) {
        return "".concat(width, "px");
      }
      return dynamicWidth;
    }
    if (width) {
      return "".concat(width, "px");
    }
    return null;
  };
  var getMessageContainerLeftPosition = function getMessageContainerLeftPosition() {
    if (extendMessageFrom === 'center' && !bindToParentWidth) return centerPosition;
    if (extendMessageFrom !== 'right') return 0;
    return null;
  };
  var handleOpenMessage = function handleOpenMessage(e) {
    if (e.type === 'mouseover') {
      setHovered(true);
    }
    if (triggerEventType === 'hover') {
      if (timeout) clearTimeout(timeout);
      setOpen(true);
    }
  };
  var handleCloseMessage = function handleCloseMessage(e) {
    if (triggerEventType !== 'hover') {
      setHovered(false);
    }
    if (triggerEventType === 'hover') {
      e.preventDefault();
      timeout = setTimeout(function () {
        setOpen(false);
        setHovered(false);
      }, closeDelay);
    }
  };
  useEffect(function () {
    var tooltipParentWidth = tooltipRef.current.parentNode.getBoundingClientRect().width;
    setDynamicWidth("".concat(tooltipParentWidth, "px"));
    var iconWidth = iconRef.current.childNodes[0].getBoundingClientRect().width;
    var halfIconWidth = iconWidth / 2;
    var iconPadding = Number(getComputedStyle(iconRef.current).paddingLeft.slice(0, -2));
    var iconLeftEdge = iconRef.current.offsetLeft;

    /**
     * caclulates the "before" css position for the triangle based on the width of the icon.
     */
    var tooltipAnchorPosition = bindToParentWidth ? iconLeftEdge + (halfIconWidth - 2) + iconPadding / 2 : iconLeftEdge + halfIconWidth - iconPadding / 2;
    setTriangleAnchor(tooltipAnchorPosition);
    if (open) {
      /**
       * if the tooltip is displayed inline, it needs to 'push down' the elements below it
       * use the heights of the "i" button and the tooltip message to calculate the margin-bottom
       */
      if (appearance === 'inline') {
        var iconHeight = iconRef.current.getBoundingClientRect().height;
        if (messageRef.current) {
          var messageHeight = messageRef.current.getBoundingClientRect().height;
          var marginBottom = messageHeight + iconHeight / 2;
          setTooltipMargin("".concat(marginBottom, "px"));
        }
      }

      /**
       * if the tooltip extends from the center, it needs to know how much offset to apply
       * use the widths of the "i" button and the tooltip message to calculate the `left` position
       */
      var iconButtonWidth = iconRef.current.getBoundingClientRect().width;
      if (extendMessageFrom === 'center' && !bindToParentWidth) {
        var center = width / 2 - iconButtonWidth / 2;
        setCenterPosition("-".concat(center, "px"));
      }
    }
  }, [open, dynamicWidth]);
  return /*#__PURE__*/React.createElement("div", _extends$1({
    className: tooltipClass,
    ref: tooltipRef,
    style: getTooltipStyle()
  }, safeRest(rest)), /*#__PURE__*/React.createElement(StandaloneIcon, {
    a11yText: getTriggerA11yText(connectedFieldLabel),
    "aria-controls": bubbleId,
    "aria-expanded": open ? 'true' : 'false',
    "aria-haspopup": "true",
    id: triggerId,
    onClick: function onClick() {
      if (triggerEventType === 'click') setOpen(function (prevOpen) {
        return !prevOpen;
      });
    },
    onMouseOver: handleOpenMessage,
    onMouseOut: handleCloseMessage,
    onFocus: handleOpenMessage,
    onBlur: handleCloseMessage,
    ref: iconRef,
    size: iconSize,
    symbol:
    // eslint-disable-next-line no-nested-ternary
    open && theme === 'blueberryWhiteIce' && !iconColor ? 'infoSelected' : hovered ? 'infoHovered' : icon,
    color: open && iconColor ? iconActiveColor : iconColor
  }), open && /*#__PURE__*/React.createElement("div", {
    className: messageContainerClass,
    style: {
      width: getMessageWidth(),
      left: getMessageContainerLeftPosition(),
      minWidth: bindToParentWidth ? "".concat(triangleAnchor + 20, "px") : null,
      maxWidth: bindToParentWidth ? dynamicWidth : null
    }
  }, /*#__PURE__*/React.createElement(Box, {
    "aria-hidden": "false",
    "aria-live": "polite",
    "data-testid": "bubble",
    dangerouslyAddClassName: messageClass,
    id: bubbleId,
    ref: messageRef,
    role: "tooltip",
    horizontal: 3,
    vertical: 2
  }, /*#__PURE__*/React.createElement(Text$2, {
    size: "small"
  }, children))));
};
Tooltip.propTypes = {
  /**
   * The message. Can be raw text or text components.
   */
  children: PropTypes.node.isRequired,
  /**
   * How to display the message.
   */
  appearance: PropTypes.oneOf(['inline', 'overlay']),
  /**
   * From which direction to extend the message.
   */
  extendMessageFrom: PropTypes.oneOf(['left', 'center', 'right']),
  /**
   * Set the background color of the tooltip message and the info icon when selected.
   */
  theme: PropTypes.oneOf(['blueberryWhiteIce', 'white', 'gray']),
  /**
   * Set a width in pixels for the tooltip. Use in conjunction with `extendMessageFrom="center"`.
   */
  width: PropTypes.string,
  /**
   * The input field that using this tooltip must pass its label so that the tooltip trigger can connect itself. Do not
   * show this prop as it is not part of the public API. If this prop is not specified, the tooltip will generate
   * a generic ID, which could produce duplicate ids.
   *
   * @ignore
   */
  connectedFieldLabel: PropTypes.string,
  /**
   * Set the mouse event that triggers the tooltip to open.
   */
  triggerEventType: PropTypes.oneOf(['click', 'hover']),
  /**
   * Set the delay time for the tooltip to close.  Used in conjunction with 'hover' triggerEventType.
   */
  closeDelay: PropTypes.number,
  /**
   * Set symbol to be used for the icon.
   */
  icon: PropTypes.string,
  /**
   * Icon color when tooltip is closed. Must be from the list of available [`Colours`](#section-colours).
   */
  iconColor: PropTypes.oneOf(getColorPropTypes()),
  /**
   * Icon color when tooltip is open. Must be from the list of available [`Colours`](#section-colours).
   */
  iconActiveColor: PropTypes.oneOf(getColorPropTypes()),
  /**
   * Set size of the symbol to be used for the icon.
   */
  iconSize: PropTypes.oneOf([12, 14, 16, 24, 30, 40]),
  /**
   * Message box can have sharp (border-radius:0px) or rounded (border-radius:8px) corners
   */
  sharp: PropTypes.bool,
  /**
   * Position the message box above the icon when tooltip is open.
   */
  positionMessageAbove: PropTypes.bool,
  /**
   * Bind the width of the message to its parent node.
   */
  bindToParentWidth: PropTypes.bool
};
Tooltip.defaultProps = {
  extendMessageFrom: 'left',
  appearance: 'overlay',
  width: undefined,
  connectedFieldLabel: undefined,
  theme: 'blueberryWhiteIce',
  triggerEventType: 'click',
  closeDelay: 0,
  icon: 'info',
  iconColor: undefined,
  iconActiveColor: undefined,
  iconSize: 24,
  sharp: true,
  positionMessageAbove: false,
  bindToParentWidth: false
};

var styles$p = {"flirt":"#7c1366","mosque":"#016b6a","texas":"#f9f6a5","amaranth":"#ee2c74","cardinal-pink":"#8c0448","trinidad":"#df3d0c","chestnut":"#bc4850","onahau":"#c3efff","burnt-sienna":"#ed6358","chathams-blue":"#17367d","mid-blue":"#1a347d","well-read":"#b8373e","wattle":"#d5e04d","beeswax":"#feeec7","bilbao":"#258b0b","sea-buckthorn":"#fbaf34","mint-tulip":"#c1f2e8","turquoise":"#39cdc9","hibiscus":"#c53a70","carousel-pink":"#fae6f4","white":"#fff","black":"#000","mortar":"#595959","gallery":"#efefef","silver":"#c9c8c8","dove":"#666666","iceberg":"#cbf0e8","icicle":"#e5f7fb","light-gray":"#fafafa","super-nova":"#fbaf33","expand-yellow":"#fee8b8","expand-yellow-light":"rgba(254, 232, 184, 0.5)","hero-pink":"#a6298c","label":"KDS_FormField-modules__label___3kAg9","inlineLabel":"KDS_FormField-modules__inlineLabel___2KO-q","alignCenter":"KDS_FormField-modules__alignCenter___3GHgA","topRightText":"KDS_FormField-modules__topRightText___PH59Z","formfield":"KDS_FormField-modules__formfield___gEwne undefined undefined KDS_Borders-modules__thin___3wU-3 KDS_Borders-modules__rounded___1M93U KDS_Forms-modules__font___sDGt2 KDS_Text-modules__medium___1SwM7 KDS_Typography-modules__wordbreak___2hwoO undefined KDS_Text-modules__color___Qi2FL","hasTooltip":"KDS_FormField-modules__hasTooltip___2kGU5","defaultboxshadow":"KDS_FormField-modules__defaultboxshadow___2x_p2","defaultbgcolor":"KDS_FormField-modules__defaultbgcolor___202Bn","default":"KDS_FormField-modules__default___2crVo KDS_FormField-modules__formfield___gEwne undefined undefined KDS_Borders-modules__thin___3wU-3 KDS_Borders-modules__rounded___1M93U KDS_Forms-modules__font___sDGt2 KDS_Text-modules__medium___1SwM7 KDS_Typography-modules__wordbreak___2hwoO undefined KDS_Text-modules__color___Qi2FL KDS_FormField-modules__defaultbgcolor___202Bn KDS_FormField-modules__defaultboxshadow___2x_p2","disabled":"KDS_FormField-modules__disabled___ddOSA KDS_FormField-modules__formfield___gEwne undefined undefined KDS_Borders-modules__thin___3wU-3 KDS_Borders-modules__rounded___1M93U KDS_Forms-modules__font___sDGt2 KDS_Text-modules__medium___1SwM7 KDS_Typography-modules__wordbreak___2hwoO undefined KDS_Text-modules__color___Qi2FL","focus":"KDS_FormField-modules__focus___1rll_ KDS_FormField-modules__formfield___gEwne undefined undefined KDS_Borders-modules__thin___3wU-3 KDS_Borders-modules__rounded___1M93U KDS_Forms-modules__font___sDGt2 KDS_Text-modules__medium___1SwM7 KDS_Typography-modules__wordbreak___2hwoO undefined KDS_Text-modules__color___Qi2FL KDS_FormField-modules__defaultbgcolor___202Bn","success":"KDS_FormField-modules__success___2Nvbu KDS_FormField-modules__formfield___gEwne undefined undefined KDS_Borders-modules__thin___3wU-3 KDS_Borders-modules__rounded___1M93U KDS_Forms-modules__font___sDGt2 KDS_Text-modules__medium___1SwM7 KDS_Typography-modules__wordbreak___2hwoO undefined KDS_Text-modules__color___Qi2FL KDS_FormField-modules__defaultbgcolor___202Bn KDS_FormField-modules__defaultboxshadow___2x_p2","error":"KDS_FormField-modules__error___1Wp8U KDS_FormField-modules__formfield___gEwne undefined undefined KDS_Borders-modules__thin___3wU-3 KDS_Borders-modules__rounded___1M93U KDS_Forms-modules__font___sDGt2 KDS_Text-modules__medium___1SwM7 KDS_Typography-modules__wordbreak___2hwoO undefined KDS_Text-modules__color___Qi2FL KDS_FormField-modules__defaultbgcolor___202Bn KDS_FormField-modules__defaultboxshadow___2x_p2","warning":"KDS_FormField-modules__warning___3U9OB KDS_FormField-modules__formfield___gEwne undefined undefined KDS_Borders-modules__thin___3wU-3 KDS_Borders-modules__rounded___1M93U KDS_Forms-modules__font___sDGt2 KDS_Text-modules__medium___1SwM7 KDS_Typography-modules__wordbreak___2hwoO undefined KDS_Text-modules__color___Qi2FL KDS_FormField-modules__defaultbgcolor___202Bn KDS_FormField-modules__defaultboxshadow___2x_p2","iconright":"KDS_FormField-modules__iconright___kQhVL"};

var positionStyles = {"relative":"KDS_Position-modules__relative___2Mmek","absolute":"KDS_Position-modules__absolute___3xAGg","centervertically":"KDS_Position-modules__centervertically___JL31p"};

var _excluded$t = ["label", "hint", "feedback", "error", "helper", "tooltip", "topRightText", "children", "inlineLabel", "onChange", "onFocus", "onBlur"];
var getClassName$2 = function getClassName(feedback, focus, disabled) {
  if (disabled) {
    return styles$p.disabled;
  }
  if (focus) {
    return styles$p.focus;
  }
  if (feedback) {
    return styles$p[feedback];
  }
  return styles$p["default"];
};
var showFeedbackIcon = function showFeedbackIcon(feedback, focus) {
  return (feedback === 'success' || feedback === 'error') && !focus;
};
var renderLabel = function renderLabel(label, hint, fieldId) {
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/label-has-for
    React.createElement("label", {
      className: styles$p.label,
      htmlFor: fieldId.identity()
    }, /*#__PURE__*/React.createElement(Box, {
      inline: true,
      between: 2,
      dangerouslyAddClassName: styles$p.alignCenter
    }, /*#__PURE__*/React.createElement(Text$2, {
      bold: true
    }, label), hint && /*#__PURE__*/React.createElement(Text$2, {
      size: "small"
    }, hint)))
  );
};
var renderError = function renderError(error, errorId) {
  return /*#__PURE__*/React.createElement(InputFeedback, {
    id: errorId,
    feedback: "error",
    errorArrowUp: true
  }, /*#__PURE__*/React.createElement(Paragraph$1, {
    size: "small"
  }, error));
};
var renderHelper = function renderHelper(helper, helperId, feedback, value) {
  if (typeof helper === 'function') {
    return /*#__PURE__*/React.createElement("div", {
      id: helperId
    }, /*#__PURE__*/React.createElement(Text$2, {
      size: "small"
    }, helper(feedback, value)));
  }
  return /*#__PURE__*/React.createElement(InputFeedback, {
    id: helperId,
    feedback: feedback
  }, /*#__PURE__*/React.createElement(Text$2, {
    size: "small"
  }, helper));
};
var FormField = function FormField(_ref) {
  var label = _ref.label,
    hint = _ref.hint,
    feedback = _ref.feedback,
    error = _ref.error,
    helper = _ref.helper,
    tooltip = _ref.tooltip,
    topRightText = _ref.topRightText,
    children = _ref.children,
    inlineLabel = _ref.inlineLabel,
    onChange = _ref.onChange,
    onFocus = _ref.onFocus,
    onBlur = _ref.onBlur,
    rest = _objectWithoutProperties$1(_ref, _excluded$t);
  var _useState = useState(rest.value),
    _useState2 = _slicedToArray(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    focus = _useState4[0],
    setFocus = _useState4[1];
  var fieldId;
  var helperId;
  var errorId;
  if (rest.id || rest.name || label) {
    fieldId = generateId(rest.id, rest.name, label);
    helperId = helper && fieldId.postfix('helper');
    errorId = error && fieldId.postfix('error-message');
  }
  var handleOnChange = function handleOnChange(event) {
    setValue(event.target.value);
    if (onChange) {
      onChange(event);
    }
  };
  var handleOnFocus = function handleOnFocus(event) {
    setFocus(true);
    if (onFocus) {
      onFocus(event);
    }
  };
  var handleOnBlur = function handleOnBlur(event) {
    setFocus(false);
    if (onBlur) {
      onBlur(event);
    }
  };
  var showIcon = showFeedbackIcon(feedback, focus);
  var classes = joinClassNames(positionStyles.relative, tooltip ? styles$p.hasTooltip : null);
  return /*#__PURE__*/React.createElement("div", {
    className: inlineLabel ? styles$p.inlineLabel : ''
  }, /*#__PURE__*/React.createElement("div", {
    className: classes
  }, label && renderLabel(label, hint, fieldId), tooltip && /*#__PURE__*/React.cloneElement(tooltip, {
    connectedFieldLabel: label
  }), topRightText && /*#__PURE__*/React.createElement("div", {
    className: "".concat(positionStyles.absolute, " ").concat(styles$p.topRightText)
  }, topRightText)), /*#__PURE__*/React.createElement(Box, {
    between: error || feedback === 'error' ? undefined : 2,
    "data-testid": "fieldAndMessage",
    vertical: 2
  }, children(_objectSpread2(_objectSpread2({}, safeRest(rest)), {}, {
    id: fieldId && fieldId.identity(),
    className: getClassName$2(feedback, focus, rest.disabled),
    value: value,
    onChange: handleOnChange,
    onFocus: handleOnFocus,
    onBlur: handleOnBlur,
    'aria-invalid': feedback === 'error',
    'aria-describedby': errorId || helperId || undefined
  }), showIcon, feedback), error && renderError(error, errorId), helper && renderHelper(helper, helperId, feedback, value)));
};
FormField.propTypes = {
  label: PropTypes.string,
  hint: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  feedback: PropTypes.oneOf(['success', 'error', 'warning']),
  error: PropTypes.string,
  helper: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
  tooltip: airbnbPropTypes.childrenOfType(Tooltip),
  topRightText: PropTypes.element,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  children: PropTypes.func.isRequired,
  inlineLabel: PropTypes.bool
};
FormField.defaultProps = {
  label: undefined,
  hint: undefined,
  feedback: undefined,
  error: undefined,
  helper: undefined,
  tooltip: undefined,
  topRightText: undefined,
  onChange: undefined,
  onFocus: undefined,
  onBlur: undefined,
  inlineLabel: false
};

var _excluded$s = ["children"];

// based off of react-transition-group's fade example
// http://reactcommunity.org/react-transition-group/transition

var defaultStyle = function defaultStyle(timeout) {
  return {
    transition: "opacity ".concat(timeout, "ms ease-in-out"),
    opacity: 0
  };
};
var transitionStyles = {
  entering: {
    opacity: 0
  },
  entered: {
    opacity: 1
  }
};
var Fade = function Fade(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties$1(_ref, _excluded$s);
  return /*#__PURE__*/React.createElement(Transition$1, rest, function (status) {
    return /*#__PURE__*/React.createElement("div", {
      style: _objectSpread2(_objectSpread2({}, defaultStyle(rest.timeout)), transitionStyles[status])
    }, children());
  });
};
Fade.propTypes = {
  timeout: PropTypes.number.isRequired,
  children: PropTypes.func.isRequired
};

var FeedbackIcon = function FeedbackIcon(_ref) {
  var showIcon = _ref.showIcon,
    feedback = _ref.feedback;
  return /*#__PURE__*/React.createElement(Fade, {
    timeout: 100,
    "in": showIcon,
    mountOnEnter: true,
    unmountOnExit: true
  }, function () {
    return /*#__PURE__*/React.createElement("div", {
      className: iconWrapperStyles.fixLineHeight
    }, feedback === 'success' ? /*#__PURE__*/React.createElement(StandaloneIcon, {
      symbol: "check",
      variant: "success",
      size: 16,
      a11yText: "The value of this input field is valid."
    }) : /*#__PURE__*/React.createElement(StandaloneIcon, {
      symbol: "exclamationOctagon",
      variant: "error",
      size: 16,
      a11yText: "The value of this input field is invalid."
    }));
  });
};
FeedbackIcon.propTypes = {
  showIcon: PropTypes.bool.isRequired,
  feedback: PropTypes.oneOf(['success', 'error'])
};
FeedbackIcon.defaultProps = {
  feedback: undefined
};

var betweenSpacing = 1; // rem
var iconWidth = 16; // px

var addRightPadding = (function (numberOfIcons) {
  if (numberOfIcons === 0) {
    return undefined;
  }
  return {
    paddingRight: "calc(".concat(iconWidth * numberOfIcons, "px + ").concat(betweenSpacing * (numberOfIcons + 1), "rem)")
  };
});

var formStyles = {"height":"KDS_Forms-modules__height___2059u","font":"KDS_Forms-modules__font___sDGt2","containsTooltip":"KDS_Forms-modules__containsTooltip___o_AIw"};

var styles$o = {"hideNumberSpinner":"KDS_Input-modules__hideNumberSpinner___2zW7v","iconsPosition":"KDS_Input-modules__iconsPosition___3HBJg KDS_Position-modules__absolute___3xAGg KDS_FormField-modules__iconright___kQhVL","prefix":"KDS_Input-modules__prefix___qfEB7 KDS_Position-modules__absolute___3xAGg","suffix":"KDS_Input-modules__suffix___12pGr KDS_Position-modules__absolute___3xAGg KDS_FormField-modules__iconright___kQhVL","inputPrefix":"KDS_Input-modules__inputPrefix___3hMGy","passwordVisibility":"KDS_Input-modules__passwordVisibility___2IKpZ"};

var _excluded$r = ["className"];
var Input = /*#__PURE__*/function (_React$Component) {
  function Input() {
    var _this;
    _classCallCheck(this, Input);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Input, [].concat(args));
    _defineProperty$1(_this, "state", {
      isMasked: false,
      isPassword: false
    });
    _defineProperty$1(_this, "renderPasswordVisibilityIcon", function () {
      var isMasked = _this.state.isMasked;
      var symbol = isMasked ? 'eyeClosed' : 'eyeOpened';
      return /*#__PURE__*/React.createElement("div", {
        className: styles$o.passwordVisibility
      }, /*#__PURE__*/React.createElement(StandaloneIcon, {
        a11yText: "Change password visibility",
        onClick: function onClick() {
          _this.toggleMasking();
        },
        size: 30,
        symbol: symbol
      }));
    });
    _defineProperty$1(_this, "setInputType", function () {
      var isMasked = _this.state.isMasked;
      var type;
      if (isMasked) {
        type = 'password';
      } else if (!isMasked) {
        type = 'text';
      }
      return type;
    });
    _defineProperty$1(_this, "toggleMasking", function () {
      _this.setState(function (_ref) {
        var isMasked = _ref.isMasked;
        return {
          isMasked: !isMasked
        };
      });
    });
    return _this;
  }
  _inherits(Input, _React$Component);
  return _createClass(Input, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var type = this.props.type;
      if (type === 'password') {
        // eslint-disable-next-line react/no-did-mount-set-state
        this.setState({
          isMasked: true,
          isPassword: true
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var isPassword = this.state.isPassword;
      var _this$props = this.props,
        type = _this$props.type,
        prefix = _this$props.prefix,
        suffix = _this$props.suffix;
      return /*#__PURE__*/React.createElement(FormField, this.props, function (_ref2, showFeedbackIcon, feedback) {
        var className = _ref2.className,
          inputProps = _objectWithoutProperties$1(_ref2, _excluded$r);
        return /*#__PURE__*/React.createElement("div", {
          className: positionStyles.relative
        }, prefix && /*#__PURE__*/React.createElement("span", {
          className: styles$o.prefix
        }, " ", prefix, " "), /*#__PURE__*/React.createElement("input", _extends$1({}, inputProps, {
          type: isPassword ? _this2.setInputType() : type,
          className: joinClassNames(className, formStyles.height, styles$o.hideNumberSpinner, prefix && styles$o.inputPrefix),
          style: addRightPadding(showFeedbackIcon ? 1 : 0)
        })), suffix && /*#__PURE__*/React.createElement("span", {
          className: styles$o.suffix
        }, " ", suffix, "  "), /*#__PURE__*/React.createElement("span", {
          className: styles$o.iconsPosition
        }, isPassword ? _this2.renderPasswordVisibilityIcon() : null, !inputProps.disabled && /*#__PURE__*/React.createElement(FeedbackIcon, {
          showIcon: showFeedbackIcon,
          feedback: feedback
        })));
      });
    }
  }]);
}(React.Component);
Input.propTypes = {
  /**
   * The HTML5 type of the input field.
   */
  type: PropTypes.oneOf(['text', 'number', 'password', 'email', 'search', 'tel', 'url']),
  /**
   * The label.
   */
  label: PropTypes.string.isRequired,
  /**
   * Clarify the expected input.
   */
  hint: PropTypes.string,
  /**
   * The value.
   */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /**
   * A feedback state.
   */
  feedback: PropTypes.oneOf(['success', 'error', 'warning']),
  /**
   * An error message. Either an error or a helper should be used, not both.
   */
  error: PropTypes.string,
  /**
   * A detailed explanation of the input expected by a form field. Can be text,
   * other components, or HTML elements.
   *
   * If a function is provided, it must return an `InputFeedback`. The function will be
   * invoked with arguments below.
   *
   * **Deprecation:** As of v1.0.0, passing `Input.Helper` will no longer work.
   *
   * @param {String} feedback The input's current feedback state.
   * @param {String} value The input's current value.
   */
  helper: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
  /**
   * A `Tooltip`.
   * Note: cannot be used with `topRightText` prop (elements will overlap each other).
   */
  tooltip: airbnbPropTypes.childrenOfType(Tooltip),
  /**
   * Text-based KDS component (i.e. `Link`, `Text`) placed in the top-right corner of the `Input` container element.
   * Note: cannot be used alongside `tooltip` prop (elements will overlap each other).
   */
  topRightText: PropTypes.element,
  /**
   * A callback function to be invoked when the input value changes.
   *
   * @param {SyntheticEvent} event The React `SyntheticEvent`
   */
  onChange: PropTypes.func,
  /**
   * A callback function to be invoked when the input receives focus.
   *
   * @param {SyntheticEvent} event The React `SyntheticEvent`
   */
  onFocus: PropTypes.func,
  /**
   * A callback function to be invoked when the input loses focus.
   *
   * @param {SyntheticEvent} event The React `SyntheticEvent`
   */
  onBlur: PropTypes.func,
  prefix: PropTypes.string,
  suffix: PropTypes.string
};
Input.defaultProps = {
  type: 'text',
  hint: undefined,
  value: '',
  feedback: undefined,
  error: undefined,
  helper: undefined,
  tooltip: undefined,
  topRightText: undefined,
  onChange: undefined,
  onFocus: undefined,
  onBlur: undefined,
  prefix: undefined,
  suffix: undefined
};

// TODO: This will no longer necessary once InputFeedback is exported on its own. Removing this will be a breaking change.
Input.Helper = InputFeedback;

var styles$n = {"flirt":"#7c1366","mosque":"#016b6a","texas":"#f9f6a5","amaranth":"#ee2c74","cardinal-pink":"#8c0448","trinidad":"#df3d0c","chestnut":"#bc4850","onahau":"#c3efff","burnt-sienna":"#ed6358","chathams-blue":"#17367d","mid-blue":"#1a347d","well-read":"#b8373e","wattle":"#d5e04d","beeswax":"#feeec7","bilbao":"#258b0b","sea-buckthorn":"#fbaf34","mint-tulip":"#c1f2e8","turquoise":"#39cdc9","hibiscus":"#c53a70","carousel-pink":"#fae6f4","white":"#fff","black":"#000","mortar":"#595959","gallery":"#efefef","silver":"#c9c8c8","dove":"#666666","iceberg":"#cbf0e8","icicle":"#e5f7fb","light-gray":"#fafafa","super-nova":"#fbaf33","expand-yellow":"#fee8b8","expand-yellow-light":"rgba(254, 232, 184, 0.5)","hero-pink":"#a6298c","kebabMenu":"KDS_KebabMenu-modules__kebabMenu___fNRQB","options":"KDS_KebabMenu-modules__options___3hnaE"};

var _excluded$q = ["options", "setSelection"];
var KebabMenu = function KebabMenu(_ref) {
  var options = _ref.options,
    setSelection = _ref.setSelection,
    rest = _objectWithoutProperties$1(_ref, _excluded$q);
  var componentRef = React.useRef(null);
  var openButtonRef = React.useRef(null);
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isOpen = _React$useState2[0],
    setIsOpen = _React$useState2[1];
  var handleClickOutside = function handleClickOutside(event) {
    if (componentRef.current && !componentRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };
  var handleSelection = function handleSelection(event, option) {
    setSelection(option);
    setIsOpen(false);
    if (event.detail === 0) {
      // a keypress triggered this, so return focus to
      // the button that opened the kebab options
      openButtonRef.current.focus();
    }
  };
  var toggleIsOpen = function toggleIsOpen() {
    return setIsOpen(!isOpen);
  };
  React.useEffect(function () {
    window.addEventListener('click', handleClickOutside);
    return function () {
      window.removeEventListener('click', handleClickOutside);
    };
  }, []);
  return /*#__PURE__*/React.createElement("div", _extends$1({
    className: styles$n.kebabMenu,
    ref: componentRef
  }, safeRest(rest)), /*#__PURE__*/React.createElement(StandaloneIcon
  // TODO: bilingual a11yText
  , {
    a11yText: "Toggle options menu",
    appLikeInteraction: {
      active: isOpen
    },
    onClick: toggleIsOpen,
    ref: openButtonRef,
    symbol: "kebab"
  }), isOpen && /*#__PURE__*/React.createElement("div", {
    className: styles$n.options
  }, options.map(function (option) {
    return /*#__PURE__*/React.createElement("button", {
      key: option,
      onClick: function onClick(event) {
        return handleSelection(event, option);
      },
      type: "button"
    }, capitalize(option));
  })));
};
KebabMenu.propTypes = {
  setSelection: PropTypes.func,
  options: PropTypes.array
};
KebabMenu.defaultProps = {
  setSelection: undefined,
  options: undefined
};

var styles$m = {"flirt":"#7c1366","mosque":"#016b6a","texas":"#f9f6a5","amaranth":"#ee2c74","cardinal-pink":"#8c0448","trinidad":"#df3d0c","chestnut":"#bc4850","onahau":"#c3efff","burnt-sienna":"#ed6358","chathams-blue":"#17367d","mid-blue":"#1a347d","well-read":"#b8373e","wattle":"#d5e04d","beeswax":"#feeec7","bilbao":"#258b0b","sea-buckthorn":"#fbaf34","mint-tulip":"#c1f2e8","turquoise":"#39cdc9","hibiscus":"#c53a70","carousel-pink":"#fae6f4","white":"#fff","black":"#000","mortar":"#595959","gallery":"#efefef","silver":"#c9c8c8","dove":"#666666","iceberg":"#cbf0e8","icicle":"#e5f7fb","light-gray":"#fafafa","super-nova":"#fbaf33","expand-yellow":"#fee8b8","expand-yellow-light":"rgba(254, 232, 184, 0.5)","hero-pink":"#a6298c","linkEl":"KDS_Link-modules__linkEl___F4V79","inheritColor":"KDS_Link-modules__inheritColor___3l0KM"};

var _excluded$p = ["reactRouterLinkComponent", "theme", "children", "newTab", "color"];
var getTextColor = function getTextColor(theme, color) {
  var themeColors = {
    primary: 'var(--color-mosque)',
    commerce: 'var(--color-chathams-blue)',
    support: 'var(--color-flirt)'
  };
  return theme ? themeColors[theme] : "var(--color-".concat(color, ")");
};
var Link = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var reactRouterLinkComponent = _ref.reactRouterLinkComponent,
    theme = _ref.theme,
    children = _ref.children,
    newTab = _ref.newTab,
    color = _ref.color,
    rest = _objectWithoutProperties$1(_ref, _excluded$p);
  if (!(reactRouterLinkComponent && rest.to) && (reactRouterLinkComponent || rest.to)) {
    warn('Link', 'The props `reactRouterLinkComponent` and `to` must be used together.');
  }
  return /*#__PURE__*/React.createElement(reactRouterLinkComponent || 'a', _objectSpread2(_objectSpread2(_objectSpread2({}, safeRest(rest)), ref && {
    ref: ref
  }), {}, {
    className: "".concat(color || theme ? styles$m.linkEl : joinClassNames(styles$m.linkEl, styles$m.inheritColor)),
    target: newTab ? '_blank' : '_self',
    style: theme || color ? {
      '--link-color': getTextColor(theme, color)
    } : {}
  }), children);
});
Link.propTypes = {
  /**
   * The theme.
   */
  theme: PropTypes.oneOf(['primary', 'commerce', 'support']),
  /**
   * Font color. Must be from the list of available [`Colours`](#section-colours).
   */
  color: PropTypes.string,
  /**
   * React Router Link component.
   */
  reactRouterLinkComponent: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  /**
   * Target URL (if using 'reactRouterLinkComponent')
   */
  to: PropTypes.string,
  /**
   * Target URL.
   */
  href: PropTypes.string,
  /**
   * Link text.
   */
  children: PropTypes.node.isRequired,
  /**
   * Opens a new tab.
   */
  newTab: PropTypes.bool
};
Link.defaultProps = {
  reactRouterLinkComponent: null,
  theme: undefined,
  to: null,
  href: null,
  newTab: false,
  color: undefined
};
Link.displayName = 'Link';

var styles$l = {"flirt":"#7c1366","mosque":"#016b6a","texas":"#f9f6a5","amaranth":"#ee2c74","cardinal-pink":"#8c0448","trinidad":"#df3d0c","chestnut":"#bc4850","onahau":"#c3efff","burnt-sienna":"#ed6358","chathams-blue":"#17367d","mid-blue":"#1a347d","well-read":"#b8373e","wattle":"#d5e04d","beeswax":"#feeec7","bilbao":"#258b0b","sea-buckthorn":"#fbaf34","mint-tulip":"#c1f2e8","turquoise":"#39cdc9","hibiscus":"#c53a70","carousel-pink":"#fae6f4","white":"#fff","black":"#000","mortar":"#595959","gallery":"#efefef","silver":"#c9c8c8","dove":"#666666","iceberg":"#cbf0e8","icicle":"#e5f7fb","light-gray":"#fafafa","super-nova":"#fbaf33","expand-yellow":"#fee8b8","expand-yellow-light":"rgba(254, 232, 184, 0.5)","hero-pink":"#a6298c","loader":"KDS_Loader-modules__loader___2l8oY","pulse1":"KDS_Loader-modules__pulse1___1FC2k","pulse":"KDS_Loader-modules__pulse___1RiBC","pulse2":"KDS_Loader-modules__pulse2___3gI4u","pulse3":"KDS_Loader-modules__pulse3___1TEQs"};

/**
 * @version 1.0.0
 *
 * A waiting indicator.
 */
var Loader = function Loader(_ref) {
  var loading = _ref.loading;
  return loading && /*#__PURE__*/createPortal( /*#__PURE__*/React.createElement("div", {
    className: styles$l.loader
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$l.pulse1
  }), /*#__PURE__*/React.createElement("div", {
    className: styles$l.pulse2
  }), /*#__PURE__*/React.createElement("div", {
    className: styles$l.pulse3
  })), document.body);
};
Loader.defaultProps = {
  loading: false
};
Loader.propTypes = {
  /**
   * Whether or not the Loader is loading.
   */
  loading: PropTypes.bool
};

var styles$k = {"flirt":"#7c1366","mosque":"#016b6a","texas":"#f9f6a5","amaranth":"#ee2c74","cardinal-pink":"#8c0448","trinidad":"#df3d0c","chestnut":"#bc4850","onahau":"#c3efff","burnt-sienna":"#ed6358","chathams-blue":"#17367d","mid-blue":"#1a347d","well-read":"#b8373e","wattle":"#d5e04d","beeswax":"#feeec7","bilbao":"#258b0b","sea-buckthorn":"#fbaf34","mint-tulip":"#c1f2e8","turquoise":"#39cdc9","hibiscus":"#c53a70","carousel-pink":"#fae6f4","white":"#fff","black":"#000","mortar":"#595959","gallery":"#efefef","silver":"#c9c8c8","dove":"#666666","iceberg":"#cbf0e8","icicle":"#e5f7fb","light-gray":"#fafafa","super-nova":"#fbaf33","expand-yellow":"#fee8b8","expand-yellow-light":"rgba(254, 232, 184, 0.5)","hero-pink":"#a6298c","button":"KDS_LoaderButton-modules__button___3CFLA","sharp":"KDS_LoaderButton-modules__sharp___3hYn6","colorSpinnerButton":"KDS_LoaderButton-modules__colorSpinnerButton___YJZmi","loading":"KDS_LoaderButton-modules__loading___xWbXq","success":"KDS_LoaderButton-modules__success___3g5Ww","spinner":"KDS_LoaderButton-modules__spinner___3YI_e","spin":"KDS_LoaderButton-modules__spin___3h2ya","colorSpinnerInverse":"KDS_LoaderButton-modules__colorSpinnerInverse___1NyLB KDS_LoaderButton-modules__spinner___3YI_e","primary":"KDS_LoaderButton-modules__primary___2AyC9 KDS_LoaderButton-modules__button___3CFLA","clear":"KDS_LoaderButton-modules__clear___36NU3","secondary":"KDS_LoaderButton-modules__secondary___6DQou KDS_LoaderButton-modules__button___3CFLA","colorSpinnerButtonInverse":"KDS_LoaderButton-modules__colorSpinnerButtonInverse___3lx_S","commerce":"KDS_LoaderButton-modules__commerce___1cU-v KDS_LoaderButton-modules__primary___2AyC9 KDS_LoaderButton-modules__button___3CFLA","tertiary":"KDS_LoaderButton-modules__tertiary___209dc","colorButton":"KDS_LoaderButton-modules__colorButton___3HGAD KDS_LoaderButton-modules__button___3CFLA","colorButtonInverse":"KDS_LoaderButton-modules__colorButtonInverse___dFAdt KDS_LoaderButton-modules__button___3CFLA","support":"KDS_LoaderButton-modules__support___3UJjH KDS_LoaderButton-modules__primary___2AyC9 KDS_LoaderButton-modules__button___3CFLA","disabled":"KDS_LoaderButton-modules__disabled___2wF0_","customButton":"KDS_LoaderButton-modules__customButton___LXbuG","link":"KDS_LoaderButton-modules__link___3GLAe","legal":"KDS_LoaderButton-modules__legal___bGceB","checkmark":"KDS_LoaderButton-modules__checkmark___22FCA"};

var _excluded$o = ["children", "theme", "type", "variant", "sharp", "clear", "disabled", "buttonType", "textColor", "inverse", "version", "color"];
var ConditionalSuperScript = function ConditionalSuperScript(_ref) {
  var children = _ref.children;
  return children;
};
var getClassName$1 = function getClassName(theme, variant, sharp, clear, disabled, className, version, inverse) {
  if (version === 2) {
    return inverse ? styles$k.colorSpinnerButtonInverse : styles$k.colorSpinnerButton;
  }
  return joinClassNames(styles$k[className], getTheme(theme, styles$k), styles$k[variant], sharp ? styles$k.sharp : null, clear ? styles$k.clear : null, disabled ? styles$k.disabled : null);
};
var getSpinnerClassName = function getSpinnerClassName(inverse) {
  return inverse ? styles$k.colorSpinnerInverse : styles$k.spinner;
};
var LoaderButton = /*#__PURE__*/forwardRef(function (_ref2, ref) {
  var children = _ref2.children,
    theme = _ref2.theme,
    type = _ref2.type,
    variant = _ref2.variant,
    sharp = _ref2.sharp,
    clear = _ref2.clear,
    disabled = _ref2.disabled,
    buttonType = _ref2.buttonType,
    textColor = _ref2.textColor,
    inverse = _ref2.inverse,
    version = _ref2.version,
    color = _ref2.color,
    rest = _objectWithoutProperties$1(_ref2, _excluded$o);
  return /*#__PURE__*/React.createElement(Box, {
    vertical: 2,
    between: 2,
    inline: true
  }, /*#__PURE__*/React.createElement(ConditionalSuperScript, {
    condition: buttonType === 'default'
  }, /*#__PURE__*/React.createElement("button", _extends$1({
    className: buttonType === 'default' ? getClassName$1(theme, variant, sharp, clear, disabled, undefined, version, inverse) : getClassName$1(theme, variant, sharp, false, disabled, buttonType, version, inverse),
    ref: ref,
    type: type // eslint-disable-line
  }, safeRest(rest), {
    style: textColor ? {
      '--font-color': "var(--color-".concat(textColor, ")")
    } : {
      '--color': "var(--color-".concat(color, ")")
    }
  }), buttonType === 'loading' && /*#__PURE__*/React.createElement("span", {
    className: version === 2 ? getSpinnerClassName(inverse) : styles$k.spinner,
    style: {
      '--color': "var(--color-".concat(color, ")")
    }
  }, /*#__PURE__*/React.createElement("span", null), /*#__PURE__*/React.createElement("span", null), /*#__PURE__*/React.createElement("span", null)), buttonType === 'success' && /*#__PURE__*/React.createElement("span", {
    className: styles$k.checkmark
  }), buttonType === 'default' ? children : '')));
});
LoaderButton.displayName = 'LoaderButton';
LoaderButton.propTypes = {
  /** The label inside the button. */
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  /** The HTML button type. */
  type: PropTypes.oneOf(['button', 'submit', 'reset']),
  /** An unspecified themed button will default to a green background. */
  theme: PropTypes.oneOf(['commerce', 'support']),
  /** Each theme (ie. Commerce, Support) has its own variant: Commerce: [primary, secondary, tertiary]. Support: [primary]  */
  variant: PropTypes.oneOf(['primary', 'secondary', 'tertiary']),
  /** The corners of the button where the defaulted border-radius is 4px and sharp is 0px. */
  sharp: PropTypes.bool,
  /** Supplies a clear button with the default color. */
  clear: PropTypes.bool,
  /** Supplies button in a disabled state. */
  disabled: PropTypes.bool,
  /** Color of the text.  *Only applies to custom buttons.* */
  textColor: PropTypes.string,
  /** Button type */
  buttonType: PropTypes.oneOf(['default', 'loading', 'success'])
};
LoaderButton.defaultProps = {
  theme: undefined,
  type: 'button',
  variant: 'primary',
  sharp: false,
  clear: false,
  disabled: false,
  textColor: undefined,
  buttonType: 'default'
};

var styles$j = {"flirt":"#7c1366","mosque":"#016b6a","texas":"#f9f6a5","amaranth":"#ee2c74","cardinal-pink":"#8c0448","trinidad":"#df3d0c","chestnut":"#bc4850","onahau":"#c3efff","burnt-sienna":"#ed6358","chathams-blue":"#17367d","mid-blue":"#1a347d","well-read":"#b8373e","wattle":"#d5e04d","beeswax":"#feeec7","bilbao":"#258b0b","sea-buckthorn":"#fbaf34","mint-tulip":"#c1f2e8","turquoise":"#39cdc9","hibiscus":"#c53a70","carousel-pink":"#fae6f4","white":"#fff","black":"#000","mortar":"#595959","gallery":"#efefef","silver":"#c9c8c8","dove":"#666666","iceberg":"#cbf0e8","icicle":"#e5f7fb","light-gray":"#fafafa","super-nova":"#fbaf33","expand-yellow":"#fee8b8","expand-yellow-light":"rgba(254, 232, 184, 0.5)","hero-pink":"#a6298c","green":"#016b6a","gray":"#efefef","darkgray":"#666666","seabuckthorn":"#fbaf34","circle":"KDS_Meter-modules__circle___1_aan","meters":"KDS_Meter-modules__meters___t8AJD","finishedCircle":"KDS_Meter-modules__finishedCircle___10g8n","finishedMeters":"KDS_Meter-modules__finishedMeters___3Yp6M","circleWithOpacity":"KDS_Meter-modules__circleWithOpacity___nfosh","opacity":"KDS_Meter-modules__opacity___2QlDT"};

var Meter = function Meter(_ref) {
  var maximumValue = _ref.maximumValue,
    currentValue = _ref.currentValue,
    overage = _ref.overage,
    width = _ref.width,
    height = _ref.height,
    color = _ref.color,
    children = _ref.children;
  var circleSize = 200;
  var dialWidth = 15;

  // DON'T change the variables below
  var radius = (circleSize - 2 * dialWidth) / 2;
  var circumference = 2 * 3.141592653589793 * radius;
  var diameter = 2 * radius;
  var meter = {
    // all of the variables below are set in the SCSS file
    size: circleSize,
    dialWidth: dialWidth,
    radius: radius,
    circumference: circumference,
    diameter: diameter,
    lightGray: styles$j.gray,
    seaBuckthorn: styles$j.seabuckthorn,
    darkGray: styles$j.darkgray,
    trinidad: styles$j.trinidad,
    progressWidth: 15,
    progressColor: styles$j.green,
    progressColorComplete: styles$j.darkgray,
    progressFontSize: '40'
  };
  meter.cX = meter.size / 2;
  meter.cY = meter.size / 2;
  var renderDial = function renderDial() {
    var dialColor = function dialColor() {
      if (typeof currentValue !== 'number') {
        return meter.darkGray;
      }
      return meter.lightGray;
    };
    return /*#__PURE__*/React.createElement("circle", {
      cx: meter.cX,
      cy: meter.cY,
      r: meter.radius,
      fill: "none",
      stroke: dialColor(),
      strokeWidth: meter.dialWidth,
      strokeLinecap: "round"
    });
  };
  var colors = {
    darkGray: 'darkGray',
    lightGray: 'lightGray',
    seaBuckthorn: 'seaBuckthorn',
    mosque: 'progressColor',
    trinidad: 'trinidad'
  };
  var getColor = function getColor(colorToValidate) {
    return colors[colorToValidate];
  };
  var renderProgress = function renderProgress() {
    var offset = meter.circumference * (1 - currentValue / maximumValue);
    if (isNaN(currentValue) || currentValue === 0) {
      offset = meter.circumference;
    }
    var getProgressColor = function getProgressColor(meterColor) {
      if (getColor(meterColor)) return meter[getColor(meterColor)];
      if (currentValue === maximumValue) {
        return meter.progressColorComplete;
      }
      if (currentValue === 0) {
        return meter.lightGray;
      }
      return meter.progressColor;
    };
    return /*#__PURE__*/React.createElement("circle", {
      cx: meter.cX,
      cy: meter.cY,
      r: meter.radius,
      fill: "none",
      stroke: getProgressColor(color),
      strokeWidth: meter.progressWidth,
      strokeDasharray: meter.circumference,
      strokeDashoffset: offset,
      strokeLinecap: "square",
      className: !overage ? styles$j.circle : styles$j.finishedCircle
    });
  };
  var renderMeterSvg = function renderMeterSvg() {
    var meterWidth = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '100%';
    var meterHeight = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '100%';
    return /*#__PURE__*/React.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      height: meterHeight,
      width: meterWidth,
      viewBox: "0 0 ".concat(meter.size, " ").concat(meter.size)
    }, /*#__PURE__*/React.createElement("g", {
      transform: "rotate(-90 ".concat(meter.cX, " ").concat(meter.cY, ")")
    }, renderDial(), renderProgress(), children));
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Responsive, {
    maxWidth: "md",
    render: function render() {
      return renderMeterSvg();
    }
  }), /*#__PURE__*/React.createElement(Responsive, {
    minWidth: "md",
    render: function render() {
      return renderMeterSvg(width, height);
    }
  }));
};
Meter.propTypes = {
  /**
   * Sets the maximum value of the meter.
   */
  maximumValue: PropTypes.number,
  /**
   * Sets the current value of the meter.
   */
  currentValue: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * If `true`, meter color becomes red.
   */
  overage: PropTypes.bool,
  /**
   * The height of the meter
   */
  height: PropTypes.number,
  /**
   * The width of the meter
   */
  width: PropTypes.number,
  /**
   * The color of the meter (lightGray, seaBuckthorn, darkGray, trinidad, mosque)
   */
  color: PropTypes.string,
  /**
   * React element passed as child component
   */
  children: PropTypes.element
};
Meter.defaultProps = {
  currentValue: 0,
  maximumValue: 0,
  overage: false,
  height: 230,
  width: 230,
  color: '',
  children: React.Fragment
};

var styles$i = {"triangle":"KDS_Triangle-modules__triangle___3OZP2","triangle--outer":"KDS_Triangle-modules__triangle--outer___1d5i6","triangle--inner":"KDS_Triangle-modules__triangle--inner___1YdKT"};

var Triangle = function Triangle(_ref) {
  var color = _ref.color,
    placement = _ref.placement;
  var triangleClasses = joinClassNames(styles$i.triangle, styles$i["triangle--".concat(placement)]);
  return /*#__PURE__*/React.createElement("div", {
    className: triangleClasses,
    style: {
      '--tri-color': "var(--color-".concat(color, ")")
    }
  });
};
Triangle.propTypes = {
  color: PropTypes.string.isRequired,
  placement: PropTypes.string.isRequired
};

var styles$h = {"flirt":"#7c1366","mosque":"#016b6a","texas":"#f9f6a5","amaranth":"#ee2c74","cardinal-pink":"#8c0448","trinidad":"#df3d0c","chestnut":"#bc4850","onahau":"#c3efff","burnt-sienna":"#ed6358","chathams-blue":"#17367d","mid-blue":"#1a347d","well-read":"#b8373e","wattle":"#d5e04d","beeswax":"#feeec7","bilbao":"#258b0b","sea-buckthorn":"#fbaf34","mint-tulip":"#c1f2e8","turquoise":"#39cdc9","hibiscus":"#c53a70","carousel-pink":"#fae6f4","white":"#fff","black":"#000","mortar":"#595959","gallery":"#efefef","silver":"#c9c8c8","dove":"#666666","iceberg":"#cbf0e8","icicle":"#e5f7fb","light-gray":"#fafafa","super-nova":"#fbaf33","expand-yellow":"#fee8b8","expand-yellow-light":"rgba(254, 232, 184, 0.5)","hero-pink":"#a6298c","modalOverlay":"KDS_Modal-modules__modalOverlay___BAPzL","modal":"KDS_Modal-modules__modal___3aFag","modal--large":"KDS_Modal-modules__modal--large___24Zyo","modal--fullScreenMobile":"KDS_Modal-modules__modal--fullScreenMobile___7e6xO","modal--loginModal":"KDS_Modal-modules__modal--loginModal___p_cZM","modal__header":"KDS_Modal-modules__modal__header___11lIT","modal__loginHeader":"KDS_Modal-modules__modal__loginHeader___3Y6IP","modal__content":"KDS_Modal-modules__modal__content___3WqXF","modal__loginContent":"KDS_Modal-modules__modal__loginContent___2oyx0","hideTitle":"KDS_Modal-modules__hideTitle___-HcgW","loginCard":"KDS_Modal-modules__loginCard___6DvQc","loginCard--yellow":"KDS_Modal-modules__loginCard--yellow___2k4vB","loginCard--green":"KDS_Modal-modules__loginCard--green___2AfNn"};

var _excluded$n = ["children", "focusElementOnClose", "handleClose", "isOpen", "title", "widthAtMdAndAbove", "hideClose", "hideTitle", "modalSize", "triangleBackground", "triangleColors", "fullScreenMobile", "closeIconStyle", "loginModal"];

/**
 * A dialog that overlays the browser window.
 *
 * Modals are typically used to confirm a non-trivial decision that the user has made before the completing the user's request.
 * They can also be used to communicate additional information to the user.
 */
var Modal = function Modal(_ref) {
  var children = _ref.children,
    focusElementOnClose = _ref.focusElementOnClose,
    handleClose = _ref.handleClose,
    isOpen = _ref.isOpen,
    title = _ref.title,
    widthAtMdAndAbove = _ref.widthAtMdAndAbove,
    hideClose = _ref.hideClose,
    hideTitle = _ref.hideTitle,
    modalSize = _ref.modalSize,
    triangleBackground = _ref.triangleBackground,
    triangleColors = _ref.triangleColors,
    fullScreenMobile = _ref.fullScreenMobile,
    closeIconStyle = _ref.closeIconStyle,
    loginModal = _ref.loginModal,
    rest = _objectWithoutProperties$1(_ref, _excluded$n);
  var modal = useRef(null);
  var closeModalButton = useRef(null);
  var modalTitle = useRef(null);
  var modalContent = useRef(null);
  var dialogClassNames = joinClassNames(styles$h.modal, "".concat(styles$h["modal--".concat(modalSize)]), "".concat(fullScreenMobile ? styles$h['modal--fullScreenMobile'] : ''), "".concat(loginModal ? styles$h['modal--loginModal'] : ''));
  var handleOverlayClick = function handleOverlayClick(event) {
    if (event.target.className !== styles$h.modalOverlay) {
      event.stopPropagation();
      return;
    }
    handleClose();
  };
  var handleKeyDown = function handleKeyDown(event) {
    if (event.key === 'Escape') handleClose();
  };

  // Determines what element in the modal will receive focus when it opens.  This determines what will be read by the screen reader.
  var getModalFocus = function getModalFocus() {
    // If there is nothing to display within the modal header then focus on the content
    if (hideClose && (hideTitle || !title) && modalContent.current) {
      modalContent.current.focus();
      // If there is no title but there is a close button then focus on close.
    } else if ((hideTitle || !title) && !hideClose && closeModalButton.current) {
      closeModalButton.current.focus();
      // If there is a title but no close button then focus on title.
    } else if (!hideTitle && hideClose && modalTitle.current) {
      modalTitle.current.focus();
    } else if (closeModalButton.current) {
      // Focus on close by default if both the title and close button are there.
      closeModalButton.current.focus();
    }
  };
  useEffect(function () {
    // function to capture the window's scroll position when the modal is opened
    var capturePosition = function capturePosition() {
      var cachedPosition = window.pageYOffset;
      var prevBodyStyle = document.body.getAttribute('style');
      return {
        disableBodyScrolling: function disableBodyScrolling() {
          document.body.setAttribute('style', "width: 100%; position: fixed; top: ".concat(cachedPosition * -1, "px;"));
        },
        enableBodyScrolling: function enableBodyScrolling() {
          document.body.removeAttribute('style');
          if (prevBodyStyle) {
            document.body.setAttribute('style', prevBodyStyle);
          }
          window.scrollTo({
            top: cachedPosition
          });
        }
      };
    };
    var _capturePosition = capturePosition(),
      disableBodyScrolling = _capturePosition.disableBodyScrolling,
      enableBodyScrolling = _capturePosition.enableBodyScrolling;
    var manageTabIndex = function manageTabIndex(htmlParent, tabIndex) {
      var focusableElements = htmlParent && htmlParent.querySelectorAll('button, a, input, textarea, select');
      if (focusableElements) focusableElements.forEach(function (element) {
        if (tabIndex === 'enable') {
          element.removeAttribute('tabindex');
        } else if (tabIndex === 'disable') {
          element.setAttribute('tabindex', '-1');
        }
      });
    };
    if (isOpen) {
      disableBodyScrolling();
      manageTabIndex(document.body, 'disable');
      manageTabIndex(modal.current, 'enable');
      getModalFocus();
      window.addEventListener('keydown', handleKeyDown);
    } else {
      enableBodyScrolling();
      // note: no need to disable tabIndex on the modal because
      //       it is completely removed from the DOM on close
      manageTabIndex(document.body, 'enable');
      window.removeEventListener('keydown', handleKeyDown);
      if (focusElementOnClose) focusElementOnClose.focus();
    }
    return function () {
      if (isOpen) {
        enableBodyScrolling();
        window.removeEventListener('keydown', handleKeyDown);
      }
    };
  }, [focusElementOnClose, handleClose, handleKeyDown, isOpen]);
  var renderChildren = useMemo(function () {
    /* eslint-disable consistent-return */
    return loginModal ? /*#__PURE__*/React.createElement(React.Fragment, null, children.map(function (child, index) {
      // Login Modal will only render the first 2 children
      if (index < 2) {
        return (
          /*#__PURE__*/
          /* eslint-disable react/no-array-index-key */
          React.createElement("div", {
            key: "loginCard-".concat(index),
            className: "".concat(styles$h.loginCard, " ").concat(index === 0 ? styles$h['loginCard--yellow'] : styles$h['loginCard--green'])
          }, child)
        );
      }
    })) :
    /*#__PURE__*/
    /* eslint-disable react/jsx-no-useless-fragment */
    React.createElement(React.Fragment, null, children);
  }, [children, loginModal]);
  return !isOpen || !isClient() ?
  // if modal !isOpen or server side - render nothing
  null :
  /*#__PURE__*/
  // if modal isOpen and on client side - render it and use a React Portal
  // to append it as a child at the end of <body>
  createPortal( /*#__PURE__*/React.createElement("div", {
    className: styles$h.modalOverlay,
    onClick: handleOverlayClick,
    onKeyDown: handleKeyDown
    // according to 'eslint-plugin-jsx-a11y': use `role="presentation"` to
    // indicate to assistive technology that an element should be ignored
    ,
    role: "presentation"
  }, /*#__PURE__*/React.createElement("div", _extends$1({
    "aria-labelledby": "modalTitle",
    className: dialogClassNames,
    ref: modal,
    role: "dialog",
    style: {
      '--modal-background-color': "var(--color-".concat(triangleBackground ? triangleColors.background : 'white', ")"),
      '--modal-maxWidth': widthAtMdAndAbove
    }
  }, safeRest(rest)), triangleBackground && /*#__PURE__*/React.createElement(Triangle, {
    color: triangleColors.innerTriangle,
    placement: "inner"
  }), triangleBackground && /*#__PURE__*/React.createElement(Triangle, {
    color: triangleColors.outerTriangle,
    placement: "outer"
  }), loginModal ? /*#__PURE__*/React.createElement("div", {
    className: styles$h.modal__loginHeader
  }, title && /*#__PURE__*/React.createElement("span", {
    className: styles$h.hideTitle,
    tabIndex: 0 // eslint-disable-line jsx-a11y/no-noninteractive-tabindex
    ,
    ref: modalTitle
  }, /*#__PURE__*/React.createElement(Text$2, {
    id: "modalTitle",
    bold: true
  }, title)), /*#__PURE__*/React.createElement(StandaloneIcon
  // TODO: bilingual a11yText
  , {
    a11yText: "Close",
    onClick: handleClose,
    ref: closeModalButton,
    size: closeIconStyle.size ? closeIconStyle.size : 16,
    symbol: "times",
    color: closeIconStyle.color ? closeIconStyle.color : 'black'
  })) : /*#__PURE__*/React.createElement("div", {
    className: styles$h.modal__header
  }, title && /*#__PURE__*/React.createElement("span", {
    className: hideTitle ? styles$h.hideTitle : '',
    tabIndex: hideClose ? 1 : 0 // eslint-disable-line jsx-a11y/no-noninteractive-tabindex
    ,
    ref: modalTitle
  }, /*#__PURE__*/React.createElement(Text$2, {
    id: "modalTitle",
    bold: true
  }, title)), !hideClose && /*#__PURE__*/React.createElement(StandaloneIcon
  // TODO: bilingual a11yText
  , {
    a11yText: "Close",
    onClick: handleClose,
    ref: closeModalButton,
    size: closeIconStyle.size ? closeIconStyle.size : 16,
    symbol: "times",
    color: closeIconStyle.color ? closeIconStyle.color : 'black'
  })), /*#__PURE__*/React.createElement(Responsive, {
    className: "".concat(loginModal ? styles$h.modal__loginContent : ''),
    maxWidth: "md",
    render: function render() {
      return renderChildren;
    }
  }), /*#__PURE__*/React.createElement(Responsive, {
    minWidth: "md",
    render: function render() {
      return /*#__PURE__*/React.createElement("div", _extends$1({
        style: {
          width: widthAtMdAndAbove
        },
        ref: modalContent
      }, hideTitle && hideClose && {
        tabIndex: 0
      }, {
        className: "".concat(loginModal ? styles$h.modal__loginContent : styles$h.modal__content)
      }), renderChildren);
    }
  }))), document.body);
};
Modal.propTypes = {
  /** The content. Can be text, any HTML element, or any component. */
  children: PropTypes.node,
  /** HTML element to which focus is returned when the modal is closed. */
  focusElementOnClose: PropTypes.object,
  /** Function to close the modal. */
  handleClose: PropTypes.func,
  /** Toggle whether the modal is opened or closed. */
  isOpen: PropTypes.bool,
  /**
   * The modal title.
   *
   * Used in the modal's rendered HTML and as the `aria-labelledby` attribute value.
   */
  title: PropTypes.string,
  /**
   * The width of the modal's childen when the viewport is at `"md"` (medium) or above.
   * The final modal size will be this value + 32px of padding.
   * This prop is necessary for the modal's size to remain adaptable to various design requirements on tablet/desktop.
   *
   * This prop is not used when the viewport is mobile.
   */
  widthAtMdAndAbove: PropTypes.string,
  /** Determines if the 'X' is rendered */
  hideClose: PropTypes.bool,
  /** Determines if the title is rendered */
  hideTitle: PropTypes.bool,
  /** Increases max-height of the modal on devices medium sized and larger. */
  modalSize: PropTypes.oneOf(['medium', 'large']),
  /** Applies a triangle background if true. */
  triangleBackground: PropTypes.bool,
  /** Object describing the colors for the triangles background. Must be from the list of available [`Colours`](#section-colours).
   *
   * Use in conjunction with triangleBackground.
   */
  triangleColors: PropTypes.shape({
    background: PropTypes.string,
    innerTriangle: PropTypes.string,
    outerTriangle: PropTypes.string
  }),
  /** Modal takes up full height of the screen on mobile devices if true.
   *  The maximum width of the modal on mobile is 375px.
   */
  fullScreenMobile: PropTypes.bool,
  /** Used to modify the size and color of the close icon. */
  closeIconStyle: PropTypes.shape({
    size: PropTypes.number,
    color: PropTypes.string
  }),
  /** Used to render the login modal variant */
  loginModal: PropTypes.bool
};
Modal.defaultProps = {
  children: undefined,
  focusElementOnClose: undefined,
  handleClose: undefined,
  isOpen: false,
  title: undefined,
  widthAtMdAndAbove: undefined,
  hideClose: false,
  hideTitle: false,
  modalSize: 'medium',
  triangleBackground: false,
  triangleColors: {
    background: 'beeswax',
    innerTriangle: 'flirt',
    outerTriangle: 'wattle'
  },
  fullScreenMobile: false,
  closeIconStyle: {
    size: 16,
    color: 'black'
  },
  loginModal: false
};

var styles$g = {"flirt":"#7c1366","mosque":"#016b6a","texas":"#f9f6a5","amaranth":"#ee2c74","cardinal-pink":"#8c0448","trinidad":"#df3d0c","chestnut":"#bc4850","onahau":"#c3efff","burnt-sienna":"#ed6358","chathams-blue":"#17367d","mid-blue":"#1a347d","well-read":"#b8373e","wattle":"#d5e04d","beeswax":"#feeec7","bilbao":"#258b0b","sea-buckthorn":"#fbaf34","mint-tulip":"#c1f2e8","turquoise":"#39cdc9","hibiscus":"#c53a70","carousel-pink":"#fae6f4","white":"#fff","black":"#000","mortar":"#595959","gallery":"#efefef","silver":"#c9c8c8","dove":"#666666","iceberg":"#cbf0e8","icicle":"#e5f7fb","light-gray":"#fafafa","super-nova":"#fbaf33","expand-yellow":"#fee8b8","expand-yellow-light":"rgba(254, 232, 184, 0.5)","hero-pink":"#a6298c","rounded":"KDS_Notification-modules__rounded___3LgSO","error":"KDS_Notification-modules__error___3umY_ KDS_Messaging-modules__error___uK_Ed","notice":"KDS_Notification-modules__notice___1qci_","success":"KDS_Notification-modules__success___3SYVb","tag":"KDS_Notification-modules__tag___cMEJL","cart":"KDS_Notification-modules__cart___1lUxS","warning":"KDS_Notification-modules__warning___2acwU","lock":"KDS_Notification-modules__lock___2OMTi","content-with-close":"KDS_Notification-modules__content-with-close___2hCas","icon__wrapper":"KDS_Notification-modules__icon__wrapper___1ZztP","icon-close":"KDS_Notification-modules__icon-close___2BTLg","content-wrapper":"KDS_Notification-modules__content-wrapper___3JL4j"};

var _excluded$m = ["close", "variant", "rounded", "children", "onClose"];
var iconByVariant = {
  error: {
    symbol: 'caution',
    color: 'error'
  },
  notice: {
    symbol: 'exclamationTriangle',
    color: 'error'
  },
  success: {
    symbol: 'checkCircledFilled',
    color: 'success'
  },
  tag: {
    symbol: 'tag',
    color: 'tag'
  },
  cart: {
    symbol: 'cart',
    color: 'cart'
  },
  warning: {
    symbol: 'caution',
    color: 'warning'
  },
  lock: {
    symbol: 'lock',
    color: 'warning'
  }
};
var renderIcon = function renderIcon(icon) {
  return /*#__PURE__*/React.createElement(DecorativeIcon, {
    symbol: icon.symbol,
    variant: icon.color,
    size: 24
  });
};
var renderContent = function renderContent(children) {
  return /*#__PURE__*/React.createElement(Box, null, children);
};
var Notification = function Notification(_ref) {
  var close = _ref.close,
    variant = _ref.variant,
    rounded = _ref.rounded,
    children = _ref.children,
    onClose = _ref.onClose,
    rest = _objectWithoutProperties$1(_ref, _excluded$m);
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    notification = _useState2[0],
    setNotification = _useState2[1];
  var roundedClass = rounded ? styles$g.rounded : '';
  var closeClick = function closeClick() {
    setNotification(false);
    if (onClose) {
      onClose(false);
    }
  };
  return notification ? /*#__PURE__*/React.createElement(Box, _extends$1({}, safeRest(rest), {
    vertical: 3,
    dangerouslyAddClassName: joinClassNames(styles$g[variant], roundedClass)
  }), /*#__PURE__*/React.createElement(FlexGrid, {
    limitWidth: true
  }, /*#__PURE__*/React.createElement(FlexGrid.Col, null, /*#__PURE__*/React.createElement("div", {
    className: styles$g['content-wrapper']
  }, /*#__PURE__*/React.createElement(Box, {
    inline: true,
    between: 2,
    dangerouslyAddClassName: close ? styles$g['content-with-close'] : ''
  }, renderIcon(iconByVariant[variant]), renderContent(children), /*#__PURE__*/React.createElement("div", {
    className: styles$g.icon__wrapper
  }, close && /*#__PURE__*/React.createElement("span", {
    className: styles$g['icon-close'],
    "data-test": "icon-close"
  }, /*#__PURE__*/React.createElement(StandaloneIcon, {
    a11yText: "Close",
    onClick: function onClick() {
      return closeClick();
    },
    size: 14,
    symbol: "times",
    variant: "black"
  })))))))) : null;
};
Notification.propTypes = {
  /**
   * The appearance.
   */
  variant: PropTypes.oneOf(['error', 'notice', 'success', 'tag', 'cart', 'warning', 'lock']),
  /**
   * The close button.
   */
  close: PropTypes.bool,
  /**
   * Rounded corners
   */
  rounded: PropTypes.bool,
  /**
   * The message. Can be raw text or text components.
   */
  children: PropTypes.node.isRequired,
  /** A callback function to be invoked when close button is clicked.
  @param {SyntheticEvent} event The React `SyntheticEvent` */
  onClose: PropTypes.func
};
Notification.defaultProps = {
  variant: 'error',
  close: false,
  rounded: false,
  onClose: undefined
};

var styles$f = {"flirt":"#7c1366","mosque":"#016b6a","texas":"#f9f6a5","amaranth":"#ee2c74","cardinal-pink":"#8c0448","trinidad":"#df3d0c","chestnut":"#bc4850","onahau":"#c3efff","burnt-sienna":"#ed6358","chathams-blue":"#17367d","mid-blue":"#1a347d","well-read":"#b8373e","wattle":"#d5e04d","beeswax":"#feeec7","bilbao":"#258b0b","sea-buckthorn":"#fbaf34","mint-tulip":"#c1f2e8","turquoise":"#39cdc9","hibiscus":"#c53a70","carousel-pink":"#fae6f4","white":"#fff","black":"#000","mortar":"#595959","gallery":"#efefef","silver":"#c9c8c8","dove":"#666666","iceberg":"#cbf0e8","icicle":"#e5f7fb","light-gray":"#fafafa","super-nova":"#fbaf33","expand-yellow":"#fee8b8","expand-yellow-light":"rgba(254, 232, 184, 0.5)","hero-pink":"#a6298c","largeTrianglePosition":"KDS_PageTitle-modules__largeTrianglePosition___3FFiZ","pageTitleBar":"KDS_PageTitle-modules__pageTitleBar___2Rr25","triangles__secondary":"KDS_PageTitle-modules__triangles__secondary___vtJGh","triangles__commerce":"KDS_PageTitle-modules__triangles__commerce___2WQ1B","triangles":"KDS_PageTitle-modules__triangles___eWgRb","pageTitleBackLink":"KDS_PageTitle-modules__pageTitleBackLink___1lnXR","chevronRight":"KDS_PageTitle-modules__chevronRight___2UbIm","titleText":"KDS_PageTitle-modules__titleText___3DZ2X","pageTitleHeadingBanner":"KDS_PageTitle-modules__pageTitleHeadingBanner___160Tk","pageTitleHeading":"KDS_PageTitle-modules__pageTitleHeading___wsf8h","commerce":"KDS_PageTitle-modules__commerce___2iNNz","secondary":"KDS_PageTitle-modules__secondary___cyQx0","large":"KDS_PageTitle-modules__large___2N9gT"};

var _excluded$l = ["title", "heading", "theme", "variant", "backLink", "breadcrumbs"];
var Row = FlexGrid.Row,
  Col = FlexGrid.Col;
var getClassName = function getClassName(defaultStyle, theme, variant, heading) {
  var styleClass = null;
  var styleVariant = null;
  if (heading) {
    styleClass = styles$f.pageTitleHeadingBanner;
  }
  if (variant) {
    styleVariant = styles$f[variant];
  }
  return joinClassNames(defaultStyle, getTheme(theme, styles$f), styleVariant, styleClass);
};
var getTriangleLargeStyles = function getTriangleLargeStyles(theme) {
  if (theme === 'commerce') {
    return styles$f.triangles__commerce;
  }
  if (theme === 'secondary') {
    return styles$f.triangles__secondary;
  }
  return styles$f.triangles;
};
var renderRightChevron = function renderRightChevron() {
  return /*#__PURE__*/React.createElement("span", {
    className: styles$f.chevronRight
  }, /*#__PURE__*/React.createElement(DecorativeIcon, {
    symbol: "chevronRight"
  }));
};
var renderBackLink = function renderBackLink(desktop, backLink, heading) {
  return /*#__PURE__*/React.createElement("div", {
    className: styles$f.pageTitleBackLink
  }, /*#__PURE__*/React.createElement(Link, {
    reactRouterLinkComponent: backLink.reactRouterLinkComponent,
    href: !backLink.reactRouterLinkComponent ? backLink.href : '',
    to: backLink.reactRouterLinkComponent && backLink.href
  }, /*#__PURE__*/React.createElement("span", null, !desktop && /*#__PURE__*/React.createElement(DecorativeIcon, {
    symbol: "chevronLeft"
  }), desktop && /*#__PURE__*/React.createElement(Text$2, {
    bold: true,
    size: "medium"
  }, backLink.text), !desktop && heading && /*#__PURE__*/React.createElement(Text$2, {
    bold: true,
    size: "medium"
  }, backLink.text), desktop && renderRightChevron())));
};
var slicedItems = function slicedItems(items, device) {
  var isMobile = device.isMobile;
  if (isMobile && items.length > 2) {
    return items.slice(0, 2 - items.length);
  }
  return items;
};
var renderBreadcrumbs = function renderBreadcrumbs(items) {
  return /*#__PURE__*/React.createElement(React.Fragment, null, items.map(function (item, index) {
    var text = item.text,
      href = item.href,
      reactRouterLinkComponent = item.reactRouterLinkComponent,
      type = item.type;
    var isLink = type === 'link' && (href || reactRouterLinkComponent);
    return /*#__PURE__*/React.createElement("div", {
      className: styles$f.pageTitleBackLink,
      key: text
    }, isLink && /*#__PURE__*/React.createElement(Link, {
      reactRouterLinkComponent: reactRouterLinkComponent,
      href: !reactRouterLinkComponent ? href : '',
      to: reactRouterLinkComponent && href
    }, /*#__PURE__*/React.createElement(Text$2, {
      semiBold: true,
      size: "medium"
    }, text), index < items.length - 1 ? renderRightChevron() : ''), !isLink && /*#__PURE__*/React.createElement(Text$2, {
      bold: true,
      size: "medium"
    }, text));
  }));
};

/**
 * A general page title
 */
var PageTitle = function PageTitle(_ref) {
  var title = _ref.title,
    heading = _ref.heading,
    theme = _ref.theme,
    variant = _ref.variant,
    backLink = _ref.backLink,
    breadcrumbs = _ref.breadcrumbs,
    rest = _objectWithoutProperties$1(_ref, _excluded$l);
  var titleSize = 'large';
  var responsiveMinWidth = 'md';
  var _useWindowDimensions = useWindowDimensions(breakpoints$1),
    device = _useWindowDimensions.device;
  var slicedBreadcrumbs = slicedItems(breadcrumbs, device);
  if (heading) {
    titleSize = 'medium';
    responsiveMinWidth = theme === 'commerce' ? 'md' : 'lg';
  }
  return /*#__PURE__*/React.createElement("div", _extends$1({}, safeRest(rest), {
    className: getClassName(styles$f.pageTitleBar, theme, variant, heading)
  }), /*#__PURE__*/React.createElement(FlexGrid, {
    limitWidth: true
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Responsive, {
    minWidth: responsiveMinWidth
  }, function (desktop) {
    var showTitleInCrumbs = (desktop || !backLink || !heading) && slicedBreadcrumbs.length < 1;
    return /*#__PURE__*/React.createElement(Box, {
      vertical: 2,
      "data-test": "pageTitle",
      inline: true,
      between: 2
    }, backLink && renderBackLink(desktop, backLink, heading), slicedBreadcrumbs && renderBreadcrumbs(slicedBreadcrumbs), showTitleInCrumbs && /*#__PURE__*/React.createElement(Text$2, {
      bold: true,
      size: titleSize
    }, /*#__PURE__*/React.createElement("span", {
      className: styles$f.titleText
    }, title)));
  }), typeof heading === 'string' ? /*#__PURE__*/React.createElement(Box, {
    dangerouslyAddClassName: styles$f.pageTitleHeading
  }, /*#__PURE__*/React.createElement(Heading$1, {
    level: "h1",
    theme: theme === 'default' ? 'selfServe' : 'commerce',
    color: "trinidad"
  }, heading)) : heading))), variant === 'large' && /*#__PURE__*/React.createElement("div", {
    className: getTriangleLargeStyles(theme)
  }));
};
PageTitle.defaultProps = {
  backLink: null,
  theme: 'default',
  heading: null,
  variant: null,
  breadcrumbs: []
};
PageTitle.propTypes = {
  /**
   * The page title
   */
  title: PropTypes.string.isRequired,
  /**
   * The heading. If provided a bigger banner would be shown.
   */
  heading: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  /**
   * This property determines the color of the background triangles of the banner.
   */
  theme: PropTypes.oneOf(['commerce', 'secondary', 'default']),
  /**
   * This determines the shape of the triangles. If large variant is used
   * then a slightly more slanted triangles would be displayed.
   */
  variant: PropTypes.oneOf(['large']),
  /**
   * The back link text, href and reactRouterLinkComponent.
   * The reactRouterLinkComponent is optional.  If passed in, the href will be applied apply
   * to a "to" attribute, otherwise it will be applied to an 'href' attribute.
   * Banners that include a heading will show the backlink to the right of the chevron on mobile
   * and banners that do not include a heading will show the title to the right of the chevron on mobile.
   */
  backLink: PropTypes.shape({
    text: PropTypes.string,
    href: PropTypes.string,
    reactRouterLinkComponent: PropTypes.oneOfType([PropTypes.object, PropTypes.func])
  }),
  /**
   * when specified list breadcrumbs after back link and before breadcrumb title.
   * Note: It is possible to disable breadcrumb title and backlink and only use
   * breadcrumbs that you specity here.
   */
  breadcrumbs: PropTypes.arrayOf(PropTypes.shape({
    type: PropTypes.oneOf(['text', 'link']),
    text: PropTypes.string,
    href: PropTypes.string,
    reactRouterLinkComponent: PropTypes.oneOfType([PropTypes.object, PropTypes.func])
  }))
};

var styles$e = {"flirt":"#7c1366","mosque":"#016b6a","texas":"#f9f6a5","amaranth":"#ee2c74","cardinal-pink":"#8c0448","trinidad":"#df3d0c","chestnut":"#bc4850","onahau":"#c3efff","burnt-sienna":"#ed6358","chathams-blue":"#17367d","mid-blue":"#1a347d","well-read":"#b8373e","wattle":"#d5e04d","beeswax":"#feeec7","bilbao":"#258b0b","sea-buckthorn":"#fbaf34","mint-tulip":"#c1f2e8","turquoise":"#39cdc9","hibiscus":"#c53a70","carousel-pink":"#fae6f4","white":"#fff","black":"#000","mortar":"#595959","gallery":"#efefef","silver":"#c9c8c8","dove":"#666666","iceberg":"#cbf0e8","icicle":"#e5f7fb","light-gray":"#fafafa","super-nova":"#fbaf33","expand-yellow":"#fee8b8","expand-yellow-light":"rgba(254, 232, 184, 0.5)","hero-pink":"#a6298c","column":"KDS_Price-modules__column___1USUc","price":"KDS_Price-modules__price___2Bbiz","terms__side":"KDS_Price-modules__terms__side___1DVR7","price--xs":"KDS_Price-modules__price--xs___y6yQx","price--sm":"KDS_Price-modules__price--sm___2veII","price--med":"KDS_Price-modules__price--med___1Gzgn","price--lg":"KDS_Price-modules__price--lg___2fM5c","price__sup--xs":"KDS_Price-modules__price__sup--xs___Eon1h","price__sup--sm":"KDS_Price-modules__price__sup--sm___1t5jZ","price__sup--med":"KDS_Price-modules__price__sup--med___3mzr7","price__sup--lg":"KDS_Price-modules__price__sup--lg___1g4R_","number":"KDS_Price-modules__number___3zLNZ","number__wrapper":"KDS_Price-modules__number__wrapper___OOFWB","number__amount":"KDS_Price-modules__number__amount___3aSLn","number--withTerms-med":"KDS_Price-modules__number--withTerms-med___2s61q","number--withTerms-lg":"KDS_Price-modules__number--withTerms-lg___3CZ7q","terms__below":"KDS_Price-modules__terms__below___1JJ8H","terms__side--xs":"KDS_Price-modules__terms__side--xs___2uEK1","terms__side--sm":"KDS_Price-modules__terms__side--sm___2viip","terms__side--med":"KDS_Price-modules__terms__side--med___1pptX","terms__side--lg":"KDS_Price-modules__terms__side--lg___2AD-4"};

var _excluded$k = ["children", "size", "showDecimal", "lang", "showCurrency", "terms", "ariaTerms", "termsBelow", "color"];
var INTEGER_DECIMALS = '00';
var Price = function Price(_ref) {
  var children = _ref.children,
    size = _ref.size,
    showDecimal = _ref.showDecimal,
    lang = _ref.lang,
    showCurrency = _ref.showCurrency,
    terms = _ref.terms,
    ariaTerms = _ref.ariaTerms,
    termsBelow = _ref.termsBelow,
    color = _ref.color,
    rest = _objectWithoutProperties$1(_ref, _excluded$k);
  var supClassname = styles$e["price__sup--".concat(size)];
  var hasTermsBelow = termsBelow && terms && terms.length > 0;
  var numberClassName = joinClassNames(styles$e.number, hasTermsBelow ? styles$e["number--withTerms-".concat(size)] : '');
  var integralPart = children;
  var decimalPart = INTEGER_DECIMALS;
  if (children) {
    var _numberArray$;
    var numberArray = children.toString().split('.');
    var langWithRegion = lang;
    if (!langWithRegion.endsWith('-CA')) {
      langWithRegion = "".concat(lang, "-CA");
    }
    integralPart = new Intl.NumberFormat(langWithRegion).format(numberArray[0]);
    decimalPart = (_numberArray$ = numberArray[1]) !== null && _numberArray$ !== void 0 ? _numberArray$ : INTEGER_DECIMALS;
    if (decimalPart.length < 2) decimalPart += INTEGER_DECIMALS[0];
  }

  // if decimals are 00 then these dont need to be accessible.
  var isDecimalsAriaHidden = decimalPart === INTEGER_DECIMALS;
  var isEnglish = lang === LANGUAGE.EN;
  var isFrench = lang === LANGUAGE.FR;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(styles$e.price, " ").concat(styles$e.column)
  }, /*#__PURE__*/React.createElement("div", _extends$1({
    className: "".concat(styles$e.price, " ").concat(styles$e["price--".concat(size)]),
    style: color ? {
      color: "var(--color-".concat(color, ")")
    } : {}
  }, safeRest(rest)), isEnglish && showCurrency && /*#__PURE__*/React.createElement("div", {
    className: supClassname
  }, "$"), /*#__PURE__*/React.createElement("div", {
    className: styles$e.number__wrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$e.number__amount
  }, /*#__PURE__*/React.createElement("div", {
    className: numberClassName
  }, integralPart), showDecimal && /*#__PURE__*/React.createElement("div", {
    className: supClassname,
    "aria-hidden": isDecimalsAriaHidden
  }, isEnglish ? '.' : ',', decimalPart), isFrench && showCurrency && /*#__PURE__*/React.createElement("div", {
    className: supClassname
  }, "$")), terms && !hasTermsBelow && /*#__PURE__*/React.createElement("div", {
    className: styles$e["terms__side--".concat(size)],
    "aria-label": ariaTerms
  }, terms))), hasTermsBelow && /*#__PURE__*/React.createElement("div", {
    className: styles$e.terms__below
  }, terms));
};
Price.propTypes = {
  /**
   * Price number of type string without the decimals or currency.
   */
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  /**
   * Alters the font sizes.
   */
  size: PropTypes.oneOf(['xs', 'sm', 'med', 'lg', 'inline']),
  /**
   * Determines if the decimal superscript will be shown.
   */
  showDecimal: PropTypes.bool,
  /**
   * Determines if the currency symbol superscript will be shown.
   */
  showCurrency: PropTypes.bool,
  /**
   * Changes the decimal and currency formatting based on the language.
   */
  lang: PropTypes.oneOf(['en', 'fr']),
  /**
   * Description for terms of the price.  Can be a string or rich text.
   */
  terms: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  /**
   * Accessibility label for terms of the price or as is if not provided.
   */
  ariaTerms: PropTypes.string,
  /**
   * Determines if the terms will be shown below of to the side of the price.
   */
  termsBelow: PropTypes.bool,
  /**
   * Font color. Must be from the list of available [`Colours`](#section-colours).
   */
  color: PropTypes.string
};
Price.defaultProps = {
  size: 'med',
  showDecimal: true,
  showCurrency: true,
  lang: LANGUAGE.EN,
  terms: '',
  ariaTerms: undefined,
  termsBelow: false,
  color: undefined
};

var styles$d = {"flirt":"#7c1366","mosque":"#016b6a","texas":"#f9f6a5","amaranth":"#ee2c74","cardinal-pink":"#8c0448","trinidad":"#df3d0c","chestnut":"#bc4850","onahau":"#c3efff","burnt-sienna":"#ed6358","chathams-blue":"#17367d","mid-blue":"#1a347d","well-read":"#b8373e","wattle":"#d5e04d","beeswax":"#feeec7","bilbao":"#258b0b","sea-buckthorn":"#fbaf34","mint-tulip":"#c1f2e8","turquoise":"#39cdc9","hibiscus":"#c53a70","carousel-pink":"#fae6f4","white":"#fff","black":"#000","mortar":"#595959","gallery":"#efefef","silver":"#c9c8c8","dove":"#666666","iceberg":"#cbf0e8","icicle":"#e5f7fb","light-gray":"#fafafa","super-nova":"#fbaf33","expand-yellow":"#fee8b8","expand-yellow-light":"rgba(254, 232, 184, 0.5)","hero-pink":"#a6298c","disabled":"KDS_Radio-modules__disabled___181ZW KDS_Borders-modules__circular___2Wn2f","disabledChecked":"KDS_Radio-modules__disabledChecked___3C373 KDS_Borders-modules__circular___2Wn2f","checked":"KDS_Radio-modules__checked___24F_d","checked__rectangle":"KDS_Radio-modules__checked__rectangle___3o-wa KDS_Choice-modules__rectangle___3wREv","checked__color":"KDS_Radio-modules__checked__color___KMVb7","checked__circle":"KDS_Radio-modules__checked__circle___3q6s3 KDS_Borders-modules__circular___2Wn2f","checked__regular":"KDS_Radio-modules__checked__regular___1ViPD KDS_Borders-modules__circular___2Wn2f","rectangle":"KDS_Radio-modules__rectangle___3AcYE","inner__circle":"KDS_Radio-modules__inner__circle___1zfxP KDS_Borders-modules__circular___2Wn2f","inner__regular":"KDS_Radio-modules__inner__regular___Jp3tu KDS_Borders-modules__circular___2Wn2f","inner__rectangle":"KDS_Radio-modules__inner__rectangle___2NnAc KDS_Radio-modules__rectangle___3AcYE","innerChecked__circle":"KDS_Radio-modules__innerChecked__circle___1igai KDS_Radio-modules__inner__circle___1zfxP KDS_Borders-modules__circular___2Wn2f","innerChecked__regular":"KDS_Radio-modules__innerChecked__regular___3akJ2 KDS_Radio-modules__inner__circle___1zfxP KDS_Borders-modules__circular___2Wn2f","innerChecked__rectangle":"KDS_Radio-modules__innerChecked__rectangle___2pYxG KDS_Radio-modules__rectangle___3AcYE","colored__circle__normal":"KDS_Radio-modules__colored__circle__normal___2x-bO","colored__circle__large__container":"KDS_Radio-modules__colored__circle__large__container___1awkd KDS_Borders-modules__circular___2Wn2f","colored__circle__large__item":"KDS_Radio-modules__colored__circle__large__item___1RxSe KDS_Borders-modules__circular___2Wn2f","colored__regular":"KDS_Radio-modules__colored__regular___3ATpd","innerCheckedDisabled__circle":"KDS_Radio-modules__innerCheckedDisabled__circle___3_O89 KDS_Radio-modules__inner__circle___1zfxP KDS_Borders-modules__circular___2Wn2f","innerCheckedDisabled__regular":"KDS_Radio-modules__innerCheckedDisabled__regular___2f5jv KDS_Radio-modules__inner__circle___1zfxP KDS_Borders-modules__circular___2Wn2f","innerCheckedDisabled__rectangle":"KDS_Radio-modules__innerCheckedDisabled__rectangle___2eVju KDS_Radio-modules__rectangle___3AcYE","innerDisabled":"KDS_Radio-modules__innerDisabled___o2UZ1 KDS_Radio-modules__inner__circle___1zfxP KDS_Borders-modules__circular___2Wn2f","activeCheckmark__circle":"KDS_Radio-modules__activeCheckmark__circle___r_-j1","activeCheckmark__regular":"KDS_Radio-modules__activeCheckmark__regular___3wds6","activeCheckmark__circle__large__container":"KDS_Radio-modules__activeCheckmark__circle__large__container___1y0Je KDS_Borders-modules__circular___2Wn2f","activeCheckmark__circle__large__item":"KDS_Radio-modules__activeCheckmark__circle__large__item___3CM0T KDS_Borders-modules__circular___2Wn2f","activeCheckmark__rectangle":"KDS_Radio-modules__activeCheckmark__rectangle___-o3C_"};

var rectangleShape = function rectangleShape(shape) {
  return shape === 'rectangle';
};
var circleShape = function circleShape(shape) {
  return shape === 'circle';
};
var largeSize = function largeSize(size) {
  return size === 'large';
};
var getClassNames = function getClassNames(checked, disabled, theme, shape, color, size) {
  if (disabled) {
    return joinClassNames(checked ? styles$d["innerCheckedDisabled__".concat(shape)] : styles$d.innerDisabled, styles$d[shape], color ? styles$d.colored : '');
  }
  var className;
  if (checked) {
    className = styles$d["innerChecked__".concat(shape)];
  } else {
    className = styles$d["inner__".concat(shape)];
  }
  return joinClassNames(className, circleShape(shape) && color && !largeSize(size) ? styles$d["colored__".concat(shape, "__").concat(size)] : '');
};
var isLightOrDark = function isLightOrDark(color) {
  // Variables for red, green, blue values
  var r;
  var g;
  var b;

  // Check the format of the color, HEX or RGB?
  if (color.match(/^rgb/)) {
    // If RGB --> store the red, green, blue values in separate variables
    /* eslint-disable no-param-reassign */
    color = color.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/);
    var _color = color;
    var _color2 = _slicedToArray(_color, 3);
    r = _color2[0];
    g = _color2[1];
    b = _color2[2];
  } else {
    /* eslint-disable prefer-template, no-bitwise */
    // If hex --> Convert it to RGB: http://gist.github.com/983661
    color = +('0x' + color.slice(1).replace(color.length < 5 && /./g, '$&$&'));
    r = color >> 16;
    g = color >> 8 & 255;
    b = color & 255;
    /* eslint-enable prefer-template, no-bitwise */
  }

  // HSP (Highly Sensitive Poo) equation from http://alienryderflex.com/hsp.html
  var hsp = Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b));

  // Using the HSP value, determine whether the color is light or dark
  return hsp > 127.5 ? 'light' : 'dark';
};
var Radio = function Radio(props) {
  return /*#__PURE__*/React.createElement(Choice, _extends$1({}, props, {
    type: "radio",
    inputTypeStyles: styles$d
  }), function (checked, disabled, theme) {
    var color = props.color,
      label = props.label,
      shape = props.shape,
      size = props.size;
    var isLightColor = isLightOrDark(color);
    var activeCheckmarkColor = isLightColor === 'light' ? 'black' : 'white';
    return (checked || color && shape !== 'regular' || rectangleShape(shape) || circleShape(shape)) && /*#__PURE__*/React.createElement("span", {
      className: getClassNames(checked, disabled, theme, shape, color, size),
      "data-testid": "fake-inner-radio",
      style: color && largeSize(size) && !disabled // eslint-disable-line
      ? {
        '--custom-inner-color': 'white'
      } : color && !disabled ? {
        '--custom-inner-color': color
      } : {
        '--custom-inner-color': checked ? 'var(--color-chathams-blue)' : 'var(--color-onahau)'
      }
    }, rectangleShape(shape) && /*#__PURE__*/React.createElement(Text$2, {
      bold: true,
      size: "medium"
    }, label), circleShape(shape) && largeSize(size) && checked && /*#__PURE__*/React.createElement("div", {
      className: styles$d["activeCheckmark__".concat(shape, "__").concat(size, "__container")],
      role: "radio",
      "aria-label": "radio_".concat(label),
      title: "radio_".concat(label),
      "aria-checked": checked
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$d["activeCheckmark__".concat(shape, "__").concat(size, "__item")]
    })), circleShape(shape) && largeSize(size) && !checked && /*#__PURE__*/React.createElement("div", {
      className: styles$d["colored__".concat(shape, "__").concat(size, "__container")],
      role: "radio",
      "aria-checked": checked,
      "aria-label": "radio_".concat(label),
      title: "radio_".concat(label)
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$d["colored__".concat(shape, "__").concat(size, "__item")]
    })), !disabled && checked && !largeSize(size) && (color || rectangleShape(shape)) && /*#__PURE__*/React.createElement("div", {
      className: styles$d["activeCheckmark__".concat(shape)]
    }, /*#__PURE__*/React.createElement(DecorativeIcon, {
      symbol: "check",
      variant: "white",
      color: activeCheckmarkColor,
      size: 16
    })));
  });
};
Radio.propTypes = {
  /**
   * The label.
   */
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  /**
   * Associate this radio with a group. Set as the HTML name attribute.
   */
  name: PropTypes.string.isRequired,
  /**
   * The value. Must be unique within the group.
   */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  /**
   * The checked state.
   */
  checked: PropTypes.bool,
  /**
   * A feedback state.
   */
  feedback: PropTypes.oneOf(['error']),
  /**
   * A callback function to be invoked when the radio is checked or unchecked.
   *
   * @param {SyntheticEvent} event The React `SyntheticEvent`
   */
  onChange: PropTypes.func,
  /**
   * A callback function to be invoked when the radio receives focus.
   *
   * @param {SyntheticEvent} event The React `SyntheticEvent`
   */
  onFocus: PropTypes.func,
  /**
   * A callback function to be invoked when the radio loses focus.
   *
   * @param {SyntheticEvent} event The React `SyntheticEvent`
   */
  onBlur: PropTypes.func,
  /**
   * The theme.
   */
  theme: PropTypes.oneOf(['commerce', 'support', 'secondary']),
  /**
   * The shape.
   */
  shape: PropTypes.oneOf(['regular', 'circle', 'rectangle']),
  /**
   * The color of the radio. This overrides the theme.
   */
  color: PropTypes.string,
  /**
   * The size.
   */
  size: PropTypes.oneOf(['normal', 'large'])
};
Radio.defaultProps = {
  checked: false,
  feedback: undefined,
  onChange: undefined,
  onFocus: undefined,
  onBlur: undefined,
  theme: undefined,
  shape: 'regular',
  color: '',
  size: 'normal'
};

var styles$c = {"flirt":"#7c1366","mosque":"#016b6a","texas":"#f9f6a5","amaranth":"#ee2c74","cardinal-pink":"#8c0448","trinidad":"#df3d0c","chestnut":"#bc4850","onahau":"#c3efff","burnt-sienna":"#ed6358","chathams-blue":"#17367d","mid-blue":"#1a347d","well-read":"#b8373e","wattle":"#d5e04d","beeswax":"#feeec7","bilbao":"#258b0b","sea-buckthorn":"#fbaf34","mint-tulip":"#c1f2e8","turquoise":"#39cdc9","hibiscus":"#c53a70","carousel-pink":"#fae6f4","white":"#fff","black":"#000","mortar":"#595959","gallery":"#efefef","silver":"#c9c8c8","dove":"#666666","iceberg":"#cbf0e8","icicle":"#e5f7fb","light-gray":"#fafafa","super-nova":"#fbaf33","expand-yellow":"#fee8b8","expand-yellow-light":"rgba(254, 232, 184, 0.5)","hero-pink":"#a6298c","ribbon__wrapper":"KDS_Ribbon-modules__ribbon__wrapper___1Mdzp","ribbon__container":"KDS_Ribbon-modules__ribbon__container___cwaFV"};

var _excluded$j = ["children", "top", "left", "theme"];
var Ribbon = function Ribbon(_ref) {
  var children = _ref.children,
    top = _ref.top,
    left = _ref.left,
    theme = _ref.theme,
    rest = _objectWithoutProperties$1(_ref, _excluded$j);
  var getStyle = function getStyle() {
    return {
      '--ribbonPosition': "".concat((top !== null && top !== void 0 ? top : left) ? 'absolute' : 'relative'),
      '--leftPosition': left ? "".concat(left, "px") : '0',
      '--topPosition': top ? "".concat(top, "px") : 0
    };
  };
  return /*#__PURE__*/React.createElement("div", _extends$1({}, safeRest(rest), {
    className: styles$c.ribbon__wrapper,
    style: getStyle()
  }), /*#__PURE__*/React.createElement("div", {
    className: "".concat(styles$c.ribbon__container, " ").concat(styles$c[theme]),
    style: {
      '--bgColor': "var(--color-".concat(theme, ")")
    }
  }, children));
};
Ribbon.propTypes = {
  /** Ribbon content */
  children: PropTypes.node.isRequired,
  /** Sets the left offset (triggers absolute positioning) */
  left: PropTypes.number,
  /** Sets the top offset (triggers absolute positioning) */
  top: PropTypes.number,
  /** theme must be from the list of available [`Colours`](#section-colours). */
  theme: PropTypes.string
};
Ribbon.defaultProps = {
  left: 0,
  top: 0,
  theme: 'carousel-pink'
};

var styles$b = {"flirt":"#7c1366","mosque":"#016b6a","texas":"#f9f6a5","amaranth":"#ee2c74","cardinal-pink":"#8c0448","trinidad":"#df3d0c","chestnut":"#bc4850","onahau":"#c3efff","burnt-sienna":"#ed6358","chathams-blue":"#17367d","mid-blue":"#1a347d","well-read":"#b8373e","wattle":"#d5e04d","beeswax":"#feeec7","bilbao":"#258b0b","sea-buckthorn":"#fbaf34","mint-tulip":"#c1f2e8","turquoise":"#39cdc9","hibiscus":"#c53a70","carousel-pink":"#fae6f4","white":"#fff","black":"#000","mortar":"#595959","gallery":"#efefef","silver":"#c9c8c8","dove":"#666666","iceberg":"#cbf0e8","icicle":"#e5f7fb","light-gray":"#fafafa","super-nova":"#fbaf33","expand-yellow":"#fee8b8","expand-yellow-light":"rgba(254, 232, 184, 0.5)","hero-pink":"#a6298c","wrapper":"KDS_Select-modules__wrapper___1JXEc KDS_Position-modules__relative___2Mmek","select":"KDS_Select-modules__select___3tBkk KDS_Forms-modules__height___2059u","positionSelectOnTop":"KDS_Select-modules__positionSelectOnTop___1BEnR KDS_Position-modules__relative___2Mmek","iconsPosition":"KDS_Select-modules__iconsPosition___3jpI0 KDS_Position-modules__absolute___3xAGg KDS_Position-modules__centervertically___JL31p KDS_FormField-modules__iconright___kQhVL","commerce":"KDS_Select-modules__commerce___34Ndo"};

var _excluded$i = ["options", "placeholder", "theme", "onChange"],
  _excluded2 = ["className"];
var variant = function variant(feedback, theme) {
  if (feedback === 'error') {
    return 'error';
  }
  if (theme === 'commerce') {
    return 'white';
  }
  return 'primary';
};
var Select = function Select(_ref) {
  var options = _ref.options,
    placeholder = _ref.placeholder,
    theme = _ref.theme,
    onChange = _ref.onChange,
    props = _objectWithoutProperties$1(_ref, _excluded$i);
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    selected = _useState2[0],
    setSelected = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isLoading = _useState4[0],
    setIsLoading = _useState4[1];
  useEffect(function () {
    var handleSetIsLoadingFalse = function handleSetIsLoadingFalse() {
      setIsLoading(false);
    };
    setIsLoading(true);
    if (isClient()) {
      if (document.readyState === 'complete') {
        setIsLoading(false);
      } else {
        window.addEventListener('pageshow', handleSetIsLoadingFalse);
      }
    }
    return function () {
      window.removeEventListener('pageshow', handleSetIsLoadingFalse);
    };
  }, []);
  useEffect(function () {
    setSelected(props.value);
  }, [props.value]);
  var handleChange = function handleChange(event) {
    setSelected(event.target.value);
    if (onChange) {
      onChange(event);
    }
  };
  return /*#__PURE__*/React.createElement(FormField, props, function (_ref2, showFeedbackIcon, feedback) {
    var className = _ref2.className,
      selectProps = _objectWithoutProperties$1(_ref2, _excluded2);
    return /*#__PURE__*/React.createElement("div", {
      className: styles$b.wrapper
    }, /*#__PURE__*/React.createElement("select", _extends$1({}, selectProps, {
      className: joinClassNames(className, getTheme(theme, styles$b), styles$b.select, !selectProps.disabled && styles$b.positionSelectOnTop),
      style: addRightPadding(showFeedbackIcon ? 2 : 1),
      value: isLoading ? options[0].value : selected,
      onChange: handleChange
    }), placeholder && /*#__PURE__*/React.createElement("option", {
      value: "",
      hidden: true,
      disabled: true
    }, placeholder), options.map(function (_ref3) {
      var text = _ref3.text,
        value = _ref3.value;
      return /*#__PURE__*/React.createElement("option", {
        key: value,
        value: value
      }, text);
    })), !selectProps.disabled && /*#__PURE__*/React.createElement(Box, {
      inline: true,
      between: 3,
      dangerouslyAddClassName: styles$b.iconsPosition
    }, /*#__PURE__*/React.createElement(FeedbackIcon, {
      showIcon: showFeedbackIcon,
      feedback: feedback
    }), /*#__PURE__*/React.createElement("div", {
      className: iconWrapperStyles.fixLineHeight
    }, /*#__PURE__*/React.createElement(DecorativeIcon, {
      symbol: "chevronDown",
      variant: variant(feedback, theme),
      size: 16
    }))));
  });
};
Select.propTypes = {
  /**
   * The selectable options.
   */
  options: PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.string,
    value: PropTypes.string
  })).isRequired,
  /**
   * The label.
   */
  label: PropTypes.string,
  /**
   * Clarify the expected input.
   */
  hint: PropTypes.string,
  /**
   * Show a un-selectable initial option.
   */
  placeholder: PropTypes.string,
  /**
   * The value.
   */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /**
   * A feedback state.
   */
  feedback: PropTypes.oneOf(['success', 'error']),
  /**
   * An error message. Either an error or a helper should be used, not both.
   */
  error: PropTypes.string,
  /**
   * A detailed explanation of the input expected by a form field. Can be text,
   * other components, or HTML elements.
   *
   * If a function is provided, it must return an `InputFeedback` component. The function will be
   * invoked with the following arguments.
   *
   * @param {String} feedback The input's current feedback state.
   * @param {String} value The input's current value.
   */
  helper: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
  /**
   * A `Tooltip`
   */
  tooltip: airbnbPropTypes.childrenOfType(Tooltip),
  /**
   * A callback function to be invoked when the input value changes.
   *
   * @param {SyntheticEvent} event The React `SyntheticEvent`
   */
  onChange: PropTypes.func,
  /**
   * A callback function to be invoked when the input receives focus.
   *
   * @param {SyntheticEvent} event The React `SyntheticEvent`
   */
  onFocus: PropTypes.func,
  /**
   * A callback function to be invoked when the input loses focus.
   *
   * @param {SyntheticEvent} event The React `SyntheticEvent`
   */
  onBlur: PropTypes.func,
  /**
   * This property determines the border radius and background color.
   */
  theme: PropTypes.oneOf(['commerce', 'default']),
  /**
   * Determines if the label is above or beside the input dropdown.
   */
  inlineLabel: PropTypes.bool
};
Select.defaultProps = {
  label: undefined,
  hint: undefined,
  placeholder: undefined,
  value: '',
  feedback: undefined,
  error: undefined,
  helper: undefined,
  tooltip: undefined,
  onChange: undefined,
  onFocus: undefined,
  onBlur: undefined,
  theme: 'default',
  inlineLabel: false
};

var classnames = {exports: {}};

/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
classnames.exports;

(function (module) {
	/* global define */

	(function () {

		var hasOwn = {}.hasOwnProperty;

		function classNames () {
			var classes = '';

			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (arg) {
					classes = appendClass(classes, parseValue(arg));
				}
			}

			return classes;
		}

		function parseValue (arg) {
			if (typeof arg === 'string' || typeof arg === 'number') {
				return arg;
			}

			if (typeof arg !== 'object') {
				return '';
			}

			if (Array.isArray(arg)) {
				return classNames.apply(null, arg);
			}

			if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
				return arg.toString();
			}

			var classes = '';

			for (var key in arg) {
				if (hasOwn.call(arg, key) && arg[key]) {
					classes = appendClass(classes, key);
				}
			}

			return classes;
		}

		function appendClass (value, newClass) {
			if (!newClass) {
				return value;
			}
		
			if (value) {
				return value + ' ' + newClass;
			}
		
			return value + newClass;
		}

		if (module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else {
			window.classNames = classNames;
		}
	}()); 
} (classnames));

var classnamesExports = classnames.exports;
var classNames = /*@__PURE__*/getDefaultExportFromCjs(classnamesExports);

var styles$a = {"flirt":"#7c1366","mosque":"#016b6a","texas":"#f9f6a5","amaranth":"#ee2c74","cardinal-pink":"#8c0448","trinidad":"#df3d0c","chestnut":"#bc4850","onahau":"#c3efff","burnt-sienna":"#ed6358","chathams-blue":"#17367d","mid-blue":"#1a347d","well-read":"#b8373e","wattle":"#d5e04d","beeswax":"#feeec7","bilbao":"#258b0b","sea-buckthorn":"#fbaf34","mint-tulip":"#c1f2e8","turquoise":"#39cdc9","hibiscus":"#c53a70","carousel-pink":"#fae6f4","white":"#fff","black":"#000","mortar":"#595959","gallery":"#efefef","silver":"#c9c8c8","dove":"#666666","iceberg":"#cbf0e8","icicle":"#e5f7fb","light-gray":"#fafafa","super-nova":"#fbaf33","expand-yellow":"#fee8b8","expand-yellow-light":"rgba(254, 232, 184, 0.5)","hero-pink":"#a6298c","stepTrackerContainer":"KDS_Steps-modules__stepTrackerContainer___1Mz7O","stepTracker":"KDS_Steps-modules__stepTracker___1s8Wc","step":"KDS_Steps-modules__step___yHj4W","icon":"KDS_Steps-modules__icon___2ldse","check":"KDS_Steps-modules__check___22TRh","label":"KDS_Steps-modules__label___3XJUU","mobileLabel":"KDS_Steps-modules__mobileLabel___1FHFt","selfServe":"KDS_Steps-modules__selfServe___2L8Iq","processingStep":"KDS_Steps-modules__processingStep___tPwd2","completedStep":"KDS_Steps-modules__completedStep___1hb-j","commerce":"KDS_Steps-modules__commerce___1BE0M","support":"KDS_Steps-modules__support___1LPn6"};

/**
 * A single step of a Steps component.
 *
 * _This component can only be used as a child of `Steps`, and must be accessed as a
 * name-spaced component: `Steps.Step`._
 *
 * @see See [Steps](#steps) for usage.
 */
var Step = function Step(_ref) {
  var label = _ref.label,
    status = _ref.status,
    stepNumber = _ref.stepNumber,
    theme = _ref.theme;
  var cls = classNames(styles$a.step, _defineProperty$1(_defineProperty$1({}, styles$a.completedStep, status === 'completed'), styles$a.processingStep, status === 'processing'));
  /* eslint-disable jsx-a11y/aria-props */
  return /*#__PURE__*/React.createElement("li", {
    className: cls,
    "aria-label": label,
    "aria-current": status === 'processing' ? 'true' : 'false'
  }, /*#__PURE__*/React.createElement("span", {
    className: styles$a.icon
  }, status === 'completed' && /*#__PURE__*/React.createElement("div", {
    className: styles$a.check
  }, /*#__PURE__*/React.createElement(DecorativeIcon, {
    symbol: "check",
    variant: "success"
  }))), /*#__PURE__*/React.createElement("span", {
    className: styles$a.label
  }, /*#__PURE__*/React.createElement(Text$2, {
    block: true,
    size: "medium",
    bold: status === 'processing'
  }, theme === 'selfServe' && "".concat(stepNumber, ". ").concat(label), theme === 'commerce' && label, theme === 'support' && label)));
  /* eslint-enable jsx-a11y/aria-props */
};
Step.defaultProps = {
  theme: 'selfServe'
};
Step.propTypes = {
  /**
   * The label.
   */
  label: PropTypes.string.isRequired,
  /**
   * The theme.
   */
  theme: PropTypes.oneOf(['commerce', 'selfServe', 'support']),
  /**
   * Each step's status is determined by its parent Steps component.
   *
   * @ignore
   */
  status: PropTypes.oneOf(['waiting', 'processing', 'completed']),
  // eslint-disable-line react/require-default-props
  /**
   * Each step's status is determined by its parent Steps component.
   *
   * @ignore
   */
  stepNumber: PropTypes.number // eslint-disable-line react/require-default-props
};

var parseStepText = function parseStepText(current, steps, mobileStepLabelTemplate) {
  return /*#__PURE__*/React.createElement("span", null, mobileStepLabelTemplate.replace('%{current}', current < steps.length ? current + 1 : steps.length).replace('%{total}', steps.length));
};
var getStepLabel = function getStepLabel(current, steps) {
  return current < steps.length ? steps[current] : steps[steps.length - 1];
};

/**
 * Show the current position in a sequence of steps.
 */
var Steps = /*#__PURE__*/function (_Component) {
  function Steps() {
    _classCallCheck(this, Steps);
    return _callSuper(this, Steps, arguments);
  }
  _inherits(Steps, _Component);
  return _createClass(Steps, [{
    key: "getStatus",
    value: function getStatus(current, index) {
      if (index < current) {
        return 'completed';
      }
      if (index === current) {
        return 'processing';
      }
      return 'waiting';
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;
      var _this$props = this.props,
        children = _this$props.children,
        current = _this$props.current,
        steps = _this$props.steps,
        mobileStepLabelTemplate = _this$props.mobileStepLabelTemplate,
        theme = _this$props.theme,
        showMobileLabel = _this$props.showMobileLabel;
      var stepText = parseStepText(current, steps, mobileStepLabelTemplate);
      var stepLabel = getStepLabel(current, steps);
      return /*#__PURE__*/React.createElement("div", {
        role: "progressbar",
        className: styles$a[theme]
      }, /*#__PURE__*/React.createElement("div", {
        className: styles$a.stepTrackerContainer
      }, /*#__PURE__*/React.createElement("ul", {
        className: styles$a.stepTracker
      }, React.Children.map(children, function (element, index) {
        var stepNumber = index + 1;
        var status = _this.getStatus(current, index);
        var props = {
          stepNumber: stepNumber,
          status: status,
          theme: theme
        };
        return /*#__PURE__*/React.cloneElement(element, props);
      }, this)), showMobileLabel && /*#__PURE__*/React.createElement("div", {
        className: styles$a.mobileLabel
      }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Text$2, {
        size: "medium",
        bold: true
      }, stepText, ' ', stepLabel)))));
    }
  }]);
}(Component);
Steps.propTypes = {
  /**
   * The active step.
   */
  current: PropTypes.number,
  /**
   * The steps as an array of strings.
   */
  steps: PropTypes.array.isRequired,
  /**
   * The steps. Must be TDS `Steps.Step` components.
   *
   * @see See [Steps.Step](#step)
   */
  children: PropTypes.node,
  // eslint-disable-line react/require-default-props,
  /**
   * String for text to display current step progress on mobile devices.
   * Use %current to place the current step and use %total to place the total amount of steps.
   */
  mobileStepLabelTemplate: PropTypes.string,
  /**
   * Theme to determine the colors
   */
  theme: PropTypes.oneOf(['commerce', 'selfServe', 'support']),
  /**
   * bool value to hide/show step mobile label.
   */
  showMobileLabel: PropTypes.bool
};
Steps.defaultProps = {
  current: 0,
  mobileStepLabelTemplate: 'Step %{current} of %{total}:',
  theme: 'selfServe',
  showMobileLabel: true
};
Steps.Step = Step;

var _excluded$h = ["children", "color"];

/**
 * Give portions of a sentence added importance.
 */
var Strong = function Strong(_ref) {
  var children = _ref.children,
    color = _ref.color,
    rest = _objectWithoutProperties$1(_ref, _excluded$h);
  return /*#__PURE__*/React.createElement("strong", _extends$1({}, safeRest(rest), {
    className: "".concat(styles$X.boldFont, " ").concat(color ? styles$X.color : styles$X.inheritColor),
    style: color ? {
      '--font-color': "var(--color-".concat(color, ")")
    } : {}
  }), children);
};
Strong.propTypes = {
  /**
   * The text.
   */
  children: PropTypes.node.isRequired,
  /**
   * Font color when not inheriting. Must be from the list of available [`Colours`](#section-colours).
   */
  color: PropTypes.string
};
Strong.defaultProps = {
  color: undefined
};

var styles$9 = {"flirt":"#7c1366","mosque":"#016b6a","texas":"#f9f6a5","amaranth":"#ee2c74","cardinal-pink":"#8c0448","trinidad":"#df3d0c","chestnut":"#bc4850","onahau":"#c3efff","burnt-sienna":"#ed6358","chathams-blue":"#17367d","mid-blue":"#1a347d","well-read":"#b8373e","wattle":"#d5e04d","beeswax":"#feeec7","bilbao":"#258b0b","sea-buckthorn":"#fbaf34","mint-tulip":"#c1f2e8","turquoise":"#39cdc9","hibiscus":"#c53a70","carousel-pink":"#fae6f4","white":"#fff","black":"#000","mortar":"#595959","gallery":"#efefef","silver":"#c9c8c8","dove":"#666666","iceberg":"#cbf0e8","icicle":"#e5f7fb","light-gray":"#fafafa","super-nova":"#fbaf33","expand-yellow":"#fee8b8","expand-yellow-light":"rgba(254, 232, 184, 0.5)","hero-pink":"#a6298c","success":"KDS_Success-modules__success___10dVW"};

/**
  * A feedback indicator to inform the customer that an operation was successful.
*/
var Success = function Success(_ref) {
  var description = _ref.description,
    title = _ref.title,
    visible = _ref.visible,
    dangerouslyAddClassName = _ref.dangerouslyAddClassName;
  var classes = joinClassNames(styles$9.success, dangerouslyAddClassName);
  return visible && /*#__PURE__*/React.createElement("div", {
    className: classes
  }, /*#__PURE__*/React.createElement(DecorativeIcon, {
    size: 40,
    symbol: "checkCircledNotFilled"
  }), /*#__PURE__*/React.createElement(Strong, null, title), /*#__PURE__*/React.createElement(Paragraph$1, null, description));
};
Success.propTypes = {
  /**
    * The description.
  */
  description: PropTypes.string,
  /**
    * The title.
  */
  title: PropTypes.string,
  /**
    * Whether or not to show the component.
  */
  visible: PropTypes.bool,
  /**
   * Append custom classes to `className`. Use sparingly, and do not
   * attempt to override Box style properties as that may cause unexpected behaviour.
   *
   * You would typically use this feature to apply flex alignment
   * properties in combination with `between`.
   */
  dangerouslyAddClassName: PropTypes.string
};
Success.defaultProps = {
  description: undefined,
  title: undefined,
  visible: false,
  dangerouslyAddClassName: undefined
};

var styles$8 = {"flirt":"#7c1366","mosque":"#016b6a","texas":"#f9f6a5","amaranth":"#ee2c74","cardinal-pink":"#8c0448","trinidad":"#df3d0c","chestnut":"#bc4850","onahau":"#c3efff","burnt-sienna":"#ed6358","chathams-blue":"#17367d","mid-blue":"#1a347d","well-read":"#b8373e","wattle":"#d5e04d","beeswax":"#feeec7","bilbao":"#258b0b","sea-buckthorn":"#fbaf34","mint-tulip":"#c1f2e8","turquoise":"#39cdc9","hibiscus":"#c53a70","carousel-pink":"#fae6f4","white":"#fff","black":"#000","mortar":"#595959","gallery":"#efefef","silver":"#c9c8c8","dove":"#666666","iceberg":"#cbf0e8","icicle":"#e5f7fb","light-gray":"#fafafa","super-nova":"#fbaf33","expand-yellow":"#fee8b8","expand-yellow-light":"rgba(254, 232, 184, 0.5)","hero-pink":"#a6298c","skeleton":"KDS_Skeleton-modules__skeleton___3T2ap","skeletonShimmer":"KDS_Skeleton-modules__skeletonShimmer___1bjpJ","skeletonsquare":"KDS_Skeleton-modules__skeletonsquare___3D1ca","skeletoncircle":"KDS_Skeleton-modules__skeletoncircle___3tObv","skeletonrectangle":"KDS_Skeleton-modules__skeletonrectangle___1ved-"};

var _excluded$g = ["characters", "size", "shape", "width", "height"];
var SIZES = {
  xs: 18,
  sm: 24,
  md: 36,
  lg: 48,
  xl: 64
};
var SHAPES = {
  rectangle: 'rectangle',
  circle: 'circle',
  square: 'square'
};
/**
 * Skeleton component for mocking content while it is loading.
 *
 * @version ./package.json
 */
var Skeleton = function Skeleton(_ref) {
  var characters = _ref.characters,
    size = _ref.size,
    shape = _ref.shape,
    width = _ref.width,
    height = _ref.height,
    rest = _objectWithoutProperties$1(_ref, _excluded$g);
  var parsedCharacters = parseInt(characters, 10);
  var safeCharacters = parsedCharacters || 0;
  var safeSize = SIZES[size] || SIZES.xs;
  var safeShape = SHAPES[shape];
  var safeHeight = height || '100px';
  var safeWidth = width || '100%';
  var isFixedCharacterWidth = safeCharacters > 0;
  var skWidth = safeShape ? safeWidth : "".concat(isFixedCharacterWidth ? "".concat(characters * safeSize, "px") : '100%');
  return /*#__PURE__*/React.createElement("span", _extends$1({
    className: "".concat(styles$8.skeleton, " ").concat(safeShape ? styles$8["skeleton".concat(safeShape)] : ''),
    style: {
      '--skeleton-size': safeSize,
      '--skeleton-width': skWidth,
      '--skeleton-height': safeHeight
    }
  }, safeRest(rest), {
    "aria-busy": "true"
  }));
};
Skeleton.propTypes = {
  /** Number of "M" characters to emulate (full width & height per size) <br />
    <em>NOTE: default and overflow states both assume to 100% width instead</em> */
  characters: PropTypes.number,
  /** Size of text to emulate (line height in pixels) */
  size: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
  /** Shape of content to emulate */
  shape: PropTypes.oneOf(['typography', 'circle', 'square', 'rectangle']),
  /** Size of shape to render - only used when passing the shape prop */
  width: PropTypes.string,
  height: PropTypes.string
};
Skeleton.defaultProps = {
  characters: 0,
  size: 'xs',
  shape: 'typography',
  width: '100%',
  height: '100px'
};

var SkeletonContext = /*#__PURE__*/createContext('skeleton');

var _excluded$f = ["skeleton"];
var SkeletonRenderer = function SkeletonRenderer(props) {
  var skeleton = props.skeleton,
    render = props.render;
  return /*#__PURE__*/React.createElement(SkeletonContext.Consumer, null, function (context) {
    return context.show ? skeleton() : render();
  });
};
SkeletonRenderer.propTypes = {
  render: PropTypes.func.isRequired,
  skeleton: PropTypes.func.isRequired
};
var getName = function getName(comp) {
  return comp.displayName || comp.name || 'Component';
};
var withSkeleton = function withSkeleton(SkeletonComponent) {
  return function (WrapperComponent) {
    return function wrapper(_ref) {
      var _skeleton = _ref.skeleton,
        props = _objectWithoutProperties$1(_ref, _excluded$f);
      wrapper.displayName = "withSkeleton(".concat(getName(SkeletonComponent), ")");
      wrapper.propTypes = {
        skeleton: PropTypes.oneOfType([PropTypes.bool, PropTypes.object])
      };
      wrapper.defaultProps = {
        skeleton: undefined
      };
      return /*#__PURE__*/React.createElement(SkeletonRenderer, {
        skeleton: function skeleton() {
          return /*#__PURE__*/React.createElement(SkeletonComponent, _extends$1({
            skeleton: _skeleton
          }, safeRest(props)));
        },
        render: function render() {
          return /*#__PURE__*/React.createElement(WrapperComponent, safeRest(props));
        }
      });
    };
  };
};

var styles$7 = {"flirt":"#7c1366","mosque":"#016b6a","texas":"#f9f6a5","amaranth":"#ee2c74","cardinal-pink":"#8c0448","trinidad":"#df3d0c","chestnut":"#bc4850","onahau":"#c3efff","burnt-sienna":"#ed6358","chathams-blue":"#17367d","mid-blue":"#1a347d","well-read":"#b8373e","wattle":"#d5e04d","beeswax":"#feeec7","bilbao":"#258b0b","sea-buckthorn":"#fbaf34","mint-tulip":"#c1f2e8","turquoise":"#39cdc9","hibiscus":"#c53a70","carousel-pink":"#fae6f4","white":"#fff","black":"#000","mortar":"#595959","gallery":"#efefef","silver":"#c9c8c8","dove":"#666666","iceberg":"#cbf0e8","icicle":"#e5f7fb","light-gray":"#fafafa","super-nova":"#fbaf33","expand-yellow":"#fee8b8","expand-yellow-light":"rgba(254, 232, 184, 0.5)","hero-pink":"#a6298c","skeletonHeading":"KDS_Skeletons-modules__skeletonHeading___2yxD4","skeletonText":"KDS_Skeletons-modules__skeletonText___1fiwT","skeletonImage":"KDS_Skeletons-modules__skeletonImage___R21bS","skeletonShimmer":"KDS_Skeletons-modules__skeletonShimmer___25uOJ","skeletonImage__circular":"KDS_Skeletons-modules__skeletonImage__circular___3hjc7"};

var _excluded$e = ["skeleton"];
var HeadingSkeleton = function HeadingSkeleton(_ref) {
  var skeleton = _ref.skeleton,
    rest = _objectWithoutProperties$1(_ref, _excluded$e);
  if (!skeleton) {
    return /*#__PURE__*/React.createElement(Heading$1, rest);
  }
  var level = rest.level;
  var levels = {
    h1: 'lg',
    h2: 'md',
    h3: 'sm',
    h4: 'xs'
  };
  var characters = skeleton.characters;
  if (skeleton === true) {
    characters = undefined;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: styles$7.headingSkeleton
  }, /*#__PURE__*/React.createElement(Skeleton, {
    characters: characters,
    size: level ? levels[level] : 'md'
  }));
};
HeadingSkeleton.propTypes = {
  skeleton: PropTypes.oneOfType([PropTypes.shape({
    characters: PropTypes.number
  }), PropTypes.bool])
};
HeadingSkeleton.defaultProps = {
  skeleton: undefined
};
var Heading = withSkeleton(HeadingSkeleton)(Heading$1);

var _excluded$d = ["skeleton"];
var TextSkeleton = function TextSkeleton(_ref) {
  var skeleton = _ref.skeleton,
    rest = _objectWithoutProperties$1(_ref, _excluded$d);
  if (!skeleton) {
    return /*#__PURE__*/React.createElement(Text$2, rest);
  }
  var skSizes = {
    large: 'md',
    base: 'xs',
    small: 'xs',
    medium: 'sm'
  };
  var size = skeleton.size;
  var lines = skeleton.lines,
    characters = skeleton.characters;
  var skSize = skSizes[size] || 'xs';
  if (skeleton === true) {
    lines = 1;
    characters = undefined;
  }
  if (!lines || lines < 1) {
    lines = 1;
  }
  if (lines === 1) {
    return /*#__PURE__*/React.createElement(Skeleton, {
      size: skSize,
      characters: characters
    });
  }
  return /*#__PURE__*/React.createElement("div", {
    className: styles$7.skeletonText
  }, _toConsumableArray(Array(lines)).map(function (_, idx) {
    return (
      /*#__PURE__*/
      // eslint-disable-next-line react/no-array-index-key
      React.createElement("div", {
        key: idx
      }, /*#__PURE__*/React.createElement(Skeleton, {
        size: skSize,
        characters: characters
      }))
    );
  }));
};
TextSkeleton.propTypes = {
  skeleton: PropTypes.oneOfType([PropTypes.shape({
    characters: PropTypes.number,
    lines: PropTypes.number
  }), PropTypes.bool])
};
TextSkeleton.defaultProps = {
  skeleton: undefined
};
var Text = withSkeleton(TextSkeleton)(Text$2);

var _excluded$c = ["skeleton"];
var OptimizeImageSkeleton = function OptimizeImageSkeleton(_ref) {
  var skeleton = _ref.skeleton,
    rest = _objectWithoutProperties$1(_ref, _excluded$c);
  if (!skeleton) {
    return /*#__PURE__*/React.createElement(OptimizeImage$1, safeRest(rest));
  }
  var _skeleton$rounded = skeleton.rounded,
    rounded = _skeleton$rounded === void 0 ? 'circular' : _skeleton$rounded,
    _skeleton$width = skeleton.width,
    width = _skeleton$width === void 0 ? 100 : _skeleton$width,
    _skeleton$height = skeleton.height,
    height = _skeleton$height === void 0 ? 100 : _skeleton$height;
  var safeWidth = parseInt(width, 10);
  var safeHeight = parseInt(height, 10);
  var skImageStyles = {
    '--skeleton-image-width': safeWidth,
    '--skeleton-image-height': safeHeight
  };
  if (rounded === 'circular') {
    // when using circle, the height props is used to size the skeleton
    // this will force the skeleton to be a circle and avoid rendering as ovals
    return /*#__PURE__*/React.createElement("div", {
      className: "".concat(styles$7.skeletonImage, " ").concat(styles$7.skeletonImage__circular),
      style: {
        '--skeleton-image-width': safeHeight,
        '--skeleton-image-height': safeHeight
      }
    });
  }
  return /*#__PURE__*/React.createElement("div", {
    className: styles$7.skeletonImage,
    style: skImageStyles
  });
};
OptimizeImageSkeleton.propTypes = {
  skeleton: PropTypes.oneOfType([PropTypes.shape({
    rounded: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number
  }), PropTypes.bool])
};
OptimizeImageSkeleton.defaultProps = {
  skeleton: false
};
var OptimizeImage = withSkeleton(OptimizeImageSkeleton)(OptimizeImage$1);

var _excluded$b = ["skeleton"];
var ParagraphSkeleton = function ParagraphSkeleton(_ref) {
  var skeleton = _ref.skeleton,
    rest = _objectWithoutProperties$1(_ref, _excluded$b);
  if (!skeleton) {
    return /*#__PURE__*/React.createElement(Paragraph$1, rest);
  }
  var skSizes = {
    large: 'md',
    base: 'xs',
    small: 'xs',
    medium: 'sm'
  };
  var size = skeleton.size;
  var lines = skeleton.lines,
    characters = skeleton.characters;
  var skSize = skSizes[size] || 'xs';
  if (skeleton === true) {
    lines = 1;
    characters = undefined;
  }
  if (!lines || lines < 1) {
    lines = 1;
  }
  if (lines === 1) {
    return /*#__PURE__*/React.createElement(Skeleton, {
      size: skSize,
      characters: characters
    });
  }
  return /*#__PURE__*/React.createElement("div", {
    className: styles$7.skeletonText
  }, _toConsumableArray(Array(lines)).map(function (_, idx) {
    return (
      /*#__PURE__*/
      // eslint-disable-next-line react/no-array-index-key
      React.createElement("div", {
        key: idx
      }, /*#__PURE__*/React.createElement(Skeleton, {
        size: skSize,
        characters: characters
      }))
    );
  }));
};
ParagraphSkeleton.propTypes = {
  skeleton: PropTypes.oneOfType([PropTypes.shape({
    characters: PropTypes.number,
    lines: PropTypes.number
  }), PropTypes.bool])
};
ParagraphSkeleton.defaultProps = {
  skeleton: undefined
};
var Paragraph = withSkeleton(ParagraphSkeleton)(Paragraph$1);

var Skeletons = {
  Heading: Heading,
  Text: Text,
  Paragraph: Paragraph,
  OptimizeImage: OptimizeImage
};

var AutoSkeletonizer = function AutoSkeletonizer(children) {
  var skeletonChildren = React.Children.map(children, function (childElement) {
    var child = childElement;
    if (child === null) {
      return null;
    }
    if (child.props && 'children' in child.props) {
      child = /*#__PURE__*/React.cloneElement(child, {
        children: AutoSkeletonizer(child.props.children)
      });
    }
    if (child.props && 'skeleton' in child.props && typeof child.props.skeleton === 'function') {
      var EnhancedChild = withSkeleton(child.props.skeleton)(function () {
        return child;
      });
      return /*#__PURE__*/React.createElement(EnhancedChild, child.props);
    }
    switch (child.type) {
      case Heading$1:
        return /*#__PURE__*/React.createElement(Skeletons.Heading, child.props);
      case Text$2:
        return /*#__PURE__*/React.createElement(Skeletons.Text, child.props);
      case Paragraph$1:
        return /*#__PURE__*/React.createElement(Skeletons.Paragraph, child.props);
      case OptimizeImage$1:
        return /*#__PURE__*/React.createElement(Skeletons.OptimizeImage, child.props);
      default:
        return child;
    }
  });
  return skeletonChildren;
};

/* eslint-disable react/no-did-update-set-state */
var SkeletonProvider = /*#__PURE__*/function (_Component) {
  function SkeletonProvider(props) {
    var _this;
    _classCallCheck(this, SkeletonProvider);
    _this = _callSuper(this, SkeletonProvider, [props]);
    var show = _this.props.show;
    _this.state = {
      show: show
    };
    return _this;
  }
  _inherits(SkeletonProvider, _Component);
  return _createClass(SkeletonProvider, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var show = this.props.show;
      if (prevProps.show !== show) {
        this.setState({
          show: show
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var show = this.state.show;
      var children = this.props.children;
      return (
        /*#__PURE__*/
        // eslint-disable-next-line react/jsx-no-constructed-context-values
        React.createElement(SkeletonContext.Provider, {
          value: {
            show: show
          }
        }, AutoSkeletonizer(children))
      );
    }
  }]);
}(Component);
SkeletonProvider.propTypes = {
  show: PropTypes.bool,
  children: PropTypes.node.isRequired
};
SkeletonProvider.defaultProps = {
  show: true
};

var styles$6 = {"flirt":"#7c1366","mosque":"#016b6a","texas":"#f9f6a5","amaranth":"#ee2c74","cardinal-pink":"#8c0448","trinidad":"#df3d0c","chestnut":"#bc4850","onahau":"#c3efff","burnt-sienna":"#ed6358","chathams-blue":"#17367d","mid-blue":"#1a347d","well-read":"#b8373e","wattle":"#d5e04d","beeswax":"#feeec7","bilbao":"#258b0b","sea-buckthorn":"#fbaf34","mint-tulip":"#c1f2e8","turquoise":"#39cdc9","hibiscus":"#c53a70","carousel-pink":"#fae6f4","white":"#fff","black":"#000","mortar":"#595959","gallery":"#efefef","silver":"#c9c8c8","dove":"#666666","iceberg":"#cbf0e8","icicle":"#e5f7fb","light-gray":"#fafafa","super-nova":"#fbaf33","expand-yellow":"#fee8b8","expand-yellow-light":"rgba(254, 232, 184, 0.5)","hero-pink":"#a6298c","table":"KDS_Table-modules__table___3PwIO"};

var _excluded$a = ["data"];
var Table = function Table(_ref) {
  var _ref$data = _ref.data,
    columns = _ref$data.columns,
    rows = _ref$data.rows,
    rest = _objectWithoutProperties$1(_ref, _excluded$a);
  var name = process.env.NODE_ENV !== 'test'
  // generate a random table name to use in maps for React keys
  ? "table".concat(Math.random().toFixed(12).substring(2, 12)) // use a static string when testing to avoid breaking snapshots
  : 'tableTest';
  return /*#__PURE__*/React.createElement("table", _extends$1({
    className: styles$6.table
  }, safeRest(rest)), /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, columns.map(function (column, columnIndex) {
    var thKey = "".concat(name, "-th").concat(columnIndex + 1);
    var header = column.header,
      width = column.width;
    return /*#__PURE__*/React.createElement("th", {
      key: thKey,
      style: {
        width: width
      }
    }, header);
  }))), /*#__PURE__*/React.createElement("tbody", null, rows.map(function (row, rowIndex) {
    var trKey = "".concat(name, "-tr").concat(rowIndex + 1);
    return /*#__PURE__*/React.createElement("tr", {
      key: trKey
    }, row.map(function (column, columnIndex) {
      var tdKey = "".concat(trKey, "-td").concat(columnIndex + 1);
      return /*#__PURE__*/React.createElement("td", {
        key: tdKey
      }, column);
    }));
  })));
};
Table.propTypes = {
  /** The table data. */
  data: PropTypes.shape({
    /**
     * The table columns.
     * Its children are objects with `header` and `width` properties.
     */
    columns: PropTypes.array,
    /**
     * The table rows.
     * Its children can be any type of item; common use cases will be strings and React components.
     */
    rows: PropTypes.array
  })
};
Table.defaultProps = {
  data: {
    columns: undefined,
    rows: undefined
  }
};

var styles$5 = {"flirt":"#7c1366","mosque":"#016b6a","texas":"#f9f6a5","amaranth":"#ee2c74","cardinal-pink":"#8c0448","trinidad":"#df3d0c","chestnut":"#bc4850","onahau":"#c3efff","burnt-sienna":"#ed6358","chathams-blue":"#17367d","mid-blue":"#1a347d","well-read":"#b8373e","wattle":"#d5e04d","beeswax":"#feeec7","bilbao":"#258b0b","sea-buckthorn":"#fbaf34","mint-tulip":"#c1f2e8","turquoise":"#39cdc9","hibiscus":"#c53a70","carousel-pink":"#fae6f4","white":"#fff","black":"#000","mortar":"#595959","gallery":"#efefef","silver":"#c9c8c8","dove":"#666666","iceberg":"#cbf0e8","icicle":"#e5f7fb","light-gray":"#fafafa","super-nova":"#fbaf33","expand-yellow":"#fee8b8","expand-yellow-light":"rgba(254, 232, 184, 0.5)","hero-pink":"#a6298c","switchContainer":"KDS_ToggleSwitch-modules__switchContainer___3NISq","switchItem":"KDS_ToggleSwitch-modules__switchItem___3iZo0","switch":"KDS_ToggleSwitch-modules__switch___3M6ac","slider":"KDS_ToggleSwitch-modules__slider___1oUlQ","switchOn":"KDS_ToggleSwitch-modules__switchOn___1IHDf","switchOff":"KDS_ToggleSwitch-modules__switchOff___3e5vA","switchDisabled":"KDS_ToggleSwitch-modules__switchDisabled___3TXya","hiddenInput":"KDS_ToggleSwitch-modules__hiddenInput___3DwbH"};

var _excluded$9 = ["id", "label", "name", "value", "checked", "onBlur", "onChange", "onFocus"];

/**
  * ToggleSwitch is an alternative to using a checkbox, and maintains a similar component interface to [KDS Checkbox](#checkbox).

  * This component will _only_ maintain internal state when an `onChange` handler is _not_ provided.
    When an `onChange` handler is passed, it becomes the app's responsibility to manage this component's state through props.
  */
var ToggleSwitch = /*#__PURE__*/function (_Component) {
  function ToggleSwitch() {
    var _this;
    _classCallCheck(this, ToggleSwitch);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ToggleSwitch, [].concat(args));
    _defineProperty$1(_this, "onChange", function (event) {
      var onChange = _this.props.onChange;
      if (onChange) {
        event.persist();
        onChange(event);
      } else {
        _this.setState(function (_ref) {
          var checked = _ref.checked;
          return {
            checked: !checked
          };
        });
      }
    });
    _defineProperty$1(_this, "onFocus", function (event) {
      var onFocus = _this.props.onFocus;
      if (onFocus) {
        event.persist();
        onFocus(event);
      }
    });
    _defineProperty$1(_this, "onBlur", function (event) {
      var onBlur = _this.props.onBlur;
      if (onBlur) {
        event.persist();
        onBlur(event);
      }
    });
    return _this;
  }
  _inherits(ToggleSwitch, _Component);
  return _createClass(ToggleSwitch, [{
    key: "UNSAFE_componentWillMount",
    value: function UNSAFE_componentWillMount() {
      var checked = this.props.checked;
      this.setState({
        checked: checked
      });
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var checked = nextProps.checked;
      // eslint-disable-next-line
      if (this.state.checked !== checked) {
        // eslint-disable-next-line
        this.setState({
          checked: checked
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        id = _this$props.id,
        label = _this$props.label,
        name = _this$props.name,
        value = _this$props.value;
        _this$props.checked;
        _this$props.onBlur;
        _this$props.onChange;
        _this$props.onFocus;
        var rest = _objectWithoutProperties$1(_this$props, _excluded$9);
      var labelledById = "".concat(id, "-label");
      var disabled = !!rest && !!rest.disabled;

      // eslint-disable-next-line
      var switchStatusClass = this.state.checked ? styles$5.switchOn : styles$5.switchOff;
      var switchClasses = disabled ? [styles$5["switch"], switchStatusClass, styles$5.switchDisabled] : [styles$5["switch"], switchStatusClass];
      return /*#__PURE__*/React.createElement("label", {
        htmlFor: id
      }, /*#__PURE__*/React.createElement(Box, {
        tag: "span",
        dangerouslyAddClassName: styles$5.switchContainer,
        inline: true,
        between: 3
      }, /*#__PURE__*/React.createElement("span", {
        className: styles$5.switchItem
      }, /*#__PURE__*/React.createElement("input", _extends$1({}, safeRest(rest), {
        className: styles$5.hiddenInput,
        id: id,
        type: "checkbox",
        name: name,
        value: value,
        checked: this.state.checked // eslint-disable-line
        ,
        disabled: disabled,
        "aria-labelledby": labelledById,
        onChange: this.onChange,
        onFocus: this.onFocus,
        onBlur: this.onBlur
      })), /*#__PURE__*/React.createElement("span", {
        "data-testid": "".concat(id, "-switch"),
        "aria-checked": this.state.checked // eslint-disable-line
        ,
        className: switchClasses.join(' ')
      }, /*#__PURE__*/React.createElement("span", {
        className: styles$5.slider
      }))), /*#__PURE__*/React.createElement(Text$2, {
        id: labelledById,
        size: "medium"
      }, label)));
    }
  }]);
}(Component);
ToggleSwitch.propTypes = {
  /** The unique HTML id for this form input. */
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  /** The label. */
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  /** Associate this checkbox with a group. Set as the HTML name attribute. */
  name: PropTypes.string.isRequired,
  /** The value. Must be unique within the group. */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]).isRequired,
  /** The checked state. */
  checked: PropTypes.bool,
  /** A callback function to be invoked when the checkbox loses focus.
  @param {SyntheticEvent} event The React `SyntheticEvent` */
  onBlur: PropTypes.func,
  /** A callback function to be invoked when the checkbox is checked or unchecked.
  @param {SyntheticEvent} event The React `SyntheticEvent` */
  onChange: PropTypes.func,
  /** A callback function to be invoked when the checkbox receives focus.
  @param {SyntheticEvent} event The React `SyntheticEvent` */
  onFocus: PropTypes.func
};
ToggleSwitch.defaultProps = {
  checked: false,
  onBlur: undefined,
  onChange: undefined,
  onFocus: undefined
};

var styles$4 = {"flirt":"#7c1366","mosque":"#016b6a","texas":"#f9f6a5","amaranth":"#ee2c74","cardinal-pink":"#8c0448","trinidad":"#df3d0c","chestnut":"#bc4850","onahau":"#c3efff","burnt-sienna":"#ed6358","chathams-blue":"#17367d","mid-blue":"#1a347d","well-read":"#b8373e","wattle":"#d5e04d","beeswax":"#feeec7","bilbao":"#258b0b","sea-buckthorn":"#fbaf34","mint-tulip":"#c1f2e8","turquoise":"#39cdc9","hibiscus":"#c53a70","carousel-pink":"#fae6f4","white":"#fff","black":"#000","mortar":"#595959","gallery":"#efefef","silver":"#c9c8c8","dove":"#666666","iceberg":"#cbf0e8","icicle":"#e5f7fb","light-gray":"#fafafa","super-nova":"#fbaf33","expand-yellow":"#fee8b8","expand-yellow-light":"rgba(254, 232, 184, 0.5)","hero-pink":"#a6298c","toastContainer":"KDS_ToastNotification-modules__toastContainer___3QB68","toast":"KDS_ToastNotification-modules__toast___1sCS1","center":"KDS_ToastNotification-modules__center___fr_Qu","left":"KDS_ToastNotification-modules__left___19Axq","right":"KDS_ToastNotification-modules__right___1f_ig"};

var _excluded$8 = ["show", "handleHide", "align", "text"];
var ToastNotification = function ToastNotification(_ref) {
  var show = _ref.show,
    handleHide = _ref.handleHide,
    align = _ref.align,
    text = _ref.text,
    rest = _objectWithoutProperties$1(_ref, _excluded$8);
  useEffect(function () {
    var timer = setTimeout(function () {
      return handleHide();
    }, 2000);
    return function () {
      return clearTimeout(timer);
    };
  }, [show]);
  var className = joinClassNames(styles$4.toast, styles$4[align]);
  return /*#__PURE__*/React.createElement(Fade, {
    "in": show,
    timeout: 200,
    mountOnEnter: true,
    unmountOnExit: true
  }, function () {
    return /*#__PURE__*/React.createElement("div", _extends$1({
      className: styles$4.toastContainer
    }, safeRest(rest)), /*#__PURE__*/React.createElement("div", {
      className: className
    }, /*#__PURE__*/React.createElement(Text$2, {
      bold: true
    }, text)));
  });
};
ToastNotification.propTypes = {
  show: PropTypes.bool,
  handleHide: PropTypes.func.isRequired,
  align: PropTypes.oneOf(['center', 'left', 'right']),
  text: PropTypes.string.isRequired
};
ToastNotification.defaultProps = {
  show: false,
  align: 'center'
};

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */

function isObject$2(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

var isObject_1 = isObject$2;

/** Detect free variable `global` from Node.js. */

var freeGlobal$1 = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

var _freeGlobal = freeGlobal$1;

var freeGlobal = _freeGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root$2 = freeGlobal || freeSelf || Function('return this')();

var _root = root$2;

var root$1 = _root;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now$1 = function() {
  return root$1.Date.now();
};

var now_1 = now$1;

/** Used to match a single whitespace character. */

var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex$1(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

var _trimmedEndIndex = trimmedEndIndex$1;

var trimmedEndIndex = _trimmedEndIndex;

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim$1(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

var _baseTrim = baseTrim$1;

var root = _root;

/** Built-in value references. */
var Symbol$3 = root.Symbol;

var _Symbol = Symbol$3;

var Symbol$2 = _Symbol;

/** Used for built-in method references. */
var objectProto$1 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto$1.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$1 = objectProto$1.toString;

/** Built-in value references. */
var symToStringTag$1 = Symbol$2 ? Symbol$2.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag$1(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag$1),
      tag = value[symToStringTag$1];

  try {
    value[symToStringTag$1] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString$1.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$1] = tag;
    } else {
      delete value[symToStringTag$1];
    }
  }
  return result;
}

var _getRawTag = getRawTag$1;

/** Used for built-in method references. */

var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString$1(value) {
  return nativeObjectToString.call(value);
}

var _objectToString = objectToString$1;

var Symbol$1 = _Symbol,
    getRawTag = _getRawTag,
    objectToString = _objectToString;

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol$1 ? Symbol$1.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag$1(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

var _baseGetTag = baseGetTag$1;

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */

function isObjectLike$1(value) {
  return value != null && typeof value == 'object';
}

var isObjectLike_1 = isObjectLike$1;

var baseGetTag = _baseGetTag,
    isObjectLike = isObjectLike_1;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol$1(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

var isSymbol_1 = isSymbol$1;

var baseTrim = _baseTrim,
    isObject$1 = isObject_1,
    isSymbol = isSymbol_1;

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber$1(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject$1(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject$1(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

var toNumber_1 = toNumber$1;

var isObject = isObject_1,
    now = now_1,
    toNumber = toNumber_1;

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

var debounce_1 = debounce;

var debounce$1 = /*@__PURE__*/getDefaultExportFromCjs(debounce_1);

var PanelWrapper$2 = /*#__PURE__*/function (_React$Component) {
  function PanelWrapper() {
    var _this;
    _classCallCheck(this, PanelWrapper);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, PanelWrapper, [].concat(args));
    _defineProperty$1(_this, "renderPanelWrapper", function () {
      var _this$props = _this.props,
        children = _this$props.children,
        open = _this$props.open;
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Reveal, {
        timeout: 0,
        height: 0,
        "in": open
      }, function () {
        return /*#__PURE__*/React.createElement("div", null, children);
      }));
    });
    return _this;
  }
  _inherits(PanelWrapper, _React$Component);
  return _createClass(PanelWrapper, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        panelId = _this$props2.panelId,
        open = _this$props2.open;
      return open && /*#__PURE__*/React.createElement("div", {
        "data-testid": panelId
      }, this.renderPanelWrapper());
    }
  }]);
}(React.Component);
PanelWrapper$2.propTypes = {
  panelId: PropTypes.string.isRequired,
  open: PropTypes.bool,
  children: PropTypes.node.isRequired
};
PanelWrapper$2.defaultProps = {
  open: false
};

/* eslint-disable react/no-unused-prop-types */

/**
 * Expandable content areas for use with the `ExpandCollapse` or `Accordion`
 *
 * _This component can only be accessed as a name-spaced component: `ExpandCollapse.Panel` or `Accordion.Panel`._
 */
var Panel$2 = function Panel(_ref) {
  var children = _ref.children,
    style = _ref.style,
    className = _ref.className;
  return /*#__PURE__*/React.createElement("div", {
    className: className,
    style: style
  }, children);
};
Panel$2.propTypes = {
  /**
   * The identifier of the panel. Must be unique within the `ExpandCollapse` panels.
   */
  id: PropTypes.string.isRequired,
  /**
   * The content. Can be text, any HTML element, or any component.
   */
  children: PropTypes.node.isRequired,
  /**
   * Add custom inline styles.
   */
  style: PropTypes.object,
  /**
   * Add custom css classes.
   */
  className: PropTypes.string
};
Panel$2.defaultProps = {
  style: undefined,
  className: undefined
};

var styles$3 = {"flirt":"#7c1366","mosque":"#016b6a","texas":"#f9f6a5","amaranth":"#ee2c74","cardinal-pink":"#8c0448","trinidad":"#df3d0c","chestnut":"#bc4850","onahau":"#c3efff","burnt-sienna":"#ed6358","chathams-blue":"#17367d","mid-blue":"#1a347d","well-read":"#b8373e","wattle":"#d5e04d","beeswax":"#feeec7","bilbao":"#258b0b","sea-buckthorn":"#fbaf34","mint-tulip":"#c1f2e8","turquoise":"#39cdc9","hibiscus":"#c53a70","carousel-pink":"#fae6f4","white":"#fff","black":"#000","mortar":"#595959","gallery":"#efefef","silver":"#c9c8c8","dove":"#666666","iceberg":"#cbf0e8","icicle":"#e5f7fb","light-gray":"#fafafa","super-nova":"#fbaf33","expand-yellow":"#fee8b8","expand-yellow-light":"rgba(254, 232, 184, 0.5)","hero-pink":"#a6298c","base":"KDS_Tabs-modules__base___3RpaS","tabButton":"KDS_Tabs-modules__tabButton___1RuCu","tabButtonActive":"KDS_Tabs-modules__tabButtonActive___zR-It","arrowDown":"KDS_Tabs-modules__arrowDown___1NHjh","tabList":"KDS_Tabs-modules__tabList___23OAY","iconLeft":"KDS_Tabs-modules__iconLeft___2QSvo","iconRight":"KDS_Tabs-modules__iconRight___3_fLa","support":"KDS_Tabs-modules__support___3pOXy","commerce":"KDS_Tabs-modules__commerce___diajO"};

var _excluded$7 = ["isPanelOpen", "children"];
var Panels$2 = function Panels(_ref) {
  var isPanelOpen = _ref.isPanelOpen,
    children = _ref.children,
    rest = _objectWithoutProperties$1(_ref, _excluded$7);
  return /*#__PURE__*/React.createElement("div", _extends$1({}, safeRest(rest), {
    className: styles$3.base
  }), /*#__PURE__*/React.createElement(Box, {
    between: 3
  }, React.Children.toArray(children).filter(Boolean).map(function (panel, key) {
    var id = panel.props.id;
    return /*#__PURE__*/React.createElement(PanelWrapper$2, {
      key: id,
      panelId: id,
      open: isPanelOpen(id, key)
    }, panel);
  })));
};
Panels$2.propTypes = {
  isPanelOpen: PropTypes.func.isRequired,
  children: airbnbPropTypes.childrenOfType(Panel$2).isRequired
};

var _excluded$6 = ["tabList", "children", "customMode"];
var Tabs = /*#__PURE__*/function (_React$Component) {
  function Tabs() {
    var _this;
    _classCallCheck(this, Tabs);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Tabs, [].concat(args));
    _defineProperty$1(_this, "state", {
      openPanel: undefined,
      firstPanel: 0,
      tabKey: 0,
      canScrollLeft: false,
      canScrollRight: false
    });
    _defineProperty$1(_this, "tabWidth", 184);
    _defineProperty$1(_this, "iconArrowWidth", 28);
    _defineProperty$1(_this, "tabsRef", /*#__PURE__*/React.createRef());
    _defineProperty$1(_this, "ScrollDirections", {
      Left: 0,
      Right: 1
    });
    _defineProperty$1(_this, "handleResize", function () {
      var _this$getOverflowValu = _this.getOverflowValues(),
        canScrollLeft = _this$getOverflowValu.canScrollLeft,
        canScrollRight = _this$getOverflowValu.canScrollRight;
      if (_this.tabsRef.current) {
        _this.setState({
          canScrollLeft: canScrollLeft,
          canScrollRight: canScrollRight
        });
      }
    });
    _defineProperty$1(_this, "handleScroll", function (e) {
      if (e.currentTarget) {
        _this.handleResize();
      }
    });
    /* eslint-disable react/sort-comp */
    _defineProperty$1(_this, "debounceHandleResize", debounce$1(_this.handleResize, 1000));
    _defineProperty$1(_this, "togglePanel", function (panelId, key) {
      _this.setState(function (_ref) {
        var openPanel = _ref.openPanel;
        return {
          firstPanel: null,
          openPanel: openPanel === panelId ? panelId : panelId,
          tabKey: parseInt(key, 10)
        };
      });
    });
    _defineProperty$1(_this, "isPanelOpen", function (panelId, key) {
      return _this.state.openPanel === panelId || key === _this.state.firstPanel;
    });
    _defineProperty$1(_this, "tabButton", function (item, i) {
      var buttonClass = joinClassNames(styles$3.tabButton, i === _this.state.tabKey && joinClassNames(styles$3.tabButtonActive, getTheme(_this.props.theme, styles$3)));
      var buttonClick = function buttonClick(e) {
        var dataKey = e.target.getAttribute('data-key');
        if (item.onClick) {
          item.onClick();
        }
        if (item.id && dataKey) {
          _this.togglePanel(item.id, dataKey);
        }
      };
      return /*#__PURE__*/React.createElement("button", {
        key: item.id,
        type: "button",
        "data-key": i,
        className: buttonClass,
        onClick: buttonClick
      }, item.title, /*#__PURE__*/React.createElement("div", {
        className: i === _this.state.tabKey ? styles$3.arrowDown : undefined
      }));
    });
    _defineProperty$1(_this, "getOverflowValues", function () {
      var isOverflownLeft = false;
      var isOverflownRight = false;
      var overflowLeft = 0;
      var overflowRight = 0;
      var tabsNode = _this.tabsRef.current;
      if (tabsNode) {
        var scrollWidth = tabsNode.scrollWidth,
          clientWidth = tabsNode.clientWidth,
          scrollLeft = tabsNode.scrollLeft;
        overflowLeft = scrollLeft;
        overflowRight = scrollWidth - clientWidth - scrollLeft;
        isOverflownLeft = overflowLeft > _this.iconArrowWidth;
        isOverflownRight = overflowRight > _this.iconArrowWidth;
      }
      return {
        canScrollLeft: isOverflownLeft,
        canScrollRight: isOverflownRight,
        overflowLeft: overflowLeft,
        overflowRight: overflowRight
      };
    });
    _defineProperty$1(_this, "onScrollClick", function (direction) {
      var _this$getOverflowValu2 = _this.getOverflowValues(),
        canScrollLeft = _this$getOverflowValu2.canScrollLeft,
        canScrollRight = _this$getOverflowValu2.canScrollRight,
        overflowLeft = _this$getOverflowValu2.overflowLeft,
        overflowRight = _this$getOverflowValu2.overflowRight;
      var tabsNode = _this.tabsRef.current;
      if (tabsNode) {
        _this.setState({
          canScrollLeft: canScrollLeft,
          canScrollRight: canScrollRight
        });
        if (direction === _this.ScrollDirections.Right) {
          var scrollValue = Math.min(_this.tabWidth, overflowRight);
          tabsNode.scrollLeft += scrollValue;
        } else if (direction === _this.ScrollDirections.Left) {
          var _scrollValue = Math.min(_this.tabWidth, overflowLeft);
          tabsNode.scrollLeft -= _scrollValue;
        }
      }
    });
    return _this;
  }
  _inherits(Tabs, _React$Component);
  return _createClass(Tabs, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (typeof window !== 'undefined') {
        window.addEventListener('resize', this.debounceHandleResize.bind(this));
        this.debounceHandleResize();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (typeof window !== 'undefined') {
        window.removeEventListener('resize', this.debounceHandleResize.bind(this));
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        tabList = _this$props.tabList,
        children = _this$props.children,
        customMode = _this$props.customMode,
        rest = _objectWithoutProperties$1(_this$props, _excluded$6);
      var _this$state = this.state,
        canScrollLeft = _this$state.canScrollLeft,
        canScrollRight = _this$state.canScrollRight;
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: styles$3.tabList,
        ref: this.tabsRef,
        onScroll: this.handleScroll
      }, canScrollLeft && /*#__PURE__*/React.createElement("div", {
        className: styles$3.iconLeft
      }, /*#__PURE__*/React.createElement(StandaloneIcon, {
        symbol: "chevronLeft",
        size: 12,
        color: "chathams-blue",
        onClick: function onClick() {
          return _this2.onScrollClick(_this2.ScrollDirections.Left);
        },
        a11yText: "Scroll left"
      })), tabList.map(function (item, i) {
        return _this2.tabButton(item, i);
      }), canScrollRight && /*#__PURE__*/React.createElement("div", {
        className: styles$3.iconRight
      }, /*#__PURE__*/React.createElement(StandaloneIcon, {
        symbol: "chevronRight",
        size: 12,
        color: "chathams-blue",
        onClick: function onClick() {
          return _this2.onScrollClick(_this2.ScrollDirections.Right);
        },
        a11yText: "Scroll right"
      }))), customMode ? /*#__PURE__*/React.createElement("div", _extends$1({}, rest, {
        className: styles$3.base
      }), children) : /*#__PURE__*/React.createElement(Panels$2, _extends$1({}, rest, {
        isPanelOpen: this.isPanelOpen
      }), children));
    }
  }]);
}(React.Component);
Tabs.propTypes = {
  /**
   * Accepts an array of objects with key value pairs (title & id):
   */
  tabList: PropTypes.array.isRequired,
  /**
    Must have at least one Tab.Panel with id that match the tabList array object.
   */
  children: airbnbPropTypes.childrenOfType(Panel$2).isRequired,
  /**
   * The theme.
   */
  theme: PropTypes.oneOf(['commerce', 'support']),
  /**
    True turns off the in-built event handler to let the app manage the state of Tab.Panel
   */
  customMode: PropTypes.bool
};
Tabs.defaultProps = {
  theme: undefined,
  customMode: false
};
Tabs.Panel = Panel$2;

var PanelWrapper$1 = /*#__PURE__*/function (_React$Component) {
  function PanelWrapper() {
    var _this;
    _classCallCheck(this, PanelWrapper);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, PanelWrapper, [].concat(args));
    _defineProperty$1(_this, "renderPanelWrapper", function () {
      var _this$props = _this.props,
        children = _this$props.children,
        open = _this$props.open;
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Reveal, {
        timeout: 0,
        height: 0,
        "in": open
      }, function () {
        return /*#__PURE__*/React.createElement("div", null, children);
      }));
    });
    return _this;
  }
  _inherits(PanelWrapper, _React$Component);
  return _createClass(PanelWrapper, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        panelId = _this$props2.panelId,
        open = _this$props2.open;
      return open && /*#__PURE__*/React.createElement("div", {
        "data-testid": panelId
      }, this.renderPanelWrapper());
    }
  }]);
}(React.Component);
PanelWrapper$1.propTypes = {
  panelId: PropTypes.string.isRequired,
  open: PropTypes.bool,
  children: PropTypes.node.isRequired
};
PanelWrapper$1.defaultProps = {
  open: false
};

/* eslint-disable react/no-unused-prop-types */

/**
 * Expandable content areas for use with the `ExpandCollapse` or `Accordion`
 *
 * _This component can only be accessed as a name-spaced component: `ExpandCollapse.Panel` or `Accordion.Panel`._
 */
var Panel$1 = function Panel(_ref) {
  var children = _ref.children,
    style = _ref.style,
    className = _ref.className;
  return /*#__PURE__*/React.createElement("div", {
    className: className,
    style: style
  }, children);
};
Panel$1.propTypes = {
  /**
   * The identifier of the panel. Must be unique within the `ExpandCollapse` panels.
   */
  id: PropTypes.string.isRequired,
  /**
   * The content. Can be text, any HTML element, or any component.
   */
  children: PropTypes.node.isRequired,
  /**
   * Add custom inline styles.
   */
  style: PropTypes.object,
  /**
   * Add custom css classes.
   */
  className: PropTypes.string
};
Panel$1.defaultProps = {
  style: undefined,
  className: undefined
};

var styles$2 = {"flirt":"#7c1366","mosque":"#016b6a","texas":"#f9f6a5","amaranth":"#ee2c74","cardinal-pink":"#8c0448","trinidad":"#df3d0c","chestnut":"#bc4850","onahau":"#c3efff","burnt-sienna":"#ed6358","chathams-blue":"#17367d","mid-blue":"#1a347d","well-read":"#b8373e","wattle":"#d5e04d","beeswax":"#feeec7","bilbao":"#258b0b","sea-buckthorn":"#fbaf34","mint-tulip":"#c1f2e8","turquoise":"#39cdc9","hibiscus":"#c53a70","carousel-pink":"#fae6f4","white":"#fff","black":"#000","mortar":"#595959","gallery":"#efefef","silver":"#c9c8c8","dove":"#666666","iceberg":"#cbf0e8","icicle":"#e5f7fb","light-gray":"#fafafa","super-nova":"#fbaf33","expand-yellow":"#fee8b8","expand-yellow-light":"rgba(254, 232, 184, 0.5)","hero-pink":"#a6298c","base":"KDS_TabFilter-modules__base___3MlTc","cardWrapper":"KDS_TabFilter-modules__cardWrapper___2fJfV","tabButton":"KDS_TabFilter-modules__tabButton____8OXd","tabButton__component":"KDS_TabFilter-modules__tabButton__component___3oooU","tabList":"KDS_TabFilter-modules__tabList___2jGmi","iconLeft":"KDS_TabFilter-modules__iconLeft___2YBov","iconRight":"KDS_TabFilter-modules__iconRight___2pLGN"};

var _excluded$5 = ["isPanelOpen", "children"];
var Panels$1 = function Panels(_ref) {
  var isPanelOpen = _ref.isPanelOpen,
    children = _ref.children,
    rest = _objectWithoutProperties$1(_ref, _excluded$5);
  return /*#__PURE__*/React.createElement("div", _extends$1({}, safeRest(rest), {
    className: styles$2.base
  }), /*#__PURE__*/React.createElement(Box, {
    between: 3
  }, React.Children.toArray(children).filter(Boolean).map(function (panel, key) {
    var id = panel.props.id;
    return /*#__PURE__*/React.createElement(PanelWrapper$1, {
      key: id,
      panelId: id,
      open: isPanelOpen(id, key)
    }, panel);
  })));
};
Panels$1.propTypes = {
  isPanelOpen: PropTypes.func.isRequired,
  children: airbnbPropTypes.childrenOfType(Panel$1).isRequired
};

var _excluded$4 = ["tabList", "children", "customMode", "selectDefault", "selectedTabCallback"];
var TabFilter = /*#__PURE__*/function (_React$Component) {
  function TabFilter() {
    var _this;
    _classCallCheck(this, TabFilter);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, TabFilter, [].concat(args));
    _defineProperty$1(_this, "state", {
      openPanel: undefined,
      firstPanel: 0,
      tabKey: 0,
      canScrollLeft: false,
      canScrollRight: false,
      isFirstClick: true
    });
    _defineProperty$1(_this, "tabWidth", 184);
    _defineProperty$1(_this, "iconArrowWidth", 32);
    _defineProperty$1(_this, "tabsRef", /*#__PURE__*/React.createRef());
    _defineProperty$1(_this, "ScrollDirections", {
      Left: 0,
      Right: 1
    });
    _defineProperty$1(_this, "handleResize", function () {
      var _this$getOverflowValu = _this.getOverflowValues(),
        canScrollLeft = _this$getOverflowValu.canScrollLeft,
        canScrollRight = _this$getOverflowValu.canScrollRight;
      if (_this.tabsRef.current) {
        _this.setState({
          canScrollLeft: canScrollLeft,
          canScrollRight: canScrollRight
        });
      }
    });
    _defineProperty$1(_this, "handleScroll", function (e) {
      if (e.currentTarget) {
        _this.handleResize();
      }
    });
    /* eslint-disable react/sort-comp */
    _defineProperty$1(_this, "debounceHandleResize", debounce$1(_this.handleResize, 1000));
    _defineProperty$1(_this, "togglePanel", function (panelId, key) {
      _this.setState(function (_ref) {
        var openPanel = _ref.openPanel;
        return {
          firstPanel: null,
          openPanel: openPanel === panelId ? panelId : panelId,
          tabKey: parseInt(key, 10)
        };
      });
      _this.props.selectedTabCallback(panelId);
    });
    _defineProperty$1(_this, "isPanelOpen", function (panelId, key) {
      return _this.state.openPanel === panelId || key === _this.state.firstPanel;
    });
    _defineProperty$1(_this, "tabButton", function (item, i) {
      var updateScrollLeft = function updateScrollLeft(dataKey) {
        var scrollWidth = _this.tabsRef.current.scrollWidth / _this.props.tabList.length * dataKey;
        _this.tabsRef.current.scrollLeft = scrollWidth;
      };
      var buttonClick = function buttonClick(e) {
        if (_this.state.isFirstClick) {
          _this.setState({
            isFirstClick: false
          });
        }
        var dataKey = e.target.getAttribute('data-key');
        if (item.onClick) {
          item.onClick();
        }
        if (item.id && dataKey) {
          _this.togglePanel(item.id, dataKey);
        }
        // scroll to begining of tab.
        updateScrollLeft(dataKey);
      };
      var isSelected = i === _this.state.tabKey;
      var cardVariant;
      if (_this.state.isFirstClick && !_this.props.selectDefault) {
        cardVariant = 'white-tab';
      } else if (isSelected) {
        cardVariant = 'mosque-tab';
      } else {
        cardVariant = 'white-tab';
      }

      /* eslint-disable jsx-a11y/no-noninteractive-tabindex */
      return /*#__PURE__*/React.createElement(Clickable, {
        key: item.id,
        dangerouslyAddClassName: styles$2.tabButton,
        "data-key": i,
        onKeyPress: function onKeyPress(e) {
          if (e.key === 'Enter' || e.key === ' ') {
            buttonClick(e);
          }
        },
        onKeyUp: function onKeyUp(e) {
          if (e.shiftKey && e.key === 'Tab' || e.key === 'Tab') {
            var dataKey = e.target.getAttribute('data-key');
            updateScrollLeft(dataKey);
          }
        },
        role: "tab"
      }, /*#__PURE__*/React.createElement("div", {
        className: styles$2.cardWrapper
      }, /*#__PURE__*/React.createElement(Card, {
        variant: cardVariant,
        boxShadow: false,
        border: "mosque",
        borderRadius: "8px",
        "data-key": i,
        onClick: buttonClick
      }, /*#__PURE__*/React.createElement("div", {
        className: styles$2.tabButton__component
      }, item.component))));
    });
    _defineProperty$1(_this, "getOverflowValues", function () {
      var isOverflownLeft = false;
      var isOverflownRight = false;
      var overflowLeft = 0;
      var overflowRight = 0;
      var tabsNode = _this.tabsRef.current;
      if (tabsNode) {
        var scrollWidth = tabsNode.scrollWidth,
          clientWidth = tabsNode.clientWidth,
          scrollLeft = tabsNode.scrollLeft;
        overflowLeft = scrollLeft;
        overflowRight = scrollWidth - clientWidth - scrollLeft;
        isOverflownLeft = overflowLeft > _this.iconArrowWidth;
        isOverflownRight = overflowRight > _this.iconArrowWidth;
      }
      return {
        canScrollLeft: isOverflownLeft,
        canScrollRight: isOverflownRight,
        overflowLeft: overflowLeft,
        overflowRight: overflowRight
      };
    });
    _defineProperty$1(_this, "onScrollClick", function (direction) {
      var _this$getOverflowValu2 = _this.getOverflowValues(),
        canScrollLeft = _this$getOverflowValu2.canScrollLeft,
        canScrollRight = _this$getOverflowValu2.canScrollRight,
        overflowLeft = _this$getOverflowValu2.overflowLeft,
        overflowRight = _this$getOverflowValu2.overflowRight;
      var tabsNode = _this.tabsRef.current;
      if (tabsNode) {
        _this.setState({
          canScrollLeft: canScrollLeft,
          canScrollRight: canScrollRight
        });
        if (direction === _this.ScrollDirections.Right) {
          var scrollValue = Math.min(_this.tabWidth, overflowRight);
          tabsNode.scrollLeft += scrollValue;
        } else if (direction === _this.ScrollDirections.Left) {
          var _scrollValue = Math.min(_this.tabWidth, overflowLeft);
          tabsNode.scrollLeft -= _scrollValue;
        }
      }
    });
    return _this;
  }
  _inherits(TabFilter, _React$Component);
  return _createClass(TabFilter, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (typeof window !== 'undefined') {
        window.addEventListener('resize', this.debounceHandleResize.bind(this));
        this.debounceHandleResize();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (typeof window !== 'undefined') {
        window.removeEventListener('resize', this.debounceHandleResize.bind(this));
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        tabList = _this$props.tabList,
        children = _this$props.children,
        customMode = _this$props.customMode;
        _this$props.selectDefault;
        _this$props.selectedTabCallback;
        var rest = _objectWithoutProperties$1(_this$props, _excluded$4);
      var _this$state = this.state,
        canScrollLeft = _this$state.canScrollLeft,
        canScrollRight = _this$state.canScrollRight;
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: styles$2.tabList,
        ref: this.tabsRef,
        onScroll: this.handleScroll
      }, canScrollLeft && /*#__PURE__*/React.createElement("div", {
        className: styles$2.iconLeft
      }, /*#__PURE__*/React.createElement(StandaloneIcon, {
        symbol: "chevronLeft",
        size: 12,
        color: "mosque",
        onClick: function onClick() {
          return _this2.onScrollClick(_this2.ScrollDirections.Left);
        },
        a11yText: "Scroll left"
      })), tabList.map(function (item, i) {
        return _this2.tabButton(item, i);
      }), canScrollRight && /*#__PURE__*/React.createElement("div", {
        className: styles$2.iconRight
      }, /*#__PURE__*/React.createElement(StandaloneIcon, {
        symbol: "chevronRight",
        size: 12,
        color: "mosque",
        onClick: function onClick() {
          return _this2.onScrollClick(_this2.ScrollDirections.Right);
        },
        a11yText: "Scroll right"
      }))), customMode ? /*#__PURE__*/React.createElement("div", _extends$1({}, rest, {
        className: styles$2.base
      }), children) : /*#__PURE__*/React.createElement(Panels$1, _extends$1({}, rest, {
        isPanelOpen: this.isPanelOpen
      }), children));
    }
  }]);
}(React.Component);
TabFilter.propTypes = {
  /**
   * Accepts an array of objects with key value pairs (id & component):
   */
  tabList: PropTypes.array.isRequired,
  /**
    Must have at least one Tab.Panel with id that match the tabList array object.
   */
  children: airbnbPropTypes.childrenOfType(Panel$1).isRequired,
  /**
    True turns off the in-built event handler to let the app manage the state of Tab.Panel
   */
  customMode: PropTypes.bool,
  /**
    False turns off the default selection of the first Tab
   */
  selectDefault: PropTypes.bool,
  /**
    A callback function used to return the id of the tab currently selected to the parent
   */
  selectedTabCallback: PropTypes.func
};
TabFilter.defaultProps = {
  customMode: false,
  selectDefault: true,
  selectedTabCallback: function selectedTabCallback() {}
};
TabFilter.Panel = Panel$1;

var PanelWrapper = /*#__PURE__*/function (_React$Component) {
  function PanelWrapper() {
    var _this;
    _classCallCheck(this, PanelWrapper);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, PanelWrapper, [].concat(args));
    _defineProperty$1(_this, "renderPanelWrapper", function () {
      var _this$props = _this.props,
        children = _this$props.children,
        open = _this$props.open;
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Reveal, {
        timeout: 0,
        height: 0,
        "in": open
      }, function () {
        return /*#__PURE__*/React.createElement("div", null, children);
      }));
    });
    return _this;
  }
  _inherits(PanelWrapper, _React$Component);
  return _createClass(PanelWrapper, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        panelId = _this$props2.panelId,
        open = _this$props2.open;
      return open && /*#__PURE__*/React.createElement("div", {
        "data-testid": panelId
      }, this.renderPanelWrapper());
    }
  }]);
}(React.Component);
PanelWrapper.propTypes = {
  panelId: PropTypes.string.isRequired,
  open: PropTypes.bool,
  children: PropTypes.node.isRequired
};
PanelWrapper.defaultProps = {
  open: false
};

/* eslint-disable react/no-unused-prop-types */

/**
 * Expandable content areas for use with the `ExpandCollapse` or `Accordion`
 *
 * _This component can only be accessed as a name-spaced component: `ExpandCollapse.Panel` or `Accordion.Panel`._
 */
var Panel = function Panel(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement("div", null, children);
};
Panel.propTypes = {
  /**
   * The identifier of the panel. Must be unique within the `ExpandCollapse` panels.
   */
  id: PropTypes.string.isRequired,
  /**
   * The content. Can be text, any HTML element, or any component.
   */
  children: PropTypes.node.isRequired
};

var styles$1 = {"flirt":"#7c1366","mosque":"#016b6a","texas":"#f9f6a5","amaranth":"#ee2c74","cardinal-pink":"#8c0448","trinidad":"#df3d0c","chestnut":"#bc4850","onahau":"#c3efff","burnt-sienna":"#ed6358","chathams-blue":"#17367d","mid-blue":"#1a347d","well-read":"#b8373e","wattle":"#d5e04d","beeswax":"#feeec7","bilbao":"#258b0b","sea-buckthorn":"#fbaf34","mint-tulip":"#c1f2e8","turquoise":"#39cdc9","hibiscus":"#c53a70","carousel-pink":"#fae6f4","white":"#fff","black":"#000","mortar":"#595959","gallery":"#efefef","silver":"#c9c8c8","dove":"#666666","iceberg":"#cbf0e8","icicle":"#e5f7fb","light-gray":"#fafafa","super-nova":"#fbaf33","expand-yellow":"#fee8b8","expand-yellow-light":"rgba(254, 232, 184, 0.5)","hero-pink":"#a6298c","base":"KDS_TabSlider-modules__base___3phb0","tabButton":"KDS_TabSlider-modules__tabButton___3Izbl","tabButtonContainer":"KDS_TabSlider-modules__tabButtonContainer___fKoUv","tabButtonActive":"KDS_TabSlider-modules__tabButtonActive___3JCC4","tabIndicator":"KDS_TabSlider-modules__tabIndicator___15-To","support":"KDS_TabSlider-modules__support___3cMe6","commerce":"KDS_TabSlider-modules__commerce___qSQ_r"};

var _excluded$3 = ["isPanelOpen", "children"];
var Panels = function Panels(_ref) {
  var isPanelOpen = _ref.isPanelOpen,
    children = _ref.children,
    rest = _objectWithoutProperties$1(_ref, _excluded$3);
  return /*#__PURE__*/React.createElement("div", _extends$1({}, safeRest(rest), {
    className: styles$1.base
  }), /*#__PURE__*/React.createElement(Box, {
    between: 3
  }, React.Children.toArray(children).filter(Boolean).map(function (panel, key) {
    var id = panel.props.id;
    return /*#__PURE__*/React.createElement(PanelWrapper, {
      key: id,
      panelId: id,
      open: isPanelOpen(id, key)
    }, panel);
  })));
};
Panels.propTypes = {
  isPanelOpen: PropTypes.func.isRequired,
  children: airbnbPropTypes.childrenOfType(Panel).isRequired
};

var _excluded$2 = ["tabList", "children"];
var TabSlider = /*#__PURE__*/function (_React$Component) {
  function TabSlider(props) {
    var _this;
    _classCallCheck(this, TabSlider);
    _this = _callSuper(this, TabSlider, [props]);
    _defineProperty$1(_this, "togglePanel", function (panelId, key) {
      _this.setState(function (_ref) {
        var openPanel = _ref.openPanel;
        return {
          firstPanel: null,
          openPanel: openPanel === panelId ? panelId : panelId,
          tabKey: parseInt(key, 10)
        };
      });
    });
    _defineProperty$1(_this, "isPanelOpen", function (panelId, key) {
      return _this.state.openPanel === panelId || key === _this.state.firstPanel;
    });
    _defineProperty$1(_this, "tabButton", function (item, i) {
      var buttonClass = joinClassNames(styles$1.tabButton, getTheme(_this.props.theme, styles$1));
      var buttonClick = function buttonClick(e, index) {
        _this.setState({
          activeTab: index
        });
        var dataKey = e.target.getAttribute('data-key');
        _this.togglePanel(item.id, dataKey);
      };
      return /*#__PURE__*/React.createElement("button", {
        "data-id": "button-tab-".concat(i),
        key: item.id,
        ref: _this.tabWidth,
        type: "button",
        "data-key": i,
        className: "".concat(buttonClass, " ").concat(_this.state.activeTab === i ? styles$1.tabButtonActive : ''),
        onClick: function onClick(e) {
          buttonClick(e, i);
          if (item.onClick) {
            item.onClick();
          }
        },
        style: {
          width: "".concat(_this.state.mobile ? "".concat(_this.state.tabWidth, "px") : "".concat(_this.state.tabWidth, "%"))
        }
      }, item.icon && /*#__PURE__*/React.createElement(DecorativeIcon, {
        "data-id": "icon-tab-".concat(i),
        symbol: item.icon
      }), item.title);
    });
    _this.state = {
      openPanel: undefined,
      firstPanel: 0,
      tabWidth: 0,
      tabKey: 0,
      activeTab: 0
    };
    _this.tabWidth = /*#__PURE__*/React.createRef();
    return _this;
  }
  _inherits(TabSlider, _React$Component);
  return _createClass(TabSlider, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (typeof window !== 'undefined') {
        window.addEventListener('resize', this.handleTabResize.bind(this));
        this.handleTabResize();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (typeof window !== 'undefined') {
        window.removeEventListener('resize', this.handleTabResize.bind(this));
      }
    }
  }, {
    key: "handleTabResize",
    value: function handleTabResize() {
      var tabWidth = window.innerWidth;
      var tabList = this.props.tabList;
      if (tabWidth <= 767) {
        this.setState({
          mobile: true,
          tabWidth: this.tabWidth.current.offsetWidth
        });
      } else {
        this.setState({
          mobile: false,
          tabWidth: 100 / tabList.length
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        tabList = _this$props.tabList,
        children = _this$props.children,
        rest = _objectWithoutProperties$1(_this$props, _excluded$2);
      var _this$state = this.state,
        tabWidth = _this$state.tabWidth,
        tabKey = _this$state.tabKey,
        mobile = _this$state.mobile;
      var tabDesktopIndicator = {
        width: "".concat(tabWidth, "%"),
        left: "calc(".concat(tabWidth, "% * ").concat(tabKey, ")")
      };
      var tabMobileIndicator = {
        width: "".concat(tabWidth, "px"),
        left: "calc(".concat(tabWidth, "px * ").concat(tabKey, ")")
      };
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: styles$1.tabButtonContainer
      }, tabList.map(function (item, i) {
        return _this2.tabButton(item, i);
      }), /*#__PURE__*/React.createElement("span", {
        style: mobile ? tabMobileIndicator : tabDesktopIndicator,
        className: styles$1.tabIndicator
      })), /*#__PURE__*/React.createElement(Panels, _extends$1({}, rest, {
        isPanelOpen: this.isPanelOpen
      }), children));
    }
  }]);
}(React.Component);
TabSlider.propTypes = {
  /**
   * Accepts an array of objects with key value pairs (title & id):
   */
  tabList: PropTypes.array.isRequired,
  /**
    Must have at least one Tab.Panel with id that match the tabList array object.
   */
  children: airbnbPropTypes.childrenOfType(Panel).isRequired,
  /**
   * The theme.
   */
  theme: PropTypes.oneOf(['commerce', 'support'])
};
TabSlider.defaultProps = {
  theme: undefined
};
TabSlider.Panel = Panel;

var styles = {"flirt":"#7c1366","mosque":"#016b6a","texas":"#f9f6a5","amaranth":"#ee2c74","cardinal-pink":"#8c0448","trinidad":"#df3d0c","chestnut":"#bc4850","onahau":"#c3efff","burnt-sienna":"#ed6358","chathams-blue":"#17367d","mid-blue":"#1a347d","well-read":"#b8373e","wattle":"#d5e04d","beeswax":"#feeec7","bilbao":"#258b0b","sea-buckthorn":"#fbaf34","mint-tulip":"#c1f2e8","turquoise":"#39cdc9","hibiscus":"#c53a70","carousel-pink":"#fae6f4","white":"#fff","black":"#000","mortar":"#595959","gallery":"#efefef","silver":"#c9c8c8","dove":"#666666","iceberg":"#cbf0e8","icicle":"#e5f7fb","light-gray":"#fafafa","super-nova":"#fbaf33","expand-yellow":"#fee8b8","expand-yellow-light":"rgba(254, 232, 184, 0.5)","hero-pink":"#a6298c","base":"KDS_UnorderedList-modules__base___2CooL","item":"KDS_UnorderedList-modules__item___3WffK","circle":"KDS_UnorderedList-modules__circle___26nMD KDS_UnorderedList-modules__base___2CooL","circleItem":"KDS_UnorderedList-modules__circleItem___ltN5C","purple":"KDS_UnorderedList-modules__purple___1XFbs","decorative":"KDS_UnorderedList-modules__decorative___1ii_D KDS_UnorderedList-modules__base___2CooL","decorativeItem":"KDS_UnorderedList-modules__decorativeItem___3HlW1","checkmark":"KDS_UnorderedList-modules__checkmark___1urmo KDS_UnorderedList-modules__base___2CooL","checkmarkItem":"KDS_UnorderedList-modules__checkmarkItem___1wxbf"};

var _excluded$1 = ["size", "listStyle", "children"];
var UnorderedItem = function UnorderedItem(_ref) {
  var size = _ref.size,
    listStyle = _ref.listStyle,
    children = _ref.children,
    rest = _objectWithoutProperties$1(_ref, _excluded$1);
  return children ? /*#__PURE__*/React.createElement("li", _extends$1({}, safeRest(rest), {
    className: styles["".concat(listStyle, "Item")]
  }), /*#__PURE__*/React.createElement(Text$2, {
    size: size || 'base'
  }, children)) : '';
};
UnorderedItem.propTypes = {
  listStyle: PropTypes.oneOf(['circle', 'decorative', 'checkmark']),
  size: PropTypes.oneOf(['base', 'small']),
  /**
   * The content
   */
  children: PropTypes.node.isRequired
};
UnorderedItem.defaultProps = {
  listStyle: 'circle',
  size: undefined
};
UnorderedItem.displayName = 'UnorderedList.Item';

var _excluded = ["listStyle", "size", "listColor", "children"];
var UnorderedList = function UnorderedList(_ref) {
  var listStyle = _ref.listStyle,
    size = _ref.size,
    listColor = _ref.listColor,
    children = _ref.children,
    rest = _objectWithoutProperties$1(_ref, _excluded);
  var classes = "".concat(styles[listStyle], " ").concat(styles[listColor]);
  var generateChildren = function generateChildren(child) {
    return /*#__PURE__*/React.cloneElement(child, {
      size: size,
      listStyle: listStyle
    });
  };
  var items = React.Children.map(children, generateChildren);
  return /*#__PURE__*/React.createElement(Text$2, {
    size: size || 'base'
  }, /*#__PURE__*/React.createElement("ul", _extends$1({}, safeRest(rest), {
    className: classes
  }), items));
};
UnorderedList.propTypes = {
  /**
   * The type of list.
   */
  listStyle: PropTypes.oneOf(['circle', 'decorative', 'checkmark']),
  /**
   * The font size
   */
  size: PropTypes.oneOf(['base', 'small']),
  /**
   * The color of the list.
   */
  listColor: PropTypes.oneOf(['default', 'purple']),
  /**
   * The list items
   */
  children: PropTypes.node.isRequired
};
UnorderedList.defaultProps = {
  listStyle: 'circle',
  size: 'base',
  listColor: 'default'
};
UnorderedList.Item = UnorderedItem;

function getBreakpointAttributes() {
  return breakpoints$1;
}

var zIndexes = {};

var getZIndexes = function getZIndexes() {
  return zIndexes;
};

export { AccordionList, Banner, Box, Button, ButtonLink, Card, Checkbox, ChevronLink, Clickable, Container, DecorativeIcon, DisplayHeading, Drawer, ExpandCollapse, FlexGrid, HairlineDivider, Heading$1 as Heading, HeroBanner, ImageCarousel, Input, InputFeedback, KebabMenu, Link, Loader, LoaderButton, Meter, Modal, Notification, OptimizeImage$1 as OptimizeImage, OrderedList, PageTitle, Paragraph$1 as Paragraph, Price, Radio, Responsive, ResponsiveImage, Ribbon, Select, Skeleton, SkeletonProvider, StandaloneIcon, Steps, Strong, Success, TabFilter, TabSlider, Table, Tabs, Text$2 as Text, ToastNotification, ToggleSwitch, Tooltip, UnorderedList, getBreakpointAttributes, getColors, getZIndexes };
//# sourceMappingURL=kds.es.js.map
